// D27: Game Plan PPG application code, extracted from <script type="text/babel">
// block in pre-D27 src/index.html (lines 1549-15443). Body preserved verbatim;
// only changes: React/ReactDOM imports added at top, KNIGHT_LOGO_SRC base64 inlined
// here (was a separate <script> block), final mount line uses imported createRoot.

import React from 'react';
import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

// Knight logo as global variable (preserved from pre-D27 to avoid touching
// every reference site — many components read window.KNIGHT_LOGO_SRC directly).
    window.KNIGHT_LOGO_SRC = "data:image/png;base64,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";

    const { useState, useEffect, useMemo, useRef } = React;

    // ================================================================
    // v4.5: SUPABASE AUTH CONFIGURATION
    // ================================================================
    const SUPABASE_URL = 'https://qiegfdufpoizyguyznbp.supabase.co';
    const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFpZWdmZHVmcG9penlndXl6bmJwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY1ODI1NTYsImV4cCI6MjA5MjE1ODU1Nn0.v1MaEmncXR_qi_kJw5y-KGiJ9jORtgR8oguykdGvoSA';

    const supabaseClient = supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        detectSessionInUrl: true,
        flowType: 'implicit',
        persistSession: true,
        storageKey: 'gameplan-auth',
        autoRefreshToken: true
      }
    });

    // ================================================================
    // v5.0: FEATURE FLAGS
    // ================================================================
    const ENABLE_PROFILE_BRANDING = true; // Toggle agent branding on Step 4 and PDFs

    // ================================================================
    // SAMPLE REPORT DATA - Inserted for new users to explore the product
    // ================================================================
    const SAMPLE_REPORT = {
      property_address: '742 Evergreen Terrace',
      city_state: 'Portland, OR',
      zip_code: '97205',
      contract_price: 485000,
      original_list_price: 510000,
      list_price: 499000,
      days_on_market: 47,
      client_name: 'Sample Client',
      is_sample: true,
      report_status: 'analysis_complete',
      leverage_score: 6,
      leverage_tier: 'strong',
      ask_total: 28500,
      findings_count: 14,
      must_haves_total: 12800,
      strong_asks_total: 8200,
      tradeables_total: 4500,
      concessions_total: 3000,
      findings_json: [
        { id: 'sample-1', description: 'Water heater past expected lifespan (18 years old)', category: 'Plumbing', priority: 'high', cost: 2800, lowEstimate: 2200, highEstimate: 3400, selected: true, urgencyTier: 'immediate', regionalCity: 'Portland' },
        { id: 'sample-2', description: 'GFCI outlets not installed in bathrooms and kitchen', category: 'Electrical', priority: 'high', cost: 650, lowEstimate: 400, highEstimate: 900, selected: true, urgencyTier: 'immediate', regionalCity: 'Portland' },
        { id: 'sample-3', description: 'Roof showing signs of wear, estimated 3-5 years remaining life', category: 'Roofing', priority: 'high', cost: 4500, lowEstimate: 3500, highEstimate: 5500, selected: true, urgencyTier: 'nearTerm', regionalCity: 'Portland' },
        { id: 'sample-4', description: 'HVAC filter dirty, system last serviced 3+ years ago', category: 'HVAC', priority: 'medium', cost: 350, lowEstimate: 200, highEstimate: 500, selected: true, urgencyTier: 'maintenance', regionalCity: 'Portland' },
        { id: 'sample-5', description: 'Minor settling cracks in foundation (cosmetic)', category: 'Foundation', priority: 'low', cost: 800, lowEstimate: 500, highEstimate: 1200, selected: true, urgencyTier: 'cosmetic', regionalCity: 'Portland' },
        { id: 'sample-6', description: 'Deck boards showing rot in several areas', category: 'Exterior', priority: 'medium', cost: 3200, lowEstimate: 2500, highEstimate: 4000, selected: true, urgencyTier: 'nearTerm', regionalCity: 'Portland' },
        { id: 'sample-7', description: 'Garage door opener not functioning properly', category: 'Garage', priority: 'low', cost: 450, lowEstimate: 300, highEstimate: 600, selected: true, urgencyTier: 'convenience', regionalCity: 'Portland' },
        { id: 'sample-8', description: 'Kitchen faucet leaking at base', category: 'Plumbing', priority: 'medium', cost: 380, lowEstimate: 250, highEstimate: 500, selected: true, urgencyTier: 'maintenance', regionalCity: 'Portland' },
        { id: 'sample-9', description: 'Attic insulation below current code standards', category: 'Insulation', priority: 'medium', cost: 2200, lowEstimate: 1800, highEstimate: 2800, selected: true, urgencyTier: 'efficiency', regionalCity: 'Portland' },
        { id: 'sample-10', description: 'Smoke detectors expired or missing in bedrooms', category: 'Safety', priority: 'high', cost: 180, lowEstimate: 120, highEstimate: 250, selected: true, urgencyTier: 'immediate', regionalCity: 'Portland' },
        { id: 'sample-11', description: 'Exterior paint peeling on south-facing walls', category: 'Exterior', priority: 'low', cost: 4800, lowEstimate: 3800, highEstimate: 6000, selected: true, urgencyTier: 'cosmetic', regionalCity: 'Portland' },
        { id: 'sample-12', description: 'Bathroom exhaust fans venting into attic', category: 'Ventilation', priority: 'medium', cost: 650, lowEstimate: 450, highEstimate: 850, selected: true, urgencyTier: 'nearTerm', regionalCity: 'Portland' },
        { id: 'sample-13', description: 'Downspouts not extending away from foundation', category: 'Drainage', priority: 'medium', cost: 280, lowEstimate: 150, highEstimate: 400, selected: true, urgencyTier: 'maintenance', regionalCity: 'Portland' },
        { id: 'sample-14', description: 'Window seals failed in 3 windows (foggy)', category: 'Windows', priority: 'low', cost: 1800, lowEstimate: 1200, highEstimate: 2400, selected: true, urgencyTier: 'efficiency', regionalCity: 'Portland' }
      ],
      strategy_json: {
        openingAsk: 28500,
        expectedLow: 14000,
        expectedHigh: 18000,
        floor: 8500,
        captureRateLow: 0.45,
        captureRateHigh: 0.65,
        dealCriticalTotal: 8130,
        totals: { mustHaves: 12800, strongAsks: 8200, tradeables: 4500, concessions: 3000, allItems: 28500 }
      },
      market_context_json: { medianDOM: 23, inventoryMonths: 1.8, priceReductionPct: 0.34 },
      buyer_factors_json: [
        { id: 'comparables', label: 'Comparable Properties Available', value: 7, weight: 1.5, enabled: true },
        { id: 'buyerUrgency', label: 'Buyer Timeline Pressure', value: 5, weight: 1.0, enabled: true }
      ],
      seller_factors_json: [
        { id: 'sellerMotivated', label: 'Seller Appears Motivated', value: 7, weight: 1.8, enabled: true },
        { id: 'daysOnMarket', label: 'Days on Market', value: 8, weight: 1.5, enabled: true }
      ]
    };

    // Helper function to insert sample report for new users
    const insertSampleReportForNewUser = async (userId, supabaseClient) => {
      try {
        // Check if sample already exists
        const { data: existing } = await supabaseClient
          .from('reports')
          .select('id')
          .eq('user_id', userId)
          .eq('is_sample', true)
          .maybeSingle();

        if (existing) {
          console.log('Sample report already exists for user');
          return;
        }

        // Insert sample report
        const { error } = await supabaseClient
          .from('reports')
          .insert({
            ...SAMPLE_REPORT,
            user_id: userId,
            created_at: new Date().toISOString()
          });

        if (error) {
          console.error('Error inserting sample report:', error);
        } else {
          console.log('Sample report inserted for new user');
        }
      } catch (err) {
        console.error('Exception inserting sample report:', err);
      }
    };

    // ================================================================
    // D32-C: Page 3 input architecture
    // ================================================================
    // Classification of the 7 remaining sliders (post-D32-A) by who answers them.
    // BUYER_INPUT_IDS will become SMS-pending placeholders in D32-B; until then
    // the agent fills them on Page 3 just like the agent-input sliders.
    // AGENT_INPUT_IDS get required justification dropdowns when moved off default.
    const D32C_BUYER_INPUT_IDS = new Set(['buyerFinancialStrength', 'uniquelySuited', 'emotional', 'timePressure']);
    const D32C_AGENT_INPUT_IDS = new Set(['sellerDisclosed', 'sellerMotivated', 'backupOffers']);
    const D32C_SLIDER_DEFAULT_VALUE = 6; // matches the initial state values

    // Canned justification dropdown options per slider. First-pass drafts per directive
    // — Andrew will refine during the May 5 working session. Schema is forward-compatible
    // with option swaps because we store the raw selected text, not an integer enum.
    // Bottom option of every list is the literal sentinel 'Other (specify)' which
    // reveals a free-text input.
    // D35-C1/C2 (Andrew session 2026-05-06): Andrew reviewed every option live and
    // cut/renamed the ones that didn't fit the slider's stated category, asked the
    // agent to assert knowledge they don't reliably have, or were redundant with
    // the kept options. sellerMotivated reviewed-no-changes per D35-C3.
    // Legacy reports written under prior options remain readable — we store the
    // raw selected text, not an integer enum, so removed strings that were already
    // saved continue to render exactly as written.
    const D32C_JUSTIFICATION_OPTIONS = {
      sellerDisclosed: [
        'Disclosure form mentions specific items now confirmed by inspection',
        'Disclosure form is minimal or evasive',
        'Other (specify)'
      ],
      sellerMotivated: [
        'Listing agent has communicated relocation/job change urgency',
        'Property has been on market longer than local median DOM',
        'Listing has had one or more price reductions',
        'Estate sale, divorce, or other forced-sale circumstance',
        'Seller is carrying two mortgages',
        'Listing agent has signaled flexibility on terms',
        'No clear signal of motivation; rating based on general market conditions',
        'Other (specify)'
      ],
      backupOffers: [
        'Listing agent has confirmed multiple offers received',
        'Listing agent has hinted at competing interest without confirming',
        'Multiple showings reported by listing agent',
        'Other (specify)'
      ]
    };
    const D32C_OTHER_SENTINEL = 'Other (specify)';

    // ================================================================
    // D36: CONCESSION PROBABILITY CURVE — bespoke insight tile
    // ================================================================
    // Self-contained mockup-as-feature for the May 12 demo. Visualizes where the
    // current ask sits on a logistic close-probability curve, with a clearly-
    // labeled PREVIEW ribbon making its future-state nature unmistakable. Inputs:
    // propertyValue, askAmount, score. NO engine integration — the curve is
    // pure visualization, not a probability the engine actually uses. Reference
    // implementation: docs/directives/D36-Candidate-A-v10-final.html.
    const ConcessionProbabilityCurve = ({ propertyValue, askAmount, score }) => {
      // Configuration (locked at v10-final, do not paraphrase)
      const X_AXIS_MAX_PCT = 0.06;
      const REF_LOW_PCT = 0.02;
      const REF_HIGH_PCT = 0.03;
      const PLOT_LEFT = 60;
      const PLOT_RIGHT = 640;
      const PLOT_TOP = 60;
      const PLOT_BOTTOM = 240;
      const PLOT_WIDTH = PLOT_RIGHT - PLOT_LEFT;
      const PLOT_HEIGHT = PLOT_BOTTOM - PLOT_TOP;
      const CURVE_CEILING = 0.90;
      const CURVE_FLOOR = 0.05;
      const CURVE_MIDPOINT = 0.027;
      const CURVE_STEEPNESS = 90;

      // Edge cases
      const safePropVal = (typeof propertyValue === 'number' && propertyValue > 0) ? propertyValue : 0;
      const safeAsk = (typeof askAmount === 'number' && askAmount > 0) ? askAmount : 0;
      const safeScore = (typeof score === 'number' && !isNaN(score))
        ? Math.max(2, Math.min(9, Math.round(score)))
        : 5;

      // Math
      const curveProb = (askPct) => {
        const range = CURVE_CEILING - CURVE_FLOOR;
        const decay = 1 / (1 + Math.exp(-CURVE_STEEPNESS * (askPct - CURVE_MIDPOINT)));
        return CURVE_CEILING - (range * decay);
      };
      const pctToX = (pct) => {
        const clamped = Math.max(0, Math.min(pct, X_AXIS_MAX_PCT));
        return PLOT_LEFT + (clamped / X_AXIS_MAX_PCT) * PLOT_WIDTH;
      };
      const probToY = (prob) => PLOT_BOTTOM - (prob * PLOT_HEIGHT);

      const formatDollars = (amount) => {
        if (amount >= 1000000) return '$' + (amount / 1000000).toFixed(amount % 1000000 === 0 ? 0 : 2) + 'M';
        if (amount >= 1000) return '$' + Math.round(amount / 1000) + 'K';
        return '$' + Math.round(amount).toLocaleString();
      };
      const formatDollarsExact = (amount) => '$' + Math.round(amount).toLocaleString();

      const askPct = safePropVal > 0 ? safeAsk / safePropVal : 0;
      const isOffChart = askPct > X_AXIS_MAX_PCT;

      const dotX = isOffChart ? PLOT_RIGHT : pctToX(askPct);
      const dotProb = isOffChart ? curveProb(X_AXIS_MAX_PCT) : curveProb(askPct);
      const dotY = probToY(dotProb);

      // Build curve path
      const curvePoints = [];
      for (let i = 0; i <= 100; i++) {
        const pct = (i / 100) * X_AXIS_MAX_PCT;
        const prob = curveProb(pct);
        curvePoints.push([pctToX(pct), probToY(prob)]);
      }
      let pathD = `M ${curvePoints[0][0]},${curvePoints[0][1]}`;
      for (let i = 1; i < curvePoints.length; i++) {
        pathD += ` L ${curvePoints[i][0]},${curvePoints[i][1]}`;
      }
      const areaD = pathD + ` L ${curvePoints[curvePoints.length-1][0]},${PLOT_BOTTOM} L ${curvePoints[0][0]},${PLOT_BOTTOM} Z`;

      // X-axis tick labels: 1%, 2%, 3%, 4%, 5%, 6%
      const labelPcts = [0.01, 0.02, 0.03, 0.04, 0.05, 0.06];

      // Reference range
      const refLowX = pctToX(REF_LOW_PCT);
      const refHighX = pctToX(REF_HIGH_PCT);
      const refMidX = (refLowX + refHighX) / 2;

      // Tooltip positioning
      const tooltipWidth = 155;
      const tooltipHeight = 36;
      const tooltipDropDistance = 50;

      let tooltipY, connectorY1, connectorY2;
      if (dotY < PLOT_TOP + PLOT_HEIGHT * 0.5) {
        tooltipY = dotY + tooltipDropDistance;
        connectorY1 = dotY + 7;
        connectorY2 = tooltipY;
      } else {
        tooltipY = dotY - tooltipDropDistance - tooltipHeight;
        connectorY1 = dotY - 7;
        connectorY2 = tooltipY + tooltipHeight;
      }

      let tooltipX = dotX - tooltipWidth / 2;
      if (tooltipX < PLOT_LEFT) tooltipX = PLOT_LEFT;
      if (tooltipX + tooltipWidth > PLOT_RIGHT) tooltipX = PLOT_RIGHT - tooltipWidth;

      const probPct = (dotProb * 100).toFixed(0) + '%';
      const tooltipLine1Text = isOffChart
        ? `Off-chart · Score ${safeScore}`
        : `${formatDollars(safeAsk)} · Score ${safeScore}`;

      const refLowDollars = REF_LOW_PCT * safePropVal;
      const refHighDollars = REF_HIGH_PCT * safePropVal;
      const askValueColor = isOffChart ? '#DC2626' : '#7B8BFF';

      // Static gradient ID — only one curve renders per page
      const gradId = 'd36-curve-gradient';

      // D36 dark-motif pass (2026-05-07): per Jared's "matches the rest of the page"
      // ask, swapped from the v10 white-tile design to the glass dark motif used by
      // every other Page 4 tile. PREVIEW ribbon, curve, reference range, and
      // off-chart banner stay distinctive (visual identity preserved); the tile
      // chrome and text colors flip to dark/light.
      return (
        <div
          data-pdf-section="concession-probability-curve"
          className="glass rounded-2xl"
          style={{
            padding: '24px',
            position: 'relative',
            overflow: 'hidden',
            color: 'white',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            lineHeight: 1.5
          }}
        >
          {/* PREVIEW ribbon */}
          <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            background: '#E1E0FF',
            color: '#4A4070',
            padding: '4px 12px',
            fontSize: '10px',
            fontWeight: 600,
            letterSpacing: '0.04em',
            borderBottomLeftRadius: '8px'
          }}>
            PREVIEW · Activates with live data
          </div>

          <div style={{ fontSize: '18px', fontWeight: 700, color: 'white', marginBottom: '4px' }}>
            Where Your Ask Lands
          </div>
          <div style={{ fontSize: '13px', color: '#a8a29e', marginBottom: '20px' }}>
            Probability of close, modeled across comparable Portland metro deals
          </div>

          <svg viewBox="0 0 660 320" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: 'auto', display: 'block', margin: '8px 0 0 0' }}>
            <defs>
              <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#7B8BFF"/>
                <stop offset="100%" stopColor="#7B8BFF" stopOpacity="0"/>
              </linearGradient>
            </defs>

            {/* Y-axis grid lines */}
            <g stroke="rgba(255,255,255,0.08)" strokeWidth="1">
              <line x1="60" y1="60" x2="640" y2="60"/>
              <line x1="60" y1="120" x2="640" y2="120"/>
              <line x1="60" y1="180" x2="640" y2="180"/>
              <line x1="60" y1="240" x2="640" y2="240"/>
            </g>

            {/* Y-axis labels */}
            <g fontFamily="-apple-system, sans-serif" fontSize="11" fill="#9CA3AF">
              <text x="50" y="64" textAnchor="end">100%</text>
              <text x="50" y="124" textAnchor="end">75%</text>
              <text x="50" y="184" textAnchor="end">50%</text>
              <text x="50" y="244" textAnchor="end">25%</text>
            </g>

            {/* X-axis line */}
            <line x1="60" y1="240" x2="640" y2="240" stroke="rgba(255,255,255,0.18)" strokeWidth="1.5"/>

            {/* X-axis tick labels (dollars stacked above percentages) */}
            <g fontFamily="-apple-system, sans-serif" fontSize="11" fill="#9CA3AF">
              {labelPcts.filter(pct => pct <= X_AXIS_MAX_PCT).map(pct => {
                const x = pctToX(pct);
                const dollars = pct * safePropVal;
                return (
                  <g key={pct}>
                    <text x={x} y="265" textAnchor="middle">{formatDollars(dollars)}</text>
                    <text x={x} y="252" textAnchor="middle" fontSize="9" fill="#6B7280">{(pct * 100).toFixed(0)}%</text>
                  </g>
                );
              })}
            </g>

            <text x="350" y="290" textAnchor="middle" fontFamily="-apple-system, sans-serif" fontSize="11" fill="#a8a29e" fontStyle="italic">Ask Amount (% of property value)</text>

            {/* Reference range — "WHERE DEALS CLOSE" */}
            <rect x={refLowX} y="60" width={refHighX - refLowX} height="180" fill="#10B981" opacity="0.08"/>
            <line x1={refLowX} y1="60" x2={refLowX} y2="240" stroke="#10B981" strokeWidth="1" strokeDasharray="4,3" opacity="0.7"/>
            <line x1={refHighX} y1="60" x2={refHighX} y2="240" stroke="#10B981" strokeWidth="1" strokeDasharray="4,3" opacity="0.7"/>
            <text x={refMidX} y="55" textAnchor="middle" fontFamily="-apple-system, sans-serif" fontSize="9" fill="#34D399" fontWeight="600" letterSpacing="0.08em">WHERE DEALS CLOSE</text>

            {/* Curve fill + stroke */}
            <path d={areaD} fill={`url(#${gradId})`} opacity="0.18"/>
            <path d={pathD} fill="none" stroke="#7B8BFF" strokeWidth="3" strokeLinecap="round"/>

            {/* Dot + dashed vertical drop line — inverted from the v10 reference for the dark motif */}
            <line x1={dotX} y1="60" x2={dotX} y2="240" stroke="rgba(255,255,255,0.5)" strokeWidth="1" strokeDasharray="3,3"/>
            <circle cx={dotX} cy={dotY} r="7" fill="white"/>
            <circle cx={dotX} cy={dotY} r="4" fill="#1A1B2E"/>

            {/* Tooltip + connector */}
            <line x1={dotX} y1={connectorY1} x2={dotX} y2={connectorY2} stroke="rgba(255,255,255,0.6)" strokeWidth="1.5"/>
            <rect x={tooltipX} y={tooltipY} width={tooltipWidth} height={tooltipHeight} rx="4" fill="#0a0a0a" stroke="rgba(255,255,255,0.18)" strokeWidth="1"/>
            <text x={tooltipX + tooltipWidth/2} y={tooltipY + 14} textAnchor="middle" fontFamily="-apple-system, sans-serif" fontSize="10" fill="#9CA3AF">{tooltipLine1Text}</text>
            <text x={tooltipX + tooltipWidth/2} y={tooltipY + 28} textAnchor="middle" fontFamily="-apple-system, sans-serif" fontSize="12" fill="white" fontWeight="700">{probPct} close prob.</text>
          </svg>

          {/* Readout panel */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '16px',
            marginTop: '16px',
            paddingTop: '16px',
            borderTop: '1px solid rgba(255,255,255,0.1)'
          }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '11px', color: '#a8a29e', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>
                Current Ask · Game Plan Score
              </span>
              <span style={{ fontSize: '16px', fontWeight: 600, color: 'white' }}>
                {formatDollarsExact(safeAsk)} · Score {safeScore} · <span style={{ color: askValueColor }}>{probPct} close</span>
              </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '11px', color: '#a8a29e', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>
                Where Deals Close
              </span>
              <span style={{ fontSize: '16px', fontWeight: 600, color: 'white' }}>
                {formatDollarsExact(refLowDollars)} – {formatDollarsExact(refHighDollars)} <span style={{ color: '#a8a29e', fontWeight: 500 }}>· 2–3% of value</span>
              </span>
            </div>
          </div>

          {/* Off-chart banner — only renders when ask exceeds 6% of property value */}
          {isOffChart && (
            <div style={{
              marginTop: '12px',
              padding: '10px 14px',
              background: '#FEF3C7',
              borderLeft: '3px solid #F59E0B',
              borderRadius: '4px',
              fontSize: '12px',
              color: '#92400E',
              lineHeight: 1.5
            }}>
              <strong>Off-chart ask:</strong> {formatDollarsExact(safeAsk)} is {(askPct * 100).toFixed(1)}% of property value, beyond our typical analytical range. Score {safeScore} reflects this position.
            </div>
          )}
        </div>
      );
    };

    // ================================================================
    // FACTOR INPUT COMPONENT (defined outside main component to prevent re-mounting)
    // ================================================================
    const FactorInput = ({ factor, onUpdate, colorScheme, justificationOptions, justification, onJustificationChange, isLegacyReport, variant }) => {
      // D32-C punchlist: variant='agent-input' suppresses the enable/disable
      // checkbox (always required) and the legacy "Add context (optional)" note
      // input (redundant with the new justification dropdown). Default variant
      // keeps the original UI for buyer-input sliders (which still allow opt-out
      // until D32-B replaces them with SMS-pending placeholders).
      const isAgentInput = variant === 'agent-input';
      const colors = colorScheme === 'buyer'
        ? { bg: 'bg-emerald-500/10', border: 'border-emerald-500/30', accent: 'text-emerald-400', dot: 'bg-emerald-500', dotOff: 'bg-white/20', checkbox: 'bg-emerald-500', weight: 'bg-emerald-600/30 text-emerald-300' }
        : colorScheme === 'seller'
        ? { bg: 'bg-rose-500/10', border: 'border-rose-500/30', accent: 'text-rose-400', dot: 'bg-rose-500', dotOff: 'bg-white/20', checkbox: 'bg-rose-500', weight: 'bg-rose-600/30 text-rose-300' }
        // D32-C: neutral palette strips green/red leverage tells
        : { bg: 'bg-stone-800/40', border: 'border-stone-700/60', accent: 'text-stone-300', dot: 'bg-stone-300', dotOff: 'bg-white/15', checkbox: 'bg-stone-500', weight: 'bg-stone-700/50 text-stone-300' };

      return (
        <div className={`p-4 rounded-xl border mb-3 transition-all ${factor.enabled ? `${colors.bg} ${colors.border}` : 'bg-white/5 border-white/10 opacity-50'}`}>
          <div className="flex justify-between items-start mb-2">
            <div className="flex items-start gap-3">
              {/* D32-C punchlist: agent-input variant suppresses the enable/disable
                  checkbox entirely. The 3 agent-input sliders are always required
                  and have no opt-out semantics. */}
              {!isAgentInput && (
                <button
                  onClick={(e) => { e.stopPropagation(); onUpdate({ ...factor, enabled: !factor.enabled }); }}
                  className={`w-5 h-5 rounded border-2 flex items-center justify-center mt-0.5 transition-all flex-shrink-0 ${
                    factor.enabled ? `${colors.checkbox} border-transparent` : 'border-white/30 bg-transparent'
                  }`}
                >
                  {factor.enabled && (
                    <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </button>
              )}
              <div>
                <div className="flex items-center gap-2">
                  <label className={`text-sm font-semibold ${factor.enabled ? 'text-white/90' : 'text-white/50'}`}>
                    {factor.label}
                  </label>
                </div>
                {factor.enabled && factor.research && (
                  <p className="text-xs text-white/30 mt-0.5">{factor.research}</p>
                )}
              </div>
            </div>
            {factor.enabled && (
              <div className="flex items-center gap-1">
                {/* Bug fix: dots were lighting whenever n <= factor.value, but value
                    range is 1-10 — so any value ≥5 lit all 5 dots, making midpoint
                    look like maximum. Divide value by 2 (ceil) so the dot count is
                    a true normalized indicator: 1-2→1, 3-4→2, 5-6→3, 7-8→4, 9-10→5. */}
                {[1,2,3,4,5].map(n => (
                  <div key={n} className={`w-2 h-2 rounded-full transition-all ${n <= Math.ceil(factor.value / 2) ? colors.dot : colors.dotOff}`} />
                ))}
              </div>
            )}
          </div>

          {factor.enabled && (
            <>
              {/* Slider with Labels */}
              <div className="mt-3">
                <input
                  type="range" min="1" max="10" value={factor.value}
                  onChange={(e) => onUpdate({ ...factor, value: parseInt(e.target.value) })}
                  className="w-full h-2 rounded-lg appearance-none cursor-pointer"
                />
                <div className="flex justify-between mt-1">
                  <span className="text-xs text-white/40">{factor.lowLabel}</span>
                  <span className="text-xs text-white/40">{factor.highLabel}</span>
                </div>
              </div>

              {/* Optional Note — D32-C punchlist: suppressed for agent-input variant
                  because the new justification dropdown replaces it (and having both
                  visible was redundant + confusing). Default variant keeps it. */}
              {!isAgentInput && (
                <input
                  type="text" value={factor.note}
                  onChange={(e) => onUpdate({ ...factor, note: e.target.value })}
                  placeholder="Add context (optional)"
                  className="w-full mt-3 px-3 py-2 text-sm bg-black/30 border border-white/10 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-transparent text-white placeholder-white/30"
                />
              )}

              {/* D32-C + post-Andrew polish: Required justification dropdown for
                  agent-input sliders. Always shown when justificationOptions provided
                  (not just when slider is moved off default) — per Jared 2026-05-05:
                  CYA paper trail requires the agent to provide a reason for EVERY
                  rating including default-position holds. Validation gate enforces
                  presence on all 3 agent inputs before Step 4 transition.
                  For legacy reports, shows a small contextual note above the dropdown
                  but the dropdown REMAINS USABLE — agents can optionally add
                  justification to old reports without being blocked. */}
              {justificationOptions && (
                <div className="mt-3">
                  <div className="flex items-center gap-1 mb-1.5">
                    <label className="text-xs uppercase tracking-wider text-white/60">Why?</label>
                    <span
                      className="text-xs text-white/30 cursor-help"
                      title="This justification helps document your professional reasoning for this rating. It will appear on the printed report and in any future dispute records."
                    >ⓘ</span>
                    {!isLegacyReport && (
                      <span className="text-xs text-amber-400/80 ml-auto">required</span>
                    )}
                  </div>
                  {/* D32-C punchlist fix: legacy reports now ALSO get the dropdown
                      (with a small contextual note above), instead of the dropdown
                      being replaced by the placeholder. Agent can OPTIONALLY add
                      justification to old reports — submission is still not blocked
                      for legacy reports per validation logic upstream. */}
                  {isLegacyReport && (!justification || !justification.type) && (
                    <div className="text-xs italic text-white/50 mb-2">
                      (No justification was recorded when this report was originally saved. You can optionally add one now.)
                    </div>
                  )}
                  <select
                    value={justification?.type || ''}
                    onChange={(e) => {
                      const selected = e.target.value;
                      if (!selected) {
                        onJustificationChange?.(null);
                      } else if (selected === D32C_OTHER_SENTINEL) {
                        // Switching to Other; preserve any existing free-text content
                        onJustificationChange?.({ type: D32C_OTHER_SENTINEL, text: justification?.type === D32C_OTHER_SENTINEL ? (justification.text || '') : '' });
                      } else {
                        // Canned option: text equals the selection
                        onJustificationChange?.({ type: selected, text: selected });
                      }
                    }}
                    className="w-full px-3 py-2 text-sm bg-stone-800 border border-stone-600 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-brand-500 text-white"
                  >
                    <option value="">Select a reason…</option>
                    {justificationOptions.map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                  {justification?.type === D32C_OTHER_SENTINEL && (
                    <textarea
                      value={justification?.text || ''}
                      onChange={(e) => onJustificationChange?.({ type: D32C_OTHER_SENTINEL, text: e.target.value.slice(0, 500) })}
                      placeholder="Briefly describe your reasoning (30+ chars recommended)"
                      rows={2}
                      className="w-full mt-2 px-3 py-2 text-sm bg-stone-800 border border-stone-600 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-brand-500 text-white placeholder-white/40 resize-y"
                    />
                  )}
                  {justification?.type === D32C_OTHER_SENTINEL && (justification?.text || '').trim().length > 0 && (justification?.text || '').trim().length < 30 && (
                    <div className="text-xs text-amber-400/70 mt-1">Please add at least one specific reason ({30 - (justification?.text || '').trim().length} more chars).</div>
                  )}
                </div>
              )}
            </>
          )}

          {!factor.enabled && (
            <p className="text-xs text-white/30 mt-1 ml-8">Not applicable to this deal</p>
          )}
        </div>
      );
    };

    // ============================================================
    // v4.5: AUTH SCREEN COMPONENT
    // ============================================================
    const AuthScreen = ({
      authView, setAuthView,
      authEmail, setAuthEmail,
      authPassword, setAuthPassword,
      authName, setAuthName,
      authError,
      handleSignIn, handleSignUp, handleGoogleSignIn, handleForgotPassword
    }) => {
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="glass rounded-2xl p-8 w-full max-w-md">
            <div className="flex items-center justify-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gradient-to-br from-brand-500 to-brand-600 rounded-xl flex items-center justify-center overflow-hidden">
                <img src={window.KNIGHT_LOGO_SRC} alt="Gambit Lab" className="w-full h-full object-contain" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-white">Game Plan PPG<sup className="text-sm">™</sup></h1>
                <p className="text-xs text-stone-400">by Gambit Lab</p>
              </div>
            </div>
            <button onClick={handleGoogleSignIn} className="w-full flex items-center justify-center gap-3 bg-white text-gray-800 font-medium py-3 px-4 rounded-lg hover:bg-gray-100 transition-colors mb-4">
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Continue with Google
            </button>
            <div className="flex items-center gap-4 my-6">
              <div className="flex-1 h-px bg-stone-700"></div>
              <span className="text-stone-500 text-sm">or</span>
              <div className="flex-1 h-px bg-stone-700"></div>
            </div>
            <form onSubmit={authView === 'login' ? handleSignIn : authView === 'signup' ? handleSignUp : handleForgotPassword}>
              {authView === 'signup' && (
                <div className="mb-4">
                  <label className="block text-sm font-medium text-stone-400 mb-1">Full Name</label>
                  <input type="text" value={authName} onChange={(e) => setAuthName(e.target.value)} className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-3 text-white focus:border-brand-500 focus:outline-none" placeholder="Jane Smith" required />
                </div>
              )}
              <div className="mb-4">
                <label className="block text-sm font-medium text-stone-400 mb-1">Email</label>
                <input type="email" value={authEmail} onChange={(e) => setAuthEmail(e.target.value)} className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-3 text-white focus:border-brand-500 focus:outline-none" placeholder="you@example.com" required />
              </div>
              {authView !== 'forgot' && (
                <div className="mb-6">
                  <label className="block text-sm font-medium text-stone-400 mb-1">Password</label>
                  <input type="password" value={authPassword} onChange={(e) => setAuthPassword(e.target.value)} className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-3 text-white focus:border-brand-500 focus:outline-none" placeholder="••••••••" required minLength={6} />
                </div>
              )}
              {/* D38: signup consent checkbox removed from the email/password
                  form — captured instead by the universal post-auth
                  SignupConsentGate, which fires for every signup path. */}
              {authError && (
                <div className={`mb-4 p-3 rounded-lg text-sm ${authError.includes('Check your email') ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>
                  {authError}
                </div>
              )}
              <button type="submit" className="w-full bg-gradient-to-r from-brand-500 to-brand-600 text-white font-semibold py-3 px-4 rounded-lg hover:opacity-90 transition-opacity">
                {authView === 'login' ? 'Sign In' : authView === 'signup' ? 'Create Account' : 'Send Reset Link'}
              </button>
            </form>
            <div className="mt-6 text-center text-sm">
              {authView === 'login' && (
                <>
                  <button onClick={() => { setAuthView('forgot'); }} className="text-stone-400 hover:text-white transition-colors">Forgot password?</button>
                  <div className="mt-2">
                    <span className="text-stone-500">Don't have an account? </span>
                    <button onClick={() => { setAuthView('signup'); }} className="text-brand-400 hover:text-brand-300 transition-colors">Sign up</button>
                  </div>
                </>
              )}
              {authView === 'signup' && (
                <div>
                  <span className="text-stone-500">Already have an account? </span>
                  <button onClick={() => { setAuthView('login'); }} className="text-brand-400 hover:text-brand-300 transition-colors">Sign in</button>
                </div>
              )}
              {authView === 'forgot' && (
                <button onClick={() => { setAuthView('login'); }} className="text-brand-400 hover:text-brand-300 transition-colors">Back to sign in</button>
              )}
            </div>
          </div>
        </div>
      );
    };


    // ============================================================
    // D10: PPG LANDING PAGE (rewritten 2026-04-20)
    // Flat design, no gradients/shadows. Copy spec: directive D10 Part 3.
    // ============================================================
    const LandingPage = ({ onSignIn }) => {
      const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
      const ACCENT = '#06b6d4';
      const BG = '#0a0e1a';
      const MUTED = '#94a3b8';

      const scrollToHow = (e) => {
        if (e) e.preventDefault();
        const el = document.getElementById('how-it-works');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      return (
        <div style={{ background: BG, minHeight: '100vh', color: 'white', fontFamily: 'inherit' }}>
          {/* ============================== NAV ============================== */}
          <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 50, background: 'rgba(10,14,26,0.85)', backdropFilter: 'blur(8px)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex items-center justify-between" style={{ height: '64px' }}>
                <div className="flex items-center" style={{ gap: '10px' }}>
                  <img src="./assets/gambit-knight-logo.png" alt="Gambit Knight" style={{ height: '24px', width: 'auto' }} />
                  <span style={{ fontSize: '16px', fontWeight: 500, color: 'white' }}>
                    Game Plan <span style={{ color: ACCENT }}>PPG</span><sup style={{ fontSize: '0.65em', marginLeft: '2px', opacity: 0.75 }}>™</sup>
                  </span>
                </div>
                <div className="hidden md:flex items-center" style={{ gap: '24px' }}>
                  <a href="#how-it-works" onClick={scrollToHow} style={{ color: MUTED, fontSize: '14px', textDecoration: 'none' }}>How it works</a>
                  <button onClick={onSignIn} style={{ padding: '8px 16px', background: 'rgba(255,255,255,0.08)', color: 'white', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }}>
                    Sign in
                  </button>
                </div>
                <div className="md:hidden">
                  <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} style={{ color: 'white', background: 'transparent', border: 'none', cursor: 'pointer' }}>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            {mobileMenuOpen && (
              <div className="md:hidden" style={{ borderTop: '1px solid rgba(255,255,255,0.05)', background: BG }}>
                <div className="px-4 py-4" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  <a href="#how-it-works" onClick={(e) => { scrollToHow(e); setMobileMenuOpen(false); }} style={{ color: MUTED, fontSize: '14px', textDecoration: 'none' }}>How it works</a>
                  <button onClick={onSignIn} style={{ padding: '8px 16px', background: 'rgba(255,255,255,0.08)', color: 'white', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', fontSize: '14px', fontWeight: 500, cursor: 'pointer', textAlign: 'center' }}>
                    Sign in
                  </button>
                </div>
              </div>
            )}
          </nav>

          {/* ============================== HERO ============================== */}
          <section style={{ paddingTop: '128px', paddingBottom: '80px', paddingLeft: '16px', paddingRight: '16px' }}>
            <div className="max-w-7xl mx-auto" style={{ textAlign: 'center' }}>
              {/* Badge */}
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '6px 12px', background: 'rgba(123,139,255,0.12)', border: '1px solid rgba(123,139,255,0.25)', borderRadius: '999px', fontSize: '12px', color: ACCENT, marginBottom: '32px' }}>
                <span style={{ width: '6px', height: '6px', background: ACCENT, borderRadius: '999px' }}></span>
                Built for Premiere Property Group
              </div>

              {/* Headline */}
              <h1 className="text-4xl sm:text-6xl" style={{ fontWeight: 500, lineHeight: 1.1, color: 'white', marginBottom: '24px', letterSpacing: '-0.02em' }}>
                Know the odds.<br/>
                <span style={{ color: ACCENT }}>Close the deal.</span>
              </h1>

              {/* Subheading */}
              <p style={{ maxWidth: '440px', margin: '0 auto 40px', fontSize: '16px', lineHeight: 1.55, color: MUTED }}>
                Turn any inspection report into a Game Plan Score — the credible negotiation anchor you can point your client at.
              </p>

              {/* Score card mockup (static marketing element — flat solid blue) */}
              <div style={{ maxWidth: '400px', margin: '0 auto 32px', background: '#1e40af', borderRadius: '14px', padding: '24px', color: 'white', textAlign: 'left' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  <div style={{ flexShrink: 0 }}>
                    <div style={{ fontSize: '64px', fontWeight: 500, lineHeight: 1, color: 'white' }}>7</div>
                    <div style={{ fontSize: '10px', letterSpacing: '0.15em', color: 'rgba(255,255,255,0.65)', marginTop: '2px' }}>OUT OF 10</div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '11px', letterSpacing: '0.12em', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase' }}>Game Plan Score</div>
                    <div style={{ fontSize: '16px', fontWeight: 500, color: 'white', marginTop: '2px' }}>Solid position</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '8px' }}>
                      <span style={{ width: '6px', height: '6px', borderRadius: '999px', background: 'white' }}></span>
                      <span style={{ width: '6px', height: '6px', borderRadius: '999px', background: 'white' }}></span>
                      <span style={{ width: '6px', height: '6px', borderRadius: '999px', background: 'rgba(255,255,255,0.25)' }}></span>
                      <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.85)', marginLeft: '4px' }}>Moderate confidence</span>
                    </div>
                    <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.65)', marginTop: '6px' }}>Based on 14 similar Portland deals</div>
                  </div>
                </div>
              </div>

              {/* CTAs */}
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '12px', marginBottom: '24px' }}>
                <button onClick={onSignIn} style={{ padding: '12px 24px', background: '#7b8bff', color: BG, border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: 500, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                  <svg style={{ width: '18px', height: '18px' }} viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  Sign in with Google
                </button>
                <a href="#how-it-works" onClick={scrollToHow} style={{ padding: '12px 24px', background: 'transparent', color: 'white', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', fontSize: '15px', fontWeight: 500, textDecoration: 'none', cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                  See how it works
                </a>
              </div>

              {/* Feature pills */}
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '8px' }}>
                {['1–10 deal likelihood', 'Contractor-verified costs', 'Shareable analysis'].map(p => (
                  <span key={p} style={{ padding: '6px 12px', background: 'rgba(255,255,255,0.04)', color: MUTED, border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', fontSize: '11px' }}>
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </section>

          {/* ============================== THREE PILLARS ============================== */}
          <section style={{ paddingTop: '80px', paddingBottom: '80px', paddingLeft: '16px', paddingRight: '16px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
            <div className="max-w-5xl mx-auto">
              <h2 style={{ textAlign: 'center', fontSize: '28px', fontWeight: 500, color: 'white', marginBottom: '48px', letterSpacing: '-0.01em' }}>
                What makes PPG different.
              </h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '32px' }}>
                {[
                  { title: 'Know where you stand.', body: 'Every analysis gets a 1-10 Game Plan Score — a credible deal-likelihood anchor rooted in leverage data, market context, and outcome patterns.' },
                  { title: 'Keep agents out of the cost game.', body: "Attach contractor quotes or let your client enter their own numbers. You're not liable for cost estimates you didn't produce." },
                  { title: 'One document, both sides.', body: 'Share your analysis with the listing agent. Negotiate against the same set of facts. No more dueling spreadsheets.' }
                ].map((p, i) => (
                  <div key={i}>
                    <h3 style={{ fontSize: '17px', fontWeight: 500, color: 'white', marginBottom: '12px' }}>{p.title}</h3>
                    <p style={{ fontSize: '14px', lineHeight: 1.6, color: MUTED }}>{p.body}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ============================== HOW IT WORKS ============================== */}
          <section id="how-it-works" style={{ paddingTop: '80px', paddingBottom: '80px', paddingLeft: '16px', paddingRight: '16px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
            <div className="max-w-5xl mx-auto">
              <h2 style={{ textAlign: 'center', fontSize: '28px', fontWeight: 500, color: 'white', marginBottom: '48px', letterSpacing: '-0.01em' }}>
                How it works.
              </h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '32px' }}>
                {[
                  { num: '01', title: 'Upload the inspection.', body: 'Drag and drop the PDF. We extract every finding and categorize it by severity.' },
                  { num: '02', title: 'Get your Game Plan Score.', body: 'See the 1-10 score instantly, with the four factors behind it and a confidence indicator.' },
                  { num: '03', title: 'Share with the other side.', body: 'Generate a link the listing agent can view. Both sides negotiate from the same analysis.' }
                ].map((s, i) => (
                  <div key={i}>
                    <div style={{ fontSize: '13px', color: ACCENT, fontWeight: 500, marginBottom: '8px', letterSpacing: '0.05em' }}>{s.num}</div>
                    <h3 style={{ fontSize: '17px', fontWeight: 500, color: 'white', marginBottom: '12px' }}>{s.title}</h3>
                    <p style={{ fontSize: '14px', lineHeight: 1.6, color: MUTED }}>{s.body}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ============================== FINAL CTA ============================== */}
          <section style={{ paddingTop: '80px', paddingBottom: '96px', paddingLeft: '16px', paddingRight: '16px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
            <div className="max-w-3xl mx-auto" style={{ textAlign: 'center' }}>
              <h2 style={{ fontSize: '28px', fontWeight: 500, color: 'white', marginBottom: '12px', letterSpacing: '-0.01em' }}>
                Ready to try it on your next deal?
              </h2>
              <p style={{ fontSize: '14px', color: MUTED, marginBottom: '24px' }}>
                Sign in with Google to get started. Takes 30 seconds.
              </p>
              <button onClick={onSignIn} style={{ padding: '12px 24px', background: '#7b8bff', color: BG, border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: 500, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <svg style={{ width: '18px', height: '18px' }} viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Sign in with Google
              </button>
            </div>
          </section>

          {/* ============================== FOOTER ============================== */}
          <footer style={{ padding: '48px 16px', borderTop: '1px solid rgba(255,255,255,0.05)', background: BG }}>
            <div className="max-w-7xl mx-auto">
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '32px', marginBottom: '40px' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                    <img src="./assets/gambit-knight-logo.png" alt="Gambit Knight" style={{ height: '20px', width: 'auto' }} />
                    <span style={{ fontSize: '14px', fontWeight: 500, color: 'white' }}>
                      Game Plan <span style={{ color: ACCENT }}>PPG</span>
                    </span>
                  </div>
                  <p style={{ fontSize: '13px', lineHeight: 1.55, color: MUTED, maxWidth: '280px' }}>
                    Science-backed negotiation strategy, built for PPG agents.
                  </p>
                </div>
                <div>
                  <h4 style={{ fontSize: '12px', color: 'white', marginBottom: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 500 }}>Product</h4>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <li><a href="#how-it-works" onClick={scrollToHow} style={{ fontSize: '13px', color: MUTED, textDecoration: 'none' }}>How it works</a></li>
                  </ul>
                </div>
                <div>
                  <h4 style={{ fontSize: '12px', color: 'white', marginBottom: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 500 }}>Contact</h4>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <li><a href="mailto:jared@gambitlab.org" style={{ fontSize: '13px', color: MUTED, textDecoration: 'none' }}>jared@gambitlab.org</a></li>
                    <li><a href="mailto:support@gameplanppg.ai" style={{ fontSize: '13px', color: MUTED, textDecoration: 'none' }}>support@gameplanppg.ai</a></li>
                  </ul>
                </div>
              </div>
              <div style={{ paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '12px' }}>
                  <p style={{ fontSize: '12px', color: MUTED, margin: 0 }}>© 2026 Gambit Lab LLC. All rights reserved.</p>
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <a href="/privacy.html" style={{ fontSize: '12px', color: MUTED, textDecoration: 'none' }}>Privacy</a>
                    <a href="/terms.html" style={{ fontSize: '12px', color: MUTED, textDecoration: 'none' }}>Terms</a>
                  </div>
                </div>
                <p style={{ fontSize: '11px', color: '#6b7280', lineHeight: 1.6, marginTop: '20px', maxWidth: '900px' }}>
                  Disclaimer: Game Plan PPG™ provides negotiation strategy recommendations based on inspection report analysis.
                  Actual repair costs may vary based on local market conditions, contractor availability, and property-specific factors.
                  This tool is designed to assist licensed real estate professionals and should not be considered a substitute for professional
                  inspection, contractor estimates, or legal advice. Results may vary.
                </p>
              </div>
            </div>
          </footer>
        </div>
      );
    };

    // ============================================================
    // D10: OLD LANDING PAGE REMOVED — preserved in src/index.html.backup-pre-d10
    // ============================================================

    // ============================================================
    // D12: REQUEST ACCESS SCREEN (non-whitelisted authenticated users)
    // ============================================================
    const RequestAccessScreen = ({ user, onSignOut }) => {
      const ACCENT = '#7b8bff';
      const BG = '#0a0e1a';
      const MUTED = '#94a3b8';
      // Log the denied access for monitoring
      React.useEffect(() => {
        if (!user?.id) return;
        (async () => {
          try {
            await supabaseClient.from('data_events').insert({
              event_type: 'access_denied_non_whitelist',
              user_id: user.id,
              metadata: { email: user.email, signed_in_at: new Date().toISOString() }
            });
          } catch (err) {
            console.warn('data_events log failed:', err);
          }
        })();
      }, [user?.id]);

      return (
        <div style={{ background: BG, minHeight: '100vh', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ maxWidth: '480px', width: '100%', textAlign: 'center' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '32px' }}>
              <img src="./assets/gambit-knight-logo.png" alt="Gambit Knight" style={{ height: '28px', width: 'auto' }} />
              <span style={{ fontSize: '18px', fontWeight: 500 }}>
                Game Plan <span style={{ color: ACCENT }}>PPG</span><sup style={{ fontSize: '0.65em', marginLeft: '2px', opacity: 0.75 }}>™</sup>
              </span>
            </div>
            <h1 style={{ fontSize: '28px', fontWeight: 500, marginBottom: '16px', letterSpacing: '-0.01em' }}>
              You're signed in, but not yet approved.
            </h1>
            <p style={{ fontSize: '15px', lineHeight: 1.6, color: MUTED, marginBottom: '24px' }}>
              Game Plan PPG is in limited beta with Premiere Property Group agents. Your account has been created but needs manual approval before you can access the product.
            </p>
            <p style={{ fontSize: '14px', lineHeight: 1.6, color: MUTED, marginBottom: '32px' }}>
              If you believe you should have access, reach out to{' '}
              <a href="mailto:jared@gambitlab.org" style={{ color: ACCENT, textDecoration: 'none' }}>jared@gambitlab.org</a>
              {' '}with your name, brokerage, and a note about how you heard about us.
            </p>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '24px' }}>
              Signed in as <span style={{ color: MUTED }}>{user?.email || 'unknown'}</span>
            </div>
            <button
              onClick={onSignOut}
              style={{
                padding: '10px 20px',
                background: 'transparent',
                color: 'white',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 500,
                cursor: 'pointer'
              }}>
              Sign out
            </button>
          </div>
        </div>
      );
    };

    // ============================================================
    // D38: SIGNUP CONSENT GATE (universal, pre-whitelist)
    //
    // Renders for any signed-in user without a 'signup'-source row in
    // sms_consent_attestations. Fires before the whitelist check so that
    // EVERY signup path (Google OAuth, email/password, pre-whitelisted bulk
    // pilot) is captured in a single funnel. TCR auditors see this screen by
    // signing in with their own Google account — no greenlight required from
    // us, since the gate predates the whitelist enforcement.
    // ============================================================
    const SignupConsentGate = ({ user, onConfirm, onSignOut }) => {
      const ACCENT = '#7b8bff';
      const BG = '#0a0e1a';
      const MUTED = '#94a3b8';
      const [checked, setChecked] = React.useState(false);
      const [submitting, setSubmitting] = React.useState(false);
      const [errorMsg, setErrorMsg] = React.useState('');

      const handleConfirm = async () => {
        if (!checked || submitting) return;
        setSubmitting(true);
        setErrorMsg('');
        const result = await onConfirm();
        if (!result?.ok) {
          setErrorMsg(result?.error || 'Could not record consent. Try again or sign out.');
          setSubmitting(false);
        }
        // On success, parent flips signupAttestationStatus to 'present' and the
        // render switch falls through to the next view; this component unmounts.
      };

      return (
        <div style={{ background: BG, minHeight: '100vh', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ maxWidth: '560px', width: '100%' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '32px' }}>
              <img src="./assets/gambit-knight-logo.png" alt="Gambit Knight" style={{ height: '28px', width: 'auto' }} />
              <span style={{ fontSize: '18px', fontWeight: 500 }}>
                Game Plan <span style={{ color: ACCENT }}>PPG</span><sup style={{ fontSize: '0.65em', marginLeft: '2px', opacity: 0.75 }}>™</sup>
              </span>
            </div>
            <h1 style={{ fontSize: '28px', fontWeight: 500, marginBottom: '12px', letterSpacing: '-0.01em' }}>
              One quick consent step
            </h1>
            <p style={{ fontSize: '15px', lineHeight: 1.6, color: MUTED, marginBottom: '24px' }}>
              Before you use Game Plan, please review and confirm our Terms, Privacy Policy, and text-messaging terms. This is a one-time step required to activate your account.
            </p>

            <label htmlFor="d38ConsentCheckbox" style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', padding: '16px', borderRadius: '12px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', cursor: submitting ? 'wait' : 'pointer', marginBottom: '20px' }}>
              <input
                id="d38ConsentCheckbox"
                type="checkbox"
                checked={checked}
                disabled={submitting}
                onChange={(e) => setChecked(e.target.checked)}
                style={{ marginTop: '4px', width: '16px', height: '16px', flexShrink: 0, accentColor: ACCENT, cursor: submitting ? 'wait' : 'pointer' }}
              />
              <span style={{ fontSize: '13px', lineHeight: 1.6, color: '#cbd5e1' }}>
                I agree to the{' '}
                <a href="/terms" target="_blank" rel="noopener" style={{ color: ACCENT, textDecoration: 'underline' }}>Terms of Service</a>
                {' '}and{' '}
                <a href="/privacy" target="_blank" rel="noopener" style={{ color: ACCENT, textDecoration: 'underline' }}>Privacy Policy</a>
                . I understand that Game Plan may send me transactional and outcome-tracking SMS messages tied to negotiation reports I generate. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.
              </span>
            </label>

            {errorMsg && (
              <div style={{ marginBottom: '16px', padding: '12px', borderRadius: '8px', background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.4)', fontSize: '13px', color: '#fca5a5' }}>
                {errorMsg}
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '20px' }}>
              <button
                onClick={handleConfirm}
                disabled={!checked || submitting}
                style={{
                  padding: '12px 24px',
                  background: !checked || submitting ? 'rgba(123,139,255,0.4)' : ACCENT,
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: !checked || submitting ? 'not-allowed' : 'pointer'
                }}>
                {submitting ? 'Saving…' : 'Continue'}
              </button>
              <button
                onClick={onSignOut}
                disabled={submitting}
                style={{
                  padding: '12px 20px',
                  background: 'transparent',
                  color: MUTED,
                  border: '1px solid rgba(255,255,255,0.2)',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: submitting ? 'wait' : 'pointer'
                }}>
                Sign out
              </button>
            </div>

            <div style={{ fontSize: '12px', color: '#6b7280' }}>
              Signed in as <span style={{ color: MUTED }}>{user?.email || 'unknown'}</span>
            </div>
          </div>
        </div>
      );
    };

    // ============================================================
    // D39: CONTRACTOR QUOTE UPLOAD MODAL
    //
    // Multi-step modal for the new LLM-extraction quote flow. Renders one of:
    //   - idle:        drop zone (drag PDF or click to browse)
    //   - extracting:  spinner while Claude parses the PDF
    //   - confirm:     extraction result UI, branched on extraction.type:
    //                    single | line_items | multi_option | unclear
    //   - override:    structured-reason form when LLM was wrong
    //
    // All persistence + DB writes are handled by the parent's handler props.
    // This component is rendering-only (plus local form state).
    // ============================================================
    const ContractorQuoteUploadModal = ({
      finding, uploadState, busy, propertyClientName, propertyClientPhone,
      onClose, onFileSelected, onConfirmSingle, onOverrideStart, onOverrideSubmit, onMultiOptionDispatch,
      // D46 Task 5: dispatch path — agent flags the LLM-extracted amount as
      // wrong and routes the corrected-cost decision to the buyer via text
      // instead of typing the number themselves. The "verbal" path stays as
      // an escape valve when the buyer communicates outside the text channel.
      onOverrideDispatch,
      // D40 Task 2: when true, the modal renders only the override view —
      // no drop zone, no PDF requirement, no extraction. Used to override
      // an already-populated cost (contractor or client) without re-uploading.
      isStandaloneOverride = false
    }) => {
      const { step, filename, extraction } = uploadState || { step: 'idle' };

      // Local form state for the override view + multi-option dispatch view.
      // Lives inside this component so it resets when the modal unmounts.
      const [overrideAmount, setOverrideAmount] = React.useState('');
      const [overrideReason, setOverrideReason] = React.useState('wrong_number');
      const [overrideOtherText, setOverrideOtherText] = React.useState('');
      const [multiClientName, setMultiClientName] = React.useState(propertyClientName || '');
      const [multiClientPhone, setMultiClientPhone] = React.useState(propertyClientPhone || '');
      const [dragActive, setDragActive] = React.useState(false);
      // D46 Task 5: dispatch state. verbalEscape=true reveals the legacy
      // manual-entry path (D39 escape valve). dispatchToken is generated
      // once when the override view opens so the preview text shows the
      // exact link the buyer will receive. Token is reused on send so the
      // preview matches what's persisted.
      const [verbalEscape, setVerbalEscape] = React.useState(false);
      const [dispatchToken] = React.useState(() => (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
      // D39.1: agent must explicitly confirm a category mismatch before the
      // primary CTA enables. Reset whenever a new extraction lands.
      const [categoryConfirmed, setCategoryConfirmed] = React.useState(false);

      // When extraction first lands in 'confirm' step, prefill override amount
      // with the LLM's suggested value so the agent can edit rather than retype.
      React.useEffect(() => {
        if (step === 'confirm' && extraction) {
          const suggestion = extraction.type === 'single' ? extraction.amount
                          : extraction.type === 'line_items' ? extraction.total
                          : '';
          if (typeof suggestion === 'number' && Number.isFinite(suggestion)) {
            setOverrideAmount(String(suggestion));
          } else {
            setOverrideAmount('');
          }
          // D39.1: each new extraction restarts the category confirmation.
          setCategoryConfirmed(false);
        }
      }, [step, extraction?.type, extraction?.category_match]);

      // D39.1: shared mismatch warning block. Renders only when Claude flagged
      // a category mismatch (quote subject ≠ finding being priced). Override
      // path bypasses this — agents using the override modal are already
      // pinning a corrected number, mismatch flag is moot.
      const renderCategoryMismatchWarning = () => {
        if (!extraction || extraction.category_match !== 'mismatch') return null;
        return (
          <div className="rounded-lg p-3 mb-4" style={{
            background: 'rgba(251,191,36,0.12)',
            border: '1px solid rgba(251,191,36,0.55)'
          }}>
            <p className="text-xs uppercase tracking-wide mb-1" style={{ color: '#fcd34d' }}>
              ⚠️ Possible quote/finding mismatch
            </p>
            <p className="text-sm text-stone-200 mb-2">
              This quote may not be for <em>{finding.item}</em>. Double-check before proceeding.
            </p>
            <label htmlFor="d39-1-cat-confirm" className="flex items-start gap-2 cursor-pointer">
              <input
                id="d39-1-cat-confirm"
                type="checkbox"
                checked={categoryConfirmed}
                onChange={(e) => setCategoryConfirmed(e.target.checked)}
                className="mt-0.5 h-4 w-4 flex-shrink-0 cursor-pointer"
                style={{ accentColor: '#fbbf24' }}
              />
              <span className="text-xs leading-relaxed" style={{ color: '#fcd34d' }}>
                I confirm this is the right quote for this finding.
              </span>
            </label>
          </div>
        );
      };

      // D39.1: derived flag — when the primary CTA should be blocked by a
      // pending mismatch confirmation. Used by single, line_items, and
      // multi_option confirm views.
      const mismatchBlocking = !!(extraction && extraction.category_match === 'mismatch' && !categoryConfirmed);

      const acceptedFile = (f) => {
        if (!f) return;
        // Accept PDFs primarily; images fall back to unclear since OCR isn't
        // wired yet. The Worker handles the "unclear" path gracefully.
        onFileSelected(f);
      };

      // ---------- IDLE: drop zone ----------
      const renderIdle = () => (
        <>
          <div
            className={`border-2 border-dashed rounded-xl p-8 text-center transition-all cursor-pointer mb-3
              ${dragActive ? 'border-brand-500 bg-brand-500/10' : 'border-stone-600 hover:border-brand-500 hover:bg-brand-500/5'}`}
            onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); setDragActive(true); }}
            onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); setDragActive(true); }}
            onDragLeave={(e) => { e.preventDefault(); e.stopPropagation(); setDragActive(false); }}
            onDrop={(e) => {
              e.preventDefault(); e.stopPropagation(); setDragActive(false);
              const f = Array.from(e.dataTransfer.files).find(x => x.type === 'application/pdf' || x.type.startsWith('image/'));
              if (f) acceptedFile(f);
            }}
            onClick={() => document.getElementById('d39-quote-file-input').click()}
          >
            <div className="text-4xl mb-2">📎</div>
            <p className="text-white font-medium mb-1">Drop quote here</p>
            <p className="text-xs text-stone-400">PDF preferred · we'll read the cost from the file</p>
            <input
              type="file"
              id="d39-quote-file-input"
              accept=".pdf,image/*"
              className="hidden"
              onChange={(e) => acceptedFile(e.target.files?.[0])}
            />
          </div>
          <div className="flex items-center justify-center mb-3">
            <button
              type="button"
              onClick={() => document.getElementById('d39-quote-file-input').click()}
              className="px-4 py-2 text-sm rounded-lg border border-stone-700 bg-stone-800/60 text-stone-200 hover:bg-stone-800 hover:border-stone-600 transition-colors"
            >
              Browse for file
            </button>
          </div>
          <p className="text-xs text-stone-500 italic">
            We extract the dollar amount from the quote PDF. You'll get a chance to confirm before we save.
          </p>
        </>
      );

      // ---------- EXTRACTING: spinner ----------
      const renderExtracting = () => (
        <div className="text-center py-8">
          <div className="inline-block w-8 h-8 border-2 border-brand-500 border-t-transparent rounded-full animate-spin mb-4" />
          <p className="text-white font-medium mb-1">Reading the quote…</p>
          <p className="text-xs text-stone-400">{filename}</p>
        </div>
      );

      // ---------- CONFIRM (single / line_items): show amount + Looks good / This is wrong ----------
      const renderConfirmSingle = () => {
        const amount = extraction.type === 'single' ? extraction.amount : extraction.total;
        const label = extraction.label || (extraction.type === 'line_items' ? 'Total of itemized costs' : 'Quote total');
        const conf = extraction.confidence || 'low';
        const confColor = conf === 'high' ? 'text-emerald-400' : conf === 'medium' ? 'text-yellow-400' : 'text-amber-400';
        const confDot = conf === 'high' ? '✓' : conf === 'medium' ? '·' : '!';
        return (
          <>
            <div className="rounded-xl p-4 mb-4" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <p className="text-xs text-stone-400 uppercase tracking-wide mb-1">{filename}</p>
              <div className="text-3xl font-bold text-white mb-1">${Number(amount).toLocaleString()}</div>
              <p className="text-sm text-stone-300 mb-2">{label}</p>
              <p className={`text-xs ${confColor}`}>
                <span className="mr-1">{confDot}</span>
                {conf === 'high' ? 'High confidence' : conf === 'medium' ? 'Medium confidence' : 'Low confidence — please verify against the quote'}
              </p>
              {extraction.type === 'line_items' && Array.isArray(extraction.items) && extraction.items.length > 0 && (
                <div className="mt-3 pt-3 border-t border-stone-700/50">
                  <p className="text-xs text-stone-500 mb-1">Line items detected:</p>
                  <ul className="text-xs text-stone-400 space-y-0.5">
                    {extraction.items.map((it, idx) => (
                      <li key={idx} className="flex justify-between">
                        <span>{it.label}</span>
                        <span>${Number(it.amount || 0).toLocaleString()}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            {renderCategoryMismatchWarning()}
            <div className="flex justify-end gap-2">
              <button type="button" disabled={busy} onClick={onOverrideStart} className="px-4 py-2 text-sm text-amber-300 hover:text-amber-200">
                This number is wrong
              </button>
              <button type="button" disabled={busy || mismatchBlocking} onClick={onConfirmSingle} className="px-4 py-2 text-sm bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
                {busy ? 'Saving…' : 'Looks good'}
              </button>
            </div>
          </>
        );
      };

      // ---------- CONFIRM (multi_option): show options + name/phone + Send to client ----------
      const renderConfirmMultiOption = () => {
        const options = Array.isArray(extraction.options) ? extraction.options : [];
        const phoneE164 = (() => {
          const digits = String(multiClientPhone || '').replace(/\D/g, '');
          if (digits.length === 11 && digits.startsWith('1')) return '+' + digits;
          if (digits.length === 10) return '+1' + digits;
          return null;
        })();
        const dispatchDisabled = busy || !phoneE164 || options.length < 2 || mismatchBlocking;
        return (
          <>
            <div className="rounded-xl p-4 mb-4" style={{ background: 'rgba(251,191,36,0.10)', border: '1px solid rgba(251,191,36,0.40)' }}>
              <p className="text-xs uppercase tracking-wide mb-1" style={{ color: '#fcd34d' }}>Multi-option quote</p>
              <p className="text-sm text-stone-300 mb-3">
                This quote contains multiple options. Send a text to your client so they can choose.
              </p>
              <ul className="space-y-1 mb-1">
                {options.map((o, i) => (
                  <li key={i} className="flex justify-between text-sm">
                    <span className="text-stone-200">{i + 1}. {o.label}</span>
                    <span className="text-white font-medium">${Number(o.amount || 0).toLocaleString()}</span>
                  </li>
                ))}
              </ul>
            </div>
            {renderCategoryMismatchWarning()}
            <label className="block text-xs text-stone-400 uppercase tracking-wide mb-1">Client name</label>
            <input type="text" placeholder="e.g. Jane Homebuyer" value={multiClientName} onChange={(e) => setMultiClientName(e.target.value)}
              className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-white mb-4 focus:border-brand-500 focus:outline-none" />
            <label className="block text-xs text-stone-400 uppercase tracking-wide mb-1">Client phone (required)</label>
            <input type="tel" placeholder="(503) 555-1234" value={multiClientPhone} onChange={(e) => setMultiClientPhone(e.target.value)}
              className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-white mb-4 focus:border-brand-500 focus:outline-none" />
            <div className="flex justify-end gap-2">
              <button type="button" disabled={busy} onClick={onOverrideStart} className="px-4 py-2 text-sm text-stone-400 hover:text-white">
                Override manually
              </button>
              <button type="button" disabled={dispatchDisabled} onClick={() => onMultiOptionDispatch(multiClientName, multiClientPhone)} className="px-4 py-2 text-sm bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
                {busy ? 'Sending…' : 'Send to client'}
              </button>
            </div>
          </>
        );
      };

      // ---------- CONFIRM (unclear): fallback to manual entry ----------
      const renderConfirmUnclear = () => (
        <>
          <div className="rounded-xl p-4 mb-4" style={{ background: 'rgba(251,191,36,0.10)', border: '1px solid rgba(251,191,36,0.40)' }}>
            <p className="text-xs uppercase tracking-wide mb-1" style={{ color: '#fcd34d' }}>Couldn't read the cost</p>
            <p className="text-sm text-stone-300 mb-1">{extraction.reason || 'Please enter the amount manually.'}</p>
            <p className="text-xs text-stone-500">{filename}</p>
          </div>
          <div className="flex justify-end gap-2">
            <button type="button" disabled={busy} onClick={onClose} className="px-4 py-2 text-sm text-stone-400 hover:text-white">Cancel</button>
            <button type="button" disabled={busy} onClick={onOverrideStart} className="px-4 py-2 text-sm bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-600 disabled:opacity-50">
              Enter amount manually
            </button>
          </div>
        </>
      );

      // ---------- OVERRIDE: 5-radio reasons + manual amount + submit ----------
      const renderOverride = () => {
        // D40 Task 2: standalone overrides use a different reason set —
        // the reasons describing "the LLM read the wrong number" don't apply
        // when the existing cost came from a client text or a prior quote
        // the agent now wants to revise.
        const reasons = isStandaloneOverride ? [
          { value: 'verbal_update', label: 'Client or contractor provided an updated number verbally' },
          { value: 'wrong_number', label: 'Existing amount is incorrect for this finding' },
          { value: 'scope_changed', label: 'Scope of work changed since the original price' },
          { value: 'other', label: 'Other (please specify)' }
        ] : [
          { value: 'wrong_number', label: 'System read the wrong number from the quote' },
          { value: 'system_error', label: "System couldn't read the quote (encountered error or no number returned)" },
          { value: 'multi_option_routing_failed', label: 'Quote contains multiple options and text-to-client failed or wasn\'t appropriate' },
          { value: 'verbal_update', label: 'Client provided an updated number verbally (not in the PDF)' },
          { value: 'other', label: 'Other (please specify)' }
        ];
        const amountNum = Number(String(overrideAmount).replace(/[^0-9.]/g, ''));
        const amountValid = Number.isFinite(amountNum) && amountNum >= 1 && amountNum <= 1000000;
        const otherValid = overrideReason !== 'other' || (overrideOtherText && overrideOtherText.trim().length > 0);
        const submitDisabled = busy || !amountValid || !otherValid;
        // D40 Task 2: if the selected reason isn't in this view's reasons list
        // (e.g. opened standalone but radio still shows the default 'wrong_number'),
        // it'll just gracefully not match any radio — that's fine, the agent picks one.
        return (
          <>
            {isStandaloneOverride && finding && (
              <div className="rounded-lg p-3 mb-4" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                <p className="text-xs text-stone-400 uppercase tracking-wide mb-1">Currently on file</p>
                <div className="text-lg font-semibold text-stone-200">
                  {typeof finding.cost === 'number' ? `$${Number(finding.cost).toLocaleString()}` : '—'}
                </div>
                <p className="text-xs text-stone-500">For: <em>{finding.item}</em></p>
              </div>
            )}
            <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Why is the override needed?</p>
            <div className="space-y-2 mb-4">
              {reasons.map(r => (
                <label key={r.value} className="flex items-start gap-2 cursor-pointer">
                  <input type="radio" name="overrideReason" value={r.value} checked={overrideReason === r.value} onChange={() => setOverrideReason(r.value)} className="mt-1" />
                  <span className="text-sm text-stone-300">{r.label}</span>
                </label>
              ))}
            </div>
            {overrideReason === 'other' && (
              <>
                <label className="block text-xs text-stone-400 uppercase tracking-wide mb-1">Reason details (required)</label>
                <input type="text" value={overrideOtherText} onChange={(e) => setOverrideOtherText(e.target.value)}
                  className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-white mb-4 focus:border-brand-500 focus:outline-none"
                  placeholder="Briefly describe..." />
              </>
            )}

            {/* D46 Task 5: dispatch path is now the PRIMARY action. The agent
                names the reason; the buyer supplies the corrected amount via
                SMS reply. Verbal escape valve (the legacy D39 manual entry)
                is collapsed below as a smaller link. */}
            {!verbalEscape && onOverrideDispatch && propertyClientPhone && (() => {
              const firstName = (propertyClientName || '').trim().split(/\s+/)[0] || 'there';
              const findingType = finding?.item || 'the inspection item';
              const linkBase = (typeof window !== 'undefined' && window.location && window.location.origin)
                ? `${window.location.origin.replace('//', '//').replace('gameplanppg.ai', 'gameplan-ppg-api.jraaschmidt.workers.dev')}`
                : 'https://gameplan-ppg-api.jraaschmidt.workers.dev';
              const previewUrl = `https://gameplan-ppg-api.jraaschmidt.workers.dev/quote-view/${dispatchToken}`;
              const previewText = `Game Plan: Hi ${firstName}, your agent flagged the ${findingType} quote for review. View the original quote here: ${previewUrl}. Once you've discussed with your agent, reply with the dollar amount to use for the negotiation. Reply STOP to opt out.`;
              const reasonValid = overrideReason && (overrideReason !== 'other' || (overrideOtherText && overrideOtherText.trim().length > 0));
              return (
                <>
                  <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Preview of text the client will receive</p>
                  <div className="rounded-lg p-3 mb-3" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.10)' }}>
                    <p className="text-xs text-stone-300 leading-relaxed whitespace-pre-line">{previewText}</p>
                  </div>
                  <p className="text-xs text-stone-500 italic mb-4">
                    Text content is fixed (Twilio compliance). You see exactly what your client sees — no edits, no surprises. The link is unique to this request and expires in 7 days.
                  </p>
                  <div className="flex flex-col gap-2">
                    <button
                      type="button"
                      disabled={busy || !reasonValid}
                      onClick={() => onOverrideDispatch(overrideReason, overrideOtherText, dispatchToken, !!isStandaloneOverride)}
                      className="w-full px-4 py-2.5 text-sm bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {busy ? 'Sending…' : 'Send text to client for price correction'}
                    </button>
                    <div className="flex justify-between items-center pt-1">
                      <button type="button" disabled={busy} onClick={onClose} className="text-xs text-stone-400 hover:text-white">
                        Cancel
                      </button>
                      <button
                        type="button"
                        disabled={busy}
                        onClick={() => setVerbalEscape(true)}
                        className="text-xs text-stone-500 hover:text-stone-300 underline"
                      >
                        Client provided number verbally →
                      </button>
                    </div>
                  </div>
                </>
              );
            })()}

            {/* D46 Task 5: secondary verbal escape valve. Reveals the legacy
                D39 manual-entry surface when the buyer has communicated the
                corrected amount outside the text channel. Only path that
                lets the agent type a dollar amount. */}
            {(verbalEscape || !onOverrideDispatch || !propertyClientPhone) && (
              <>
                {!verbalEscape && !propertyClientPhone && (
                  <div className="rounded-lg p-3 mb-3" style={{ background: 'rgba(251,191,36,0.10)', border: '1px solid rgba(251,191,36,0.40)' }}>
                    <p className="text-xs" style={{ color: '#fcd34d' }}>
                      No client phone on file. Returning to Page 1 to add one lets you route price corrections through the client. For now, enter the verbal update below.
                    </p>
                  </div>
                )}
                <label className="block text-xs text-stone-400 uppercase tracking-wide mb-1">Correct dollar amount</label>
                <input type="text" inputMode="decimal" value={overrideAmount} onChange={(e) => setOverrideAmount(e.target.value)}
                  className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-white mb-4 focus:border-brand-500 focus:outline-none"
                  placeholder="e.g. 5500" />
                <p className="text-xs text-stone-500 italic mb-4">
                  {isStandaloneOverride
                    ? "Your client's report will show the new amount, replacing the previous value. The override itself — your account, the previous amount, your reason, and the time — is permanently recorded and can be produced for any later audit or dispute."
                    : "Your client's report will show the amount you enter above, labeled as coming from this contractor quote. The override itself — your account, the system's original reading, your reason, and the time — is permanently recorded and can be produced for any later audit or dispute."}
                </p>
                <div className="flex justify-between items-center">
                  {verbalEscape && onOverrideDispatch && propertyClientPhone ? (
                    <button type="button" disabled={busy} onClick={() => setVerbalEscape(false)} className="text-xs text-stone-500 hover:text-stone-300 underline">
                      ← Send text to client instead
                    </button>
                  ) : (
                    <button type="button" disabled={busy} onClick={onClose} className="px-4 py-2 text-sm text-stone-400 hover:text-white">Cancel</button>
                  )}
                  <button type="button" disabled={submitDisabled} onClick={() => onOverrideSubmit(amountNum, overrideReason, overrideOtherText)} className="px-4 py-2 text-sm bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-600 disabled:opacity-50">
                    {busy ? 'Saving…' : 'Override and continue'}
                  </button>
                </div>
              </>
            )}
          </>
        );
      };

      const renderBody = () => {
        // D40 Task 2: standalone overrides skip the drop-zone / extraction
        // flow and land directly on the override view since there's no PDF
        // to upload — we're editing an existing cost.
        if (isStandaloneOverride) return renderOverride();
        if (step === 'idle') return renderIdle();
        if (step === 'extracting') return renderExtracting();
        if (step === 'override') return renderOverride();
        if (step === 'confirm' && extraction) {
          if (extraction.type === 'single') return renderConfirmSingle();
          if (extraction.type === 'line_items') return renderConfirmSingle();
          if (extraction.type === 'multi_option') return renderConfirmMultiOption();
          if (extraction.type === 'unclear') return renderConfirmUnclear();
        }
        return renderIdle();
      };

      return (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={onClose}>
          <div className="bg-stone-900 rounded-2xl p-6 max-w-md w-full border border-stone-700" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-xl font-bold text-white mb-1">
              {isStandaloneOverride ? 'Override existing cost' : 'Upload contractor quote'}
            </h3>
            <p className="text-sm text-stone-400 mb-4">For: <em>{finding.item}</em></p>
            {renderBody()}
          </div>
        </div>
      );
    };

    // ============================================================
    // v5.12b: BETA CHECKOUT COMPONENT (Replaces PaymentRequired)
    // Stripe-like checkout page with promo code validation
    // NO credit card data collected — payment methods are decorative only
    // ============================================================
    const PaymentRequired = ({ onSignOut, onSwitchAccount, userId }) => {
      // Check if user just returned from Stripe payment (kept for future use)
      const urlParams = new URLSearchParams(window.location.search);
      const justPaid = urlParams.has('welcome');

      // Form state
      const [email, setEmail] = useState('');
      const [fullName, setFullName] = useState('');
      const [promoCode, setPromoCode] = useState('');
      const [promoError, setPromoError] = useState('');
      const [promoValid, setPromoValid] = useState(false);
      const [showPromoInput, setShowPromoInput] = useState(false);
      const [selectedPayment, setSelectedPayment] = useState('card');
      const [activating, setActivating] = useState(false);
      const [activationError, setActivationError] = useState('');
      const [showTermsModal, setShowTermsModal] = useState(false);
      const [hasViewedTerms, setHasViewedTerms] = useState(false);
      const [termsAccepted, setTermsAccepted] = useState(false);
      const [checkingPromo, setCheckingPromo] = useState(false);
      const [validatedCode, setValidatedCode] = useState(null); // Store the validated code data

      // Pre-fill email from auth if available
      useEffect(() => {
        const getUser = async () => {
          const { data: { user } } = await supabaseClient.auth.getUser();
          if (user?.email) setEmail(user.email);
        };
        getUser();
      }, []);

      // Validate promo code against Supabase
      const handlePromoSubmit = async () => {
        const code = promoCode.toUpperCase().trim();
        if (!code) {
          setPromoError('Please enter a code');
          return;
        }

        setCheckingPromo(true);
        setPromoError('');

        try {
          // Query Supabase for the code
          const { data, error } = await supabaseClient
            .from('beta_codes')
            .select('*')
            .eq('code', code)
            .single();

          if (error || !data) {
            setPromoValid(false);
            setPromoError('Invalid promotion code');
            setValidatedCode(null);
          } else if (data.is_used && !data.is_unlimited) {
            // Code exists but has been used (and isn't unlimited)
            setPromoValid(false);
            setPromoError('This code has already been redeemed');
            setValidatedCode(null);
          } else {
            // Code is valid and available
            setPromoValid(true);
            setPromoError('');
            setValidatedCode(data);
          }
        } catch (err) {
          console.error('Error checking promo code:', err);
          setPromoValid(false);
          setPromoError('Error checking code. Please try again.');
          setValidatedCode(null);
        } finally {
          setCheckingPromo(false);
        }
      };

      // Handle beta activation
      const handleBetaActivation = async () => {
        if (!promoValid || !email.trim() || !fullName.trim()) return;

        setActivating(true);
        setActivationError('');

        try {
          // 1. Update the user's profile to grant beta access
          const { error } = await supabaseClient
            .from('profiles')
            .update({
              is_beta_cohort: true,
              subscription_status: 'active'
            })
            .eq('id', userId);

          if (error) throw error;

          // 2. Update the profile name if provided
          if (fullName.trim()) {
            const nameParts = fullName.trim().split(' ');
            const firstName = nameParts[0];
            const lastName = nameParts.slice(1).join(' ') || '';

            await supabaseClient
              .from('profiles')
              .update({
                first_name: firstName,
                last_name: lastName
              })
              .eq('id', userId);
          }

          // 3. Mark the beta code as used (unless it's unlimited)
          if (validatedCode && !validatedCode.is_unlimited) {
            await supabaseClient
              .from('beta_codes')
              .update({
                is_used: true,
                used_by: userId,
                used_at: new Date().toISOString()
              })
              .eq('code', promoCode.toUpperCase().trim());
          }

          // 4. Reload to enter the app
          window.location.href = window.location.origin + '?welcome=true';

        } catch (err) {
          console.error('Beta activation failed:', err);
          setActivationError('Activation failed. Please try again or contact support.');
          setActivating(false);
        }
      };

      // Can submit if promo is valid, required fields are filled, and terms accepted
      const canSubmit = promoValid && email.trim() && fullName.trim() && termsAccepted && !activating;

      // Show "Confirming" state if user just returned (kept for future Stripe use)
      if (justPaid) {
        return (
          <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-dark-landing">
            <div className="glass-landing rounded-2xl p-8 max-w-md text-center">
              <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
              <h1 className="text-xl font-bold text-white mb-2">Activating Your Account...</h1>
              <p className="text-gray-400 mb-6">This usually takes just a moment.</p>
              <button
                onClick={() => window.location.reload()}
                className="text-emerald-400 hover:text-emerald-300 text-sm"
              >
                Click here to refresh
              </button>
              <div className="mt-4">
                <button
                  onClick={onSwitchAccount}
                  className="text-sm text-gray-500 hover:text-white mr-4"
                >
                  Switch Account
                </button>
                <button
                  onClick={onSignOut}
                  className="text-sm text-gray-500 hover:text-white"
                >
                  Sign Out
                </button>
              </div>
            </div>
          </div>
        );
      }

      // Payment method icons (decorative)
      const CardIcons = () => (
        <div className="flex gap-1 ml-2">
          <div className="w-8 h-5 bg-[#1a1f71] rounded flex items-center justify-center">
            <span className="text-white text-[8px] font-bold">VISA</span>
          </div>
          <div className="w-8 h-5 bg-gradient-to-r from-[#eb001b] to-[#f79e1b] rounded flex items-center justify-center">
            <div className="flex">
              <div className="w-2 h-2 bg-[#eb001b] rounded-full opacity-80"></div>
              <div className="w-2 h-2 bg-[#f79e1b] rounded-full -ml-1 opacity-80"></div>
            </div>
          </div>
          <div className="w-8 h-5 bg-[#006fcf] rounded flex items-center justify-center">
            <span className="text-white text-[6px] font-bold">AMEX</span>
          </div>
          <div className="w-8 h-5 bg-[#ff6600] rounded flex items-center justify-center">
            <span className="text-white text-[6px] font-bold">DISC</span>
          </div>
        </div>
      );

      return (
        <div className="min-h-screen bg-[#f7f8f9] py-8 px-4">
          {/* Beta Program Badge */}
          <div className="max-w-4xl mx-auto mb-6">
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-medium">
              <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
              Beta Program Invitation
            </div>
          </div>

          {/* Main Checkout Card */}
          <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl overflow-hidden">
            <div className="grid md:grid-cols-2">

              {/* LEFT COLUMN: Order Summary */}
              <div className="bg-[#f7f8f9] p-8 border-r border-gray-200">
                {/* Product Header */}
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center">
                    <img src="gambit-logo.png" alt="Game Plan PPG" className="w-full h-full object-contain" />
                  </div>
                  <div>
                    <div className="text-gray-500 text-sm">Subscribe to</div>
                    <div className="text-gray-900 font-semibold">Game Plan PPG™</div>
                  </div>
                </div>

                {/* Price */}
                <div className="mb-6">
                  <span className="text-4xl font-bold text-gray-900">$39.99</span>
                  <span className="text-gray-500 ml-1">per month</span>
                </div>

                {/* Line Item */}
                <div className="border-t border-gray-200 pt-4 mb-4">
                  <div className="flex justify-between text-sm mb-2">
                    <div>
                      <div className="text-gray-900 font-medium">Game Plan PPG™</div>
                      <div className="text-gray-500 text-xs mt-1">AI-powered negotiation strategy for real estate professionals. Unlimited analyses.</div>
                      <div className="text-gray-400 text-xs mt-1">Billed monthly</div>
                    </div>
                    <div className="text-gray-900 font-medium">$39.99</div>
                  </div>
                </div>

                {/* Subtotal */}
                <div className="border-t border-gray-200 pt-4">
                  <div className="flex justify-between text-sm mb-2">
                    <span className="text-gray-600">Subtotal</span>
                    <span className="text-gray-900">$39.99</span>
                  </div>

                  {/* Promo Code Section */}
                  {!showPromoInput && !promoValid && (
                    <button
                      onClick={() => setShowPromoInput(true)}
                      className="text-indigo-600 text-sm hover:text-indigo-700 flex items-center gap-1 mt-2"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                      Add promotion code
                    </button>
                  )}

                  {showPromoInput && !promoValid && (
                    <div className="mt-3">
                      <div className="flex gap-2">
                        <input
                          type="text"
                          value={promoCode}
                          onChange={(e) => {
                            setPromoCode(e.target.value);
                            setPromoError('');
                          }}
                          onKeyDown={(e) => e.key === 'Enter' && !checkingPromo && handlePromoSubmit()}
                          placeholder="Promotion code"
                          disabled={checkingPromo}
                          className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent disabled:bg-gray-50"
                        />
                        <button
                          onClick={handlePromoSubmit}
                          disabled={checkingPromo}
                          className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed min-w-[70px]"
                        >
                          {checkingPromo ? (
                            <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mx-auto"></div>
                          ) : (
                            'Apply'
                          )}
                        </button>
                      </div>
                      {promoError && (
                        <p className="text-red-500 text-xs mt-1">{promoError}</p>
                      )}
                    </div>
                  )}

                  {/* Discount Applied */}
                  {promoValid && (
                    <div className="mt-3 p-2 bg-emerald-50 rounded-md border border-emerald-200">
                      <div className="flex justify-between text-sm">
                        <span className="text-emerald-700 flex items-center gap-1">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          Beta Access ({promoCode.toUpperCase()})
                        </span>
                        <span className="text-emerald-600 font-medium">-$39.99</span>
                      </div>
                    </div>
                  )}
                </div>

                {/* Total */}
                <div className="border-t border-gray-200 mt-4 pt-4">
                  <div className="flex justify-between">
                    <span className="text-gray-900 font-semibold">Total due today</span>
                    <span className="text-gray-900 font-bold text-xl">
                      {promoValid ? '$0.00' : '$39.99'}
                    </span>
                  </div>
                  {promoValid && (
                    <p className="text-emerald-600 text-xs mt-1">Beta access — no payment required</p>
                  )}
                </div>
              </div>

              {/* RIGHT COLUMN: Checkout Form */}
              <div className="p-8">
                {/* Contact Information */}
                <div className="mb-6">
                  <h3 className="text-gray-900 font-semibold mb-4">Contact information</h3>
                  <div className="space-y-3">
                    <div>
                      <label className="block text-sm text-gray-600 mb-1">Email</label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@example.com"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-gray-600 mb-1">Full name</label>
                      <input
                        type="text"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        placeholder="Jane Smith"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                      />
                    </div>
                  </div>
                </div>

                {/* Payment Method (Decorative) */}
                {!promoValid && (
                  <div className="mb-6">
                    <h3 className="text-gray-900 font-semibold mb-4">Payment method</h3>
                    <div className="border border-gray-200 rounded-lg overflow-hidden">
                      {/* Card Option */}
                      <label className={`flex items-center p-3 cursor-pointer border-b border-gray-200 ${selectedPayment === 'card' ? 'bg-indigo-50' : 'hover:bg-gray-50'}`}>
                        <input
                          type="radio"
                          name="payment"
                          value="card"
                          checked={selectedPayment === 'card'}
                          onChange={(e) => setSelectedPayment(e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <span className="ml-3 text-gray-900 text-sm font-medium">Card</span>
                        <CardIcons />
                      </label>

                      {/* Klarna */}
                      <label className={`flex items-center p-3 cursor-pointer border-b border-gray-200 ${selectedPayment === 'klarna' ? 'bg-indigo-50' : 'hover:bg-gray-50'}`}>
                        <input
                          type="radio"
                          name="payment"
                          value="klarna"
                          checked={selectedPayment === 'klarna'}
                          onChange={(e) => setSelectedPayment(e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <span className="ml-3 text-gray-900 text-sm font-medium">Klarna</span>
                        <div className="ml-2 w-10 h-5 bg-[#ffb3c7] rounded flex items-center justify-center">
                          <span className="text-[#0a0a0a] text-[10px] font-bold">Klarna</span>
                        </div>
                      </label>

                      {/* Cash App */}
                      <label className={`flex items-center p-3 cursor-pointer border-b border-gray-200 ${selectedPayment === 'cashapp' ? 'bg-indigo-50' : 'hover:bg-gray-50'}`}>
                        <input
                          type="radio"
                          name="payment"
                          value="cashapp"
                          checked={selectedPayment === 'cashapp'}
                          onChange={(e) => setSelectedPayment(e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <span className="ml-3 text-gray-900 text-sm font-medium">Cash App Pay</span>
                        <div className="ml-2 w-6 h-6 bg-[#00d632] rounded flex items-center justify-center">
                          <span className="text-white text-xs font-bold">$</span>
                        </div>
                      </label>

                      {/* Amazon Pay */}
                      <label className={`flex items-center p-3 cursor-pointer ${selectedPayment === 'amazon' ? 'bg-indigo-50' : 'hover:bg-gray-50'}`}>
                        <input
                          type="radio"
                          name="payment"
                          value="amazon"
                          checked={selectedPayment === 'amazon'}
                          onChange={(e) => setSelectedPayment(e.target.value)}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <span className="ml-3 text-gray-900 text-sm font-medium">Amazon Pay</span>
                        <div className="ml-2 w-14 h-5 bg-[#ff9900] rounded flex items-center justify-center">
                          <span className="text-[#232f3e] text-[8px] font-bold">amazon</span>
                        </div>
                      </label>
                    </div>
                    <p className="text-gray-400 text-xs mt-2 italic">
                      Enter a beta code to continue without payment
                    </p>
                  </div>
                )}

                {/* Payment Not Required Message */}
                {promoValid && (
                  <div className="mb-6 p-4 bg-emerald-50 border border-emerald-200 rounded-lg">
                    <div className="flex items-center gap-2 text-emerald-700">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="font-medium">No payment method required</span>
                    </div>
                    <p className="text-emerald-600 text-sm mt-1">
                      Beta access activated with code <span className="font-mono font-semibold">{promoCode.toUpperCase()}</span>
                    </p>
                  </div>
                )}

                {/* Activation Error */}
                {activationError && (
                  <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    {activationError}
                  </div>
                )}

                {/* Beta Terms Checkbox - only show when promo is valid */}
                {promoValid && (
                  <div className="mb-6">
                    <label className={`flex items-start gap-3 ${!hasViewedTerms ? 'opacity-60' : ''}`}>
                      <input
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={(e) => termsAccepted ? setTermsAccepted(false) : (hasViewedTerms && setTermsAccepted(true))}
                        disabled={!hasViewedTerms}
                        className={`mt-1 w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 ${!hasViewedTerms ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                      />
                      <span className="text-sm text-gray-600">
                        I have read and agree to the{' '}
                        <button
                          type="button"
                          onClick={() => setShowTermsModal(true)}
                          className="text-indigo-600 hover:text-indigo-800 underline font-medium"
                        >
                          Beta Program Terms & Conditions
                        </button>
                      </span>
                    </label>
                    {!hasViewedTerms && (
                      <p className="text-xs text-gray-400 mt-1 ml-7">
                        Please read the terms before checking this box
                      </p>
                    )}
                  </div>
                )}

                {/* Subscribe Button */}
                <button
                  onClick={handleBetaActivation}
                  disabled={!canSubmit}
                  className={`w-full py-3 px-4 rounded-lg font-semibold text-white transition-all flex items-center justify-center gap-2 ${
                    canSubmit
                      ? 'bg-[#635bff] hover:bg-[#5851db] cursor-pointer'
                      : 'bg-gray-300 cursor-not-allowed'
                  }`}
                >
                  {activating ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Activating...
                    </>
                  ) : promoValid ? (
                    'Start Free Beta Access'
                  ) : (
                    'Subscribe'
                  )}
                </button>

                {/* Terms */}
                <p className="text-gray-400 text-xs mt-4 text-center">
                  By subscribing, you authorize Gambit Lab to charge you according to the terms until you cancel.
                </p>

                {/* Account Actions */}
                <div className="mt-6 pt-4 border-t border-gray-200 flex gap-4 justify-center">
                  <button
                    onClick={onSwitchAccount}
                    className="text-sm text-gray-500 hover:text-gray-700"
                  >
                    Switch Account
                  </button>
                  <button
                    onClick={onSignOut}
                    className="text-sm text-gray-500 hover:text-gray-700"
                  >
                    Sign Out
                  </button>
                </div>

              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="max-w-4xl mx-auto mt-6 text-center text-gray-400 text-xs">
            <p>Gambit Lab • Game Plan PPG™ • <a href="mailto:support@gameplanpro.ai" className="text-indigo-500 hover:text-indigo-600">support@gameplanpro.ai</a></p>
          </div>

          {/* Beta Terms Modal */}
          {showTermsModal && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
              <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
                {/* Modal Header */}
                <div className="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-indigo-600 to-purple-600">
                  <h2 className="text-xl font-bold text-white">Game Plan PPG™ Beta Program Terms</h2>
                </div>

                {/* Modal Content - Scrollable */}
                <div className="px-6 py-6 overflow-y-auto flex-1">
                  <p className="text-gray-700 mb-6">
                    By activating a beta access code, you agree to the following:
                  </p>

                  <div className="space-y-5">
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">1. Beta Product</h3>
                      <p className="text-gray-600 text-sm">
                        Game Plan PPG™ is in active development. Features may change, break, or be removed without notice. We're building this with your help, and your patience during this phase is appreciated.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">2. Your Data</h3>
                      <p className="text-gray-600 text-sm">
                        Your inspection reports, property details, client names, and deal information are stored securely and accessible only to your account. We do not share your data with third parties. We may use anonymized, aggregated data (with no personally identifiable information) to improve the product and generate market benchmarks.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">3. Not Professional Advice</h3>
                      <p className="text-gray-600 text-sm">
                        Game Plan PPG™ provides strategic guidance based on data analysis. It is not a substitute for your professional judgment, legal advice, or fiduciary counsel. You are responsible for all negotiation decisions made using information from this tool.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">4. Outcome Follow-Up</h3>
                      <p className="text-gray-600 text-sm">
                        Beta users agree to provide outcome follow-up within 10 days of deal closing — what you asked for, what you landed on, and what happened. This data is what makes Game Plan PPG™ smarter for everyone. We'll reach out after reports are generated to collect this information.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">5. Monthly Check-In</h3>
                      <p className="text-gray-600 text-sm">
                        Beta users agree to be available for a brief check-in (approximately 10 minutes) once per month when requested. These conversations help us understand what's working and what to build next.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">6. Active Usage</h3>
                      <p className="text-gray-600 text-sm">
                        Beta access is provided for use on real deals. Unused accounts may be reassigned to other agents on the waitlist.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">7. Confidentiality</h3>
                      <p className="text-gray-600 text-sm">
                        You may encounter information about upcoming features, product development, or business strategy. This information should not be shared publicly or with non-beta parties. Your reports, PDFs, and experience using Game Plan PPG™ are yours to share freely.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">8. Access & Termination</h3>
                      <p className="text-gray-600 text-sm">
                        Beta access is free for the duration of the beta period — no credit card required. Gambit Lab may revoke access at any time for any reason, including violation of these terms. You may stop using Game Plan PPG™ at any time.
                      </p>
                    </div>

                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">9. After Beta</h3>
                      <p className="text-gray-600 text-sm">
                        When the beta period ends, you will be notified in advance. Beta Cohort members will receive priority consideration for early-adopter pricing.
                      </p>
                    </div>
                  </div>

                  <div className="mt-6 pt-4 border-t border-gray-200">
                    <p className="text-gray-500 text-sm">
                      Questions? Reach out to us at{' '}
                      <a href="mailto:support@gameplanpro.ai" className="text-indigo-600 hover:underline">
                        support@gameplanpro.ai
                      </a>
                    </p>
                    <p className="text-gray-400 text-xs mt-2">
                      © 2026 Gambit Lab · Portland, Oregon
                    </p>
                  </div>
                </div>

                {/* Modal Footer */}
                <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
                  <button
                    onClick={() => {
                      setHasViewedTerms(true);
                      setShowTermsModal(false);
                    }}
                    className="w-full py-3 px-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition-colors"
                  >
                    I Have Read These Terms
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    };

    // ============================================================
    // v5.0: DASHBOARD COMPONENT
    // ============================================================
    const Dashboard = ({ user, profile, reports, onNewReport, onViewReport, onResumeDraft, onHideReport, onTrackOutcome, onSignOut, onProfile, dismissedProfileNudge, onDismissProfileNudge, dismissedPhoneNudge, onDismissPhoneNudge }) => {
      // Check if profile is complete enough to hide the nudge
      const profileComplete = profile?.first_name && profile?.brokerage;
      // D40 Task 4: agent phone collection. Independent of brandingComplete
      // because outcome-tracking SMS dispatch is gated by phone presence,
      // not by branding fields. Banner is session-dismissible (low-friction
      // nudge, not a hard block) — accounts predate the requirement.
      const phoneMissing = !profile?.phone_number || String(profile.phone_number).trim().length < 7;

      // Beta Feedback Widget state
      const [feedbackOpen, setFeedbackOpen] = useState(false);
      const [feedbackText, setFeedbackText] = useState('');
      const [feedbackSending, setFeedbackSending] = useState(false);
      const [feedbackSent, setFeedbackSent] = useState(false);

      // Mobile menu state
      const [dashboardMobileMenuOpen, setDashboardMobileMenuOpen] = useState(false);

      return (
        <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #1c1917 0%, #292524 100%)'}}>
          {/* Header - identical to product page */}
          <header className="glass border-b border-brand-500/20 sticky top-0 z-50">
            <div className="max-w-5xl mx-auto px-6 py-4">
              <div className="flex items-center justify-between">
                {/* Left: Logo */}
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-brand-500 to-brand-600 rounded-xl flex items-center justify-center overflow-hidden">
                    <img src={window.KNIGHT_LOGO_SRC} alt="Game Plan PPG" className="w-full h-full object-contain" />
                  </div>
                  <div>
                    <h1 className="text-xl font-bold text-white">Game Plan PPG<sup className="text-xs">™</sup></h1>
                    <p className="text-xs text-stone-400">Dashboard</p>
                  </div>
                </div>

                {/* Right: User info - Desktop only */}
                <div className="hidden md:flex items-center gap-4">
                  {profile?.is_beta_cohort && (
                    <span className="px-2 py-1 bg-brand-500/20 text-brand-400 text-xs font-medium rounded-full">
                      Beta
                    </span>
                  )}
                  <span className="text-sm text-stone-400">{user?.email}</span>
                  {ENABLE_PROFILE_BRANDING && onProfile && (
                    <button
                      onClick={onProfile}
                      className="text-sm text-stone-500 hover:text-white transition-colors"
                    >
                      Profile
                    </button>
                  )}
                  <button
                    onClick={onSignOut}
                    className="text-sm text-stone-500 hover:text-white transition-colors"
                  >
                    Sign Out
                  </button>
                </div>

                {/* Mobile: Hamburger menu */}
                <div className="md:hidden">
                  <button onClick={() => setDashboardMobileMenuOpen(!dashboardMobileMenuOpen)} className="text-stone-400 hover:text-white p-2">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            {/* Mobile Menu Dropdown */}
            {dashboardMobileMenuOpen && (
              <div className="md:hidden border-t border-stone-700 bg-stone-900/95">
                <div className="px-6 py-4 space-y-3">
                  <div className="text-sm text-stone-400 pb-2 border-b border-stone-700">{user?.email}</div>
                  {ENABLE_PROFILE_BRANDING && onProfile && (
                    <button
                      onClick={() => { onProfile(); setDashboardMobileMenuOpen(false); }}
                      className="block w-full text-left text-stone-300 hover:text-white py-2"
                    >
                      Profile
                    </button>
                  )}
                  <button
                    onClick={() => { onSignOut(); setDashboardMobileMenuOpen(false); }}
                    className="block w-full text-left text-stone-300 hover:text-white py-2"
                  >
                    Sign Out
                  </button>
                </div>
              </div>
            )}
          </header>

          {/* Main Content */}
          <main className="max-w-5xl mx-auto px-6 py-8">
            {/* v5.0: Agent-Branded Header */}
            {ENABLE_PROFILE_BRANDING && profileComplete ? (
              <div className="bg-stone-900/50 backdrop-blur border border-stone-800 rounded-2xl p-6 mb-8">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                  {/* Left side: Headshot + Info */}
                  <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5">
                    {/* Headshot */}
                    {profile?.headshot_url ? (
                      <img
                        src={`https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${profile.headshot_url}`}
                        alt={`${profile.first_name} ${profile.last_name}`}
                        className="w-32 h-32 rounded-full object-cover border-2 border-brand-500/30 flex-shrink-0"
                      />
                    ) : (
                      <div className="w-32 h-32 rounded-full bg-brand-500/20 flex items-center justify-center border-2 border-brand-500/30 flex-shrink-0">
                        <span className="text-4xl font-bold text-brand-400">
                          {(profile?.first_name?.[0] || '')}{(profile?.last_name?.[0] || '')}
                        </span>
                      </div>
                    )}
                    {/* Info */}
                    <div className="text-center sm:text-left">
                      <h2 className="text-2xl font-bold text-white">
                        {profile?.first_name} {profile?.last_name}
                      </h2>
                      {profile?.designations && (
                        <p className="text-lg font-normal text-stone-400 sm:mt-0 sm:-mt-1">{profile.designations}</p>
                      )}
                      {profile?.brokerage && (
                        <p className="text-stone-400">{profile.brokerage}</p>
                      )}
                      {profile?.tagline && (
                        <p className="text-sm text-brand-400 italic mt-1">"{profile.tagline}"</p>
                      )}
                      <p className="text-xs text-stone-500 mt-1">
                        {profile?.license_number && `License #${profile.license_number}`}
                        {profile?.license_number && profile?.phone_number && ' | '}
                        {profile?.phone_number}
                      </p>
                    </div>
                  </div>
                  {/* Brokerage logo - bottom on mobile, right side on desktop */}
                  {profile?.brokerage_logo_url && (
                    <img
                      src={`https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${profile.brokerage_logo_url}`}
                      alt="Brokerage"
                      className="h-16 md:h-24 max-w-32 md:max-w-48 object-contain mx-auto md:mx-0"
                    />
                  )}
                </div>
              </div>
            ) : (
              <div className="mb-8">
                <h2 className="text-3xl font-bold text-white mb-1">
                  {profile?.first_name && profile?.last_name
                    ? `${profile.first_name} ${profile.last_name}`
                    : 'Dashboard'}
                </h2>
                <p className="text-stone-400">
                  © {new Date().getFullYear()} • Game Plan PPG™
                </p>
              </div>
            )}

            {/* v5.0: Profile Completion Nudge */}
            {ENABLE_PROFILE_BRANDING && !profileComplete && !dismissedProfileNudge && (
              <div className="bg-stone-900/50 backdrop-blur border border-amber-500/30 rounded-xl p-4 mb-6 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-medium text-white">Complete your profile</h3>
                    <p className="text-sm text-stone-400">Add your photo and brokerage info to personalize your analyses.</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <button
                    onClick={onDismissProfileNudge}
                    className="text-sm text-stone-500 hover:text-stone-300 transition-colors"
                  >
                    Maybe Later
                  </button>
                  <button
                    onClick={onProfile}
                    className="px-4 py-2 bg-brand-500 text-white text-sm font-medium rounded-lg hover:bg-brand-600 transition-colors flex items-center gap-2"
                  >
                    Complete Profile
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            )}

            {/* D40 Task 4: Phone-number nudge for outcome-tracking SMS.
                Independent of the branding-completion banner above. Session-
                dismissible; existing accounts (which predate the requirement)
                see it once per login until they add a phone number on the
                Profile page. */}
            {phoneMissing && !dismissedPhoneNudge && (
              <div className="bg-stone-900/50 backdrop-blur border border-blue-500/30 rounded-xl p-4 mb-6 flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center">
                    <svg className="w-5 h-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-medium text-white">Add your phone number</h3>
                    <p className="text-sm text-stone-400">Game Plan sends agent-side updates (like Day 7 / Day 14 deal follow-ups) by text. Add a number on your Profile to receive them.</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <button
                    onClick={onDismissPhoneNudge}
                    className="text-sm text-stone-500 hover:text-stone-300 transition-colors"
                  >
                    Maybe Later
                  </button>
                  <button
                    onClick={onProfile}
                    className="px-4 py-2 bg-blue-500 text-white text-sm font-medium rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-2"
                  >
                    Add Phone
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>
              </div>
            )}

            {/* New Report Card - Primary CTA */}
            <div
              onClick={onNewReport}
              className="bg-stone-900/50 backdrop-blur border border-stone-800 rounded-2xl p-6 mb-8 cursor-pointer hover:border-brand-500/50 transition-all group"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-brand-500 to-brand-600 rounded-xl flex items-center justify-center">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white group-hover:text-brand-400 transition-colors">
                      Start New Analysis
                    </h3>
                    <p className="text-sm text-stone-400">
                      Upload an inspection report. Get your strategy in minutes.
                    </p>
                  </div>
                </div>
                <svg className="w-5 h-5 text-stone-500 group-hover:text-brand-400 group-hover:translate-x-1 transition-all" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </div>

            {/* Recent Analyses Section */}
            <div>
              <h3 className="text-lg font-semibold text-white mb-4">Recent Analyses</h3>

              {reports.length === 0 ? (
                /* Empty State */
                <div className="bg-stone-900/50 backdrop-blur border border-stone-800 rounded-2xl p-12 text-center">
                  <div className="w-16 h-16 bg-stone-800 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <h4 className="text-lg font-medium text-white mb-2">No analyses yet</h4>
                  <p className="text-stone-400 mb-6">Generate your first negotiation strategy to get started</p>
                  <button
                    onClick={onNewReport}
                    className="px-6 py-3 bg-gradient-to-r from-brand-500 to-brand-600 text-white font-semibold rounded-xl hover:opacity-90 transition-opacity"
                  >
                    Start Your First Analysis
                  </button>
                </div>
              ) : (
                /* Reports List - v5.1: Shows both complete and partial (draft) reports */
                <div className="space-y-3">
                  {/* Welcome message for new users (only sample report exists) */}
                  {reports.length === 1 && reports[0].is_sample && (
                    <div style={{
                      background: 'rgba(249, 115, 22, 0.08)',
                      border: '1px solid rgba(249, 115, 22, 0.2)',
                      borderRadius: '12px',
                      padding: '20px',
                      marginBottom: '16px',
                    }}>
                      <h3 style={{ color: '#ffffff', fontSize: '18px', fontWeight: '600', margin: '0 0 8px 0' }}>
                        Welcome to Game Plan PPG™!
                      </h3>
                      <p style={{ color: '#a8a29e', fontSize: '14px', margin: '0 0 12px 0', lineHeight: '1.5' }}>
                        We've loaded a sample analysis so you can see what Game Plan PPG™ generates. Tap into it to explore the strategy, scripts, and client explanation.
                      </p>
                      <p style={{ color: '#a8a29e', fontSize: '14px', margin: 0, lineHeight: '1.5' }}>
                        When you're ready, click <strong style={{ color: '#7b8bff' }}>Start New Analysis</strong> above to upload your own inspection report.
                      </p>
                    </div>
                  )}
                  {reports.map((report) => {
                    // v5.1: Determine if this is a draft (partial) report
                    // Legacy reports (null/undefined status) are treated as complete
                    // D44 Bug 4: include step1_draft so partial Page-1 entries show up
                    // as drafts on the dashboard.
                    const isDraft = report.report_status === 'step1_draft' ||
                                   report.report_status === 'extraction_complete' ||
                                   report.report_status === 'customization_complete';
                    const draftLabel = report.report_status === 'step1_draft'
                      ? 'Draft — needs inspection report'
                      : report.report_status === 'extraction_complete'
                        ? 'Draft — click to continue'
                        : report.report_status === 'customization_complete'
                          ? 'Draft — ready to generate'
                          : null;

                    // v5.2: Outcome tracking
                    // A report is complete if it has strategy data (ask_total > 0) and isn't a draft
                    // This covers both new reports (with report_status) and legacy reports (without)
                    const hasStrategyData = report.ask_total && Number(report.ask_total) > 0;
                    const isComplete = !isDraft && hasStrategyData;
                    const hasOutcome = report.outcome_status && ['won', 'lost', 'walked', 'stalled'].includes(report.outcome_status);
                    // D22: detect manual_dev cost source on any finding for the TEST DATA badge
                    const hasManualDevCost = Array.isArray(report.findings_json)
                      && report.findings_json.some(f => f && f.costSource === 'manual_dev');
                    const outcomeLabels = {
                      won: { text: 'Won', emoji: '🎉', color: 'bg-emerald-500/20 text-emerald-400' },
                      lost: { text: 'Not This One', emoji: '😔', color: 'bg-red-500/20 text-red-400' },
                      walked: { text: 'Walked Away', emoji: '🚶', color: 'bg-stone-500/20 text-stone-400' },
                      stalled: { text: 'Still Going', emoji: '⏳', color: 'bg-amber-500/20 text-amber-400' }
                    };

                    const handleCardClick = () => {
                      if (isDraft) {
                        onResumeDraft(report);
                      } else {
                        onViewReport(report);
                      }
                    };

                    const handleDelete = (e) => {
                      e.stopPropagation(); // Don't trigger card click
                      if (window.confirm(`Remove "${report.property_address || 'this report'}" from your dashboard?`)) {
                        onHideReport(report.id);
                      }
                    };

                    const handleTrackOutcome = (e) => {
                      e.stopPropagation();
                      onTrackOutcome(report.id);
                    };

                    return (
                      <div
                        key={report.id}
                        onClick={handleCardClick}
                        className={`backdrop-blur border rounded-xl p-4 transition-all group cursor-pointer ${
                          isDraft
                            ? 'bg-stone-900/30 border-amber-500/30 hover:border-amber-500/50'
                            : 'bg-stone-900/50 border-stone-800 hover:border-brand-500/50'
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 flex-wrap">
                              <h4 className={`font-medium transition-colors truncate ${
                                isDraft ? 'text-amber-200 group-hover:text-amber-100' : 'text-white group-hover:text-brand-400'
                              }`}>
                                {report.property_address || 'Unnamed Property'}
                              </h4>
                              {isDraft && (
                                <span className="text-xs bg-amber-500/20 text-amber-400 px-2 py-0.5 rounded whitespace-nowrap">
                                  {draftLabel}
                                </span>
                              )}
                              {/* Sample report badge */}
                              {report.is_sample && (
                                <span style={{
                                  background: 'rgba(249, 115, 22, 0.15)',
                                  color: '#7b8bff',
                                  fontSize: '11px',
                                  fontWeight: '600',
                                  padding: '3px 8px',
                                  borderRadius: '4px',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  whiteSpace: 'nowrap'
                                }}>
                                  Sample Analysis
                                </span>
                              )}
                              {/* D22: TEST DATA badge — fires when any finding on this report has a manual_dev cost source */}
                              {hasManualDevCost && (
                                <span style={{
                                  background: 'rgba(251,191,36,0.18)',
                                  color: '#fbbf24',
                                  border: '1px solid rgba(251,191,36,0.55)',
                                  fontSize: '11px',
                                  fontWeight: '700',
                                  padding: '3px 8px',
                                  borderRadius: '4px',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  whiteSpace: 'nowrap'
                                }} title="This report contains manually-entered cost estimates for development testing. Not for client use.">
                                  ⚠️ TEST DATA
                                </span>
                              )}
                            </div>
                            <p className="text-sm text-stone-500">
                              {report.is_sample
                                ? 'Explore what Game Plan PPG™ generates from a real inspection report'
                                : `${report.client_name || 'No client'} • ${new Date(report.created_at).toLocaleDateString()}`
                              }
                            </p>
                          </div>
                          <div className="flex items-center gap-3">
                            <div className="text-right">
                              <p className={`text-lg font-semibold ${isDraft ? 'text-amber-400' : 'text-brand-400'}`}>
                                {isDraft ? 'Continue' : `$${report.ask_total?.toLocaleString() || '—'}`}
                              </p>
                              <p className="text-xs text-stone-500">{isDraft ? `${report.findings_count || 0} findings` : 'Total Ask'}</p>
                            </div>
                            {/* v5.2: Track Outcome button - always visible for completed reports without outcome */}
                            {isComplete && !hasOutcome && (
                              <button
                                onClick={handleTrackOutcome}
                                className="px-3 py-1.5 text-xs bg-brand-500/20 text-brand-400 hover:bg-brand-500/30 border border-brand-500/30 rounded-lg transition-colors whitespace-nowrap"
                                title="Track negotiation outcome"
                              >
                                Track Outcome
                              </button>
                            )}
                            {/* Show green Outcome Tracked badge when outcome has been tracked - clickable to view/edit */}
                            {isComplete && hasOutcome && (
                              <button
                                onClick={handleTrackOutcome}
                                className="flex items-center gap-1.5 px-3 py-1.5 text-xs bg-emerald-500/20 text-emerald-400 hover:bg-emerald-500/30 border border-emerald-500/30 rounded-lg transition-colors whitespace-nowrap"
                                title="View or update outcome"
                              >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                                </svg>
                                Outcome Tracked
                              </button>
                            )}
                            <svg className={`w-5 h-5 transition-colors ${isDraft ? 'text-amber-500 group-hover:text-amber-400' : 'text-stone-500 group-hover:text-brand-400'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                            </svg>
                            {/* Delete button */}
                            <button
                              onClick={handleDelete}
                              className="p-1.5 text-stone-600 hover:text-red-400 hover:bg-red-500/10 rounded transition-colors opacity-0 group-hover:opacity-100"
                              title="Remove from dashboard"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Beta Feedback Widget */}
            <div className="glass rounded-2xl overflow-hidden mt-6" style={{ borderColor: 'rgba(99, 102, 241, 0.2)' }}>
              {!feedbackOpen && !feedbackSent && (
                <button
                  onClick={() => setFeedbackOpen(true)}
                  className="w-full p-4 flex items-center justify-center gap-2 text-stone-400 hover:text-white transition-colors text-sm"
                >
                  <span>Found a bug or have feedback? <strong className="text-indigo-400">Let us know →</strong></span>
                </button>
              )}
              {feedbackSent && (
                <div className="p-4 text-center text-emerald-400 text-sm">
                  Thanks! We got your feedback. 🙏
                </div>
              )}
              {feedbackOpen && !feedbackSent && (
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="font-semibold text-white text-sm">BETA FEEDBACK</span>
                  </div>
                  <textarea
                    value={feedbackText}
                    onChange={(e) => setFeedbackText(e.target.value)}
                    placeholder="What happened? What could be better? Any bugs to report?"
                    className="w-full bg-stone-800/50 border border-stone-700 rounded-lg p-3 text-white placeholder-stone-500 text-sm resize-none focus:outline-none focus:border-indigo-500"
                    rows={4}
                  />
                  <div className="flex items-center justify-between mt-3">
                    <p className="text-stone-500 text-xs">Your feedback goes directly to the engineering team.</p>
                    <div className="flex gap-2">
                      <button
                        onClick={() => { setFeedbackOpen(false); setFeedbackText(''); }}
                        className="px-3 py-1.5 text-stone-400 hover:text-white text-sm transition-colors"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={async () => {
                          if (!feedbackText.trim()) return;
                          setFeedbackSending(true);
                          try {
                            const { error } = await supabaseClient.from('feedback').insert({
                              user_id: user?.id || null,
                              email: user?.email || 'anonymous',
                              message: feedbackText.trim(),
                              page: 'dashboard',
                              report_id: null,
                              created_at: new Date().toISOString()
                            });
                            if (error) throw error;
                            setFeedbackSent(true);
                            setFeedbackText('');
                          } catch (err) {
                            console.error('Feedback error:', err);
                            alert('Failed to send feedback. Please try again.');
                          } finally {
                            setFeedbackSending(false);
                          }
                        }}
                        disabled={feedbackSending || !feedbackText.trim()}
                        className="px-4 py-1.5 bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 text-white text-sm rounded-lg font-medium transition-colors"
                      >
                        {feedbackSending ? 'Sending...' : 'Submit Feedback'}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

          </main>

          {/* v5.0: Full-width Footer */}
          <footer className="bg-stone-950 border-t border-stone-800">
            <div className="px-8 md:px-12 lg:px-16 py-8">
              {/* Top section */}
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-8">
                <div className="flex items-center gap-3">
                  <img src={window.KNIGHT_LOGO_SRC} alt="Game Plan" className="w-8 h-8 rounded-lg" />
                  <div>
                    <span className="text-white font-semibold">Game Plan PPG™</span>
                    <span className="ml-2 px-2 py-0.5 text-xs bg-brand-500/20 text-brand-400 rounded-full border border-brand-500/30">Beta</span>
                  </div>
                </div>
                <div className="flex flex-wrap items-center gap-6 text-sm">
                  <a href="mailto:support@gameplanpro.ai?subject=Terms%20of%20Service%20Request&body=Hello%2C%0A%0AI%20would%20like%20to%20review%20the%20Terms%20of%20Service%20for%20Game%20Plan%E2%84%A2.%20Please%20send%20them%20at%20your%20earliest%20convenience.%0A%0AThank%20you!" className="text-stone-400 hover:text-white transition-colors">Terms of Service</a>
                  <a href="mailto:support@gameplanpro.ai?subject=Privacy%20Policy%20Request&body=Hello%2C%0A%0AI%20would%20like%20to%20review%20the%20Privacy%20Policy%20for%20Game%20Plan%E2%84%A2.%20Please%20send%20it%20at%20your%20earliest%20convenience.%0A%0AThank%20you!" className="text-stone-400 hover:text-white transition-colors">Privacy Policy</a>
                  <a href="mailto:support@gameplanpro.ai?subject=Support%20Request" className="text-stone-400 hover:text-white transition-colors">Support</a>
                  <a href="mailto:support@gameplanpro.ai" className="text-stone-400 hover:text-white transition-colors">Contact</a>
                </div>
              </div>

              {/* Divider */}
              <div className="border-t border-stone-800 pt-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  {/* Copyright */}
                  <p className="text-xs text-stone-500">
                    &copy; {new Date().getFullYear()} Game Plan PPG™ by Gambit Lab LLC. All rights reserved.
                  </p>

                  {/* Trust indicators */}
                  <div className="flex items-center gap-4 text-xs text-stone-500">
                    <span className="flex items-center gap-1">
                      <svg className="w-3.5 h-3.5 text-emerald-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                      </svg>
                      256-bit encryption
                    </span>
                    <span className="flex items-center gap-1">
                      <svg className="w-3.5 h-3.5 text-stone-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                      </svg>
                      Portland, OR
                    </span>
                    <span className="text-stone-600">v5.0</span>
                  </div>
                </div>

                {/* Disclaimer */}
                <p className="mt-4 text-xs text-stone-600 leading-relaxed">
                  Game Plan PPG™ provides data-driven negotiation insights for informational purposes only. Results are based on algorithmic analysis and should not be construed as legal, financial, or professional advice. Users should independently verify all information and consult with qualified professionals before making real estate decisions.
                </p>
              </div>
            </div>
          </footer>
        </div>
      );
    };

    // ============================================================
    // v5.0: PROFILE PAGE COMPONENT
    // ============================================================
    const ProfilePage = ({ user, profile, profileForm, setProfileForm, onSave, onBack, saving, pendingHeadshot, setPendingHeadshot, pendingBrokerageLogo, setPendingBrokerageLogo, onSwitchAccount }) => {
      const [saveSuccess, setSaveSuccess] = useState(false);
      const [headshotPreview, setHeadshotPreview] = useState(null);
      const [brokerageLogoPreview, setBrokerageLogoPreview] = useState(null);

      // Cropper state
      const [showCropModal, setShowCropModal] = useState(false);
      const [cropImageSrc, setCropImageSrc] = useState(null);
      const [cropper, setCropper] = useState(null);
      const cropperImageRef = useRef(null);

      // Generate image URL from storage path
      const getStorageUrl = (path) => {
        if (!path) return null;
        return `https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${path}`;
      };

      // Initialize cropper when modal opens
      useEffect(() => {
        if (showCropModal && cropImageSrc && cropperImageRef.current) {
          const cropperInstance = new Cropper(cropperImageRef.current, {
            aspectRatio: 1,
            viewMode: 1,
            dragMode: 'move',
            autoCropArea: 1,
            cropBoxMovable: false,
            cropBoxResizable: false,
            guides: false,
            center: true,
            background: false,
            responsive: true,
            restore: false,
          });
          setCropper(cropperInstance);

          return () => {
            cropperInstance.destroy();
            setCropper(null);
          };
        }
      }, [showCropModal, cropImageSrc]);

      // Handle crop confirmation
      const handleCropConfirm = () => {
        if (!cropper) return;

        const canvas = cropper.getCroppedCanvas({
          width: 400,
          height: 400,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high',
        });

        canvas.toBlob((blob) => {
          if (blob) {
            const croppedFile = new File([blob], 'headshot.jpg', { type: 'image/jpeg' });
            const previewUrl = URL.createObjectURL(blob);
            setPendingHeadshot(croppedFile);
            setHeadshotPreview(previewUrl);
          }
          setShowCropModal(false);
          setCropImageSrc(null);
        }, 'image/jpeg', 0.9);
      };

      // Handle crop cancel
      const handleCropCancel = () => {
        setShowCropModal(false);
        setCropImageSrc(null);
      };

      // Perf Pass: client-side downscale for brokerage logos. Caps at 600×300 px and
      // re-encodes as PNG to preserve transparency. Typical logo: 240KB → 15-30KB. Headshots
      // already go through the crop modal which produces a tightly-bounded blob; we don't
      // double-process them.
      const compressBrokerageLogo = (file) => new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const MAX_W = 600, MAX_H = 300;
          let { width, height } = img;
          if (width > MAX_W || height > MAX_H) {
            const scale = Math.min(MAX_W / width, MAX_H / height);
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob(blob => {
            if (!blob) return reject(new Error('Canvas toBlob returned null'));
            resolve(new File([blob], file.name.replace(/\.[^.]+$/, '.png'), { type: 'image/png' }));
          }, 'image/png');
        };
        img.onerror = () => reject(new Error('Failed to load image for compression'));
        img.src = URL.createObjectURL(file);
      });

      // Handle image file selection
      const handleImageSelect = async (file, type) => {
        if (!file) return;
        if (file.size > 2 * 1024 * 1024) {
          alert('Image must be less than 2MB');
          return;
        }
        if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
          alert('Please upload a JPG or PNG image');
          return;
        }

        if (type === 'headshot') {
          // Show crop modal for headshots
          setCropImageSrc(URL.createObjectURL(file));
          setShowCropModal(true);
        } else if (type === 'brokerage_logo') {
          try {
            const compressed = await compressBrokerageLogo(file);
            setPendingBrokerageLogo(compressed);
            setBrokerageLogoPreview(URL.createObjectURL(compressed));
          } catch (err) {
            console.warn('Brokerage logo compression failed, uploading original:', err);
            setPendingBrokerageLogo(file);
            setBrokerageLogoPreview(URL.createObjectURL(file));
          }
        }
      };

      const handleSave = async () => {
        const success = await onSave();
        if (success) {
          setSaveSuccess(true);
          setTimeout(() => setSaveSuccess(false), 3000);
        }
      };

      const isFormValid = profileForm.first_name?.trim() && profileForm.last_name?.trim();

      return (
        <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #1c1917 0%, #292524 100%)'}}>
          {/* Header */}
          <header className="glass border-b border-brand-500/20 sticky top-0 z-50">
            <div className="max-w-3xl mx-auto px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-brand-500 to-brand-600 rounded-xl flex items-center justify-center overflow-hidden">
                    <img src={window.KNIGHT_LOGO_SRC} alt="Game Plan PPG" className="w-full h-full object-contain" />
                  </div>
                  <div>
                    <h1 className="text-xl font-bold text-white">Game Plan PPG<sup className="text-xs">™</sup></h1>
                    <p className="text-xs text-stone-400">Profile Settings</p>
                  </div>
                </div>
                <button
                  onClick={onBack}
                  className="text-sm text-stone-400 hover:text-white transition-colors flex items-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                  </svg>
                  Back to Dashboard
                </button>
              </div>
            </div>
          </header>

          {/* Main Content */}
          <main className="max-w-3xl mx-auto px-6 py-8">
            {/* Success Toast */}
            {saveSuccess && (
              <div className="mb-6 p-4 bg-emerald-500/20 border border-emerald-500/30 rounded-xl flex items-center gap-3">
                <svg className="w-5 h-5 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span className="text-emerald-300">Profile saved successfully!</span>
              </div>
            )}

            {/* Section A: Account Info */}
            <div className="glass rounded-2xl p-6 mb-6">
              <h2 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                <svg className="w-5 h-5 text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                Account Information
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm text-stone-400 mb-1">First Name <span className="text-rose-400">*</span></label>
                  <input
                    type="text"
                    value={profileForm.first_name || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, first_name: e.target.value })}
                    className="w-full px-4 py-2.5 bg-stone-900/50 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none transition-colors"
                    placeholder="John"
                  />
                </div>
                <div>
                  <label className="block text-sm text-stone-400 mb-1">Last Name <span className="text-rose-400">*</span></label>
                  <input
                    type="text"
                    value={profileForm.last_name || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, last_name: e.target.value })}
                    className="w-full px-4 py-2.5 bg-stone-900/50 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none transition-colors"
                    placeholder="Smith"
                  />
                </div>
                <div>
                  <label className="block text-sm text-stone-400 mb-1">Email</label>
                  <input
                    type="email"
                    value={user?.email || ''}
                    disabled
                    className="w-full px-4 py-2.5 bg-stone-800/50 border border-stone-700 rounded-lg text-stone-400 cursor-not-allowed"
                  />
                </div>
                <div>
                  <label className="block text-sm text-stone-400 mb-1">Subscription Status</label>
                  <div className="px-4 py-2.5 bg-stone-800/50 border border-stone-700 rounded-lg">
                    <span className={`inline-flex items-center gap-2 ${profile?.subscription_status === 'active' || profile?.is_beta_cohort ? 'text-emerald-400' : 'text-stone-400'}`}>
                      {profile?.is_beta_cohort && (
                        <span className="px-2 py-0.5 bg-amber-500/20 text-amber-400 text-xs rounded-full">Beta</span>
                      )}
                      {profile?.subscription_status === 'active' ? 'Active' : profile?.is_beta_cohort ? 'Beta Access' : 'Inactive'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Section B: Professional Info */}
            <div className="glass rounded-2xl p-6 mb-6">
              <h2 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                <svg className="w-5 h-5 text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                Professional Information
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="block text-sm text-stone-400 mb-1">Brokerage Name</label>
                  <input
                    type="text"
                    value={profileForm.brokerage || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, brokerage: e.target.value })}
                    className="w-full px-4 py-2.5 bg-stone-900/50 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none transition-colors"
                    placeholder="Keller Williams Realty"
                  />
                </div>
                <div>
                  <label className="block text-sm text-stone-400 mb-1">License Number</label>
                  <input
                    type="text"
                    value={profileForm.license_number || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, license_number: e.target.value })}
                    className="w-full px-4 py-2.5 bg-stone-900/50 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none transition-colors"
                    placeholder="OR-12345678"
                  />
                </div>
                <div>
                  <label className="block text-sm text-stone-400 mb-1">Phone Number</label>
                  <input
                    type="tel"
                    value={profileForm.phone_number || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, phone_number: e.target.value })}
                    className="w-full px-4 py-2.5 bg-stone-900/50 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none transition-colors"
                    placeholder="(503) 555-1234"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm text-stone-400 mb-1">Designations</label>
                  <input
                    type="text"
                    value={profileForm.designations || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, designations: e.target.value })}
                    className="w-full px-4 py-2.5 bg-stone-900/50 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none transition-colors"
                    placeholder="CRS, GRI, ABR"
                  />
                  <p className="text-xs text-stone-500 mt-1">Professional designations after your name</p>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm text-stone-400 mb-1">Tagline</label>
                  <input
                    type="text"
                    value={profileForm.tagline || ''}
                    onChange={(e) => setProfileForm({ ...profileForm, tagline: e.target.value.slice(0, 100) })}
                    className="w-full px-4 py-2.5 bg-stone-900/50 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none transition-colors"
                    placeholder="Your Home, Your Future"
                    maxLength={100}
                  />
                  <p className="text-xs text-stone-500 mt-1">{(profileForm.tagline || '').length}/100 characters</p>
                </div>
              </div>
            </div>

            {/* Section C: Branding Images */}
            <div className="glass rounded-2xl p-6 mb-6">
              <h2 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                <svg className="w-5 h-5 text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Branding Images
              </h2>
              <p className="text-sm text-stone-400 mb-6">These images will appear on your analyses and PDF exports.</p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-lg mx-auto">
                {/* Headshot */}
                <div>
                  <label className="block text-sm text-stone-400 mb-2">Your Headshot</label>
                  <div
                    className="aspect-square rounded-xl border-2 border-dashed border-stone-700 hover:border-brand-500/50 transition-colors flex items-center justify-center cursor-pointer overflow-hidden bg-stone-900/30"
                    onClick={() => document.getElementById('headshot-upload').click()}
                  >
                    {(headshotPreview || profile?.headshot_url) ? (
                      <img
                        src={headshotPreview || getStorageUrl(profile?.headshot_url)}
                        alt="Headshot"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="text-center p-4">
                        <svg className="w-8 h-8 text-stone-500 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        <p className="text-xs text-stone-500">Click to upload</p>
                      </div>
                    )}
                  </div>
                  <input
                    type="file"
                    id="headshot-upload"
                    accept="image/jpeg,image/png"
                    className="hidden"
                    onChange={(e) => handleImageSelect(e.target.files[0], 'headshot')}
                  />
                  <p className="text-xs text-stone-500 mt-1">Square recommended, max 2MB</p>
                </div>

                {/* Brokerage Logo */}
                <div>
                  <label className="block text-sm text-stone-400 mb-2">Brokerage Logo</label>
                  <div
                    className="aspect-square rounded-xl border-2 border-dashed border-stone-700 hover:border-brand-500/50 transition-colors flex items-center justify-center cursor-pointer overflow-hidden bg-stone-900/30"
                    onClick={() => document.getElementById('brokerage-logo-upload').click()}
                  >
                    {(brokerageLogoPreview || profile?.brokerage_logo_url) ? (
                      <img
                        src={brokerageLogoPreview || getStorageUrl(profile?.brokerage_logo_url)}
                        alt="Brokerage Logo"
                        className="w-full h-full object-contain p-4"
                      />
                    ) : (
                      <div className="text-center p-4">
                        <svg className="w-8 h-8 text-stone-500 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                        </svg>
                        <p className="text-xs text-stone-500">Click to upload</p>
                      </div>
                    )}
                  </div>
                  <input
                    type="file"
                    id="brokerage-logo-upload"
                    accept="image/jpeg,image/png"
                    className="hidden"
                    onChange={(e) => handleImageSelect(e.target.files[0], 'brokerage_logo')}
                  />
                  <p className="text-xs text-stone-500 mt-1">e.g., Keller Williams, RE/MAX</p>
                </div>
              </div>
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-4">
              <button
                onClick={onBack}
                className="px-6 py-3 text-stone-400 hover:text-white transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                disabled={saving || !isFormValid}
                className={`px-8 py-3 rounded-xl font-medium transition-all flex items-center gap-2 ${
                  isFormValid && !saving
                    ? 'bg-brand-500 text-white hover:bg-brand-600'
                    : 'bg-stone-700 text-stone-400 cursor-not-allowed'
                }`}
              >
                {saving ? (
                  <>
                    <svg className="w-5 h-5 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Saving...
                  </>
                ) : (
                  <>
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    Save Profile
                  </>
                )}
              </button>
            </div>

            {/* Account Actions */}
            <div className="mt-8 pt-6 border-t border-stone-800">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-medium text-stone-400">Account</h3>
                  <p className="text-xs text-stone-500 mt-1">Switch to a different Google account</p>
                </div>
                <button
                  onClick={onSwitchAccount}
                  className="px-4 py-2 text-sm text-stone-400 hover:text-white border border-stone-700 rounded-lg hover:border-stone-600 transition-colors flex items-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                  </svg>
                  Switch Account
                </button>
              </div>
            </div>
          </main>

          {/* Headshot Crop Modal */}
          {showCropModal && (
            <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
              <div className="bg-stone-900 rounded-2xl border border-stone-700 max-w-lg w-full overflow-hidden">
                <div className="p-4 border-b border-stone-700">
                  <h3 className="text-lg font-semibold text-white">Adjust Your Headshot</h3>
                  <p className="text-sm text-stone-400 mt-1">Drag to reposition, scroll or pinch to zoom</p>
                </div>
                <div className="p-4 bg-stone-950">
                  <div className="relative w-full" style={{ height: '300px' }}>
                    {cropImageSrc && (
                      <img
                        ref={cropperImageRef}
                        src={cropImageSrc}
                        alt="Crop preview"
                        style={{ maxWidth: '100%', display: 'block' }}
                      />
                    )}
                  </div>
                </div>
                <div className="p-4 border-t border-stone-700 flex justify-end gap-3">
                  <button
                    onClick={handleCropCancel}
                    className="px-4 py-2 text-stone-400 hover:text-white transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleCropConfirm}
                    className="px-6 py-2 bg-brand-500 text-white rounded-lg hover:bg-brand-600 transition-colors font-medium"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    };

    // ============================================================
    // v5.2: OUTCOME FORM COMPONENT (Track negotiation results)
    // ============================================================
    const OutcomeForm = ({ reportId, onBack, user, supabaseClient, preselectedStatus, source = 'in_app' }) => {
      const [loading, setLoading] = useState(true);
      const [saving, setSaving] = useState(false);
      const [report, setReport] = useState(null);
      const [existingOutcome, setExistingOutcome] = useState(null);
      const [error, setError] = useState(null);
      const [success, setSuccess] = useState(false);

      // Form state
      const [outcome, setOutcome] = useState(preselectedStatus || ''); // won, lost, walked, stalled
      const [itemOutcomes, setItemOutcomes] = useState({}); // Per-item outcomes: { itemIndex: 'got_it'|'got_less'|'denied'|'didnt_ask' }
      const [formData, setFormData] = useState({
        // Won fields
        ask_received: '',
        credits_received: '',
        close_price: '',
        close_date: '',
        // Lost fields
        lost_reason: '',
        // Walked fields
        walked_reason: '',
        specific_issue: '',
        // Stalled fields
        still_active: true,
        next_update_date: '',
        // Common
        notes: ''
      });

      // Load report and existing outcome on mount
      useEffect(() => {
        const loadData = async () => {
          try {
            // Load the report (including findings_json for item-level tracking)
            // SECURITY: Filter by user_id to prevent unauthorized access
            const { data: reportData, error: reportError } = await supabaseClient
              .from('reports')
              .select('id, property_address, city_state, list_price, ask_total, leverage_score, created_at, findings_json')
              .eq('id', reportId)
              .eq('user_id', user.id)
              .single();

            if (reportError || !reportData) {
              // Don't reveal that the report exists but belongs to someone else
              setError('Report not found');
              setLoading(false);
              return;
            }
            setReport(reportData);

            // Check for existing outcome
            const { data: outcomeData } = await supabaseClient
              .from('outcomes')
              .select('*')
              .eq('report_id', reportId)
              .single();

            if (outcomeData) {
              setExistingOutcome(outcomeData);
              setOutcome(outcomeData.outcome_type);
              setFormData({
                ask_received: outcomeData.received_amount?.toString() || '',
                credits_received: outcomeData.credits_received?.toString() || '',
                close_price: outcomeData.purchase_price?.toString() || '',
                close_date: outcomeData.close_date || '',
                lost_reason: outcomeData.lost_reason || '',
                walked_reason: outcomeData.walked_reason || '',
                specific_issue: outcomeData.specific_issue || '',
                still_active: outcomeData.stalled_status !== 'inactive',
                next_update_date: outcomeData.next_update_date || '',
                notes: outcomeData.notes || ''
              });
              // Load existing item outcomes if present
              if (outcomeData.item_outcomes) {
                setItemOutcomes(outcomeData.item_outcomes);
              }
            }
          } catch (err) {
            console.error('Error loading outcome data:', err);
            setError('Failed to load report data. Please try again.');
          } finally {
            setLoading(false);
          }
        };

        if (reportId && user) {
          loadData();
        }
      }, [reportId, user]);

      const handleSubmit = async (e) => {
        e.preventDefault();
        if (!outcome) {
          setError('Please select an outcome');
          return;
        }

        setSaving(true);
        setError(null);

        try {
          const outcomeRecord = {
            report_id: reportId,
            user_id: user.id,
            outcome_type: outcome,
            notes: formData.notes || null,
            item_outcomes: Object.keys(itemOutcomes).length > 0 ? itemOutcomes : null,
            source: source || 'in_app' // Track where the outcome came from (in_app, email_day7, email_day14)
          };

          // Add outcome-specific fields
          if (outcome === 'won') {
            outcomeRecord.received_amount = formData.ask_received ? parseInt(formData.ask_received.replace(/[^0-9.-]/g, '')) : null;
            outcomeRecord.credits_received = formData.credits_received ? parseInt(formData.credits_received.replace(/[^0-9.-]/g, '')) : null;
            outcomeRecord.purchase_price = formData.close_price ? parseInt(formData.close_price.replace(/[^0-9.-]/g, '')) : null;
            outcomeRecord.close_date = formData.close_date || null;
          } else if (outcome === 'lost') {
            outcomeRecord.lost_reason = formData.lost_reason || null;
          } else if (outcome === 'walked') {
            outcomeRecord.walked_reason = formData.walked_reason || null;
            outcomeRecord.specific_issue = formData.specific_issue || null;
          } else if (outcome === 'stalled') {
            outcomeRecord.stalled_status = formData.still_active ? 'active' : 'inactive';
            outcomeRecord.next_update_date = formData.next_update_date || null;
          }

          if (existingOutcome) {
            // Update existing
            const { error: updateError } = await supabaseClient
              .from('outcomes')
              .update(outcomeRecord)
              .eq('id', existingOutcome.id);
            if (updateError) throw updateError;
          } else {
            // Insert new
            const { error: insertError } = await supabaseClient
              .from('outcomes')
              .insert(outcomeRecord);
            if (insertError) throw insertError;
          }

          // Update report with outcome status (include user_id for defense in depth)
          await supabaseClient
            .from('reports')
            .update({ outcome_status: outcome })
            .eq('id', reportId)
            .eq('user_id', user.id);

          setSuccess(true);
          setTimeout(() => onBack(), 1500);
        } catch (err) {
          console.error('Error saving outcome:', err);
          setError('Failed to save outcome. Please try again.');
        } finally {
          setSaving(false);
        }
      };

      // Currency formatter helper
      const formatCurrency = (value) => {
        if (!value) return '';
        const num = parseFloat(value.replace(/[^0-9.-]/g, ''));
        if (isNaN(num)) return value;
        return num.toLocaleString('en-US');
      };

      if (loading) {
        return (
          <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, #1c1917 0%, #292524 100%)'}}>
            <div className="text-center">
              <div className="w-12 h-12 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-stone-400">Loading...</p>
            </div>
          </div>
        );
      }

      if (!report) {
        return (
          <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, #1c1917 0%, #292524 100%)'}}>
            <div className="text-center max-w-md mx-auto px-6">
              <div className="w-16 h-16 bg-stone-800 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-stone-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-white mb-3">We couldn't locate this report</h2>
              <p className="text-stone-400 mb-2">It may have already been closed out.</p>
              <p className="text-stone-500 text-sm mb-8">You can track outcomes for any of your reports from your dashboard.</p>
              <button
                onClick={onBack}
                className="px-6 py-3 bg-brand-500 hover:bg-brand-600 text-white font-semibold rounded-xl transition-colors"
              >
                Go to Dashboard
              </button>
            </div>
          </div>
        );
      }

      return (
        <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #1c1917 0%, #292524 100%)'}}>
          {/* Header */}
          <header className="glass border-b border-brand-500/20 sticky top-0 z-50">
            <div className="max-w-2xl mx-auto px-6 py-4">
              <div className="flex items-center justify-between">
                <button
                  onClick={onBack}
                  className="flex items-center gap-2 text-stone-400 hover:text-white transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  Dashboard
                </button>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-gradient-to-br from-brand-500 to-brand-600 rounded-lg flex items-center justify-center overflow-hidden">
                    <img src={window.KNIGHT_LOGO_SRC} alt="Game Plan PPG" className="w-full h-full object-contain" />
                  </div>
                  <h1 className="text-lg font-bold text-white">Track Outcome</h1>
                </div>
              </div>
            </div>
          </header>

          {/* Form Content */}
          <main className="max-w-2xl mx-auto px-6 py-8">
            {/* Property Context */}
            <div className="glass rounded-xl p-4 mb-4">
              <h2 className="text-lg font-semibold text-white">{report.property_address || 'Unnamed Property'}</h2>
              <p className="text-stone-400 text-sm mt-1">{report.city_state}</p>
              <div className="flex gap-4 mt-3 text-sm">
                <span className="text-stone-500">List: <span className="text-white">${report.list_price?.toLocaleString() || '—'}</span></span>
                {report.ask_total > 0 && (
                  <span className="text-stone-500">Ask: <span className="text-emerald-400">${report.ask_total?.toLocaleString()}</span></span>
                )}
              </div>
            </div>

            {/* Confidence Coaching Block - moved from email to form */}
            {report.leverage_score !== null && report.leverage_score !== undefined && (
              <div className="rounded-xl p-4 mb-6" style={{
                background: 'rgba(249,115,22,0.06)',
                border: '1px solid rgba(249,115,22,0.12)'
              }}>
                <p className="text-stone-400 text-sm leading-relaxed">
                  When you ran this analysis, you had a leverage score of{' '}
                  <strong className="text-brand-400">
                    {report.leverage_score >= 0 ? '+' : ''}{report.leverage_score}
                  </strong>
                  {' — '}
                  {report.leverage_score >= 7 ? 'a strong negotiating position' :
                   report.leverage_score >= 3 ? 'solid ground to negotiate from' :
                   report.leverage_score >= 0 ? 'a balanced position with room to push' :
                   'a challenging position, but you had a clear strategy'}.
                  {report.ask_total > 0 && (
                    <> The data supported <strong className="text-brand-400">${Number(report.ask_total).toLocaleString()}</strong> in concessions.</>
                  )}
                  {' '}Whatever happened, you walked in with real numbers.
                </p>
              </div>
            )}

            {success ? (
              <div className="glass rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold text-white mb-2">Outcome Saved!</h3>
                <p className="text-stone-400">Thank you for tracking this negotiation.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Outcome Selection */}
                <div className="glass rounded-xl p-6">
                  <label className="block text-sm font-medium text-stone-300 mb-4">How did the negotiation end?</label>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      { value: 'won', label: 'Won', emoji: '🎉', desc: 'Deal closed successfully' },
                      { value: 'lost', label: 'Not This One', emoji: '😔', desc: 'Deal fell through' },
                      { value: 'walked', label: 'Walked Away', emoji: '🚶', desc: 'Client walked away' },
                      { value: 'stalled', label: 'Still Going', emoji: '⏳', desc: 'Still in negotiation' }
                    ].map(opt => (
                      <button
                        key={opt.value}
                        type="button"
                        onClick={() => setOutcome(opt.value)}
                        className={`p-4 rounded-xl border-2 text-left transition-all ${
                          outcome === opt.value
                            ? 'border-brand-500 bg-brand-500/10'
                            : 'border-stone-700 hover:border-stone-600'
                        }`}
                      >
                        <div className="flex items-center gap-2 mb-1">
                          <span className="text-xl">{opt.emoji}</span>
                          <span className={`font-semibold ${outcome === opt.value ? 'text-brand-400' : 'text-white'}`}>{opt.label}</span>
                        </div>
                        <p className="text-xs text-stone-400">{opt.desc}</p>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Item-Level Outcome Tracking */}
                {outcome && outcome !== 'stalled' && report.findings_json && report.findings_json.length > 0 && (
                  <div className="glass rounded-xl p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-sm font-medium text-stone-300">What happened with each item?</h3>
                      <span className="text-xs text-stone-500">Optional but valuable for future strategies</span>
                    </div>
                    <div className="space-y-3">
                      {report.findings_json.map((finding, index) => {
                        const currentOutcome = itemOutcomes[index];
                        const outcomeOptions = [
                          { value: 'got_it', label: 'Got it', color: 'emerald' },
                          { value: 'got_less', label: 'Got less', color: 'amber' },
                          { value: 'denied', label: 'Denied', color: 'red' },
                          { value: 'didnt_ask', label: "Didn't ask", color: 'stone' }
                        ];
                        return (
                          <div key={index} className="bg-stone-800/50 rounded-lg p-3">
                            <div className="flex items-start justify-between gap-4 mb-2">
                              <div className="flex-1 min-w-0">
                                <p className="text-sm text-white font-medium truncate">{finding.description || finding.item || `Item ${index + 1}`}</p>
                                {finding.askPrice > 0 && (
                                  <p className="text-xs text-stone-400 mt-0.5">Asked: ${finding.askPrice?.toLocaleString()}</p>
                                )}
                              </div>
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {outcomeOptions.map(opt => {
                                const isSelected = currentOutcome === opt.value;
                                const bgClass = isSelected
                                  ? opt.color === 'emerald' ? 'bg-emerald-500/20 border-emerald-500 text-emerald-400'
                                  : opt.color === 'amber' ? 'bg-amber-500/20 border-amber-500 text-amber-400'
                                  : opt.color === 'red' ? 'bg-red-500/20 border-red-500 text-red-400'
                                  : 'bg-stone-600/20 border-stone-500 text-stone-400'
                                  : 'border-stone-700 text-stone-500 hover:border-stone-600';
                                return (
                                  <button
                                    key={opt.value}
                                    type="button"
                                    onClick={() => {
                                      setItemOutcomes(prev => {
                                        const updated = {...prev};
                                        if (currentOutcome === opt.value) {
                                          delete updated[index]; // Toggle off
                                        } else {
                                          updated[index] = opt.value;
                                        }
                                        return updated;
                                      });
                                    }}
                                    className={`px-3 py-1.5 text-xs font-medium border rounded-lg transition-all ${bgClass}`}
                                  >
                                    {opt.label}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {Object.keys(itemOutcomes).length > 0 && (
                      <p className="text-xs text-stone-500 mt-3">
                        {Object.keys(itemOutcomes).length} of {report.findings_json.length} items tracked
                      </p>
                    )}
                  </div>
                )}

                {/* Won Fields */}
                {outcome === 'won' && (
                  <div className="glass rounded-xl p-6 space-y-4">
                    <h3 className="text-sm font-medium text-emerald-400 mb-4">Congratulations! Let's capture the details.</h3>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs text-stone-400 mb-1">Credits/Concessions Received ($)</label>
                        <input
                          type="text"
                          value={formData.credits_received}
                          onChange={(e) => setFormData({...formData, credits_received: e.target.value})}
                          placeholder="15,000"
                          className="w-full px-3 py-2 bg-stone-800 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-stone-400 mb-1">Final Purchase Price ($)</label>
                        <input
                          type="text"
                          value={formData.close_price}
                          onChange={(e) => setFormData({...formData, close_price: e.target.value})}
                          placeholder="475,000"
                          className="w-full px-3 py-2 bg-stone-800 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none"
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs text-stone-400 mb-1">Close Date</label>
                        <input
                          type="date"
                          value={formData.close_date}
                          onChange={(e) => setFormData({...formData, close_date: e.target.value})}
                          className="w-full px-3 py-2 bg-stone-800 border border-stone-700 rounded-lg text-white focus:border-brand-500 focus:outline-none"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-stone-400 mb-1">Total Amount Received ($)</label>
                        <input
                          type="text"
                          value={formData.ask_received}
                          onChange={(e) => setFormData({...formData, ask_received: e.target.value})}
                          placeholder="20,000"
                          className="w-full px-3 py-2 bg-stone-800 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none"
                        />
                      </div>
                    </div>
                  </div>
                )}

                {/* Lost Fields */}
                {outcome === 'lost' && (
                  <div className="glass rounded-xl p-6">
                    <label className="block text-sm font-medium text-stone-300 mb-3">What happened?</label>
                    <div className="space-y-2">
                      {[
                        { value: 'competing_offer', label: 'Another offer was accepted' },
                        { value: 'price_gap', label: 'Price gap too large' },
                        { value: 'seller_withdrew', label: 'Seller withdrew from market' },
                        { value: 'financing_issue', label: 'Financing fell through' },
                        { value: 'other', label: 'Other reason' }
                      ].map(opt => (
                        <label key={opt.value} className="flex items-center gap-3 p-3 rounded-lg hover:bg-stone-800/50 cursor-pointer">
                          <input
                            type="radio"
                            name="lost_reason"
                            value={opt.value}
                            checked={formData.lost_reason === opt.value}
                            onChange={(e) => setFormData({...formData, lost_reason: e.target.value})}
                            className="w-4 h-4 text-brand-500"
                          />
                          <span className="text-stone-300">{opt.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                )}

                {/* Walked Fields */}
                {outcome === 'walked' && (
                  <div className="glass rounded-xl p-6">
                    <label className="block text-sm font-medium text-stone-300 mb-3">Why did the client walk?</label>
                    <div className="space-y-2 mb-4">
                      {[
                        { value: 'inspection_issues', label: 'Inspection issues too severe' },
                        { value: 'changed_mind', label: 'Changed mind about the property' },
                        { value: 'found_better', label: 'Found a better property' },
                        { value: 'life_change', label: 'Life circumstances changed' },
                        { value: 'other', label: 'Other reason' }
                      ].map(opt => (
                        <label key={opt.value} className="flex items-center gap-3 p-3 rounded-lg hover:bg-stone-800/50 cursor-pointer">
                          <input
                            type="radio"
                            name="walked_reason"
                            value={opt.value}
                            checked={formData.walked_reason === opt.value}
                            onChange={(e) => setFormData({...formData, walked_reason: e.target.value})}
                            className="w-4 h-4 text-brand-500"
                          />
                          <span className="text-stone-300">{opt.label}</span>
                        </label>
                      ))}
                    </div>
                    {formData.walked_reason === 'inspection_issues' && (
                      <div className="mt-4">
                        <label className="block text-xs text-stone-400 mb-1">Which issue was the dealbreaker? (optional)</label>
                        <input
                          type="text"
                          value={formData.specific_issue}
                          onChange={(e) => setFormData({...formData, specific_issue: e.target.value})}
                          placeholder="e.g., Foundation crack, mold, etc."
                          className="w-full px-3 py-2 bg-stone-800 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none"
                        />
                      </div>
                    )}
                  </div>
                )}

                {/* Stalled Fields */}
                {outcome === 'stalled' && (
                  <div className="glass rounded-xl p-6 space-y-4">
                    <label className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={formData.still_active}
                        onChange={(e) => setFormData({...formData, still_active: e.target.checked})}
                        className="w-5 h-5 rounded text-brand-500"
                      />
                      <span className="text-stone-300">Negotiation is still active</span>
                    </label>
                    <div>
                      <label className="block text-xs text-stone-400 mb-1">When should we follow up?</label>
                      <input
                        type="date"
                        value={formData.next_update_date}
                        onChange={(e) => setFormData({...formData, next_update_date: e.target.value})}
                        className="w-full px-3 py-2 bg-stone-800 border border-stone-700 rounded-lg text-white focus:border-brand-500 focus:outline-none"
                      />
                    </div>
                  </div>
                )}

                {/* Notes */}
                {outcome && (
                  <div className="glass rounded-xl p-6">
                    <label className="block text-sm font-medium text-stone-300 mb-2">Additional Notes (optional)</label>
                    <textarea
                      value={formData.notes}
                      onChange={(e) => setFormData({...formData, notes: e.target.value})}
                      placeholder="Any other details worth remembering..."
                      rows={3}
                      className="w-full px-3 py-2 bg-stone-800 border border-stone-700 rounded-lg text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none resize-none"
                    />
                  </div>
                )}

                {/* Error Message */}
                {error && (
                  <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4">
                    <p className="text-red-400 text-sm">{error}</p>
                  </div>
                )}

                {/* Submit Button */}
                {outcome && (
                  <button
                    type="submit"
                    disabled={saving}
                    className="w-full py-3 bg-gradient-to-r from-brand-500 to-brand-600 text-white font-semibold rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50 flex items-center justify-center gap-2"
                  >
                    {saving ? (
                      <>
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        Saving...
                      </>
                    ) : (
                      <>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {existingOutcome ? 'Update Outcome' : 'Save Outcome'}
                      </>
                    )}
                  </button>
                )}
              </form>
            )}
          </main>
        </div>
      );
    };

    // ============================================================
    // v5.0: REPORT VIEW COMPONENT (Read-only view of saved reports)
    // ============================================================
    const ReportView = ({ report, onBack, onReanalyze }) => {
      return (
        <div className="min-h-screen" style={{background: 'linear-gradient(135deg, #1c1917 0%, #292524 100%)'}}>
          {/* Header */}
          <header className="glass border-b border-brand-500/20 sticky top-0 z-50">
            <div className="max-w-5xl mx-auto px-6 py-4">
              <div className="flex items-center justify-between">
                <button
                  onClick={onBack}
                  className="flex items-center gap-2 text-stone-400 hover:text-white transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  Back to Dashboard
                </button>

                <button
                  onClick={() => onReanalyze(report)}
                  className="px-4 py-2 bg-gradient-to-r from-brand-500 to-brand-600 text-white font-semibold rounded-lg hover:opacity-90 transition-opacity flex items-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                  Re-analyze This Property
                </button>
              </div>
            </div>
          </header>

          {/* Report Content */}
          <main className="max-w-5xl mx-auto px-6 py-8">
            {/* Property Header */}
            <div className="glass rounded-2xl p-6 mb-6">
              <h1 className="text-2xl font-bold text-white mb-2">{report.property_address || 'Property Report'}</h1>
              <p className="text-stone-400">{report.city_state} {report.zip_code}</p>
              <div className="flex gap-6 mt-4 text-sm">
                <div>
                  <span className="text-stone-500">List Price:</span>
                  <span className="text-white ml-2">${report.list_price?.toLocaleString() || '—'}</span>
                </div>
                <div>
                  <span className="text-stone-500">Client:</span>
                  <span className="text-white ml-2">{report.client_name || '—'}</span>
                </div>
                <div>
                  <span className="text-stone-500">Generated:</span>
                  <span className="text-white ml-2">{new Date(report.created_at).toLocaleDateString()}</span>
                </div>
              </div>
            </div>

            {/* Total Ask */}
            <div className="glass rounded-2xl p-6 mb-6 border-l-4 border-brand-500">
              <div className="text-stone-400 text-sm mb-1">Recommended Total Ask</div>
              <div className="text-4xl font-bold text-brand-400">
                ${report.ask_total?.toLocaleString() || '—'}
              </div>
            </div>

            {/* Findings */}
            {report.findings_json && report.findings_json.length > 0 && (
              <div className="glass rounded-2xl p-6 mb-6">
                <h2 className="text-xl font-semibold text-white mb-4">Findings</h2>
                <div className="space-y-3">
                  {report.findings_json.map((finding, index) => (
                    <div key={index} className="flex items-center justify-between p-3 bg-stone-800/50 rounded-lg">
                      <div>
                        <span className="text-white">{finding.item}</span>
                        {finding.category && (
                          <span className="ml-2 px-2 py-0.5 bg-stone-700 text-stone-400 text-xs rounded">
                            {finding.category}
                          </span>
                        )}
                      </div>
                      <span className="text-brand-400 font-semibold">
                        ${finding.cost?.toLocaleString() || finding.estimatedCost?.toLocaleString() || '—'}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Strategy */}
            {report.strategy_json && (
              <div className="glass rounded-2xl p-6">
                <h2 className="text-xl font-semibold text-white mb-4">Strategy</h2>
                <div className="text-stone-300 whitespace-pre-wrap">
                  {typeof report.strategy_json === 'string'
                    ? report.strategy_json
                    : JSON.stringify(report.strategy_json, null, 2)
                  }
                </div>
              </div>
            )}
          </main>
        </div>
      );
    };

    // ============================================================
    // GAMBIT LAB V2 - FRESH BUILD
    // New pricing architecture: Claude estimates first, then validates
    // ============================================================

    // D22: Dev cost entry override — Jared-only.
    // This gate enables a manual cost entry path on Step 2 for development testing.
    // DO NOT add other identities here without strong reason. Production agents must
    // not see manual cost entry — it's a liability hole D11a was redesigned to close.
    // Email-based gate (deviation from directive's UID-based gate): Supabase auth UID
    // wasn't directly fetchable from the dev environment when this was written, so we
    // gate on the auth email, which is just as stable for a single-user override.
    // Swap to UID by replacing the email check below; allowlist mechanics are identical.
    const DEV_COST_ENTRY_EMAILS = ['jraaschmidt@gmail.com'];
    const isDevCostEntryEnabled = (user) => {
      // 2026-07-28 PILOT LOCKDOWN: dev cheat buttons hard-disabled for real-user send.
      // Was founder-email gated. To re-enable for internal testing, restore:
      //   if (!user) return false;
      //   return DEV_COST_ENTRY_EMAILS.includes((user.email || '').toLowerCase());
      return false;
    };

    // D32-B: dev allowlist for buyer-input override (mirrors D22 pattern). When the
    // current user matches, the Buyer Inputs section on Page 3 surfaces a "Manual
    // entry (DEV)" affordance that lets the agent inject artificial buyer responses
    // — used during stubbed mode (pre-Twilio-approval) and for future regression
    // testing post-go-live. Gates UI only; no engine math impact.
    const DEV_BUYER_OVERRIDE_EMAILS = [
      'jraaschmidt@gmail.com',
      'jared@gambitlab.org',
      'andrewmckay@exprealty.com',
      'andrew@gameplanpro.ai'
    ];
    const isDevBuyerOverrideEnabled = (user) => {
      // 2026-07-28 PILOT LOCKDOWN: Page 3 "Dev: auto-fill all" / "Dev: reset" buttons
      // hard-disabled for real-user send. Was founder/Andrew-email gated. To re-enable:
      //   if (!user) return false;
      //   return DEV_BUYER_OVERRIDE_EMAILS.includes((user.email || '').toLowerCase());
      return false;
    };

    // D40 Task 1: dev allowlist for the Pending Inputs Gate bypass button.
    // Same allowlist semantics as D22/D32-B; surfaces a "Bypass (DEV)" affordance
    // on the gate so we can advance past Step 3 → Step 4 without waiting on
    // stub-mode buyer/client replies. Hidden for non-allowlisted users.
    // Tighter than DEV_BUYER_OVERRIDE_EMAILS — Andrew should see the gate as
    // designed during calibration, not be able to skip it.
    const DEV_PIG_BYPASS_EMAILS = [
      'jraaschmidt@gmail.com',
      'jared@gambitlab.org'
    ];
    const isDevModeEnabled = (user) => {
      // 2026-07-28 PILOT LOCKDOWN: Pending Inputs Gate "Bypass (DEV)" button hard-disabled
      // for real-user send. Was founder-email gated. To re-enable for internal testing:
      //   if (!user) return false;
      //   return DEV_PIG_BYPASS_EMAILS.includes((user.email || '').toLowerCase());
      return false;
    };

    const GambitLabV2 = () => {
      const [currentStep, setCurrentStep] = useState(1);
      const [isGenerating, setIsGenerating] = useState(false);
      // D43 Task 2: tracks when the computation screen started so the dismiss-
      // watch effect can enforce the 1.2s minimum hold. Reset to null when
      // the screen dismisses; non-null implies a hold is in progress.
      const [generatingStartedAt, setGeneratingStartedAt] = useState(null);
      const [reportReady, setReportReady] = useState(false);

      const goToStep = (step) => {
        // v5.9: If leaving Step 4, reset verdict so it recalculates on return
        if (currentStep === 4 && step !== 4) {
          setVerdictPhase('hidden');
        }
        setCurrentStep(step);
        window.scrollTo(0, 0);
      };

      // Strategy refinement state
      const [strategy, setStrategy] = useState(null);
      const [showRefinement, setShowRefinement] = useState(false);
      const [refinementFeedback, setRefinementFeedback] = useState('');
      const [refinedStrategy, setRefinedStrategy] = useState(null);
      const [expandedScripts, setExpandedScripts] = useState({});
      const [closingCostTipExpanded, setClosingCostTipExpanded] = useState(false);
      const [dismissedNudges, setDismissedNudges] = useState({ closingCost: false, downPayment: false });
      // ================================================================
      // v4.5: AUTH STATE
      // ================================================================
      const [user, setUser] = useState(null);
      const [authLoading, setAuthLoading] = useState(true);
      const [authView, setAuthView] = useState('login');
      const [authError, setAuthError] = useState('');
      const [authEmail, setAuthEmail] = useState('');
      const [authPassword, setAuthPassword] = useState('');
      const [authName, setAuthName] = useState('');

      // D38: universal post-auth consent gate. Tracks whether the signed-in user
      // already has a signup-source attestation row. 'unknown' while the query is
      // in flight (do not render the gate yet — avoids flash). 'missing' renders
      // the gate. 'present' falls through to the rest of the app.
      const [signupAttestationStatus, setSignupAttestationStatus] = useState('unknown');

      // ================================================================
      // v5.0: ADDITIONAL STATE FOR UNIFIED APP
      // ================================================================
      const [profile, setProfile] = useState(null);
      const [currentView, setCurrentView] = useState('landing'); // 'landing' | 'dashboard' | 'product' | 'profile'
      const [selectedReport, setSelectedReport] = useState(null);
      const [reports, setReports] = useState([]);
      const [readOnlyMode, setReadOnlyMode] = useState(false); // v5.0: True when viewing saved report

      // v5.2: Outcome tracking state
      const [outcomeReportId, setOutcomeReportId] = useState(null);
      const [outcomePreselectedStatus, setOutcomePreselectedStatus] = useState(null); // From email links
      const [outcomeSource, setOutcomeSource] = useState('in_app'); // 'in_app', 'email_day7', 'email_day14'

      // v5.0: Profile branding state
      const [profileForm, setProfileForm] = useState({
        first_name: '', last_name: '', brokerage: '', license_number: '', phone_number: '', designations: '', tagline: ''
      });
      const [pendingHeadshot, setPendingHeadshot] = useState(null);
      const [pendingBrokerageLogo, setPendingBrokerageLogo] = useState(null);
      const [profileSaving, setProfileSaving] = useState(false);
      const [dismissedProfileNudge, setDismissedProfileNudge] = useState(false);
      // D40 Task 4: separate session-dismissible flag for the phone-number banner
      // (independent of the branding-complete nudge so they can co-exist).
      const [dismissedPhoneNudge, setDismissedPhoneNudge] = useState(false);
      const [appMobileMenuOpen, setAppMobileMenuOpen] = useState(false); // v5.1: Mobile hamburger menu

      // v5.0: Check auth state and load profile on mount
      useEffect(() => {
        // IMMEDIATELY capture outcome params before any async operations
        // This ensures we don't lose them due to redirects or race conditions
        const urlParams = new URLSearchParams(window.location.search);
        const outcomeParam = urlParams.get('outcome');
        if (outcomeParam && !window.location.hash.includes('access_token')) {
          // Only store if not in OAuth callback (to avoid overwriting with stale data)
          sessionStorage.setItem('gameplan_outcome_redirect', window.location.search);
        }

        const initAuth = async () => {
          // Check if URL has OAuth tokens (hash fragment)
          const hasOAuthCallback = window.location.hash.includes('access_token');

          if (hasOAuthCallback) {
            // Supabase needs getSession() to process the OAuth hash
            setAuthLoading(true);
            try {
              const { data: { session }, error } = await supabaseClient.auth.getSession();

              if (session?.user) {
                setUser(session.user);
                // Perf Tier 2: fire profile + reports in parallel instead of waiting for
                // profile then triggering reports via a [user, profile] useEffect chain.
                await Promise.all([
                  loadProfile(session.user),
                  loadUserReports(session.user)
                ]);

                // v5.2: Check for outcome redirect after OAuth
                // Priority 1: Query params in URL (preserved through OAuth redirect)
                // Priority 2: sessionStorage (fallback)
                const urlParams = new URLSearchParams(window.location.search);
                const outcomeFromUrl = urlParams.get('outcome');
                const storedOutcome = sessionStorage.getItem('gameplan_outcome_redirect');

                let reportId, preselectedStatus, source;

                if (outcomeFromUrl) {
                  // Query params preserved in URL through OAuth redirect
                  reportId = outcomeFromUrl;
                  preselectedStatus = urlParams.get('status');
                  source = urlParams.get('source');
                } else if (storedOutcome) {
                  sessionStorage.removeItem('gameplan_outcome_redirect');

                  if (storedOutcome.startsWith('?')) {
                    const params = new URLSearchParams(storedOutcome);
                    reportId = params.get('outcome');
                    preselectedStatus = params.get('status');
                    source = params.get('source');
                  } else if (storedOutcome.startsWith('#outcome/')) {
                    const hashContent = storedOutcome.replace('#outcome/', '');
                    const [id, queryString] = hashContent.split('?');
                    reportId = id;
                    const params = new URLSearchParams(queryString || '');
                    preselectedStatus = params.get('status');
                    source = params.get('source');
                  }
                }

                if (reportId) {
                  setOutcomeReportId(reportId);
                  if (preselectedStatus && ['won', 'lost', 'walked', 'stalled'].includes(preselectedStatus)) {
                    setOutcomePreselectedStatus(preselectedStatus);
                  }
                  setOutcomeSource(source || 'in_app');
                  setCurrentView('outcome');
                  window.history.replaceState({}, '', window.location.pathname);
                  setAuthLoading(false);
                  return;
                }

                setCurrentView('dashboard');
              } else {
                setCurrentView('landing');
              }
            } catch (error) {
              console.error('Error processing OAuth:', error);
              setCurrentView('landing');
            }

            // Clear OAuth hash from URL (unless we're redirecting to outcome)
            if (!sessionStorage.getItem('gameplan_outcome_redirect')) {
              window.history.replaceState({}, '', window.location.pathname);
            }
            setAuthLoading(false);
          } else {
            // No OAuth callback - check for existing session
            checkAuthAndProfile();
          }
        };

        initAuth();

        // Also listen for auth state changes (for sign-out, etc.)
        const { data: { subscription } } = supabaseClient.auth.onAuthStateChange(
          async (event, session) => {

            // Skip if we're already handling OAuth callback above
            if (window.location.hash.includes('access_token')) {
              console.log('Skipping onAuthStateChange - OAuth callback being handled');
              return;
            }

            // Only handle SIGNED_OUT event to redirect to landing
            // For SIGNED_IN/TOKEN_REFRESHED, don't interrupt current view
            if (event === 'SIGNED_OUT') {
              setUser(null);
              setProfile(null);
              setCurrentView('landing');
              setAuthLoading(false);
              return;
            }

            // For TOKEN_REFRESHED events, just update the user silently
            // Don't interrupt their work or change views
            if (event === 'TOKEN_REFRESHED' && session?.user) {
              setUser(session.user);
              setAuthLoading(false);
              return;
            }

            // For SIGNED_IN during initial load, the checkAuthAndProfile handles it
            // Only process here if this is a fresh sign-in (not initial page load)
            if (event === 'SIGNED_IN' && session?.user) {
              setUser(session.user);
              // Only load profile and redirect if we're on landing page
              // Don't interrupt users who are already working
              setAuthLoading(false);

              // v5.2: Check for stored outcome redirect after email login
              // Supports both query params (email) and hash (PDF footer)
              const storedOutcome = sessionStorage.getItem('gameplan_outcome_redirect');
              if (storedOutcome) {
                sessionStorage.removeItem('gameplan_outcome_redirect');

                let reportId, preselectedStatus, source;

                if (storedOutcome.startsWith('?')) {
                  // Query param format from email: ?outcome=xxx&status=yyy&source=zzz
                  const params = new URLSearchParams(storedOutcome);
                  reportId = params.get('outcome');
                  preselectedStatus = params.get('status');
                  source = params.get('source');
                } else if (storedOutcome.startsWith('#outcome/')) {
                  // Hash format from PDF footer: #outcome/xxx
                  const hashContent = storedOutcome.replace('#outcome/', '');
                  const [id, queryString] = hashContent.split('?');
                  reportId = id;
                  const params = new URLSearchParams(queryString || '');
                  preselectedStatus = params.get('status');
                  source = params.get('source');
                }

                if (reportId) {
                  await loadProfile(session.user);
                  setOutcomeReportId(reportId);
                  if (preselectedStatus && ['won', 'lost', 'walked', 'stalled'].includes(preselectedStatus)) {
                    setOutcomePreselectedStatus(preselectedStatus);
                  }
                  setOutcomeSource(source || 'in_app');
                  setCurrentView('outcome');
                  window.history.replaceState({}, '', window.location.pathname);
                }
              }

              // Track login ONLY ONCE per browser session (prevent duplicates from auth refreshes)
              const loginTrackedKey = 'gameplan_login_tracked_' + session.user.id;
              if (!sessionStorage.getItem(loginTrackedKey)) {
                sessionStorage.setItem(loginTrackedKey, 'true');
                supabaseClient.from('usage').insert({
                  user_id: session.user.id,
                  action: 'user_login',
                  metadata: { email: session.user.email },
                  created_at: new Date().toISOString()
                }).then(() => console.log('Login tracked')).catch(e => console.warn('Login tracking failed:', e));
              }
            }
          }
        );
        return () => subscription.unsubscribe();
      }, []);

      // v5.0: Sync profileForm with loaded profile
      useEffect(() => {
        if (profile) {
          setProfileForm({
            first_name: profile.first_name || '',
            last_name: profile.last_name || '',
            brokerage: profile.brokerage || '',
            license_number: profile.license_number || '',
            phone_number: profile.phone_number || '',
            designations: profile.designations || '',
            tagline: profile.tagline || ''
          });
        }
      }, [profile]);

      // v5.0: Check auth and load profile
      // Payment verification is now handled by Stripe webhook (server-side)
      const checkAuthAndProfile = async () => {
        setAuthLoading(true);

        try {
          // Clean welcome param from URL if present (just came back from Stripe)
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.has('welcome')) {
            window.history.replaceState({}, '', window.location.pathname);
          }

          // Check for existing session
          const { data: { session } } = await supabaseClient.auth.getSession();

          if (session?.user) {
            setUser(session.user);
            // Perf Tier 2: parallelize profile + reports load (was strictly serial via useEffect chain).
            await Promise.all([
              loadProfile(session.user),
              loadUserReports(session.user)
            ]);

            // v5.2: Check for outcome routing from email links
            // Priority 1: Query params (email links use ?outcome=xxx&status=yyy&source=zzz)
            // Priority 2: Hash routing (PDF footer uses #outcome/xxx)
            const urlParams = new URLSearchParams(window.location.search);
            const outcomeFromQuery = urlParams.get('outcome');
            const hash = window.location.hash;

            if (outcomeFromQuery) {
              // Email link format: ?outcome={reportId}&status=won&source=email_day7
              const preselectedStatus = urlParams.get('status');
              const source = urlParams.get('source');

              setOutcomeReportId(outcomeFromQuery);
              if (preselectedStatus && ['won', 'lost', 'walked', 'stalled'].includes(preselectedStatus)) {
                setOutcomePreselectedStatus(preselectedStatus);
              }
              setOutcomeSource(source || 'in_app');
              setCurrentView('outcome');
              // Clean up URL
              window.history.replaceState({}, '', window.location.pathname);
            } else if (hash.startsWith('#outcome/')) {
              // PDF footer format: #outcome/{reportId}
              const hashContent = hash.replace('#outcome/', '');
              const [reportId, queryString] = hashContent.split('?');
              const params = new URLSearchParams(queryString || '');
              const preselectedStatus = params.get('status');
              const source = params.get('source');

              setOutcomeReportId(reportId);
              if (preselectedStatus && ['won', 'lost', 'walked', 'stalled'].includes(preselectedStatus)) {
                setOutcomePreselectedStatus(preselectedStatus);
              }
              setOutcomeSource(source || 'in_app');
              setCurrentView('outcome');
            } else {
              // The profile check in render will determine if they see dashboard or PaymentRequired
              // If webhook has fired, subscription_status will be 'active'
              setCurrentView('dashboard');
            }
          } else {
            // No session — show landing page
            // v5.2: Store outcome URL for post-login redirect
            // Check both query params (email) and hash (PDF footer)
            // Note: sessionStorage is also set at the top of useEffect as a backup
            const urlParams = new URLSearchParams(window.location.search);
            const outcomeFromQuery = urlParams.get('outcome');
            if (outcomeFromQuery) {
              sessionStorage.setItem('gameplan_outcome_redirect', window.location.search);
            } else if (window.location.hash.startsWith('#outcome/')) {
              sessionStorage.setItem('gameplan_outcome_redirect', window.location.hash);
            }
            setUser(null);
            setProfile(null);
            setCurrentView('landing');
          }
        } catch (error) {
          console.error('Error in checkAuthAndProfile:', error);
          setUser(null);
          setProfile(null);
          setCurrentView('landing');
        } finally {
          setAuthLoading(false);
        }
      };

      // v5.0: Load or create user profile
      const loadProfile = async (sessionUser) => {
        const userId = sessionUser.id;

        try {
          const { data: existingProfile, error } = await supabaseClient
            .from('profiles')
            .select('*')
            .eq('id', userId)
            .single();

          if (error && error.code === 'PGRST116') {
            // Profile doesn't exist, create one
            const { data: newProfile, error: insertError } = await supabaseClient
              .from('profiles')
              .insert({
                id: userId,
                email: sessionUser.email,
                full_name: sessionUser.user_metadata?.full_name || '',
                is_beta_cohort: false,
                subscription_status: 'none'
              })
              .select()
              .single();

            if (insertError) {
              console.error('Error creating profile:', insertError);
              // RLS may block insert — try upsert as fallback
              const { data: upsertProfile, error: upsertError } = await supabaseClient
                .from('profiles')
                .upsert({
                  id: userId,
                  email: sessionUser.email,
                  full_name: sessionUser.user_metadata?.full_name || '',
                  is_beta_cohort: false,
                  subscription_status: 'none'
                })
                .select()
                .single();

              if (upsertError) {
                console.error('Error upserting profile:', upsertError);
              } else {
                setProfile(upsertProfile);
                // Insert sample report for new user (function checks for duplicates)
                insertSampleReportForNewUser(userId, supabaseClient);
              }
            } else {
              setProfile(newProfile);
              // Insert sample report for new user
              insertSampleReportForNewUser(userId, supabaseClient);
            }
          } else if (error) {
            // Some other error
            console.error('Error loading profile:', error);
          } else {
            // Profile exists
            setProfile(existingProfile);
          }
        } catch (err) {
          console.error('Exception in loadProfile:', err);
        }
      };

      // v5.0: Load user's reports (v5.1: filter out hidden reports)
      // Perf Tier 2: accept optional override user so initAuth can call this in parallel
      // with loadProfile before React's user state has propagated.
      const loadUserReports = async (overrideUser) => {
        const u = overrideUser || user;
        if (!u) return [];
        const { data, error } = await supabaseClient
          .from('reports')
          .select('*')
          .eq('user_id', u.id)
          .is('hidden_at', null)  // v5.1: Exclude soft-deleted reports
          .order('created_at', { ascending: false });

        if (error) {
          console.error('Error loading reports:', error);
          return [];
        }
        setReports(data || []);
        return data || [];
      };

      // v5.1: Soft delete (hide) a report from the user's dashboard
      const hideReport = async (reportId) => {
        if (!user) return false;
        console.log('Hiding report:', reportId);

        const { error } = await supabaseClient
          .from('reports')
          .update({ hidden_at: new Date().toISOString() })
          .eq('id', reportId)
          .eq('user_id', user.id);  // Security: ensure user owns this report

        if (error) {
          console.error('Error hiding report:', error);
          return false;
        }

        // Refresh the reports list
        await loadUserReports();
        return true;
      };

      // v5.1: Track usage events to Supabase
      const trackUsage = async (action, metadata = {}) => {
        if (!user) {
          console.warn('trackUsage: No user, skipping');
          return;
        }
        try {
          const { error } = await supabaseClient.from('usage').insert({
            user_id: user.id,
            action: action,
            metadata: metadata,
            created_at: new Date().toISOString()
          });
          if (error) {
            console.error('trackUsage error:', error);
          } else {
            console.log('trackUsage success:', action);
          }
        } catch (e) {
          console.warn('Usage tracking failed (non-blocking):', e);
        }
      };

      // v5.1: Log data events (failures only) for visibility into what breaks
      const logDataEvent = async (eventType, resourceId, resourceType, errorMessage, metadata = {}) => {
        try {
          await supabaseClient.from('data_events').insert({
            user_id: user?.id,
            event_type: eventType,
            event_status: 'failure',
            resource_id: resourceId,
            resource_type: resourceType,
            error_message: errorMessage,
            metadata: metadata
          });
        } catch (e) {
          // If even the failure log fails, just console.error. Don't recurse.
          console.error('Failed to log data event:', e);
        }
      };

      // v5.1: Progressive auto-save at each step
      // status: 'extraction_complete' | 'customization_complete' | 'analysis_complete'
      // extractedFindings: optional - pass findings directly for Step 2 (avoids React state timing issue)
      // extractedProperty: optional - pass property info directly for Step 2 (avoids React state timing issue)
      // forceResave: optional - skip the "already saved" check (used for dashboard return saves)
      const saveReportAtStep = async (status, extractedFindings = null, extractedProperty = null, forceResave = false) => {
        // Check if this step was already saved (prevents double-saves on back/forth navigation)
        // Skip this check if forceResave is true (e.g., saving updated data on dashboard return)
        if (!forceResave) {
          if (status === 'extraction_complete' && saveState.step2Saved) {
            console.log('Step 2 already saved, skipping');
            return { success: true, skipped: true };
          }
          if (status === 'customization_complete' && saveState.step3Saved) {
            console.log('Step 3 already saved, skipping');
            return { success: true, skipped: true };
          }
          if (status === 'analysis_complete' && saveState.step4Saved) {
            console.log('Step 4 already saved, skipping');
            return { success: true, skipped: true };
          }
        }

        if (!user) {
          console.log('saveReportAtStep: No user, skipping');
          return { success: false, error: 'No user' };
        }

        // Generate report ID if needed (Step 2 creates the ID)
        let reportIdToUse = pendingReportId;
        if (!reportIdToUse) {
          reportIdToUse = crypto.randomUUID();
          setPendingReportId(reportIdToUse);
          console.log('Generated NEW report ID for progressive save:', reportIdToUse);
        }

        console.log(`saveReportAtStep: ${status}`, { reportId: reportIdToUse });

        try {
          // Use passed-in findings for Step 2 (avoids React state timing), otherwise use state
          const findingsToUse = extractedFindings || findings;
          const selectedFindings = findingsToUse.filter(f => f.selected);
          const isInsert = status === 'extraction_complete';

          // D52 (2026-05-12): defense-in-depth against the
          // raw_findings_json clobber bug. Before writing the row, fetch the
          // existing raw_findings_json length. If the current `findingsToUse`
          // array is SHORTER than what's already persisted, we're in the
          // failure mode (an earlier resumeDraft loaded only the filtered
          // findings_json into state). Omit raw_findings_json from the save
          // payload so the existing DB value is preserved (PostgREST upserts
          // only write the columns specified). Also log loudly so future-us
          // can see the guard fire if the underlying resumeDraft regression
          // ever returns. Skip the probe entirely for `extraction_complete`
          // — that's the first write and there's no prior raw to protect.
          let _d52SuppressRaw = false;
          if (status !== 'extraction_complete' && reportIdToUse) {
            try {
              const { data: _d52Existing } = await supabaseClient
                .from('reports')
                .select('raw_findings_json')
                .eq('id', reportIdToUse)
                .maybeSingle();
              const _d52ExistingLen = Array.isArray(_d52Existing?.raw_findings_json)
                ? _d52Existing.raw_findings_json.length : 0;
              if (_d52ExistingLen > 0 && findingsToUse.length < _d52ExistingLen) {
                _d52SuppressRaw = true;
                console.warn(
                  '[D52 raw guard] saveReportAtStep refusing to shrink raw_findings_json',
                  { reportId: reportIdToUse, status, existingLen: _d52ExistingLen, currentLen: findingsToUse.length }
                );
                try {
                  await logDataEvent('raw_findings_shrink_blocked', reportIdToUse, 'reports',
                    `existing=${_d52ExistingLen} current=${findingsToUse.length} status=${status}`);
                } catch (_) { /* non-fatal */ }
              }
            } catch (_) { /* probe failure is non-fatal — fall through */ }
          }

          // Build the report data based on which step we're at
          // Map status to step number for resume functionality
          const stepMap = {
            'extraction_complete': 2,
            'customization_complete': 3,
            'analysis_complete': 4
          };
          const reportData = {
            id: reportIdToUse,
            user_id: user.id,
            report_status: status,
            current_step: stepMap[status] || 1,
            updated_at: new Date().toISOString(),

            // Property info (use extracted data if available to avoid React state timing issues)
            property_address: extractedProperty?.address || propertyInfo.address,
            city_state: extractedProperty?.city || propertyInfo.city,
            zip_code: extractedProperty?.zipCode || propertyInfo.zipCode,
            client_name: propertyInfo.clientName, // Client name comes from user input, not extraction
            // D37-A: client phone + Page 1 consent attestation snapshot. Phone is
            // normalized to E.164 by handleNextStep before advancing past Step 1, so
            // any save downstream sees the canonical form. Boolean here mirrors the
            // checkbox; the audit trail of WHO/WHEN/WHAT-PHONE lives in
            // sms_consent_attestations (one row per attestation event).
            client_phone: normalizePhoneE164(propertyInfo.clientPhone) || propertyInfo.clientPhone || null,
            client_sms_consent: propertyInfo.clientSmsConsent === true,
            client_sms_consent_timestamp: propertyInfo.clientSmsConsent === true ? new Date().toISOString() : null,
            client_sms_consent_agent_id: propertyInfo.clientSmsConsent === true ? user.id : null,
            list_price: parseInt(propertyInfo.listPrice?.replace(/[^0-9]/g, '')) || 0,
            days_on_market: parseInt(propertyInfo.daysOnMarket) || 0,
            original_list_price: parseInt(String(propertyInfo.originalListPrice).replace(/[^0-9]/g, '')) || null,
            contract_price: parseInt(String(propertyInfo.contractPrice).replace(/[^0-9]/g, '')) || null,

            // Findings (raw from extraction, or customized)
            findings_json: status === 'extraction_complete' ? findingsToUse : selectedFindings,
            findings_count: status === 'extraction_complete' ? findingsToUse.length : selectedFindings.length,
            // D13: Always store the FULL findings list with original selected state so saved reports show every item Claude extracted
            // D52: but only if it wouldn't shrink the persisted value (see raw guard above).
            ...(_d52SuppressRaw ? {} : { raw_findings_json: findingsToUse }),

            // Closing cost fields
            estimated_closing_costs: parseInt(String(propertyInfo.estimatedClosingCosts).replace(/[^0-9]/g, '')) || null,
            credits_already_negotiated: parseInt(String(propertyInfo.creditsAlreadyNegotiated).replace(/[^0-9]/g, '')) || null,
            minimum_down_payment: parseInt(String(propertyInfo.minimumDownPayment).replace(/[^0-9]/g, '')) || null,
            planned_down_payment: parseInt(String(propertyInfo.plannedDownPayment).replace(/[^0-9]/g, '')) || null,

            // Version
            report_version: 'v5.1'
          };

          // Add step-specific data
          if (status === 'customization_complete' || status === 'analysis_complete') {
            // Include leverage factors after customization
            reportData.buyer_factors_json = buyerFactors;
            reportData.seller_factors_json = sellerFactors;
            reportData.market_context_json = marketContext;
            // D32-C: Agent justifications for the 3 agent-input sliders.
            reportData.justification_seller_disclosure       = justifications.sellerDisclosed?.text ?? null;
            reportData.justification_seller_disclosure_type  = justifications.sellerDisclosed?.type ?? null;
            reportData.justification_seller_motivated        = justifications.sellerMotivated?.text ?? null;
            reportData.justification_seller_motivated_type   = justifications.sellerMotivated?.type ?? null;
            reportData.justification_backup_offers           = justifications.backupOffers?.text ?? null;
            reportData.justification_backup_offers_type      = justifications.backupOffers?.type ?? null;
          }

          if (status === 'analysis_complete') {
            // Include full strategy for completed analysis
            const strat = strategy || generateStrategy();
            reportData.strategy_json = strat;
            reportData.ask_total = selectedFindings.reduce((sum, f) => sum + (f.cost || 0), 0);
            reportData.leverage_score = leverageScore;
            reportData.leverage_tier = leverageScore >= 5 ? 'FAVORABLE' : leverageScore <= -5 ? 'LIMITED' : 'BALANCED';
            reportData.must_haves_total = strat?.totals?.mustHaves || 0;
            reportData.strong_asks_total = strat?.totals?.strongAsks || 0;
            reportData.tradeables_total = strat?.totals?.tradeables || 0;
            reportData.concessions_total = strat?.totals?.concessions || 0;
            // v5.3: Persist all computed scores so loaded reports stay byte-for-byte stable (Directive 12.5)
            const askForSave = calculateAskAssessment(findings, leverageScore);
            const outlookForSave = calculateOutlookScore(leverageScore, findings);
            const sellerForSave = calculateSellerProfileScore();
            reportData.ask_favorability_score = askForSave?.score ?? null;
            reportData.outlook_score = outlookForSave?.outlookScore ?? null;
            reportData.seller_profile_score = sellerForSave?.score ?? null;
          }

          // Use upsert for all saves (insert on Step 2, update on Steps 3/4)
          const { data, error } = await supabaseClient
            .from('reports')
            .upsert(reportData)
            .select()
            .single();

          if (error) {
            console.error(`Step save failed (${status}):`, error);
            await logDataEvent('report_save_failed', reportIdToUse, 'report', error.message, { status });
            return { success: false, error };
          }

          // Update save state
          setSaveState(prev => ({
            ...prev,
            step2Saved: status === 'extraction_complete' ? true : prev.step2Saved,
            step3Saved: status === 'customization_complete' ? true : prev.step3Saved,
            step4Saved: status === 'analysis_complete' ? true : prev.step4Saved,
          }));

          console.log(`Step save successful (${status}):`, data.id);

          // Step 4 verification read-back
          if (status === 'analysis_complete') {
            const { data: verifyData, error: verifyError } = await supabaseClient
              .from('reports')
              .select('id, report_status')
              .eq('id', reportIdToUse)
              .single();

            if (verifyError || !verifyData || verifyData.report_status !== 'analysis_complete') {
              console.error('STEP 4 SAVE VERIFICATION FAILED:', { reportId: reportIdToUse, verifyError, verifyData });
              await logDataEvent('report_verification_failed', reportIdToUse, 'report',
                verifyError?.message || 'Status mismatch', { expected: 'analysis_complete', got: verifyData?.report_status });
            } else {
              console.log('Step 4 verification passed');
            }
          }

          // Track usage
          trackUsage(status === 'analysis_complete' ? 'report_generated' : 'report_draft_saved', {
            report_id: data?.id,
            property_address: propertyInfo.address,
            status: status
          });

          return { success: true, data };

        } catch (error) {
          console.error(`saveReportAtStep error (${status}):`, error);
          await logDataEvent('report_save_failed', reportIdToUse, 'report', error.message, { status });
          return { success: false, error };
        }
      };

      // v5.0: Save report to database (comprehensive data capture)
      // trackingAction: 'report_generated' for auto-save, 'report_saved' for manual save
      // overrideReportId: optional - use this ID instead of pendingReportId (for async state timing)
      const saveReport = async (trackingAction = 'report_saved', overrideReportId = null) => {
        console.log('saveReport called:', { trackingAction, overrideReportId, hasUser: !!user });
        if (!user) {
          console.log('saveReport: No user, returning null');
          return null;
        }

        const selectedFindings = findings.filter(f => f.selected);
        const totalAsk = selectedFindings.reduce((sum, f) => sum + (f.cost || 0), 0);

        // Calculate leverage tier
        let leverageTier = 'BALANCED';
        if (leverageScore >= 5) leverageTier = 'FAVORABLE';
        else if (leverageScore <= -5) leverageTier = 'LIMITED';

        // Calculate bucket totals from strategy if available
        const strat = strategy || generateStrategy();
        const mustHavesTotal = strat?.totals?.mustHaves || 0;
        const strongAsksTotal = strat?.totals?.strongAsks || 0;
        const tradeablesTotal = strat?.totals?.tradeables || 0;
        const concessionsTotal = strat?.totals?.concessions || 0;

        // Use override ID, pending report ID, or generate new one
        const reportId = overrideReportId || pendingReportId || crypto.randomUUID();

        // Upload PDFs to Supabase Storage
        // v5.1: Added verification + retry
        // v5.2: Multi-document support — primary + supplementals
        let inspectionPdfUrl = null;
        if (pendingPdfFiles.length > 0 && user?.id) {
          const folderPath = `${user.id}/${reportId}`;

          for (let fileIdx = 0; fileIdx < pendingPdfFiles.length; fileIdx++) {
            const file = pendingPdfFiles[fileIdx];
            const fileName = fileIdx === 0 ? 'inspection.pdf' : `supplemental_${fileIdx}.pdf`;
            const storagePath = `${folderPath}/${fileName}`;
            console.log(`Uploading PDF ${fileIdx + 1}/${pendingPdfFiles.length} to storage:`, storagePath);

            const { data: uploadData, error: uploadError } = await supabaseClient.storage
              .from('inspection-pdfs')
              .upload(storagePath, file, {
                contentType: 'application/pdf',
                upsert: true
              });

            if (uploadError) {
              console.error(`PDF upload failed for ${fileName} (non-blocking):`, uploadError);
            } else {
              // v5.1: Verify upload succeeded
              const { data: fileList, error: listError } = await supabaseClient.storage
                .from('inspection-pdfs')
                .list(folderPath, { search: fileName });

              if (listError || !fileList || fileList.length === 0) {
                console.error('PDF UPLOAD VERIFICATION FAILED:', { fileName, folderPath });

                // Retry once
                const retryResult = await supabaseClient.storage
                  .from('inspection-pdfs')
                  .upload(storagePath, file, { upsert: true });

                if (retryResult.error) {
                  await logDataEvent('pdf_upload_failed', reportId, 'pdf', retryResult.error.message);
                  console.error('PDF upload retry failed:', retryResult.error);
                } else {
                  if (fileIdx === 0) inspectionPdfUrl = storagePath;
                  console.log('PDF uploaded successfully on retry:', storagePath);
                }
              } else {
                if (fileIdx === 0) inspectionPdfUrl = storagePath;
                console.log('PDF uploaded and verified:', storagePath);
              }
            }
          }
        }

        // D52 (2026-05-12): same raw_findings_json shrink guard as in
        // saveReportAtStep. If a resumeDraft session left `findings` state
        // smaller than the persisted raw_findings_json, suppress the
        // raw_findings_json field in the upsert so the existing DB value
        // survives. Probe is best-effort; failures fall through.
        let _d52SuppressRaw = false;
        if (reportId) {
          try {
            const { data: _d52Existing } = await supabaseClient
              .from('reports')
              .select('raw_findings_json')
              .eq('id', reportId)
              .maybeSingle();
            const _d52ExistingLen = Array.isArray(_d52Existing?.raw_findings_json)
              ? _d52Existing.raw_findings_json.length : 0;
            if (_d52ExistingLen > 0 && findings.length < _d52ExistingLen) {
              _d52SuppressRaw = true;
              console.warn(
                '[D52 raw guard] saveReport refusing to shrink raw_findings_json',
                { reportId, existingLen: _d52ExistingLen, currentLen: findings.length }
              );
              try {
                await logDataEvent('raw_findings_shrink_blocked', reportId, 'reports',
                  `existing=${_d52ExistingLen} current=${findings.length} via=saveReport`);
              } catch (_) { /* non-fatal */ }
            }
          } catch (_) { /* probe failure is non-fatal */ }
        }

        console.log('Attempting to upsert report:', { reportId, userId: user.id, address: propertyInfo.address });
        const { data, error } = await supabaseClient
          .from('reports')
          .upsert({
            // Use the pre-generated report ID (allows auto-save + manual save to same record)
            id: reportId,

            // Core fields
            user_id: user.id,
            property_address: propertyInfo.address,
            city_state: propertyInfo.city,
            zip_code: propertyInfo.zipCode,
            list_price: parseInt(propertyInfo.listPrice?.replace(/[^0-9]/g, '')) || 0,
            days_on_market: parseInt(propertyInfo.daysOnMarket) || 0,
            client_name: propertyInfo.clientName,

            // Findings data
            findings_json: selectedFindings,
            findings_count: selectedFindings.length,
            // D13: Store the FULL findings list (selected + unselected) so the saved report shows every extracted item
            // D52: omit raw_findings_json when shrink guard tripped (see _d52SuppressRaw above).
            ...(_d52SuppressRaw ? {} : { raw_findings_json: findings }),

            // Strategy data
            strategy_json: strat,
            ask_total: totalAsk,
            leverage_score: leverageScore,
            leverage_tier: leverageTier,

            // v5.3: Persisted computed scores (Directive 12.5)
            ask_favorability_score: (() => { try { return calculateAskAssessment(findings, leverageScore)?.score ?? null; } catch (e) { return null; } })(),
            outlook_score: (() => { try { return calculateOutlookScore(leverageScore, findings)?.outlookScore ?? null; } catch (e) { return null; } })(),
            seller_profile_score: (() => { try { return calculateSellerProfileScore()?.score ?? null; } catch (e) { return null; } })(),

            // Bucket totals (for quick queries)
            must_haves_total: mustHavesTotal,
            strong_asks_total: strongAsksTotal,
            tradeables_total: tradeablesTotal,
            concessions_total: concessionsTotal,

            // Market context
            market_context_json: marketContext,

            // Buyer/seller factors
            buyer_factors_json: buyerFactors,
            seller_factors_json: sellerFactors,

            // D32-C: Agent justification fields. NULL when slider at default (no
            // justification needed) or when this is a legacy report being re-saved
            // without the agent providing one. Type column distinguishes canned
            // selections from 'OTHER' free-text submissions.
            justification_seller_disclosure:       justifications.sellerDisclosed?.text ?? null,
            justification_seller_disclosure_type:  justifications.sellerDisclosed?.type ?? null,
            justification_seller_motivated:        justifications.sellerMotivated?.text ?? null,
            justification_seller_motivated_type:   justifications.sellerMotivated?.type ?? null,
            justification_backup_offers:           justifications.backupOffers?.text ?? null,
            justification_backup_offers_type:      justifications.backupOffers?.type ?? null,

            // Closing cost and down payment fields
            estimated_closing_costs: parseInt(String(propertyInfo.estimatedClosingCosts).replace(/[^0-9]/g, '')) || null,
            credits_already_negotiated: parseInt(String(propertyInfo.creditsAlreadyNegotiated).replace(/[^0-9]/g, '')) || null,
            minimum_down_payment: parseInt(String(propertyInfo.minimumDownPayment).replace(/[^0-9]/g, '')) || null,
            planned_down_payment: parseInt(String(propertyInfo.plannedDownPayment).replace(/[^0-9]/g, '')) || null,
            original_list_price: parseInt(String(propertyInfo.originalListPrice).replace(/[^0-9]/g, '')) || null,
            contract_price: parseInt(String(propertyInfo.contractPrice).replace(/[^0-9]/g, '')) || null,

            // PDF storage
            inspection_pdf_url: inspectionPdfUrl,
            document_count: pendingPdfFiles.length || 1,

            // Metadata
            report_version: 'v5.1',

            // v5.1: Progressive save fields
            report_status: 'analysis_complete',
            current_step: 4,
            updated_at: new Date().toISOString()
          })
          .select()
          .single();

        if (error) {
          console.error('Error saving report:', error);
          return null;
        }

        // Track usage with the specified action
        trackUsage(trackingAction, {
          report_id: data?.id,
          property_address: propertyInfo.address,
          total_ask: totalAsk,
          leverage_tier: leverageTier
        });

        return data;
      };

      // v5.0 → v5.1: DEPRECATED - now using saveReportAtStep('analysis_complete') in handleNextStep
      // Keeping as backward-compatible wrapper in case it's called from elsewhere
      const autoSaveOnAnalysisGeneration = async () => {
        console.log('autoSaveOnAnalysisGeneration called (deprecated - using saveReportAtStep)');
        if (!user || readOnlyMode || saveState.step4Saved) {
          console.log('Auto-save skipped:', { hasUser: !!user, readOnlyMode, step4Saved: saveState.step4Saved });
          return;
        }
        // Delegate to new progressive save system
        await saveReportAtStep('analysis_complete');
      };

      // v5.0: Upload profile image to Supabase Storage
      // Perf Tier 2 fix: append a timestamp to the path on every upload so each new image
      // gets a unique URL. Was overwriting the same `[uid]/brokerage_logo.png` path, which
      // meant browsers kept serving the cached old image even after a successful re-upload.
      const uploadProfileImage = async (file, imageType) => {
        if (!file || !user?.id) return null;

        try {
          const ext = file.name.split('.').pop().toLowerCase();
          const ts = Date.now();
          const path = `${user.id}/${imageType}-${ts}.${ext}`;

          console.log(`Uploading ${imageType} to:`, path);

          const { data, error } = await supabaseClient.storage
            .from('profile-images')
            .upload(path, file, {
              contentType: file.type,
              upsert: true
            });

          if (error) {
            console.error(`Failed to upload ${imageType}:`, error);
            return null;
          }

          console.log(`${imageType} uploaded successfully:`, path);
          return path;
        } catch (err) {
          console.error(`Error uploading ${imageType}:`, err);
          return null;
        }
      };

      // v5.0: Save profile to database
      const saveProfile = async () => {
        if (!user?.id) return false;

        setProfileSaving(true);
        try {
          // Upload any pending images
          let headshot_url = profile?.headshot_url || null;
          let brokerage_logo_url = profile?.brokerage_logo_url || null;

          if (pendingHeadshot) {
            const path = await uploadProfileImage(pendingHeadshot, 'headshot');
            if (path) headshot_url = path;
          }
          if (pendingBrokerageLogo) {
            const path = await uploadProfileImage(pendingBrokerageLogo, 'brokerage_logo');
            if (path) brokerage_logo_url = path;
          }

          // Update profiles table
          const { data, error } = await supabaseClient
            .from('profiles')
            .update({
              first_name: profileForm.first_name || null,
              last_name: profileForm.last_name || null,
              brokerage: profileForm.brokerage || null,
              license_number: profileForm.license_number || null,
              phone_number: profileForm.phone_number || null,
              designations: profileForm.designations || null,
              tagline: profileForm.tagline || null,
              headshot_url,
              brokerage_logo_url
            })
            .eq('id', user.id)
            .select()
            .single();

          if (error) {
            console.error('Error saving profile:', error);
            setProfileSaving(false);
            return false;
          }

          // Update local profile state
          setProfile(data);

          // Clear pending images
          setPendingHeadshot(null);
          setPendingBrokerageLogo(null);

          setProfileSaving(false);
          return true;
        } catch (err) {
          console.error('Error in saveProfile:', err);
          setProfileSaving(false);
          return false;
        }
      };

      // v5.0: Handle re-analyze (pre-fill form from existing report)
      const handleReanalyze = (report) => {
        setPropertyInfo({
          address: report.property_address || '',
          city: report.city_state || '',
          zipCode: report.zip_code || '',
          originalListPrice: report.original_list_price?.toString() || '',
          listPrice: report.list_price?.toString() || '',
          contractPrice: report.contract_price?.toString() || '',
          offerPrice: '',
          daysOnMarket: report.days_on_market?.toString() || '',
          propertyType: 'single-family',
          clientName: report.client_name || '',
          // D37-A: hydrate consent fields. Pre-D37 saved reports return null/undefined
          // and default to empty/false — saved-report reopens skip the validation gate
          // anyway (see handleNextStep), so empty values don't block reuse.
          clientPhone: report.client_phone || '',
          clientSmsConsent: report.client_sms_consent === true,
          estimatedClosingCosts: report.estimated_closing_costs?.toString() || '',
          creditsAlreadyNegotiated: report.credits_already_negotiated?.toString() || '',
          minimumDownPayment: report.minimum_down_payment?.toString() || '',
          plannedDownPayment: report.planned_down_payment?.toString() || ''
        });

        setFindings([]);
        setStrategy(null);
        setCurrentStep(1);
        setReadOnlyMode(false);
        setCurrentView('product');
      };

      // v5.0: Load saved report into frozen (read-only) view
      const loadFrozenReport = (report) => {
        console.log('=== Loading frozen report ===', report.id);

        // Restore property info from saved report
        setPropertyInfo({
          address: report.property_address || '',
          city: report.city_state || '',
          zipCode: report.zip_code || '',
          originalListPrice: report.original_list_price?.toString() || '',
          listPrice: report.list_price?.toString() || '',
          contractPrice: report.contract_price?.toString() || '',
          offerPrice: '',
          daysOnMarket: report.days_on_market?.toString() || '',
          propertyType: 'single-family',
          clientName: report.client_name || '',
          // D37-A: hydrate consent fields from saved report (NULL on pre-D37 rows).
          clientPhone: report.client_phone || '',
          clientSmsConsent: report.client_sms_consent === true,
          estimatedClosingCosts: report.estimated_closing_costs?.toString() || '',
          creditsAlreadyNegotiated: report.credits_already_negotiated?.toString() || '',
          minimumDownPayment: report.minimum_down_payment?.toString() || '',
          plannedDownPayment: report.planned_down_payment?.toString() || ''
        });

        // Restore market context if saved
        if (report.market_context_json) {
          setMarketContext(report.market_context_json);
        }

        // Restore buyer/seller factors if saved (v5.2: migrate old 1-5 scale data in-memory)
        if (report.buyer_factors_json) {
          setBuyerFactors(migrateFactorsIfNeeded(report.buyer_factors_json));
        }
        if (report.seller_factors_json) {
          setSellerFactors(migrateFactorsIfNeeded(report.seller_factors_json));
        }
        // D32-C: hydrate justifications state and set legacy flag
        hydrateJustificationsFromReport(report);
        // D32-B: hydrate buyer subjective responses from buyer_subjective_responses
        hydrateBuyerResponsesForReport(report.id);

        // v5.2: Restore the saved leverage_score directly so the dial matches what was saved
        // (Directive 12 — prevents formula drift from showing wrong outlook)
        if (report.leverage_score !== null && report.leverage_score !== undefined) {
          setLoadedLeverageScore(report.leverage_score);
        } else {
          setLoadedLeverageScore(null);
        }

        // v5.3: Restore all other computed scores (Directive 12.5)
        setLoadedAskFavorabilityScore(report.ask_favorability_score ?? null);
        setLoadedOutlookScore(report.outlook_score ?? null);
        setLoadedSellerProfileScore(report.seller_profile_score ?? null);

        // v5.3: Set the dial needle position immediately from the saved outlook score
        // This prevents the needle from showing wrong values when navigating back to a report
        if (report.outlook_score !== null && report.outlook_score !== undefined) {
          const clampedScore = Math.max(-20, Math.min(20, report.outlook_score));
          let normalized = (clampedScore + 20) / 40;
          // Anti-snap: keep needle off tick marks (matches startVerdictReveal logic)
          const tickPositions = [0.15, 0.35, 0.50, 0.70, 0.85];
          const deadZone = 0.02;
          const nudgeAmount = 0.03;
          for (const tick of tickPositions) {
            if (Math.abs(normalized - tick) < deadZone) {
              if (tick === 0.50 && clampedScore === 0) {
                normalized = tick + nudgeAmount;
              } else if (normalized >= tick) {
                normalized = tick + nudgeAmount;
              } else {
                normalized = tick - nudgeAmount;
              }
              break;
            }
          }
          normalized = Math.max(0.02, Math.min(0.98, normalized));
          const adjustedScore = (normalized * 40) - 20;
          const targetRotation = (adjustedScore / 20) * 90;
          setNeedleRotation(Math.max(-90, Math.min(90, targetRotation)));
        }

        // Restore findings from saved report
        // D13: Prefer raw_findings_json (full list with original selected state) so Step 2 shows every extracted item
        // Fall back to findings_json (selected-only) for old reports that don't have raw_findings_json
        let restoredFindings;
        if (Array.isArray(report.raw_findings_json) && report.raw_findings_json.length > 0) {
          // New format: raw findings include their original selected boolean — preserve it
          // Mark items missing from findings_json as not selected (they were excluded at save time)
          const selectedIds = new Set((report.findings_json || []).map(f => f.id));
          restoredFindings = report.raw_findings_json.map(f => ({
            ...f,
            selected: selectedIds.has(f.id)
          }));
        } else {
          // Old format: only selected findings were saved — force all to selected (legacy behavior)
          restoredFindings = (report.findings_json || []).map(f => ({
            ...f,
            selected: true
          }));
        }
        setFindings(restoredFindings);

        // Restore strategy from saved report
        setStrategy(report.strategy_json || null);

        // Set Step 4 with all animations complete (frozen view)
        setCurrentStep(4);
        setCompletedSteps([1, 2, 3, 4]);
        setHasCompletedFullFlow(true);
        setVerdictPhase('complete');
        setShowSummary(true);
        setShowAssessments(true);
        setShowFunnel(true);

        // D18a fix: set pendingReportId so the Game Plan Score effect can compute/load
        // (without this, the GPS card and gauge silently fail to render on saved reports)
        setPendingReportId(report.id);

        // Mark as read-only mode
        setReadOnlyMode(true);
        setSelectedReport(report);
        setCurrentView('product'); // Use product view but in read-only mode
      };

      // v5.1: Resume a draft report (editable mode)
      const resumeDraft = (report) => {
        console.log('=== Resuming draft report ===', report.id, 'status:', report.report_status);

        // Set the pending report ID so future saves update this row
        setPendingReportId(report.id);

        // Restore property info from saved report
        setPropertyInfo({
          address: report.property_address || '',
          city: report.city_state || '',
          zipCode: report.zip_code || '',
          originalListPrice: report.original_list_price?.toString() || '',
          listPrice: report.list_price?.toString() || '',
          contractPrice: report.contract_price?.toString() || '',
          offerPrice: '',
          daysOnMarket: report.days_on_market?.toString() || '',
          propertyType: 'single-family',
          clientName: report.client_name || '',
          // D37-A: hydrate consent fields. Drafts saved post-D37-A carry the
          // captured Page 1 attestation forward; pre-D37 drafts default to false.
          clientPhone: report.client_phone || '',
          clientSmsConsent: report.client_sms_consent === true,
          estimatedClosingCosts: report.estimated_closing_costs?.toString() || '',
          creditsAlreadyNegotiated: report.credits_already_negotiated?.toString() || '',
          minimumDownPayment: report.minimum_down_payment?.toString() || '',
          plannedDownPayment: report.planned_down_payment?.toString() || ''
        });

        // Restore market context if saved
        if (report.market_context_json) {
          setMarketContext(report.market_context_json);
        }

        // Restore buyer/seller factors if saved (for customization_complete drafts)
        // v5.2: Migrate old 1-5 scale data in-memory (Directive 12)
        if (report.buyer_factors_json) {
          setBuyerFactors(migrateFactorsIfNeeded(report.buyer_factors_json));
        }
        if (report.seller_factors_json) {
          setSellerFactors(migrateFactorsIfNeeded(report.seller_factors_json));
        }
        // D32-C: hydrate justifications state and set legacy flag
        hydrateJustificationsFromReport(report);
        // D32-B: hydrate buyer subjective responses from buyer_subjective_responses
        hydrateBuyerResponsesForReport(report.id);

        // v5.2: Resume mode is editable — don't lock the leverage score, let it recompute
        setLoadedLeverageScore(null);
        // v5.3: Same for the other computed scores (Directive 12.5)
        setLoadedAskFavorabilityScore(null);
        setLoadedOutlookScore(null);
        setLoadedSellerProfileScore(null);

        // D52 (2026-05-12): mirror the D13 fix from loadFrozenReport — prefer
        // raw_findings_json (full extracted list) and rebuild the selected
        // flags from findings_json. Without this, resumeDraft shows only the
        // previously-selected items on Page 2 because findings_json is
        // filtered down to the selected subset by the customization_complete
        // / analysis_complete save paths. Worse: every downstream save then
        // overwrites raw_findings_json with that filtered subset, permanently
        // destroying the original extraction. The previous one-line
        // implementation was the root cause of corrupted raw_findings_json
        // on Jared's Risley reports (`cf92f24a-…`, `184bbe66-…`).
        let restoredFindings;
        if (Array.isArray(report.raw_findings_json) && report.raw_findings_json.length > 0) {
          const selectedIds = new Set((report.findings_json || []).map(f => f.id));
          restoredFindings = report.raw_findings_json.map(f => ({
            ...f,
            // Preserve the saved selected flag if raw row already carries one,
            // otherwise reconstruct from the findings_json selected-id set.
            selected: typeof f.selected === 'boolean' ? f.selected : selectedIds.has(f.id)
          }));
        } else {
          // Legacy report with no raw_findings_json — fall back to whatever
          // findings_json holds (may be selected-only, which is the pre-D13
          // shape, but that's the best we have for that report).
          restoredFindings = (report.findings_json || []).map(f => ({ ...f }));
        }
        setFindings(restoredFindings);
        setExtractedItems(restoredFindings); // Also set extracted items for reference

        // Determine which step to resume at based on status
        let resumeStep = report.current_step || 2;
        if (report.report_status === 'step1_draft') {
          resumeStep = 1; // D44 Bug 4: no PDF yet, go back to property entry
        } else if (report.report_status === 'extraction_complete') {
          resumeStep = 2; // Go to findings review
        } else if (report.report_status === 'customization_complete') {
          resumeStep = 3; // Go to leverage sliders (they can re-advance to Step 4)
        }

        // Set navigation state
        setCurrentStep(resumeStep);
        const completedStepsArray = [];
        for (let i = 1; i <= resumeStep; i++) {
          completedStepsArray.push(i);
        }
        setCompletedSteps(completedStepsArray);
        setHasCompletedFullFlow(false); // Not complete yet

        // Reset animation states
        setVerdictPhase('hidden');
        setShowSummary(false);
        setShowAssessments(false);
        setShowFunnel(false);

        // NOT read-only - user can edit
        setReadOnlyMode(false);
        setSelectedReport(null);

        // Mark this step's save as already done (so we don't double-save)
        if (report.report_status === 'extraction_complete') {
          setSaveState(prev => ({ ...prev, step2Saved: true }));
        } else if (report.report_status === 'customization_complete') {
          setSaveState(prev => ({ ...prev, step2Saved: true, step3Saved: true }));
        }

        // Navigate to product view
        setCurrentView('product');
        console.log('Draft resumed at step', resumeStep);
      };

      // v5.0: Save and return to dashboard
      const saveAndReturnToDashboard = async () => {
        console.log('=== Save & Return to Dashboard clicked ===');
        try {
          console.log('Saving report...');
          const savedReport = await saveReport();
          console.log('Save result:', savedReport ? 'success' : 'failed/null');

          console.log('Loading reports...');
          await loadUserReports();

          console.log('Resetting form...');
          resetForm();

          console.log('Navigating to dashboard...');
          setCurrentView('dashboard');
          console.log('saveAndReturnToDashboard complete');
        } catch (error) {
          console.error('Error in saveAndReturnToDashboard:', error);
        }
      };

      // v5.0: Reset form for new report
      const resetForm = () => {
        setPropertyInfo({
          address: '', city: '', zipCode: '', originalListPrice: '', listPrice: '', contractPrice: '',
          offerPrice: '', daysOnMarket: '', propertyType: 'single-family', clientName: '',
          clientPhone: '', clientSmsConsent: false,
          estimatedClosingCosts: '', creditsAlreadyNegotiated: '',
          minimumDownPayment: '', plannedDownPayment: ''
        });
        setFindings([]);
        setStrategy(null);
        setCurrentStep(1);
        setCompletedSteps([1]);
        setHasCompletedFullFlow(false);
        setVerdictPhase('hidden');
        setShowSummary(false);
        setShowAssessments(false);
        setShowFunnel(false);
        setDismissedNudges({ closingCost: false, downPayment: false });
        setReadOnlyMode(false);
        setSelectedReport(null);
        // Clear PDF storage state
        setPendingReportId(null);
        setPendingPdfFiles([]);
        setPdfFileName('');
        setPdfFileNames([]);
        setPdfParseStatus(null);
        // v5.2: Clear loaded leverage score (Directive 12)
        setLoadedLeverageScore(null);
        // v5.3: Clear all loaded computed scores (Directive 12.5)
        setLoadedAskFavorabilityScore(null);
        setLoadedOutlookScore(null);
        setLoadedSellerProfileScore(null);
        // v5.1: Reset progressive save state for new reports
        setSaveState({ step2Saved: false, step3Saved: false, step4Saved: false });
        // D46 Task 4: clear Page 2 cost gate so a fresh analysis doesn't open
        // with carry-over highlight from a prior cohort.
        setCostGateActive(false);
        // D44 Bug 7: Step 3 state was bleeding between reports — fresh analyses
        // were rendering with the prior report's justification dropdown selection
        // (e.g. "Disclosure form is minimal or evasive" pre-checked), slider
        // values, buyer responses, and market context. Wipe all of it so every
        // new analysis starts clean.
        setJustifications({});
        setIsLegacyJustificationReport(false);
        setBuyerResponses({});
        setMarketSegmentData(null);
        setBuyerFactors([
          { id: 'sellerDisclosed', label: 'Seller Previously Disclosed Issues', value: 6, weight: 1.5, note: '', enabled: true, lowLabel: 'None disclosed', highLabel: 'Major issues disclosed', research: 'Loss aversion - legal liability fear' },
          { id: 'sellerMotivated', label: 'Seller Appears Motivated', value: 6, weight: 1.8, note: '', enabled: true, lowLabel: 'Not motivated', highLabel: 'Very urgent', research: "Cialdini's reciprocity + time pressure" },
          { id: 'buyerFinancialStrength', label: 'Buyer Has Strong Finances', value: 6, weight: 1.2, note: '', enabled: true, lowLabel: 'Needs help', highLabel: 'Cash/20%+ down', research: 'Financial position strengthens negotiating hand' }
        ]);
        setSellerFactors([
          { id: 'uniquelySuited', label: 'Property Uniquely Suits Buyer Needs', value: 6, weight: 1.3, note: '', enabled: true, lowLabel: 'Generic fit', highLabel: 'Perfect match', research: 'Reduces buyer BATNA' },
          { id: 'emotional', label: 'Buyer Emotionally Attached', value: 6, weight: 1.5, note: '', enabled: true, lowLabel: 'Not attached', highLabel: 'In love with it', research: 'Loss aversion - irrational overpayment' },
          { id: 'backupOffers', label: 'Backup Offers or Strong Interest', value: 6, weight: 2.0, note: '', enabled: true, lowLabel: 'No competition', highLabel: 'Multiple offers', research: 'BATNA theory - strongest seller power' },
          { id: 'timePressure', label: 'Buyer Has Time Pressure', value: 6, weight: 1.4, note: '', enabled: true, lowLabel: 'Flexible timing', highLabel: 'Urgent deadline', research: 'Scarcity + deadline effect' }
        ]);
        setMarketContext({
          financingType: 'conventional',
          originalListPrice: '',
          marketTemperature: 'balanced',
          typicalConcessions: 'moderate',
          sellerSituation: 'unknown'
        });
        // Wipe Page 4 cached state so the prestige page doesn't render against
        // the prior analysis on initial paint while a fresh compute is in flight.
        setGamePlanScoreState(null);
        setBaselineRow(null);
        setSavedScenarios([]);
        setBaselineLoaded(false);
        setActiveScenarioId('baseline');
        setIndustryResearch([]);
        setResearchLoading(false);
        supervisorInputsFingerprintRef.current = null;
        setValidationErrors({});
      };
      // v4.5: Auth handlers. D38: signup consent is captured by the universal
      // post-auth SignupConsentGate, not here — handleSignUp is back to the
      // simple pre-D37-A path (just create the auth user + show "check your
      // email"). The gate fires on the user's first authenticated render.
      const handleSignUp = async (e) => {
        e.preventDefault();
        setAuthError('');
        const { error } = await supabaseClient.auth.signUp({
          email: authEmail, password: authPassword,
          options: { data: { full_name: authName } }
        });
        if (error) {
          setAuthError(error.message);
          return;
        }
        setAuthError('Check your email for the confirmation link!');
      };

      // D38: universal signup-attestation status check. On every user-state
      // change, queries sms_consent_attestations for a row with source='signup'
      // tied to this user. The result drives the consent-gate render: missing →
      // gate, present → fall through. Replaces D37-A's deferred backfill effect
      // (which only ran for users with sms_consent_text in metadata — that path
      // is gone now since the gate captures everyone via a unified flow).
      useEffect(() => {
        if (!user?.id) {
          setSignupAttestationStatus('unknown');
          return;
        }
        let cancelled = false;
        setSignupAttestationStatus('unknown');
        (async () => {
          try {
            const { data, error } = await supabaseClient
              .from('sms_consent_attestations')
              .select('id')
              .eq('agent_id', user.id)
              .eq('source', 'signup')
              .limit(1);
            if (cancelled) return;
            if (error) {
              // Fail-open: don't lock users out if the query errors. They'll just
              // bypass the gate. The audit trail will be incomplete for them, but
              // we'd rather be reachable than break the app on a transient DB hiccup.
              console.warn('[D38] signup attestation check failed (failing open):', error);
              setSignupAttestationStatus('present');
              return;
            }
            setSignupAttestationStatus(data && data.length > 0 ? 'present' : 'missing');
          } catch (err) {
            if (!cancelled) {
              console.warn('[D38] signup attestation check threw (failing open):', err);
              setSignupAttestationStatus('present');
            }
          }
        })();
        return () => { cancelled = true; };
      }, [user?.id]);

      // D38: writes the signup attestation row and flips status to 'present' so
      // the render switch falls through to the next view. Called by the consent
      // gate when the agent confirms. Uses verbatim signup attestation text.
      const recordSignupConsent = async () => {
        if (!user?.id) return { ok: false, error: 'Not signed in' };
        try {
          const { error } = await supabaseClient
            .from('sms_consent_attestations')
            .insert({
              report_id: null,
              agent_id: user.id,
              phone_number: null,
              attestation_text: SMS_CONSENT_SIGNUP_AUDIT_TEXT,
              source: 'signup'
            });
          if (error) {
            console.error('[D38] signup attestation INSERT failed:', error);
            return { ok: false, error: error.message || 'Insert failed' };
          }
          setSignupAttestationStatus('present');
          return { ok: true };
        } catch (err) {
          console.error('[D38] signup attestation INSERT threw:', err);
          return { ok: false, error: err.message || 'Insert failed' };
        }
      };

      const handleSignIn = async (e) => {
        e.preventDefault();
        setAuthError('');
        const { error } = await supabaseClient.auth.signInWithPassword({
          email: authEmail, password: authPassword
        });
        if (error) setAuthError(error.message);
      };

      const handleGoogleSignIn = async (forceAccountPicker = false) => {
        setAuthError('');
        // Always redirect to production domain to avoid cross-origin issues
        // Preserve query params (like ?outcome=xxx) through OAuth redirect.
        // D27 fix: removed the `gameplan-ppg.pages.dev` clause — it was forcing
        // ALL preview URLs to redirect back to production after OAuth, which made
        // it impossible to test pre-deploy builds on a preview URL. Now only the
        // canonical production hostname forces the consolidated origin.
        const PROD_ORIGIN = 'https://gameplanppg.ai';
        const isProd = window.location.hostname === 'gameplanppg.ai';
        const targetOrigin = isProd ? PROD_ORIGIN : window.location.origin;
        const redirectUrl = window.location.search
          ? targetOrigin + window.location.search
          : targetOrigin;
        const options = {
          redirectTo: redirectUrl,
          queryParams: forceAccountPicker ? { prompt: 'select_account' } : {}
        };
        const { error } = await supabaseClient.auth.signInWithOAuth({
          provider: 'google',
          options
        });
        if (error) setAuthError(error.message);
      };

      // v5.0: Alias for LandingPage component (always show account picker)
      const signInWithGoogle = () => handleGoogleSignIn(true);

      // Force account picker (for switch account)
      const switchAccount = async () => {
        console.log('=== Switch Account clicked ===');
        try {
          // Sign out first, then redirect to Google with account picker
          await supabaseClient.auth.signOut({ scope: 'local' });
          localStorage.clear();
          sessionStorage.clear();
          setUser(null);
          setProfile(null);
          // Redirect to Google OAuth with account picker
          handleGoogleSignIn(true);
        } catch (error) {
          console.error('switchAccount error:', error);
        }
      };

      const handleSignOut = async () => {
        console.log('=== Sign Out clicked ===');
        try {
          // Sign out from Supabase (use scope: 'local' to avoid issues)
          await supabaseClient.auth.signOut({ scope: 'local' });
          // Clear all browser storage
          localStorage.clear();
          sessionStorage.clear();
          // Clear any URL hash (OAuth tokens)
          if (window.location.hash) {
            window.history.replaceState({}, '', window.location.pathname);
          }
          // Reset React state
          setUser(null);
          setProfile(null);
          setReports([]);
          setCurrentStep(1);
          setFindings([]);
          setStrategy(null);
          setCurrentView('landing');
          console.log('Sign out complete');
        } catch (error) {
          console.error('handleSignOut error:', error);
        }
      };

      // v5.0: Navigate to dashboard (v5.1: with auto-save of current progress)
      const goToDashboard = async () => {
        console.log('=== Dashboard clicked ===');

        // v5.1: Save current progress before navigating away
        // Only save if we have an active session (not read-only, have findings)
        if (!readOnlyMode && pendingReportId && findings.length > 0 && currentStep >= 2 && currentStep <= 3) {
          // D52 (2026-05-12): don't downgrade an already-completed report.
          // Previous behavior unconditionally upserted `customization_complete`
          // when the user navigated to the dashboard from Step 2 or 3 — even
          // if they had previously completed the full analysis (status was
          // `analysis_complete`). The downgrade flipped the report into the
          // `isDraft` lane on next dashboard click, which routed through the
          // resumeDraft path and exposed the D13 gap fixed above. Check
          // existing status first; only fire the save if the report is
          // genuinely still a draft (or hasn't been saved yet at all).
          let existingStatus = null;
          try {
            const { data: existing } = await supabaseClient
              .from('reports')
              .select('report_status')
              .eq('id', pendingReportId)
              .maybeSingle();
            existingStatus = existing?.report_status || null;
          } catch (e) {
            console.warn('[D52 status guard] existing status fetch failed (proceeding cautiously):', e);
          }
          if (existingStatus === 'analysis_complete') {
            console.log('[D52 status guard] skipping customization_complete save — report is already analysis_complete');
          } else {
            console.log('Saving current progress before dashboard navigation (Step', currentStep, ')...');
            try {
              // Always save as customization_complete to capture BOTH findings edits AND slider positions
              // This ensures all user customizations are preserved regardless of which step they're on
              await saveReportAtStep('customization_complete', null, null, true);
              console.log('Progress saved successfully');
            } catch (e) {
              console.error('Failed to save progress:', e);
            }
          }
        }

        // Clear any URL hash (like #outcome/...) to prevent redirect on refresh
        if (window.location.hash) {
          history.replaceState(null, '', window.location.pathname);
        }

        // Refresh reports list and navigate
        await loadUserReports();
        setCurrentView('dashboard');
      };

      const handleForgotPassword = async (e) => {
        e.preventDefault();
        setAuthError('');
        const { error } = await supabaseClient.auth.resetPasswordForEmail(authEmail, {
          redirectTo: window.location.origin
        });
        if (error) setAuthError(error.message);
        else setAuthError('Check your email for the password reset link!');
      };

      // ================================================================
      // API CONFIGURATION
      // v4.4: API key removed - now proxied through Cloudflare Worker
      // ================================================================
      const API_CONFIG = {
        claudeApi: {
          enabled: true,
          proxyUrl: 'https://gameplan-ppg-api.jraaschmidt.workers.dev',
          model: 'claude-sonnet-4-6',
          maxTokens: 8192,
        }
      };

      // Attach the signed-in user's Supabase JWT to every Worker request.
      // Worker validates via /auth/v1/user; rejects 401 if missing/invalid.
      async function getAuthHeaders(extra = {}) {
        const headers = { 'Content-Type': 'application/json', ...extra };
        try {
          const { data: { session } } = await supabaseClient.auth.getSession();
          if (session?.access_token) {
            headers['Authorization'] = `Bearer ${session.access_token}`;
          }
        } catch (err) {
          console.warn('getAuthHeaders: failed to fetch session', err);
        }
        return headers;
      }

      // ================================================================
      // NATIONAL REFERENCE DATABASE
      // Used for Claude's self-validation step (NOT the primary source)
      // ================================================================
      const NationalReferenceData = {
        // Format: item pattern -> { low, high, description, notes }

        // === MINOR ITEMS (Quick fixes under $500) ===
        'seismic_strapping': {
          low: 100, high: 200,
          description: 'Water heater seismic straps',
          laborHours: 0.5,
          notes: 'Metal straps + wall anchors. 30-minute job.'
        },
        'anti_tip_bracket': {
          low: 50, high: 150,
          description: 'Range/stove anti-tip bracket',
          laborHours: 0.5,
          notes: 'Simple bracket installation behind range.'
        },
        'smoke_detectors': {
          low: 200, high: 500,
          description: 'Smoke/CO detectors (whole house)',
          laborHours: 1,
          notes: '4-6 detectors typical for whole house.'
        },
        'caulking_sealing': {
          low: 50, high: 200,
          description: 'Exterior caulking and sealing',
          laborHours: 1,
          notes: 'Windows, doors, penetrations.'
        },
        'garage_firewall': {
          low: 100, high: 300,
          description: 'Garage ceiling drywall/firewall sealing',
          laborHours: 1,
          notes: 'Fire separation repair.'
        },

        // === ELECTRICAL ===
        'gfci_outlet_single': {
          low: 250, high: 350,
          description: 'Single GFCI outlet installation',
          laborHours: 1,
          notes: 'Per outlet, includes device and labor.'
        },
        'gfci_outlets_kitchen': {
          low: 750, high: 1050,
          description: 'GFCI outlets - kitchen (3 outlets)',
          laborHours: 2.5,
          notes: 'Typically 3 outlets near counters/sink.'
        },
        'gfci_outlets_garage': {
          low: 750, high: 1050,
          description: 'GFCI outlets - garage (3 outlets)',
          laborHours: 2.5,
          notes: 'Typically 2-3 outlets in garage.'
        },
        'gfci_outlets_multiple': {
          low: 1500, high: 2100,
          description: 'GFCI outlets - multiple areas (6 outlets)',
          laborHours: 5,
          notes: 'Kitchen + garage + exterior typical.'
        },
        'electrical_panel_federal_pacific': {
          low: 3500, high: 5500,
          description: 'Federal Pacific panel replacement',
          laborHours: 8,
          notes: 'Known fire hazard. 200A panel typical.'
        },
        'electrical_panel_standard': {
          low: 2500, high: 4500,
          description: 'Standard electrical panel upgrade',
          laborHours: 6,
          notes: '200A panel replacement.'
        },
        'outlet_new_garage_door': {
          low: 200, high: 400,
          description: 'New outlet for garage door opener',
          laborHours: 2,
          notes: 'Ceiling-mounted outlet installation.'
        },

        // === PLUMBING ===
        'water_heater_replacement': {
          low: 2000, high: 3500,
          description: 'Water heater replacement (tank)',
          laborHours: 4,
          notes: '50-gallon tank typical. Includes disposal.'
        },
        'water_heater_tankless': {
          low: 3500, high: 6000,
          description: 'Tankless water heater installation',
          laborHours: 6,
          notes: 'May require gas line or electrical upgrades.'
        },
        'drain_clearing_single': {
          low: 100, high: 250,
          description: 'Drain clearing (single drain)',
          laborHours: 1,
          notes: 'Snake or hydro-jet single line.'
        },
        'drain_clearing_multiple': {
          low: 250, high: 600,
          description: 'Drain clearing (multiple drains)',
          laborHours: 2,
          notes: '2-3 slow drains.'
        },
        'toilet_wax_seal': {
          low: 150, high: 300,
          description: 'Toilet reset with new wax seal',
          laborHours: 1,
          notes: 'Per toilet. Pull, reseal, reset.'
        },

        // === HVAC ===
        'furnace_electric': {
          low: 8000, high: 12000,
          description: 'Electric furnace replacement',
          laborHours: 8,
          notes: 'Includes permits. Electric heat is more expensive to install.'
        },
        'furnace_gas': {
          low: 6000, high: 10000,
          description: 'Gas furnace replacement',
          laborHours: 8,
          notes: '80-95% AFUE typical.'
        },
        'hvac_full_system': {
          low: 10000, high: 18000,
          description: 'Full HVAC system (furnace + AC)',
          laborHours: 16,
          notes: 'Complete system replacement.'
        },
        'heat_pump': {
          low: 8000, high: 14000,
          description: 'Heat pump system',
          laborHours: 12,
          notes: 'Heating and cooling combined.'
        },
        'duct_cleaning': {
          low: 300, high: 600,
          description: 'Air duct cleaning',
          laborHours: 3,
          notes: 'Whole house duct cleaning.'
        },

        // === ROOFING ===
        'roof_replacement_full': {
          low: 15000, high: 25000,
          description: 'Full roof replacement',
          laborHours: 40,
          notes: 'Architectural shingles, ~2000 sq ft.'
        },
        'roof_repair_partial': {
          low: 500, high: 2500,
          description: 'Partial roof repair',
          laborHours: 4,
          notes: 'Section repair, leak fix.'
        },
        'kickout_flashing': {
          low: 300, high: 800,
          description: 'Kickout/step flashing repair',
          laborHours: 2,
          notes: 'Critical leak prevention point.'
        },
        'gutter_replacement': {
          low: 1000, high: 2500,
          description: 'Gutter system replacement',
          laborHours: 6,
          notes: '150 linear feet typical.'
        },

        // === STRUCTURAL/EXTERIOR ===
        'handrail_new': {
          low: 400, high: 1200,
          description: 'New handrail installation',
          laborHours: 4,
          notes: 'Code-compliant railing.'
        },
        'handrail_repair': {
          low: 150, high: 400,
          description: 'Handrail repair/tighten',
          laborHours: 1,
          notes: 'Secure loose railings.'
        },
        'deck_structural': {
          low: 2000, high: 5000,
          description: 'Deck structural repair',
          laborHours: 16,
          notes: 'Posts, beams, joists.'
        },
        'deck_boards': {
          low: 500, high: 2000,
          description: 'Deck board replacement',
          laborHours: 8,
          notes: 'Surface boards only.'
        },
        'siding_repair': {
          low: 500, high: 2500,
          description: 'Siding repair (section)',
          laborHours: 6,
          notes: 'Partial replacement.'
        },
        'siding_full': {
          low: 12000, high: 25000,
          description: 'Full siding replacement',
          laborHours: 80,
          notes: 'Whole house re-side.'
        },

        // === ENVIRONMENTAL ===
        'asbestos_testing': {
          low: 300, high: 700,
          description: 'Asbestos testing (lab analysis)',
          laborHours: 1,
          notes: 'Sample collection + lab fees. NOT removal.'
        },
        'asbestos_abatement': {
          low: 1500, high: 4000,
          description: 'Asbestos removal (per area)',
          laborHours: 16,
          notes: 'Licensed abatement required.'
        },
        'radon_mitigation': {
          low: 800, high: 1500,
          description: 'Radon mitigation system',
          laborHours: 6,
          notes: 'Sub-slab depressurization typical.'
        },
        'mold_testing': {
          low: 300, high: 600,
          description: 'Mold testing/inspection',
          laborHours: 2,
          notes: 'Air and surface sampling.'
        },
        'mold_remediation': {
          low: 1500, high: 5000,
          description: 'Mold remediation (per area)',
          laborHours: 20,
          notes: 'Depends heavily on extent.'
        },

        // === WINDOWS/DOORS ===
        'window_replacement_single': {
          low: 400, high: 800,
          description: 'Single window replacement',
          laborHours: 2,
          notes: 'Standard vinyl window.'
        },
        'window_seal_repair': {
          low: 100, high: 300,
          description: 'Window seal/weatherstrip repair',
          laborHours: 1,
          notes: 'Per window.'
        },
        'sliding_door_repair': {
          low: 200, high: 600,
          description: 'Sliding door repair/adjustment',
          laborHours: 2,
          notes: 'Track, rollers, weatherstrip.'
        },

        // === FOUNDATION ===
        'foundation_crack_repair': {
          low: 500, high: 2000,
          description: 'Foundation crack repair',
          laborHours: 4,
          notes: 'Epoxy injection typical.'
        },
        'foundation_major': {
          low: 5000, high: 15000,
          description: 'Major foundation repair',
          laborHours: 40,
          notes: 'Piers, underpinning, etc.'
        },
        'crawlspace_vapor_barrier': {
          low: 1500, high: 3500,
          description: 'Crawlspace vapor barrier',
          laborHours: 8,
          notes: 'Moisture control.'
        },

        // === INTERIOR ===
        'drywall_repair': {
          low: 200, high: 600,
          description: 'Drywall repair (per area)',
          laborHours: 3,
          notes: 'Patch and texture match.'
        },
        'interior_painting': {
          low: 300, high: 800,
          description: 'Interior painting (per room)',
          laborHours: 4,
          notes: 'Walls and ceiling.'
        }
      };

      // ================================================================
      // REGIONAL MULTIPLIERS (Oregon focus)
      // ================================================================
      const RegionalMultipliers = {
        '97068': { city: 'West Linn', factor: 1.25 },
        '97034': { city: 'Lake Oswego', factor: 1.30 },
        '97035': { city: 'Lake Oswego', factor: 1.30 },
        '97070': { city: 'Wilsonville', factor: 1.15 },
        '97062': { city: 'Tualatin', factor: 1.15 },
        '97201': { city: 'Portland SW', factor: 1.20 },
        '97202': { city: 'Portland SE', factor: 1.15 },
        '97203': { city: 'Portland N', factor: 1.10 },
        '97206': { city: 'Portland SE', factor: 1.10 },
        '97211': { city: 'Portland NE', factor: 1.10 },
        '97212': { city: 'Portland NE', factor: 1.15 },
        '97213': { city: 'Portland NE', factor: 1.12 },
        '97214': { city: 'Portland SE', factor: 1.18 },
        '97215': { city: 'Portland SE', factor: 1.15 },
        '97219': { city: 'Portland SW', factor: 1.20 },
        '97221': { city: 'Portland SW', factor: 1.25 },
        '97223': { city: 'Tigard', factor: 1.12 },
        '97224': { city: 'Tigard', factor: 1.12 },
        '97229': { city: 'Portland NW', factor: 1.22 },
        '97239': { city: 'Portland SW', factor: 1.20 },
        '97266': { city: 'Portland SE', factor: 1.08 },
        'default': { city: 'Oregon Average', factor: 1.10 }
      };

      const getRegionalMultiplier = (zipCode) => {
        return RegionalMultipliers[zipCode] || RegionalMultipliers['default'];
      };

      // ================================================================
      // CLAUDE PDF PARSING SERVICE - NEW TWO-PHASE APPROACH
      // Phase 1: Claude estimates using its own knowledge
      // Phase 2: Claude validates against reference data
      // ================================================================
      const ClaudePdfParsingService = {

        // Build reference data string for Claude to check against
        getReferenceDataString: () => {
          let refString = "NATIONAL REFERENCE DATA (for validation):\n";
          refString += "-------------------------------------------\n";

          const categories = {
            'Minor Items': ['seismic_strapping', 'anti_tip_bracket', 'smoke_detectors', 'caulking_sealing', 'garage_firewall'],
            'Electrical': ['gfci_outlet_single', 'gfci_outlets_kitchen', 'gfci_outlets_garage', 'gfci_outlets_multiple', 'electrical_panel_federal_pacific', 'electrical_panel_standard', 'outlet_new_garage_door'],
            'Plumbing': ['water_heater_replacement', 'drain_clearing_single', 'drain_clearing_multiple', 'toilet_wax_seal'],
            'HVAC': ['furnace_electric', 'furnace_gas', 'hvac_full_system', 'duct_cleaning'],
            'Roofing': ['roof_replacement_full', 'roof_repair_partial', 'kickout_flashing', 'gutter_replacement'],
            'Structural': ['handrail_new', 'handrail_repair', 'deck_structural', 'deck_boards', 'siding_repair'],
            'Environmental': ['asbestos_testing', 'asbestos_abatement', 'radon_mitigation', 'mold_testing']
          };

          for (const [category, items] of Object.entries(categories)) {
            refString += `\n${category}:\n`;
            for (const key of items) {
              const item = NationalReferenceData[key];
              if (item) {
                refString += `  - ${item.description}: $${item.low}-$${item.high} (${item.notes})\n`;
              }
            }
          }

          return refString;
        },

        systemPrompt: `You are an expert home inspector and contractor cost estimator. Your task is to analyze inspection reports and provide accurate repair cost estimates. You may receive multiple documents. Extract all findings across all documents. Label each finding with its source document in parentheses where relevant (e.g., 'Sewer line root intrusion (Sewer Scope)').

YOUR PROCESS (follow this exactly):

STEP 1 - EXTRACT FINDINGS:
Read the inspection report and identify all items that need repair, replacement, or attention. Skip items marked as "functional," "serviceable," or "no concerns."

STEP 2 - ESTIMATE COSTS (use your knowledge first):
For each finding, think through:
- What work is actually required? (Be specific: is it a strap installation or a full replacement?)
- How many labor hours would a licensed contractor need?
- What materials are required?
- Does it require permits?

STEP 3 - VALIDATE YOUR ESTIMATES:
Compare your estimates to the reference data provided. If your estimate is significantly different (more than 50% off), reconsider:
- Did you misunderstand the scope of work?
- Did you confuse one repair type with another (e.g., testing vs. removal)?
- Adjust if warranted, but trust your reasoning if you have good justification.

CRITICAL DISTINCTIONS (common errors to avoid):
- "Seismic strapping" = installing metal straps on existing water heater ($100-200), NOT replacing the water heater ($2000+)
- "Asbestos testing" = collecting samples and lab analysis ($300-700), NOT asbestos removal/abatement ($1500+)
- "GFCI outlets needed" = count the locations and multiply by ~$300 per outlet
- "Kickout flashing repair" = small metal flashing fix ($300-800), NOT roof replacement
- "Furnace replacement" for ELECTRIC furnaces costs $8000-12000 (more than gas)

PROPERTY ADDRESS:
Extract the address of the PROPERTY BEING INSPECTED. This is typically labeled "Property Address," "Inspection Location," or "Subject Property."
DO NOT use the inspection company's office address (often appears in headers/footers with company name, phone, website).

OUTPUT DISCIPLINE (2026-07-28 — critical for latency; Sonnet 4.6 over-writes without this):
- Do ALL of the reasoning from the steps above INTERNALLY. Do not narrate your process in the output.
- Output ONLY the JSON object below. No markdown code fences, no text before or after it.
- Every string field is a terse phrase, never a sentence or paragraph. This is structured data extraction, not prose.

RESPONSE FORMAT (JSON only):
{
  "property": {
    "address": "street address of property being inspected",
    "city": "city name",
    "state": "OR",
    "zipCode": "5-digit ZIP"
  },
  "findings": [
    {
      "item": "Short name",
      "description": "What needs to be done — terse phrase, max ~10 words",
      "priority": "high|medium|low",
      "category": "Electrical|Plumbing|HVAC|Roofing|Structural|Exterior|Environmental|Interior|General",
      "estimatedCostLow": 100,
      "estimatedCostHigh": 200,
      "reasoning": "Max ~12 words: the work + main cost driver only. No sentences, no restating the description, no process narration."
    }
  ],
  "confidence": {
    "address": "high|medium|low",
    "findings": "high|medium|low"
  }
}`,

        async parseReport(rawText) {
          if (!API_CONFIG.claudeApi.proxyUrl) {
            console.warn('Claude API proxy not configured');
            return null;
          }

          try {
            // D54 (2026-05-12): merge stable reference data into the system
            // prompt so the cached block crosses Anthropic's 1024-token
            // minimum cache size. Combined system block is ~1400 tokens —
            // reliably cacheable. The variable inspection text stays in the
            // user message (uncached, as it should be). Claude sees the same
            // content overall; only the section assignment changed.
            const referenceData = this.getReferenceDataString();
            const cachedSystemBlock = `${this.systemPrompt}

REFERENCE DATA FOR VALIDATION (use this list to sanity-check your estimates; if your number is >50% off from a matching entry, reconsider whether you misunderstood the scope before adjusting):
${referenceData}`;

            const userMessage = `Analyze the following inspection document(s). Extract findings and estimate repair costs.

INSPECTION DOCUMENT TEXT:
${rawText.substring(0, 80000)}

Remember:
1. First estimate costs based on your understanding of the actual work required
2. Then validate against the reference data in your instructions
3. Adjust only if you realize you misunderstood the scope

Return JSON only.`;

            // v4.4: Use Cloudflare Worker proxy (API key stored server-side)
            // D12: X-Analysis-Event: extraction marks this as a quota-chargeable call
            // D53: _ppgMeta tags this call for token-usage logging.
            // D54: cache_control on the system block. cache_creation_input_tokens
            // populates on first call within 5-min window; cache_read_input_tokens
            // on every subsequent call. Confirms via claude_usage_events.
            const response = await fetch(API_CONFIG.claudeApi.proxyUrl, {
              method: 'POST',
              headers: await getAuthHeaders({ 'X-Analysis-Event': 'extraction' }),
              body: JSON.stringify({
                model: API_CONFIG.claudeApi.model,
                max_tokens: API_CONFIG.claudeApi.maxTokens,
                // 2026-07-28: pin effort low. Sonnet 4.6 defaults to high (~3x slower/
                // more verbose than retired Sonnet 4). Low restores ~Sonnet-4 latency/cost
                // for structured extraction. See claude_usage_events telemetry.
                output_config: { effort: 'low' },
                system: [
                  { type: 'text', text: cachedSystemBlock, cache_control: { type: 'ephemeral' } }
                ],
                messages: [{
                  role: 'user',
                  content: userMessage
                }],
                _ppgMeta: { callSite: 'proxy_parse_report' }
              })
            });

            if (response.status === 429) {
              const errData = await response.json().catch(() => ({}));
              if (typeof window !== 'undefined') {
                window.__ppgQuotaHit = errData;
                window.dispatchEvent(new CustomEvent('ppg-quota-hit', { detail: errData }));
              }
              throw new Error(errData.message || 'Daily analysis limit reached');
            }
            if (!response.ok) {
              throw new Error(`API error: ${response.status}`);
            }

            const data = await response.json();
            const text = data.content[0].text;

            try {
              const jsonMatch = text.match(/\{[\s\S]*\}/);
              if (jsonMatch) {
                return JSON.parse(jsonMatch[0]);
              }
            } catch (parseError) {
              console.error('Failed to parse Claude response as JSON:', parseError);
            }

            return null;

          } catch (error) {
            console.error('Claude PDF parsing error:', error);
            return null;
          }
        }
      };

      // ================================================================
      // STATE MANAGEMENT
      // ================================================================

      // Step 1: Property Info
      const [propertyInfo, setPropertyInfo] = useState({
        address: '',
        city: '',
        zipCode: '',
        originalListPrice: '',
        listPrice: '', // Current list price
        contractPrice: '', // Under contract at (purchase price)
        offerPrice: '',
        daysOnMarket: '',
        propertyType: 'single-family',
        clientName: '',
        // D37-A: Client phone + SMS consent attestation. Required to advance Step 1
        // for fresh reports (saved-report reopens skip validation). Consent resets to
        // false whenever clientPhone changes — see handleClientPhoneChange.
        clientPhone: '',
        clientSmsConsent: false,
        // Closing cost ceiling fields (optional)
        estimatedClosingCosts: '',
        creditsAlreadyNegotiated: '',
        // Down payment fields (optional)
        minimumDownPayment: '',
        plannedDownPayment: ''
      });

      const [validationErrors, setValidationErrors] = useState({});

      // D37-A: SMS consent attestation text. Verbatim per directive — do NOT
      // abbreviate or paraphrase. Same string appears on Page 1, the Page 2
      // override block, and is stored in sms_consent_attestations.attestation_text
      // for audit. Twilio TCR auditors compare this against the policy and
      // evidence pages, so all surfaces must match byte-for-byte.
      const SMS_CONSENT_ATTESTATION_TEXT = "By entering this number, I confirm my client has consented to receive SMS from Game Plan regarding their inspection and negotiation analysis. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.";

      // D37-A: agent-side signup attestation. Different surface (agent consenting
      // to receive transactional + outcome-tracking SMS for their own account)
      // than the buyer-side Page 1/Page 2 attestation. Stored verbatim in the
      // attestations table on signup so the audit log distinguishes the two paths.
      const SMS_CONSENT_SIGNUP_AUDIT_TEXT = "I agree to the Terms of Service (https://gameplanppg.ai/terms) and Privacy Policy (https://gameplanppg.ai/privacy). I understand that Game Plan may send me transactional and outcome-tracking SMS messages tied to negotiation reports I generate. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.";

      // D37-A: Phone normalization to E.164. Returns null on invalid input
      // (validation gate uses null to block Step 1 advance). Accepts 10-digit
      // US numbers and 11-digit US numbers with leading 1. Anything else is
      // rejected — international numbers are out of scope for the May 12 demo.
      const normalizePhoneE164 = (raw) => {
        const digits = String(raw || '').replace(/\D/g, '');
        if (digits.length === 11 && digits.startsWith('1')) return '+' + digits;
        if (digits.length === 10) return '+1' + digits;
        return null;
      };

      // D44 Bug 4: Page 1 auto-save. Persists property fields as the agent types
      // so closing the tab mid-Page-1 doesn't lose their work. Two modes:
      //   - No pendingReportId yet → INSERT a step1_draft row (Dashboard shows it)
      //   - pendingReportId exists → UPDATE just the property columns (don't
      //     clobber findings_json or report_status of a later-stage save)
      const autoSavePage1Draft = async () => {
        if (!user) return;
        if (readOnlyMode) return;

        // Skip the noisy first-keystroke roundtrip if every field is still blank.
        const anyContent = [
          propertyInfo.address, propertyInfo.city, propertyInfo.zipCode,
          propertyInfo.clientName, propertyInfo.clientPhone,
          propertyInfo.listPrice, propertyInfo.originalListPrice,
          propertyInfo.contractPrice, propertyInfo.daysOnMarket,
          propertyInfo.estimatedClosingCosts, propertyInfo.creditsAlreadyNegotiated,
          propertyInfo.minimumDownPayment, propertyInfo.plannedDownPayment
        ].some(v => v && String(v).trim().length > 0);
        if (!anyContent) return;

        const propertyPayload = {
          property_address: propertyInfo.address || null,
          city_state: propertyInfo.city || null,
          zip_code: propertyInfo.zipCode || null,
          client_name: propertyInfo.clientName || null,
          client_phone: normalizePhoneE164(propertyInfo.clientPhone) || propertyInfo.clientPhone || null,
          client_sms_consent: propertyInfo.clientSmsConsent === true,
          list_price: parseInt(String(propertyInfo.listPrice).replace(/[^0-9]/g, '')) || 0,
          days_on_market: parseInt(propertyInfo.daysOnMarket) || 0,
          original_list_price: parseInt(String(propertyInfo.originalListPrice).replace(/[^0-9]/g, '')) || null,
          contract_price: parseInt(String(propertyInfo.contractPrice).replace(/[^0-9]/g, '')) || null,
          estimated_closing_costs: parseInt(String(propertyInfo.estimatedClosingCosts).replace(/[^0-9]/g, '')) || null,
          credits_already_negotiated: parseInt(String(propertyInfo.creditsAlreadyNegotiated).replace(/[^0-9]/g, '')) || null,
          minimum_down_payment: parseInt(String(propertyInfo.minimumDownPayment).replace(/[^0-9]/g, '')) || null,
          planned_down_payment: parseInt(String(propertyInfo.plannedDownPayment).replace(/[^0-9]/g, '')) || null,
          updated_at: new Date().toISOString()
        };

        try {
          if (pendingReportId) {
            // Selective update — leave report_status / findings_json untouched
            // so going back to Page 1 mid-flow doesn't roll back to step1_draft.
            const { error } = await supabaseClient
              .from('reports')
              .update(propertyPayload)
              .eq('id', pendingReportId)
              .eq('user_id', user.id);
            if (error) console.warn('[D44 Bug 4] Page 1 auto-save update failed:', error);
          } else {
            const newId = crypto.randomUUID();
            const { error } = await supabaseClient
              .from('reports')
              .insert({
                id: newId,
                user_id: user.id,
                report_status: 'step1_draft',
                current_step: 1,
                report_version: 'v5.1',
                ...propertyPayload
              });
            if (error) {
              console.warn('[D44 Bug 4] Page 1 auto-save insert failed:', error);
            } else {
              setPendingReportId(newId);
              console.log('[D44 Bug 4] step1_draft created:', newId);
            }
          }
        } catch (err) {
          console.warn('[D44 Bug 4] Page 1 auto-save threw:', err);
        }
      };

      // Debounced trigger: 1.5s after the last propertyInfo change. Only while
      // Page 1 is the current step in an editable analysis.
      const page1AutoSaveTimerRef = useRef(null);
      useEffect(() => {
        if (readOnlyMode) return;
        if (currentStep !== 1) return;
        if (!user) return;
        if (page1AutoSaveTimerRef.current) {
          clearTimeout(page1AutoSaveTimerRef.current);
        }
        page1AutoSaveTimerRef.current = setTimeout(() => {
          autoSavePage1Draft();
        }, 1500);
        return () => {
          if (page1AutoSaveTimerRef.current) {
            clearTimeout(page1AutoSaveTimerRef.current);
          }
        };
      }, [propertyInfo, currentStep, user, readOnlyMode]);

      // D39: Internal-only flag for whether the SMS dispatch path is real or
      // stubbed. While Twilio TCR approval is pending, we render the full UX
      // (no visible "stub" banner) but every dispatch only writes a row to
      // client_pricing_requests. When Twilio approves, flip this constant to
      // 'live' to wire actual SMS dispatch. Console-logged on every stub send
      // so an admin grepping logs can confirm before assuming SMS is firing.
      const SMS_DISPATCH_MODE = 'stub'; // 'stub' | 'live'

      // D39: Worker base URL. Centralized so endpoint additions only edit one
      // const. Existing call sites still hardcode the same string for backward
      // safety; the constant is used by D39+ paths.
      const WORKER_BASE_URL = 'https://gameplan-ppg-api.jraaschmidt.workers.dev';

      // D39: Light-touch PDF text extractor for contractor quotes. Reuses the
      // global pdfjsLib that's already loaded for inspection-report parsing
      // (see line ~6420). Quotes are typically 1-2 pages, so we don't need the
      // position-aware reconstruction the inspection path does — a flat
      // concat-with-spaces is sufficient for Claude.
      const extractTextFromQuotePdf = async (file) => {
        const arrayBuffer = await file.arrayBuffer();
        if (!pdfjsLib.GlobalWorkerOptions.workerSrc) {
          pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        }
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
        let text = '';
        for (let p = 1; p <= pdf.numPages; p++) {
          const page = await pdf.getPage(p);
          const content = await page.getTextContent();
          text += content.items.map(it => it.str).join(' ') + '\n';
        }
        return text.trim();
      };

      // D39: Format a numeric quote_date string ('YYYY-MM-DD') as a friendly
      // 'May 5, 2026' for the provenance line. Falls back to the raw string
      // if parsing fails. No timezone shenanigans — quote dates are dates,
      // not timestamps.
      const formatQuoteDate = (raw) => {
        if (!raw) return null;
        try {
          const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(raw).trim());
          if (!m) return String(raw);
          const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
          const monthIdx = parseInt(m[2], 10) - 1;
          const day = parseInt(m[3], 10);
          if (monthIdx < 0 || monthIdx > 11) return String(raw);
          return `${months[monthIdx]} ${day}, ${m[1]}`;
        } catch { return String(raw); }
      };

      // D39: 60-day staleness check. Internal-only flag (logged + surfaced in
      // override audit metadata, not customer-facing). Returns true when the
      // extracted quote date is older than 60 days vs the upload date —
      // suggests an old quote being repurposed.
      const isQuoteStale = (extractedQuoteDate, uploadedAt) => {
        if (!extractedQuoteDate || !uploadedAt) return false;
        try {
          const q = new Date(extractedQuoteDate);
          const u = new Date(uploadedAt);
          if (Number.isNaN(q.getTime()) || Number.isNaN(u.getTime())) return false;
          const diffMs = u.getTime() - q.getTime();
          return diffMs > 60 * 24 * 60 * 60 * 1000;
        } catch { return false; }
      };

      // D39: Build the customer-facing provenance label for a finding. Override
      // metadata is INTENTIONALLY NEVER REFERENCED HERE — overrides display the
      // underlying source unchanged. See directive Task 6 + override modal copy.
      const formatCostProvenance = (finding) => {
        if (!finding || !finding.costSource) return null;
        const src = finding.costSource;
        if (src === 'contractor') {
          // Prefer the date Claude extracted from the quote PDF; fall back to
          // the upload date silently. Pre-D39 quotes (no extraction_response)
          // land on the upload-date fallback, which is honest if generic.
          const extracted = finding.costSourceQuoteDate;
          const uploaded = finding.costSourceSetAt;
          const dateLabel = formatQuoteDate(extracted) || formatQuoteDate(uploaded ? String(uploaded).slice(0, 10) : null);
          if (extracted) return `Source: contractor quote dated ${dateLabel}`;
          if (uploaded) return `Source: contractor quote (uploaded ${dateLabel})`;
          return 'Source: contractor quote';
        }
        if (src === 'client') {
          const responseDate = finding.costSourceClientResponseAt || finding.costSourceSetAt;
          const dateLabel = formatQuoteDate(responseDate ? String(responseDate).slice(0, 10) : null);
          return dateLabel ? `Source: client text response on ${dateLabel}` : 'Source: client text response';
        }
        if (src === 'manual_dev') {
          // Internal dev override (D22) — never used in real client work.
          return null;
        }
        // Default / agent-estimate fallback. Used when the agent records a
        // legitimate estimate without a quote (future flow); not displayed for
        // findings without any cost set.
        if (typeof finding.cost === 'number' && finding.cost > 0) {
          return 'Source: agent estimate';
        }
        return null;
      };

      // Market Context (v3.7)
      const [marketContext, setMarketContext] = useState({
        financingType: 'conventional',
        originalListPrice: '',
        marketTemperature: 'balanced',
        typicalConcessions: 'moderate',
        sellerSituation: 'unknown'
      });

      // Outcome Tracking (v3.7)
      const [showOutcomeModal, setShowOutcomeModal] = useState(false);
      const [outcomeData, setOutcomeData] = useState({
        negotiationResult: '',
        finalCreditReceived: '',
        sellerHandledRepairs: [],
        sellerRepairValue: '',
        recommendationAccuracy: '',
        agentNotes: ''
      });

      // v5.1: Save outcome to Supabase (with localStorage backup)
      const OUTCOMES_KEY = 'gambitlab_outcomes';

      const saveOutcome = async (outcome) => {
        try {
          // Save to Supabase first - matching existing table schema
          const { error } = await supabaseClient.from('outcomes').insert({
            user_id: user?.id,
            submitted_by: user?.id,
            report_id: selectedReport?.id || null,
            asked_amount: Math.round(outcome.recommendedOpeningAsk || 0),
            received_amount: Math.round(outcome.finalCreditReceived || 0),
            deal_status: outcome.negotiationResult || 'unknown',
            outcome_type: outcome.negotiationResult || 'unknown',
            purchase_price: Math.round(outcome.listPrice || 0),
            notes: outcome.agentNotes || '',
            action: 'outcome_submitted',
            // Store all detailed data in metadata JSONB column
            metadata: {
              propertyZip: outcome.propertyZip,
              propertyCity: outcome.propertyCity,
              propertyState: outcome.propertyState,
              listPrice: outcome.listPrice,
              daysOnMarket: outcome.daysOnMarket,
              documentedRepairs: outcome.documentedRepairs,
              leverageScore: outcome.leverageScore,
              leveragePosition: outcome.leveragePosition,
              financingType: outcome.financingType,
              marketTemperature: outcome.marketTemperature,
              mustHavesTotal: outcome.mustHavesTotal,
              strongAsksTotal: outcome.strongAsksTotal,
              tradeablesTotal: outcome.tradeablesTotal,
              concessionsTotal: outcome.concessionsTotal,
              recommendedOpeningAsk: outcome.recommendedOpeningAsk,
              recommendedWalkAway: outcome.recommendedWalkAway,
              realisticCreditLow: outcome.realisticCreditLow,
              realisticCreditHigh: outcome.realisticCreditHigh,
              sellerHandledRepairs: outcome.sellerHandledRepairs,
              sellerRepairValue: outcome.sellerRepairValue,
              recommendationAccuracy: outcome.recommendationAccuracy
            }
          });

          if (error) {
            console.error('Failed to save outcome to Supabase:', error);
            // Fall back to localStorage if Supabase fails
          } else {
            console.log('Outcome saved to Supabase successfully!');
          }

          // Also save to localStorage as backup
          const existing = JSON.parse(localStorage.getItem(OUTCOMES_KEY) || '[]');
          existing.push(outcome);
          localStorage.setItem(OUTCOMES_KEY, JSON.stringify(existing));
          return true;
        } catch (e) {
          console.error('Failed to save outcome:', e);
          return false;
        }
      };

      const getOutcomes = (filters = {}) => {
        try {
          const all = JSON.parse(localStorage.getItem(OUTCOMES_KEY) || '[]');
          return all.filter(o => {
            if (filters.zip && o.propertyZip !== filters.zip) return false;
            if (filters.state && o.propertyState !== filters.state) return false;
            return true;
          });
        } catch (e) {
          console.error('Failed to get outcomes:', e);
          return [];
        }
      };

      const handleOutcomeSubmit = async () => {
        const strategy = generateStrategy();
        const outcome = {
          id: crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(),
          timestamp: new Date().toISOString(),
          propertyZip: propertyInfo.zipCode,
          propertyCity: propertyInfo.city,
          propertyState: propertyInfo.state || '',
          listPrice: parseFloat(String(propertyInfo.listPrice).replace(/[^0-9.]/g, '')) || 0,
          daysOnMarket: parseInt(propertyInfo.daysOnMarket) || 0,
          documentedRepairs: totalRepairCost,
          leverageScore: leverageScore,
          leveragePosition: strategy.strategy.leveragePosition,
          financingType: marketContext.financingType,
          marketTemperature: marketContext.marketTemperature,
          mustHavesTotal: strategy.totals.mustHaves,
          strongAsksTotal: strategy.totals.strongAsks,
          tradeablesTotal: strategy.totals.tradeables,
          concessionsTotal: strategy.totals.concessions,
          recommendedOpeningAsk: strategy.strategy.openingAsk,
          recommendedWalkAway: strategy.strategy.walkAwayThreshold,
          realisticCreditLow: strategy.strategy.realisticCreditLow,
          realisticCreditHigh: strategy.strategy.realisticCreditHigh,
          // Agent-reported outcome
          negotiationResult: outcomeData.negotiationResult,
          finalCreditReceived: parseFloat(String(outcomeData.finalCreditReceived).replace(/[^0-9.]/g, '')) || 0,
          sellerHandledRepairs: outcomeData.sellerHandledRepairs,
          sellerRepairValue: parseFloat(String(outcomeData.sellerRepairValue).replace(/[^0-9.]/g, '')) || 0,
          recommendationAccuracy: outcomeData.recommendationAccuracy,
          agentNotes: outcomeData.agentNotes,
          submittedAt: new Date().toISOString()
        };

        if (await saveOutcome(outcome)) {
          setShowOutcomeModal(false);
          setOutcomeData({
            negotiationResult: '',
            finalCreditReceived: '',
            sellerHandledRepairs: [],
            sellerRepairValue: '',
            recommendationAccuracy: '',
            agentNotes: ''
          });
          alert('Thank you! Your outcome has been recorded and will help improve recommendations for all agents.');
        }
      };

      // Calculate insights from stored outcomes
      const calculateInsights = () => {
        const state = propertyInfo.state || '';
        const outcomes = getOutcomes({ state: state || undefined });

        const comparable = outcomes.filter(o =>
          o.negotiationResult === 'closed' &&
          o.finalCreditReceived !== null &&
          o.documentedRepairs > 0
        );

        if (comparable.length < 5) {
          return { hasEnoughData: false, sampleSize: comparable.length };
        }

        // Calculate capture rates
        const captureRates = comparable.map(o => {
          const totalReceived = (o.finalCreditReceived || 0) + (o.sellerRepairValue || 0);
          return totalReceived / o.documentedRepairs;
        });

        const mean = (arr) => arr.reduce((a, b) => a + b, 0) / arr.length;
        const median = (arr) => {
          const sorted = [...arr].sort((a, b) => a - b);
          const mid = Math.floor(sorted.length / 2);
          return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
        };

        const avgCaptureRate = mean(captureRates);
        const medianCaptureRate = median(captureRates);

        // Calculate percentile for current deal's target
        const calculatePercentile = (arr, value) => {
          const sorted = [...arr].sort((a, b) => a - b);
          const count = sorted.filter(v => v <= value).length;
          return Math.round((count / sorted.length) * 100);
        };

        // Get average credits by leverage position
        const byLeverage = {};
        comparable.forEach(o => {
          const pos = o.leveragePosition || 'unknown';
          if (!byLeverage[pos]) byLeverage[pos] = [];
          byLeverage[pos].push({
            captureRate: ((o.finalCreditReceived || 0) + (o.sellerRepairValue || 0)) / o.documentedRepairs,
            credit: o.finalCreditReceived || 0
          });
        });

        const leverageAvgs = Object.entries(byLeverage).map(([pos, deals]) => ({
          position: pos,
          avgCaptureRate: mean(deals.map(d => d.captureRate)),
          avgCredit: mean(deals.map(d => d.credit)),
          count: deals.length
        }));

        return {
          hasEnoughData: true,
          sampleSize: comparable.length,
          avgCaptureRate,
          medianCaptureRate,
          byLeverage: leverageAvgs,
          calculatePercentile: (rate) => calculatePercentile(captureRates, rate)
        };
      };

      // V3.6: Local Market Data (pre-compiled regional data)
      const LOCAL_MARKET_DATA = {
        // Oregon markets
        '97068': { city: 'West Linn', medianSaleToList: 0.982, medianDOM: 23, inventoryMonths: 1.8, priceReductionPct: 0.34, lastUpdated: '2026-01' },
        '97034': { city: 'Lake Oswego', medianSaleToList: 0.985, medianDOM: 19, inventoryMonths: 1.5, priceReductionPct: 0.28, lastUpdated: '2026-01' },
        '97035': { city: 'Lake Oswego', medianSaleToList: 0.983, medianDOM: 21, inventoryMonths: 1.6, priceReductionPct: 0.30, lastUpdated: '2026-01' },
        '97201': { city: 'Portland', medianSaleToList: 0.978, medianDOM: 28, inventoryMonths: 2.1, priceReductionPct: 0.38, lastUpdated: '2026-01' },
        '97209': { city: 'Portland NW', medianSaleToList: 0.975, medianDOM: 32, inventoryMonths: 2.4, priceReductionPct: 0.42, lastUpdated: '2026-01' },
        '97215': { city: 'Portland SE', medianSaleToList: 0.980, medianDOM: 25, inventoryMonths: 1.9, priceReductionPct: 0.35, lastUpdated: '2026-01' },
        '97005': { city: 'Beaverton', medianSaleToList: 0.979, medianDOM: 22, inventoryMonths: 1.7, priceReductionPct: 0.32, lastUpdated: '2026-01' },
        '97006': { city: 'Beaverton', medianSaleToList: 0.981, medianDOM: 20, inventoryMonths: 1.6, priceReductionPct: 0.30, lastUpdated: '2026-01' },
        // California markets
        '94102': { city: 'San Francisco', medianSaleToList: 0.995, medianDOM: 14, inventoryMonths: 1.2, priceReductionPct: 0.18, lastUpdated: '2026-01' },
        '90210': { city: 'Beverly Hills', medianSaleToList: 0.92, medianDOM: 45, inventoryMonths: 3.5, priceReductionPct: 0.55, lastUpdated: '2026-01' },
        '92101': { city: 'San Diego', medianSaleToList: 0.988, medianDOM: 18, inventoryMonths: 1.4, priceReductionPct: 0.25, lastUpdated: '2026-01' },
        // Washington markets
        '98101': { city: 'Seattle', medianSaleToList: 0.990, medianDOM: 16, inventoryMonths: 1.3, priceReductionPct: 0.22, lastUpdated: '2026-01' },
        '98004': { city: 'Bellevue', medianSaleToList: 0.992, medianDOM: 15, inventoryMonths: 1.2, priceReductionPct: 0.20, lastUpdated: '2026-01' },
        // Texas markets
        '78701': { city: 'Austin', medianSaleToList: 0.965, medianDOM: 35, inventoryMonths: 2.8, priceReductionPct: 0.45, lastUpdated: '2026-01' },
        '75201': { city: 'Dallas', medianSaleToList: 0.972, medianDOM: 30, inventoryMonths: 2.3, priceReductionPct: 0.40, lastUpdated: '2026-01' },
        // Default/fallback
        'default': { city: 'National Average', medianSaleToList: 0.975, medianDOM: 28, inventoryMonths: 2.2, priceReductionPct: 0.38, lastUpdated: '2026-01' }
      };

      const getLocalMarketData = (zipCode) => {
        return LOCAL_MARKET_DATA[zipCode] || LOCAL_MARKET_DATA['default'];
      };

      const getMarketInterpretation = (data) => {
        if (data.inventoryMonths < 2) {
          return { type: 'seller', description: 'seller\'s market where concessions are harder to secure' };
        } else if (data.inventoryMonths < 4) {
          return { type: 'balanced', description: 'balanced market with moderate negotiating room' };
        } else {
          return { type: 'buyer', description: 'buyer\'s market with significant negotiating leverage' };
        }
      };

      // Step 2: Inspection Findings
      const [findings, setFindings] = useState([]);
      const [extractedItems, setExtractedItems] = useState([]);
      const [findingsSort, setFindingsSort] = useState('category-grouped'); // v3.7: Changed default

      // v3.7: Navigation lock state
      const [completedSteps, setCompletedSteps] = useState([1]);
      const [hasCompletedFullFlow, setHasCompletedFullFlow] = useState(false);

      // v3.7: Custom item form state
      const [showCustomItemForm, setShowCustomItemForm] = useState(false);
      const [customItemData, setCustomItemData] = useState({
        name: '',
        description: '',
        cost: '',
        category: 'General',
        priority: 'medium'
      });

      // v4.0: Three-tab structure for Strategy page
      const [activeTab, setActiveTab] = useState('strategy'); // 'strategy' | 'client' | 'negotiation'

      // v4.0: Outlook Verdict reveal sequence state (renamed from Leverage Verdict)
      const [verdictPhase, setVerdictPhase] = useState('hidden'); // 'hidden' | 'analyzing' | 'verdict' | 'complete'
      const [needleRotation, setNeedleRotation] = useState(0); // Starts at center (0°)
      const [showSummary, setShowSummary] = useState(false);
      const [showAssessments, setShowAssessments] = useState(false); // v4.0: Show assessment boxes
      const [showFunnel, setShowFunnel] = useState(false);
      const [showCalcReceipt, setShowCalcReceipt] = useState(false); // v4.4: Calculation Receipt

      // v4.0: Track which sections are expanded
      const [expandedSections, setExpandedSections] = useState({
        'section-ask-breakdown': false,
        'section-market-context': false,
        'section-critical-items': false,
        'section-must-haves': false,
        'section-strong-asks': false,
        'section-tradeables': false,
        'section-concessions': false,
      });

      // v5.0: PDF Export dropdown state
      const [pdfDropdownOpen, setPdfDropdownOpen] = useState(false);
      const [pdfGenerating, setPdfGenerating] = useState(false);

      // v5.1: Beta Feedback Widget state
      const [feedbackOpen, setFeedbackOpen] = useState(false);
      const [feedbackText, setFeedbackText] = useState('');
      const [feedbackSending, setFeedbackSending] = useState(false);
      const [feedbackSent, setFeedbackSent] = useState(false);

      // v4.0: Toggle a section's expanded state
      const toggleSection = (sectionId) => {
        setExpandedSections(prev => ({
          ...prev,
          [sectionId]: !prev[sectionId]
        }));
      };

      // v4.0: Scroll to a section and expand it
      const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setExpandedSections(prev => ({ ...prev, [sectionId]: true }));
          // Add highlight animation
          element.classList.add('section-highlighted');
          setTimeout(() => element.classList.remove('section-highlighted'), 600);
        }
      };

      // v3.7: Price display variance function
      const addDisplayVariance = (price) => {
        const variance = Math.floor(Math.random() * 50) - 25; // ±$25
        const roundTo = price > 1000 ? 50 : 25;
        return Math.round((price + variance) / roundTo) * roundTo;
      };

      // v3.7: Category order for sorting
      const CATEGORY_ORDER = [
        'Electrical',
        'HVAC',
        'Plumbing',
        'Roofing',
        'Structural',
        'Foundation',
        'Exterior',
        'Interior',
        'Environmental',
        'Safety',
        'General'
      ];

      // v3.7: Super priority detection
      const isSuperPriority = (finding) => {
        const text = `${finding.item || ''} ${finding.description || ''}`.toLowerCase();

        // Panel work
        if (/panel|breaker.?box|federal.?pacific|fpe|zinsco|stab.?lok/.test(text)) return true;

        // Sewer issues
        if (/sewer|scope|main.?line|bellied|belly/.test(text)) return true;

        // HVAC replacement
        if (/furnace.?replacement|hvac.?replacement|heat.?pump.?replacement|ac.?replacement/.test(text)) return true;

        // Roof > $2500
        if (/roof/.test(text) && (finding.cost || 0) > 2500) return true;

        // Mold
        if (/mold|fungal|microbial/.test(text)) return true;

        return false;
      };

      // v3.7: Sort by category then price
      const sortByCategoryThenPrice = (findingsArray) => {
        return [...findingsArray].sort((a, b) => {
          // First by category order
          const catA = a.category || 'General';
          const catB = b.category || 'General';
          const catOrderA = CATEGORY_ORDER.indexOf(catA) >= 0 ? CATEGORY_ORDER.indexOf(catA) : 99;
          const catOrderB = CATEGORY_ORDER.indexOf(catB) >= 0 ? CATEGORY_ORDER.indexOf(catB) : 99;
          if (catOrderA !== catOrderB) return catOrderA - catOrderB;

          // Within category: super priority first
          const superA = isSuperPriority(a) ? 0 : 1;
          const superB = isSuperPriority(b) ? 0 : 1;
          if (superA !== superB) return superA - superB;

          // Then by price descending
          return (b.cost || 0) - (a.cost || 0);
        });
      };

      // v3.7: Get seller repair hint
      const getSellerRepairHint = (finding) => {
        const text = `${finding.item || ''} ${finding.description || ''}`.toLowerCase();

        if (/sewer|scope/.test(text)) {
          return "Consider seller repair: Sewer work often expands in scope. Having the seller handle it protects the buyer from surprises.";
        }
        if (/mold|remediation/.test(text)) {
          return "Consider seller repair: Remediation requires certification. Seller handles liability and ensures proper protocol.";
        }
        if (/roof.?replacement/.test(text) && (finding.cost || 0) > 10000) {
          return "Consider seller repair: Large project requiring contractor management. Many buyers prefer this handled before closing.";
        }
        if (/structural/.test(text)) {
          return "Consider seller repair: Complex work requiring permits and engineering. Often better for seller to manage.";
        }
        if (/foundation/.test(text)) {
          return "Consider seller repair: Foundation repairs can uncover additional issues. Seller repair limits buyer exposure.";
        }

        return null;
      };

      // v3.7: Navigation lock helpers
      const canAccessStep = (step) => {
        if (hasCompletedFullFlow) return true;
        return completedSteps.includes(step);
      };

      // v5.1: Made async for sequential saves (prevents race conditions)
      const handleNextStep = async (currentStepNum) => {
        const nextStep = currentStepNum + 1;

        // D37-A: Step 1 → 2 validation gate. Fresh reports must capture client phone
        // and SMS consent attestation before advancing. Saved-report reopens skip
        // the gate (readOnlyMode true → Continue button isn't even rendered, but
        // belt-and-suspenders here in case advance is triggered programmatically).
        if (currentStepNum === 1 && !readOnlyMode) {
          const e164 = normalizePhoneE164(propertyInfo.clientPhone);
          const errors = {};
          if (!e164) {
            errors.clientPhone = 'Enter a valid 10-digit US phone number.';
          }
          if (!propertyInfo.clientSmsConsent) {
            errors.clientSmsConsent = 'Required: confirm client consent to receive text messages before continuing.';
          }
          if (Object.keys(errors).length > 0) {
            setValidationErrors(prev => ({ ...prev, ...errors }));
            return; // block advance
          }
          // Persist E.164-normalized phone back into state so saves and the Page 2
          // modal pre-fill see the canonical form rather than what the user typed.
          if (propertyInfo.clientPhone !== e164) {
            setPropertyInfo(prev => ({ ...prev, clientPhone: e164 }));
          }
          // Append-only audit row. Fire-and-forget — failure here logs but doesn't
          // block advance (the consent columns on the report row are the UI gate;
          // the attestation row is the audit trail). report_id may be null if no
          // pendingReportId yet — saveReportAtStep will write the consent columns
          // onto the report row when it's created.
          try {
            await supabaseClient.from('sms_consent_attestations').insert({
              report_id: pendingReportId || null,
              agent_id: user.id,
              phone_number: e164,
              attestation_text: SMS_CONSENT_ATTESTATION_TEXT,
              source: 'page1'
            });
          } catch (err) {
            console.warn('[D37-A] sms_consent_attestations INSERT failed (non-fatal):', err);
          }
        }

        setCompletedSteps(prev => [...new Set([...prev, nextStep])]);

        // v5.1: Step 3 save - AWAIT before allowing advancement to Step 4
        // This captures slider customizations before analysis generation
        if (nextStep === 4) {
          console.log('=== Step 3 → Step 4: Saving customizations first ===');
          await saveReportAtStep('customization_complete');
        }

        if (nextStep === 4) {
          console.log('=== Entering Step 4 - Analysis Generated ===');
          setHasCompletedFullFlow(true);
          // v4.0: Trigger the Leverage Verdict reveal sequence
          startVerdictReveal();
          // v5.1: Auto-save with verification (replaces autoSaveOnAnalysisGeneration)
          console.log('Calling saveReportAtStep for analysis_complete...');
          await saveReportAtStep('analysis_complete');
        }

        goToStep(nextStep);
      };

      // D46 Task 4: gate the Step 2 → Step 3 advance on every selected finding
      // having a value path. "Value path" = contractor quote uploaded
      // (costSource set), client text request dispatched (pendingRequest set),
      // or structured-reason override applied (also sets costSource). Selected-
      // but-empty findings block advance; on first block we activate the gate
      // visualizer and scroll to the first offender.
      const _selectedFindingsMissingValue = () =>
        findings.filter(f => f.selected && !f.costSource && !f.pendingRequest);

      const attemptStep2Continue = () => {
        const offenders = _selectedFindingsMissingValue();
        if (offenders.length === 0) {
          setCostGateActive(false);
          handleNextStep(2);
          return;
        }
        setCostGateActive(true);
        // Scroll to the first offender in DISPLAYED order. getSortedFindings
        // reflects whatever sort the agent has applied; iterate that and pick
        // the first one in the offender set so the visible scroll target
        // matches the top-most offending card.
        const offenderIds = new Set(offenders.map(f => f.id));
        const firstDisplayedOffender = getSortedFindings.find(f => offenderIds.has(f.id));
        if (firstDisplayedOffender) {
          // Small delay so the per-card amber styling renders before the
          // scroll lands; otherwise the agent sees the scroll, then the
          // highlight appears a frame later.
          setTimeout(() => {
            const el = document.getElementById(`finding-card-${firstDisplayedOffender.id}`);
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 50);
        }
      };

      // v3.7: Add custom finding
      const addCustomFinding = () => {
        if (!customItemData.name || !customItemData.cost) return;

        const newFinding = {
          id: `custom-${Date.now()}`,
          item: customItemData.name,
          description: customItemData.description,
          cost: parseFloat(customItemData.cost) || 0,
          displayPrice: parseFloat(customItemData.cost) || 0, // No variance on manual
          category: customItemData.category,
          priority: customItemData.priority,
          selected: true,
          isCustom: true,
          fromPdf: false,
          requestType: 'credit' // Default to credit
        };

        setFindings(prev => [...prev, newFinding]);
        setCustomItemData({ name: '', description: '', cost: '', category: 'General', priority: 'medium' });
        setShowCustomItemForm(false);
      };

      // v3.7: Update finding request type
      const updateFindingRequestType = (findingId, requestType) => {
        setFindings(prev => prev.map(f =>
          f.id === findingId ? { ...f, requestType } : f
        ));
      };

      // House position mapping for "Roof to Foundation" walkthrough sort
      const HOUSE_SECTIONS = {
        1: { label: 'Roof & Gutters', icon: 'R' },
        2: { label: 'Attic & Insulation', icon: 'A' },
        3: { label: 'Exterior & Structure', icon: 'E' },
        4: { label: 'Electrical Systems', icon: 'Z' },
        5: { label: 'HVAC & Mechanical', icon: 'H' },
        6: { label: 'Interior', icon: 'I' },
        7: { label: 'Kitchen & Appliances', icon: 'K' },
        8: { label: 'Bathroom & Fixtures', icon: 'B' },
        9: { label: 'Plumbing & Water', icon: 'P' },
        10: { label: 'Foundation & Crawlspace', icon: 'F' },
        11: { label: 'Environmental & Safety', icon: '!' }
      };

      const getHousePosition = (finding) => {
        const item = (finding.item || '').toLowerCase();
        const desc = (finding.description || '').toLowerCase();
        const category = (finding.category || '').toLowerCase();
        const combined = `${item} ${desc} ${category}`;

        // Roof & Gutters (top of house)
        if (/roof|shingle|gutter|flashing|chimney|skylight/.test(combined)) return 1;
        // Attic & Insulation
        if (/attic|insulation|ventilation|soffit|fascia/.test(combined)) return 2;
        // Exterior & Siding
        if (/exterior|siding|paint|window|door|deck|porch|stair|rail|handrail/.test(combined)) return 3;
        // Electrical Systems
        if (/electric|panel|outlet|gfci|wiring|breaker|circuit/.test(combined)) return 4;
        // HVAC & Mechanical
        if (/hvac|furnace|heat|air condition|ac unit|duct|thermostat/.test(combined)) return 5;
        // Interior & Walls
        if (/interior|wall|ceiling|floor|drywall|paint|door|window/.test(combined)) return 6;
        // Kitchen & Appliances
        if (/kitchen|appliance|range|oven|dishwasher|garbage|disposal|hood|vent|anti.?tip/.test(combined)) return 7;
        // Bathroom & Fixtures
        if (/bathroom|bath|toilet|shower|tub|faucet|sink|vanity/.test(combined)) return 8;
        // Plumbing & Water
        if (/plumb|water|pipe|drain|sewer|water heater|seismic/.test(combined)) return 9;
        // Foundation & Crawlspace (bottom of house)
        if (/foundation|crawl|basement|concrete|slab|structural|pier|post/.test(combined)) return 10;
        // Environmental (can be anywhere)
        if (/asbestos|radon|mold|lead|pest|termite/.test(combined)) return 11;
        // Default - middle
        return 6;
      };

      const getHouseSectionLabel = (finding) => {
        const pos = getHousePosition(finding);
        return HOUSE_SECTIONS[pos] || HOUSE_SECTIONS[6];
      };

      // Sorting function for findings
      const PRIORITY_ORDER = { high: 1, medium: 2, low: 3 };

      const getSortedFindings = useMemo(() => {
        const sorted = [...findings];
        switch (findingsSort) {
          case 'category-grouped': // v3.7: New default - category grouped with super priority
            return sortByCategoryThenPrice(sorted);
          case 'cost-high':
            return sorted.sort((a, b) => b.cost - a.cost);
          case 'cost-low':
            return sorted.sort((a, b) => a.cost - b.cost);
          case 'priority':
            return sorted.sort((a, b) => (PRIORITY_ORDER[a.priority] || 3) - (PRIORITY_ORDER[b.priority] || 3));
          case 'house-flow':
            return sorted.sort((a, b) => getHousePosition(a) - getHousePosition(b));
          case 'category':
            return sorted.sort((a, b) => (a.category || 'ZZZ').localeCompare(b.category || 'ZZZ'));
          case 'alphabetical':
            return sorted.sort((a, b) => (a.item || '').localeCompare(b.item || ''));
          default:
            return sortByCategoryThenPrice(sorted); // v3.7: Default to category-grouped
        }
      }, [findings, findingsSort]);

      // PDF Upload State
      const [pdfUploading, setPdfUploading] = useState(false);
      const [pdfParseStatus, setPdfParseStatus] = useState(null);
      const [pdfFileName, setPdfFileName] = useState('');
      const [pdfFileNames, setPdfFileNames] = useState([]);
      const [pendingReportId, setPendingReportId] = useState(null); // UUID for Supabase storage path
      const [pendingPdfFiles, setPendingPdfFiles] = useState([]);   // File objects for later upload
      // v5.1: Progressive auto-save state tracking (replaces hasAutoSaved boolean)
      const [saveState, setSaveState] = useState({
        step2Saved: false,  // After extraction complete
        step3Saved: false,  // After customization complete
        step4Saved: false   // After analysis complete
      });

      // D46 Task 4: Page 2 selected-item-cost gate. Flips to true the first
      // time the agent clicks Continue while any selected finding lacks a value
      // path (no quote, no client request, no override). While active, every
      // selected-no-value card renders an amber highlight + badge, and a banner
      // above Continue shows the live offender count. The count auto-decrements
      // as the agent resolves items (banner re-renders from findings state on
      // each update). Gate clears silently when offenders.length === 0.
      const [costGateActive, setCostGateActive] = useState(false);

      // Step 3: Leverage Factors - BUYER factors (high = good for buyer)
      // Weights based on negotiation research (BATNA theory, Cialdini, loss aversion)
      // D32-A: Removed 5 sliders (comparables, marketCooling, multipleIssues — buyer side;
      // limitedInventory, alternativeBuyerLikelihood — seller side). Per directive:
      // - comparables / marketCooling / limitedInventory → replaced by D32-D auto-data
      // - multipleIssues → redundant with auto-calculated Inspection Severity
      // - alternativeBuyerLikelihood → too speculative, removed entirely
      // Score calc is structurally dynamic (enabledBuyer.reduce + buyerMaxPossible
      // both adjust automatically), so no engine math changes needed beyond removal.
      // The 4 sliders that move to buyer-input (D32-B) stay in current position
      // until D32-B reorganizes them into the "Buyer Subjective Inputs" section.
      const [buyerFactors, setBuyerFactors] = useState([
        { id: 'sellerDisclosed', label: 'Seller Previously Disclosed Issues', value: 6, weight: 1.5, note: '', enabled: true, lowLabel: 'None disclosed', highLabel: 'Major issues disclosed', research: 'Loss aversion - legal liability fear' },
        { id: 'sellerMotivated', label: 'Seller Appears Motivated', value: 6, weight: 1.8, note: '', enabled: true, lowLabel: 'Not motivated', highLabel: 'Very urgent', research: "Cialdini's reciprocity + time pressure" },
        { id: 'buyerFinancialStrength', label: 'Buyer Has Strong Finances', value: 6, weight: 1.2, note: '', enabled: true, lowLabel: 'Needs help', highLabel: 'Cash/20%+ down', research: 'Financial position strengthens negotiating hand' }
      ]);

      // SELLER leverage factors (high = good for seller, bad for buyer)
      const [sellerFactors, setSellerFactors] = useState([
        { id: 'uniquelySuited', label: 'Property Uniquely Suits Buyer Needs', value: 6, weight: 1.3, note: '', enabled: true, lowLabel: 'Generic fit', highLabel: 'Perfect match', research: 'Reduces buyer BATNA' },
        { id: 'emotional', label: 'Buyer Emotionally Attached', value: 6, weight: 1.5, note: '', enabled: true, lowLabel: 'Not attached', highLabel: 'In love with it', research: 'Loss aversion - irrational overpayment' },
        { id: 'backupOffers', label: 'Backup Offers or Strong Interest', value: 6, weight: 2.0, note: '', enabled: true, lowLabel: 'No competition', highLabel: 'Multiple offers', research: 'BATNA theory - strongest seller power' },
        { id: 'timePressure', label: 'Buyer Has Time Pressure', value: 6, weight: 1.4, note: '', enabled: true, lowLabel: 'Flexible timing', highLabel: 'Urgent deadline', research: 'Scarcity + deadline effect' }
      ]);

      // Validation state
      const [validationResult, setValidationResult] = useState(null);
      const [validationLoading, setValidationLoading] = useState(false);
      const [showValidationPanel, setShowValidationPanel] = useState(false);

      // v5.2: Persisted leverage score from saved reports (Directive 12)
      // When non-null, the dial uses this value instead of recomputing from factors
      // This guarantees the dial matches what was saved, regardless of formula changes
      const [loadedLeverageScore, setLoadedLeverageScore] = useState(null);
      // D32-C: Justifications for the 3 agent-input sliders.
      // Shape: { [factorId]: { type: <canned-string-or-OTHER>, text: <text-content> } }
      // Persisted to reports.justification_<slider> + reports.justification_<slider>_type.
      const [justifications, setJustifications] = useState({});
      // D32-C: Legacy report flag — true when a loaded report has no justification
      // columns populated. Skips the require-justification validation so editing an
      // old report's slider doesn't retroactively force justification entry.
      const [isLegacyJustificationReport, setIsLegacyJustificationReport] = useState(false);
      // D32-B: Buyer subjective responses. Map keyed by factor.id (e.g. 'emotional')
      // → { value, source: 'sms' | 'manual_dev' | 'legacy', receivedAt: ISO }.
      // Absence of a key means "pending — no response yet". Hydrated from the
      // buyer_subjective_responses table on report load. Working copy lives here
      // and ALSO syncs back into buyerFactors/sellerFactors so the leverageScore
      // useMemo continues to read from the same source it always has.
      const [buyerResponses, setBuyerResponses] = useState({});
      // D32-D: market segment data (cooling/inventory/comparables + the legacy
      // segment economics). Fetched async when ZIP + purchasePrice are known,
      // re-fetched on changes. Null = not yet loaded; auto-calc helpers fall
      // back to neutral (score 3) when missing. The leverageScore useMemo
      // re-runs when this state changes (it's in the deps array below).
      const [marketSegmentData, setMarketSegmentData] = useState(null);
      // v5.3: Persisted ask, outlook, and seller profile scores (Directive 12.5)
      // Same pattern as loadedLeverageScore — guarantees byte-for-byte stability of saved reports
      const [loadedAskFavorabilityScore, setLoadedAskFavorabilityScore] = useState(null);
      const [loadedOutlookScore, setLoadedOutlookScore] = useState(null);
      const [loadedSellerProfileScore, setLoadedSellerProfileScore] = useState(null);

      // v5.2: Migrate factor data from old 1-5 scale to new 1-10 scale (in-memory only)
      // Detection: if all values are <= 5, assume it's old scale data
      // Migration: linearly map 1-5 → 1-10 (oldValue 1→1, 3→5, 5→9 — close to neutral 6)
      // D32-A: factor IDs removed from the active set. Saved reports created under the
      // old 12-slider model may still have these in their persisted JSON; filter them
      // out on load so the engine doesn't try to render UI for sliders that no longer
      // exist. The saved score itself is preserved by the loadedLeverageScore
      // short-circuit in the leverageScore useMemo.
      const D32A_REMOVED_FACTOR_IDS = new Set([
        'comparables',                  // → D32-D auto-data (Comparables Signal)
        'marketCooling',                // → D32-D auto-data (Market Cooling Signal)
        'multipleIssues',               // → redundant with auto-calc Inspection Severity
        'limitedInventory',             // → D32-D auto-data (Inventory Signal)
        'alternativeBuyerLikelihood'    // → removed entirely (too speculative)
      ]);

      // D32-B: hydrate buyer_subjective_responses for a loaded report. Async DB
      // query — populates buyerResponses state AND mirrors any received values
      // into buyerFactors/sellerFactors so the leverageScore useMemo picks them up.
      // Pre-D32-B saved reports won't have rows here; their buyer-input slider
      // values stay as saved in buyer_factors_json (treated as "received" if !== 6,
      // "pending" if === 6, per the value-as-source-of-truth convention).
      const hydrateBuyerResponsesForReport = async (reportId) => {
        if (!reportId) { setBuyerResponses({}); return; }
        try {
          const { data, error } = await supabaseClient
            .from('buyer_subjective_responses')
            .select('question_key, response_value, response_source, response_received_at, status')
            .eq('report_id', reportId);
          if (error) throw error;
          const out = {};
          (data || []).forEach(row => {
            if (row.response_value != null && (row.status === 'received' || row.status === 'dev_override')) {
              out[row.question_key] = {
                value: row.response_value,
                source: row.response_source,
                receivedAt: row.response_received_at
              };
            }
          });
          setBuyerResponses(out);
        } catch (err) {
          console.warn('[D32-B] hydrateBuyerResponsesForReport failed (non-fatal):', err);
          setBuyerResponses({});
        }
      };

      // D32-B: STUBBED-MODE SMS dispatch. Logs only; does NOT actually send SMS.
      // When Twilio Campaign approves, replace this function body with the real
      // Twilio API call — signature stays the same, no other code needs to change.
      // Inserts a 'pending' row in buyer_subjective_responses so the UI knows the
      // question is in flight (sms_sent_at NULL until Twilio is live).
      const sendBuyerSubjectiveQuestion = async ({ reportId, questionKey, questionText }) => {
        console.log('[D32-B STUB] Would send SMS:', { reportId, questionKey, questionText });
        if (!reportId) return { success: false, error: 'no reportId' };
        try {
          const { error } = await supabaseClient
            .from('buyer_subjective_responses')
            .upsert({
              report_id: reportId,
              question_key: questionKey,
              response_source: 'sms',
              sms_sent_at: null,
              status: 'pending'
            }, { onConflict: 'report_id,question_key' });
          if (error) throw error;
          return { success: true, stubbed: true };
        } catch (err) {
          console.warn('[D32-B] sendBuyerSubjectiveQuestion failed:', err);
          return { success: false, error: err.message };
        }
      };

      // D32-B post-Andrew polish: clear all buyer responses (state + DB rows) so
      // the section returns to the all-pending state. Used during red-team testing
      // to reset between scenarios. Allowlist-gated upstream where the button is
      // rendered; this fn doesn't re-check.
      const resetBuyerResponsesDev = async () => {
        setBuyerResponses({});
        // Reset buyer-input factor values back to default 6 in both arrays
        setBuyerFactors(prev => prev.map(f => D32C_BUYER_INPUT_IDS.has(f.id) ? { ...f, value: D32C_SLIDER_DEFAULT_VALUE } : f));
        setSellerFactors(prev => prev.map(f => D32C_BUYER_INPUT_IDS.has(f.id) ? { ...f, value: D32C_SLIDER_DEFAULT_VALUE } : f));
        if (loadedLeverageScore !== null) setLoadedLeverageScore(null);
        if (!pendingReportId) return;
        try {
          await supabaseClient
            .from('buyer_subjective_responses')
            .delete()
            .eq('report_id', pendingReportId);
        } catch (err) {
          console.warn('[D32-B] dev reset DB delete failed:', err);
        }
      };

      // D32-B: dev-override write helper. Inserts a buyer_subjective_responses row
      // marked 'manual_dev' and updates buyerResponses state + the corresponding
      // factor.value. The write is best-effort — if DB persistence fails, the local
      // state still updates so the agent can keep working (will re-attempt on save).
      const setBuyerResponseDevOverride = async (factorId, value) => {
        const nowIso = new Date().toISOString();
        // 1) Local state update first (snappy UI)
        setBuyerResponses(prev => ({
          ...prev,
          [factorId]: { value, source: 'manual_dev', receivedAt: nowIso }
        }));
        // 2) Mirror into buyerFactors/sellerFactors so leverageScore picks it up
        const inBuyer = buyerFactors.findIndex(f => f.id === factorId);
        if (inBuyer >= 0) {
          const next = [...buyerFactors]; next[inBuyer] = { ...next[inBuyer], value };
          setBuyerFactors(next);
        } else {
          const inSeller = sellerFactors.findIndex(f => f.id === factorId);
          if (inSeller >= 0) {
            const next = [...sellerFactors]; next[inSeller] = { ...next[inSeller], value };
            setSellerFactors(next);
          }
        }
        if (loadedLeverageScore !== null) setLoadedLeverageScore(null);
        // 3) DB persistence (best effort)
        if (!pendingReportId) return; // no report row yet, will save with the report
        try {
          await supabaseClient
            .from('buyer_subjective_responses')
            .upsert({
              report_id: pendingReportId,
              question_key: factorId,
              response_value: value,
              response_source: 'manual_dev',
              response_received_at: nowIso,
              status: 'dev_override',
              updated_at: nowIso
            }, { onConflict: 'report_id,question_key' });
        } catch (err) {
          console.warn('[D32-B] dev-override DB write failed (will retry on save):', err);
        }
      };

      // D32-C: hydrate justifications state from a loaded report row, and set the
      // legacy flag if no justification columns are populated. Centralized so both
      // load handlers (saved-report flow + restore-pending-report flow) stay in sync.
      const hydrateJustificationsFromReport = (report) => {
        const out = {};
        const slots = [
          ['sellerDisclosed', 'justification_seller_disclosure',      'justification_seller_disclosure_type'],
          ['sellerMotivated', 'justification_seller_motivated',       'justification_seller_motivated_type'],
          ['backupOffers',    'justification_backup_offers',          'justification_backup_offers_type']
        ];
        let anyPopulated = false;
        for (const [key, textCol, typeCol] of slots) {
          const type = report[typeCol];
          const text = report[textCol];
          if (type) {
            out[key] = { type, text: text ?? type };
            anyPopulated = true;
          }
        }
        setJustifications(out);
        // Legacy = saved report has factor data but no justification data. Fresh
        // reports also have no justification data initially, but they're not loaded
        // from DB so they don't go through this hydration path.
        setIsLegacyJustificationReport(!anyPopulated);
      };

      const migrateFactorsIfNeeded = (factors) => {
        if (!Array.isArray(factors) || factors.length === 0) return factors;
        // D32-A: filter out removed slider IDs first so they don't render
        const filtered = factors.filter(f => !D32A_REMOVED_FACTOR_IDS.has(f.id));
        if (filtered.length === 0) return filtered;
        // Then apply the existing 1-5 → 1-10 scale migration
        const maxValue = Math.max(...filtered.map(f => f.value || 0));
        if (maxValue > 5) return filtered; // Already in 1-10 scale
        return filtered.map(f => ({
          ...f,
          value: Math.round((f.value - 1) * 9 / 4 + 1)
        }));
      };

      // ================================================================
      // PDF EXTRACTION - FRESH IMPLEMENTATION
      // ================================================================
      const parsePdfForFindings = async (files) => {
        const fileArray = Array.isArray(files) ? files : [files];
        setPdfUploading(true);
        setPdfParseStatus('parsing');
        setPdfFileName(fileArray[0].name);
        setPdfFileNames(fileArray.map(f => f.name));

        // Generate UUID for this report (used for storage path)
        // This becomes the report_id when saved to database
        const reportId = crypto.randomUUID();
        setPendingReportId(reportId);
        setPendingPdfFiles(fileArray);
        console.log('Generated pending report ID:', reportId);
        console.log('Processing', fileArray.length, 'document(s):', fileArray.map(f => f.name));

        try {
          let fullText = '';

          for (let fileIdx = 0; fileIdx < fileArray.length; fileIdx++) {
            const file = fileArray[fileIdx];
            const docLabel = fileIdx === 0
              ? 'PRIMARY INSPECTION REPORT'
              : `SUPPLEMENTAL DOCUMENT ${fileIdx}: ${file.name}`;
            fullText += `\n\n=== ${docLabel} ===\n`;

            const arrayBuffer = await file.arrayBuffer();
            // Perf Tier 2: lazy-init pdf.js worker (was eagerly set at head load; moved here so
            // the head script can defer without breaking the workerSrc assignment).
            if (!pdfjsLib.GlobalWorkerOptions.workerSrc) {
              pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
            }
            const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

            // Extract text with position awareness for better structure
            for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
              const page = await pdf.getPage(pageNum);
              const textContent = await page.getTextContent();

              let pageText = '';
              let lastY = null;
              let lastX = null;

              // Sort items by position (top to bottom, left to right)
              const sortedItems = textContent.items.sort((a, b) => {
                const yDiff = (b.transform?.[5] || 0) - (a.transform?.[5] || 0);
                if (Math.abs(yDiff) > 5) return yDiff;
                return (a.transform?.[4] || 0) - (b.transform?.[4] || 0);
              });

              for (const item of sortedItems) {
                const currentY = item.transform?.[5];
                const currentX = item.transform?.[4];

                // New line detection
                if (lastY !== null && currentY !== null && Math.abs(currentY - lastY) > 8) {
                  pageText += '\n';
                  lastX = null;
                }
                // Space detection
                else if (lastX !== null && currentX !== null && currentX - lastX > 15) {
                  pageText += ' ';
                }
                // No space needed at start of line or after space
                else if (pageText.length > 0 &&
                         !pageText.endsWith(' ') &&
                         !pageText.endsWith('\n') &&
                         item.str &&
                         !item.str.startsWith(' ')) {
                  if (lastX !== null && currentX !== null && currentX > lastX + 3) {
                    pageText += ' ';
                  }
                }

                pageText += item.str || '';
                lastY = currentY;
                lastX = currentX !== null ? currentX + (item.width || 0) : null;
              }

              fullText += `\n--- PAGE ${pageNum} ---\n${pageText}`;
            }
          }

          // Send to Claude for parsing
          const claudeResult = await ClaudePdfParsingService.parseReport(fullText);

          if (claudeResult) {
            const { property, findings: extractedFindings, confidence } = claudeResult;

            // Update property info
            if (property) {
              setPropertyInfo(prev => ({
                ...prev,
                address: property.address || prev.address,
                city: property.city && property.state
                  ? `${property.city}, ${property.state}`
                  : prev.city,
                zipCode: property.zipCode || prev.zipCode
              }));
            }

            // Process findings
            if (extractedFindings && extractedFindings.length > 0) {
              const zipCode = property?.zipCode || propertyInfo.zipCode || '97068';
              const regional = getRegionalMultiplier(zipCode);

              const newFindings = extractedFindings.map((f, idx) => {
                const lowEstimate = Math.round((f.estimatedCostLow || 500) * regional.factor);
                const highEstimate = Math.round((f.estimatedCostHigh || 1000) * regional.factor);
                let midEstimate = Math.round((lowEstimate + highEstimate) / 2);

                // v5.12b: Minimum cost floor - contractors won't come out for less than ~$239
                // Small jobs carry a premium because nobody gets out of bed for $120
                const MINIMUM_COST_FLOOR = 239;
                midEstimate = Math.max(midEstimate, MINIMUM_COST_FLOOR);
                const adjustedLow = Math.max(lowEstimate, MINIMUM_COST_FLOOR);
                const adjustedHigh = Math.max(highEstimate, MINIMUM_COST_FLOOR);

                return {
                  id: idx + 1,
                  item: f.item,
                  description: f.description,
                  priority: f.priority || 'medium',
                  // D11a: cost is NULL until agent uploads contractor quote or client submits
                  cost: null,
                  originalCost: midEstimate,  // AI estimate — kept as sniff-test benchmark
                  lowEstimate: adjustedLow,
                  highEstimate: adjustedHigh,
                  // D46 Task 2: all findings start deselected. Agent affirmatively
                  // opts each item in. Reinforces "agent curates, system documents"
                  // — pre-selection read as a Game Plan recommendation, which is
                  // the opposite of where the product is going. Severity badges
                  // (red/yellow/green) still render so agents notice critical items.
                  selected: false,
                  fromPdf: true,
                  reasoning: f.reasoning || '',
                  category: f.category || 'General',
                  regionalMultiplier: regional.factor,
                  regionalCity: regional.city,
                  // D11a: cost source metadata — all null until a source fills them in
                  costSource: null,           // 'contractor' | 'client' | null
                  costSourceUrl: null,        // signed URL for contractor PDF (only if costSource='contractor')
                  costSourceQuoteId: null,    // contractor_quotes.id (only if costSource='contractor')
                  costSourceRequestId: null,  // client_pricing_requests.id (only if costSource='client')
                  costSourceClientName: null, // cached client name for display
                  costSourceSetAt: null,      // when the price was set
                  pendingRequest: null        // { id, clientName, clientPhone, sentAt } — live client request
                };
              });

              setExtractedItems(newFindings);
              setFindings(newFindings);

              // v5.1: Step 2 auto-save - capture data immediately after extraction
              // Pass newFindings and extracted property directly to avoid React state timing issues
              console.log('=== Step 2: Extraction complete, auto-saving ===');
              const extractedPropertyForSave = property ? {
                address: property.address || '',
                city: property.city && property.state ? `${property.city}, ${property.state}` : '',
                zipCode: property.zipCode || ''
              } : null;
              saveReportAtStep('extraction_complete', newFindings, extractedPropertyForSave);
            }

            setPdfParseStatus(confidence?.findings === 'high' ? 'success' : 'partial');
          } else {
            setPdfParseStatus('error');
          }

        } catch (error) {
          console.error('PDF parsing error:', error);
          setPdfParseStatus('error');
        } finally {
          setPdfUploading(false);
        }
      };

      // ================================================================
      // AUTO-CALCULATED LEVERAGE FACTORS
      // ================================================================

      // Calculate inspection severity score (adds to buyer leverage)
      // Post-Andrew polish (2026-05-05): rewrote from weighted-sum thresholds to
      // presence-based tiers. Old formula: severityScore = high*3 + medium*1.5 +
      // low*0.5, then bucketed by absolute thresholds (≥5 to register as score 2).
      // Bug: a single critical finding produced severityScore=3, which fell below
      // the 5-threshold and returned score 1 ("CLEAN") — wrong. Critical findings
      // should drive the tier regardless of total finding count. New formula:
      //   - 0 findings              → 1 (no leverage)
      //   - 0 critical, ≤1 medium   → 1 (clean-ish)
      //   - 0 critical, 2-4 medium  → 2 (light leverage)
      //   - 0 critical, 5+ medium   → 3 (moderate)
      //   - 1 critical              → 4 (significant)
      //   - 2+ critical             → 5 (critical leverage)
      // Uses _normalizeSeverity for shape-tolerance (handles both 'priority' and
      // 'severity' field names, and both 'high'/'red' canonicalization).
      const getInspectionSeverityScore = () => {
        const selected = (findings || []).filter(f => f && f.selected);
        if (selected.length === 0) return 1;
        const highCount = selected.filter(f => _normalizeSeverity(f) === 'red').length;
        const mediumCount = selected.filter(f => _normalizeSeverity(f) === 'yellow').length;
        if (highCount >= 2) return 5;
        if (highCount === 1) return 4;
        if (mediumCount >= 5) return 3;
        if (mediumCount >= 2) return 2;
        return 1;
      };

      // Calculate days on market score (adds to buyer leverage)
      const getDaysOnMarketScore = () => {
        const dom = parseInt(propertyInfo.daysOnMarket) || 0;
        if (dom < 7) return 1;       // Fresh listing - seller leverage
        if (dom < 30) return 2;      // Normal
        if (dom < 60) return 3;      // Getting stale - buyer leverage increasing
        if (dom < 90) return 4;      // Seller nervous
        return 5;                    // Seller desperate
      };

      // Weights for auto-calculated factors
      const AUTO_WEIGHTS = {
        inspectionSeverity: 1.5,     // Buyer leverage
        daysOnMarket: 1.3,           // Buyer leverage
        // Post-Andrew polish (2026-05-05): inspectionCleanliness removed — it was
        // mathematically the inverse of inspectionSeverity. Comparables removed
        // (post-Andrew round 2, 2026-05-06) — was reading ZIP-aggregate inventory
        // count as "matched comps", overpromising precision. Per-listing comp
        // matching by price/sqft requires MLS data beyond Redfin's free aggregate.
        // Local Inventory tile already captures the supply-side signal more
        // rigorously (months-of-supply via NAR formula).
        marketCooling:  1.0,         // Buyer leverage (cooling = buyer-favorable)
        inventory:      1.0          // Buyer leverage (oversupply = buyer-favorable)
      };

      // D32-D: Auto-data scoring helpers. All return 1-5 (centered at 3 = neutral),
      // matching the existing getInspectionSeverityScore convention. They take the
      // marketSegmentData state object (from lookupMarketSegment) and bucket the
      // raw Redfin numbers into 5-tier bands. Tier thresholds tuned for Portland
      // metro residential SFR; when a ZIP has no local data (non-target ZIPs OR
      // pre-D32-D rows that haven't been backfilled yet), they return neutral 3.
      const getMarketCoolingScore = (mkt) => {
        // avg_sale_to_list typical range 0.92-1.05. Lower = cooling = buyer-favorable.
        if (!mkt || mkt.avgSaleToList == null) return 3;
        const r = mkt.avgSaleToList;
        if (r < 0.96) return 5;       // strong cooling
        if (r < 0.99) return 4;       // soft
        if (r <= 1.01) return 3;      // balanced
        if (r <= 1.03) return 2;      // warm
        return 1;                     // hot (seller-favorable)
      };
      // Derive effective months-of-supply: prefer the explicit Redfin value when
      // present; otherwise compute from inventory/homes_sold (NAR-standard formula).
      // This recovers the signal for ZIPs where the TSV omitted months_of_supply
      // explicitly but did report inventory + homes_sold (common for SFR-filtered
      // subsets in the Redfin TSV).
      const _effectiveMonthsOfSupply = (mkt) => {
        if (!mkt) return null;
        if (mkt.monthsOfSupply != null) return mkt.monthsOfSupply;
        if (mkt.inventory != null && mkt.homesSold != null && mkt.homesSold > 0) {
          return mkt.inventory / mkt.homesSold;
        }
        return null;
      };

      const getInventoryScore = (mkt) => {
        // months_of_supply: <1.5 tight (seller's market), >6 oversupplied (buyer's market).
        const m = _effectiveMonthsOfSupply(mkt);
        if (m == null) return 3;
        if (m < 1.5) return 1;        // tight inventory, seller power
        if (m < 2.5) return 2;        // constrained
        if (m <= 4.5) return 3;       // balanced
        if (m <= 6) return 4;         // ample
        return 5;                     // oversupplied
      };
      // (getComparablesScore removed post-Andrew round 2 — was overpromising
      // precision on ZIP-aggregate inventory. When MLS per-listing data is
      // available post-pilot, a true matched-comp score helper goes here.)

      // Post-Andrew polish: tier word + raw-context derivers for the auto-calc
      // tiles. Replaces the "N/5 fraction" hero numerals (which Jared called out
      // as "third-grade fractions worksheet"-feeling) with prominent tier word +
      // small raw-data subtitle. Each helper returns { tier, raw } strings; the
      // tier word leads, the raw value provides defensible context.

      // Inspection severity: high score = many red findings = lots to negotiate.
      const getInspectionSeverityContext = () => {
        const active = (findings || []).filter(f => f && f.selected !== false);
        const reds = active.filter(f => _normalizeSeverity(f) === 'red').length;
        const total = active.length;
        const score = getInspectionSeverityScore();
        const tier = score >= 5 ? 'CRITICAL' : score >= 4 ? 'SIGNIFICANT' : score >= 3 ? 'MODERATE' : score >= 2 ? 'MINOR' : 'CLEAN';
        const raw = total === 0 ? 'no findings yet'
          : reds === 0 ? `${total} finding${total === 1 ? '' : 's'}, no critical`
          : `${reds} critical of ${total}`;
        return { tier, raw };
      };

      // DOM factor: high DOM = motivated seller (buyer-favorable).
      const getDaysOnMarketContext = () => {
        const dom = parseInt(propertyInfo.daysOnMarket || '0', 10) || 0;
        const score = getDaysOnMarketScore();
        const tier = score >= 5 ? 'STALE' : score >= 4 ? 'SLOW' : score >= 3 ? 'STEADY' : score >= 2 ? 'ACTIVE' : 'FRESH';
        const raw = dom === 0 ? 'unknown' : `${dom} days listed`;
        return { tier, raw };
      };

      // (getInspectionCleanlinessContext removed — Cleanliness tile dropped per
      // post-Andrew polish. Was the inverse of Severity, redundant signal.)

      // D32-D context derivers (mirror the score helpers' band logic).
      const getMarketCoolingContext = (mkt) => {
        if (!mkt || mkt.avgSaleToList == null) return { tier: '—', raw: 'no local data' };
        const r = mkt.avgSaleToList;
        const tier = r < 0.96 ? 'COOLING' : r < 0.99 ? 'SOFT' : r <= 1.01 ? 'BALANCED' : r <= 1.03 ? 'WARM' : 'HOT';
        const raw = `${(r * 100).toFixed(1)}% sale-to-list`;
        return { tier, raw };
      };
      const getInventoryContext = (mkt) => {
        const m = _effectiveMonthsOfSupply(mkt);
        if (m == null) return { tier: '—', raw: 'no local data' };
        const tier = m < 1.5 ? 'TIGHT' : m < 2.5 ? 'CONSTRAINED' : m <= 4.5 ? 'BALANCED' : m <= 6 ? 'AMPLE' : 'OVERSUPPLIED';
        // Show "derived" footnote when computed from inventory/homes_sold (vs. read directly)
        const derived = mkt.monthsOfSupply == null;
        return { tier, raw: `${m.toFixed(1)} months supply${derived ? ' (derived)' : ''}` };
      };
      // (getComparablesContext removed post-Andrew round 2 alongside the score helper.)

      // ============================================================
      // GAME PLAN SCORE ENGINE — D6
      // Deal likelihood scoring with Bayesian updating + sniff test
      // See: /docs/d5-engine-design/01-statistical-modeling.md
      // ============================================================

      const GamePlanScoreConfig = {
        PRIOR_ALPHA: 8.5,
        PRIOR_BETA: 1.5,
        PRIOR_EFFECTIVE_SAMPLE: 10,
        W_O_MAX: 0.45,
        TAU: 150,
        // D45 (2026-05-11): replaced Property Specifics (W_P_COLD: 0.20) with
        // Ask Justification (W_AJ_COLD: 0.25). Market Realism reduced from 0.40
        // to 0.35 to make room. Cold totals still sum to 1.0.
        W_L_COLD: 0.40,
        W_M_COLD: 0.35,
        W_AJ_COLD: 0.25,
        LEVERAGE_SIGMOID_K: 0.15,
        MARKET_TOLERANCE_SIGMAS: 2.0,
        SIMILARITY_BANDWIDTHS: {
          leverage: 8.0,
          askRatio: 0.015,
          dom: 30,
          priceBand: 150000
        },
        BOOTSTRAP_SCORE_MIN: 2,
        BOOTSTRAP_SCORE_MAX: 9,
        BOOTSTRAP_ACTIVE: true,
        CI_HIGH_THRESHOLD: 2.0,
        CI_MODERATE_THRESHOLD: 4.0,
        SNIFF_TEST_ENABLED: true,
        SNIFF_TEST_TIMEOUT_MS: 10000,
        SNIFF_TEST_ENDPOINT: 'https://gameplan-ppg-api.jraaschmidt.workers.dev/sniff-test'
      };

      // Accept either {severity: 'red'|'yellow'|'green'} or {priority: 'high'|'medium'|'low'}
      function _normalizeSeverity(f) {
        if (!f) return null;
        const v = (f.severity || f.priority || '').toString().toLowerCase();
        if (v === 'red' || v === 'high') return 'red';
        if (v === 'yellow' || v === 'medium') return 'yellow';
        if (v === 'green' || v === 'low') return 'green';
        return null;
      }

      function computeLeverageScore(leverageRaw) {
        const k = GamePlanScoreConfig.LEVERAGE_SIGMOID_K;
        const safe = typeof leverageRaw === 'number' ? leverageRaw : 0;
        return 1 / (1 + Math.exp(-k * safe));
      }

      // D26: Property-value-anchored sanity check for Market Realism.
      // Returns a score in [0,1] based purely on ask as % of purchase price.
      // Used as a floor under the segment-relative score so degraded segment
      // data can't punish objectively reasonable asks.
      //
      // Anchor points (% of property value → score):
      //   0.0% – 1.0%   → 1.00   (very reasonable)
      //   1.0% – 2.0%   → 1.00 → 0.85
      //   2.0% – 3.0%   → 0.85 → 0.70
      //   3.0% – 5.0%   → 0.70 → 0.50
      //   5.0% – 8.0%   → 0.50 → 0.20
      //   8.0%+         → 0.20 → 0.05 (clamped at 12%)
      function computePropertyValueAnchorScore(ask, purchasePrice) {
        if (!purchasePrice || purchasePrice <= 0) return null;
        if (!ask || ask < 0) return 1.0;
        const pct = ask / purchasePrice;
        if (pct <= 0.01) return 1.00;
        if (pct <= 0.02) return 1.00 - ((pct - 0.01) / 0.01) * 0.15;
        if (pct <= 0.03) return 0.85 - ((pct - 0.02) / 0.01) * 0.15;
        if (pct <= 0.05) return 0.70 - ((pct - 0.03) / 0.02) * 0.20;
        if (pct <= 0.08) return 0.50 - ((pct - 0.05) / 0.03) * 0.30;
        if (pct <= 0.12) return 0.20 - ((pct - 0.08) / 0.04) * 0.15;
        return 0.05;
      }

      // D26: Market Realism now combines segment-relative score with a
      // property-value-anchored fallback. We take max() because if the ask is
      // reasonable on EITHER dimension, the deal isn't dead on market realism.
      // This is the "innocent until proven guilty" version — one strong signal
      // of reasonableness is enough.
      function computeMarketRealismScore(ask, expectedConcession, segmentStdDev, purchasePrice) {
        let s_segment;
        if (!expectedConcession || !segmentStdDev) {
          s_segment = null;
        } else {
          const tolerance = GamePlanScoreConfig.MARKET_TOLERANCE_SIGMAS * segmentStdDev;
          if (tolerance <= 0) {
            s_segment = null;
          } else {
            const gap = Math.abs((ask || 0) - expectedConcession);
            s_segment = 1 - Math.min(1, gap / tolerance);
          }
        }
        const s_pct = computePropertyValueAnchorScore(ask, purchasePrice);
        if (s_segment === null && s_pct === null) return 0.5;
        if (s_segment === null) return s_pct;
        if (s_pct === null) return s_segment;
        return Math.max(s_segment, s_pct);
      }

      // D45 (2026-05-11): Justifiable repair pool. Sum of agent-assigned dollar
      // amounts for selected high/medium severity findings. Pool is the
      // denominator for the Ask Justification component and the new pool floor
      // below. It stays internal to the engine — never surfaced via UI, never
      // sent to the supervisor sniff. Showing a pool number before the agent
      // has entered real quotes would be an agent-displaced cost estimate,
      // which is the liability surface D39 closed.
      function _justifiableRepairPool(findings) {
        const list = Array.isArray(findings) ? findings : [];
        const active = list.filter(f => !(f && f.selected === false));
        return active.reduce((sum, f) => {
          const sev = _normalizeSeverity(f);
          if (sev !== 'red' && sev !== 'yellow') return sum;
          if (typeof f.cost !== 'number' || f.cost <= 0) return sum;
          return sum + f.cost;
        }, 0);
      }

      // D45: Ask Justification component (replaces Property Specifics).
      // Evaluates the ask as a fraction of the justifiable repair pool. Returns
      // null when the pool is zero (no priced high/medium findings yet) so
      // weights redistribute across remaining components — we don't penalize
      // agents who haven't gotten quotes, we just have nothing to score against.
      function computeAskJustificationScore(findings, ask) {
        if (!ask || ask <= 0) return 1.0; // Asking nothing is the safest ask
        const pool = _justifiableRepairPool(findings);
        if (pool <= 0) return null;
        const ratio = ask / pool;
        // D50 (2026-05-12): recalibration. The original D45 curve mapped the
        // ratio 0.80-1.00 band to 0.30 ("aggressive") even though asking for
        // exactly what the inspection justifies is COMPLETE, not aggressive.
        // That punished the most defensible ask shape — tight & matched to
        // documented findings — and was the structural reason the score fell
        // off a cliff the moment D33's softball floor stopped firing. New
        // curve treats ratio ≈ 1.0 as well-supported (0.65) and replaces the
        // 2-bin descent above pool with a 3-bin smoother gradient.
        //
        //   ratio ≤ 0.40   → 0.90  conservative (ask well below justification)
        //   0.40 – 0.70    → 0.80  reasonable (within pool, room to negotiate)
        //   0.70 – 1.05    → 0.65  tight & complete (ask ≈ documented pool)
        //   1.05 – 1.30    → 0.45  slight overreach (small unjustified margin)
        //   1.30 – 1.75    → 0.25  notable overreach (ask materially above pool)
        //   > 1.75         → 0.10  substantial overreach (ask far above pool)
        //
        // 1.05 (not 1.00) is the "tight & complete" upper bound so $50 of
        // rounding noise around ask = pool doesn't drop a defensible ask into
        // the overreach bin.
        if (ratio <= 0.40) return 0.90;
        if (ratio <= 0.70) return 0.80;
        if (ratio <= 1.05) return 0.65;
        if (ratio <= 1.30) return 0.45;
        if (ratio <= 1.75) return 0.25;
        return 0.10;
      }

      // D45: Pool-Justified Ask Floor — symmetric counterpart to D33's softball
      // floor, keyed on ask% of POOL rather than ask% of property value. When
      // the ask is small relative to defensible inspection findings, the deal
      // is structurally low-risk by definition (the agent has receipts), and
      // the score should reflect that regardless of softer signals. Floor is
      // one-directional (raises, never lowers) so earned high scores stay
      // earned. Inert when pool is zero (no priced findings → no defensibility
      // signal to bind on). Engine-internal only — pool value is never exposed.
      //
      // Floor curve (ask as % of pool → minimum allowed Score):
      //   ≤ 30%        →  floor 7
      //   30% – 50%    →  floor 6
      //   > 50%        →  no floor effect (component weight does the work)
      function applyPoolJustifiedAskFloor(score, ask, pool) {
        if (!pool || pool <= 0) return score;
        if (!ask || ask <= 0) return score;
        const ratio = ask / pool;
        if (ratio <= 0.30) return Math.max(score, 7);
        if (ratio <= 0.50) return Math.max(score, 6);
        return score;
      }

      function _similarityKernel(currentDeal, pastDeal) {
        if (!pastDeal || pastDeal.segment !== currentDeal.segment) return 0;
        const bw = GamePlanScoreConfig.SIMILARITY_BANDWIDTHS;
        let kernel = 1.0;

        const dLev = ((currentDeal.leverage ?? 0) - (pastDeal.leverage ?? 0)) / bw.leverage;
        kernel *= Math.exp(-0.5 * dLev * dLev);

        if (currentDeal.purchasePrice > 0 && pastDeal.purchasePrice > 0) {
          const aCur = (currentDeal.ask || 0) / currentDeal.purchasePrice;
          const aPast = (pastDeal.ask || 0) / pastDeal.purchasePrice;
          const dAsk = (aCur - aPast) / bw.askRatio;
          kernel *= Math.exp(-0.5 * dAsk * dAsk);
        }

        if (currentDeal.dom != null && pastDeal.dom != null) {
          const dDom = (currentDeal.dom - pastDeal.dom) / bw.dom;
          kernel *= Math.exp(-0.5 * dDom * dDom);
        }

        const dPrice = ((currentDeal.purchasePrice || 0) - (pastDeal.purchasePrice || 0)) / bw.priceBand;
        kernel *= Math.exp(-0.5 * dPrice * dPrice);

        return kernel;
      }

      function computeOutcomeSimilarityScore(currentDeal, historicalOutcomes) {
        if (!Array.isArray(historicalOutcomes) || historicalOutcomes.length === 0) {
          return { score: null, effectiveSampleSize: 0, similarityWeights: [] };
        }
        const current = {
          leverage: currentDeal.leverageScore,
          ask: currentDeal.ask,
          purchasePrice: currentDeal.purchasePrice,
          dom: currentDeal.daysOnMarket,
          segment: currentDeal.segment
        };
        let weightedSum = 0;
        let weightSum = 0;
        const similarityWeights = [];
        for (const past of historicalOutcomes) {
          let w = _similarityKernel(current, past);
          if (w < 0.01) w = 0;
          similarityWeights.push(w);
          if (w === 0) continue;
          weightedSum += w * (past.outcome === 'closed' ? 1 : 0);
          weightSum += w;
        }
        if (weightSum < 0.1) {
          return { score: null, effectiveSampleSize: 0, similarityWeights };
        }
        return { score: weightedSum / weightSum, effectiveSampleSize: weightSum, similarityWeights };
      }

      // D26: When market data is the fallback (no ZIP match), we don't trust
      // Market Realism enough to give it full weight. Halve its weight and
      // redistribute the freed weight proportionally to Leverage and the
      // remaining inspection-side component (D45: Ask Justification — was
      // Property Specifics pre-D45). Outcome Similarity weight is unaffected.
      function computeWeights(effectiveSampleSize, marketDataQuality) {
        const cfg = GamePlanScoreConfig;
        const n = Math.max(0, effectiveSampleSize || 0);
        const w_O = cfg.W_O_MAX * (1 - Math.exp(-n / cfg.TAU));
        const remaining = 1 - w_O;
        const coldTotal = cfg.W_L_COLD + cfg.W_M_COLD + cfg.W_AJ_COLD;

        let w_L = remaining * (cfg.W_L_COLD / coldTotal);
        let w_M = remaining * (cfg.W_M_COLD / coldTotal);
        let w_AJ = remaining * (cfg.W_AJ_COLD / coldTotal);

        if (marketDataQuality === 'fallback') {
          const freed = w_M * 0.5;
          w_M = w_M - freed;
          const lajTotal = w_L + w_AJ;
          if (lajTotal > 0) {
            w_L += freed * (w_L / lajTotal);
            w_AJ += freed * (w_AJ / lajTotal);
          }
        }

        return { w_L, w_M, w_AJ, w_O };
      }

      function computeBayesianProbability(rawProbability, historicalOutcomes, similarityWeights) {
        const cfg = GamePlanScoreConfig;
        let k_eff = 0;
        let n_eff = 0;
        if (Array.isArray(historicalOutcomes) && Array.isArray(similarityWeights)) {
          const len = Math.min(historicalOutcomes.length, similarityWeights.length);
          for (let i = 0; i < len; i++) {
            const w = similarityWeights[i] || 0;
            if (w <= 0) continue;
            n_eff += w;
            if (historicalOutcomes[i].outcome === 'closed') k_eff += w;
          }
        }
        const alpha = cfg.PRIOR_ALPHA + k_eff;
        const beta = cfg.PRIOR_BETA + (n_eff - k_eff);
        const p_posterior = alpha / (alpha + beta);
        const lambda = n_eff / (n_eff + cfg.PRIOR_EFFECTIVE_SAMPLE);
        const p_blended = lambda * p_posterior + (1 - lambda) * rawProbability;
        return { probability: p_blended, alpha, beta, effectiveSampleSize: n_eff };
      }

      // D31: Catastrophic Ask Score Cap
      // Hard ceiling on the final 1-10 Score for asks that are mathematically unfundable
      // or vastly disproportionate to property value. One-directional cap — can lower a
      // score, never raises one. Weak deals stay weak.
      //
      // Threshold rationale: 5% matches the engine's "typical successful credit request"
      // upper bound (Strategy Insight templates also call 2-5% the typical band). Above 5%
      // is genuinely aggressive territory regardless of leverage.
      //
      // Cap curve (ask as % of property value → max allowed Score):
      //   ≤ 5%        →  no cap (score holds as computed)
      //    5% –  10%  →  cap at 6
      //   10% –  20%  →  cap at 4
      //   20% –  40%  →  cap at 3
      //   40% – 100%  →  cap at 2
      //   100%+       →  cap at 1
      function applyCatastrophicAskCap(score, ask, purchasePrice) {
        if (!purchasePrice || purchasePrice <= 0) return score;
        if (!ask || ask <= 0) return score;
        const pct = ask / purchasePrice;
        let cap;
        if (pct <= 0.05) return score;
        else if (pct <= 0.10) cap = 6;
        else if (pct <= 0.20) cap = 4;
        else if (pct <= 0.40) cap = 3;
        else if (pct <= 1.00) cap = 2;
        else                  cap = 1;
        return Math.min(score, cap);
      }

      // D33: Softball Ask Score Floor
      // Symmetric counterpart to D31's catastrophic cap. Without MLS integration,
      // the ask% ratio is the highest-signal input we have, but the cold-start
      // weighting leaves a small ask topping out around Score 5-6 even with
      // perfect Market Realism. This floor restores honesty: if an agent is
      // asking BELOW the NAR-typical concession band (3-6%), the deal is
      // structurally low-risk regardless of softer signals. One-directional —
      // can raise a score, never lowers one. Strong scores (8-10) stay earned,
      // not floored to.
      //
      // D48 (2026-05-12): threshold raised from 2% → 3.5%. The 2% number was
      // anchored to pre-NAR-data guesses; NAR data shows sellers typically
      // concede 3-6% of value, so asking <3.5% is structurally below the
      // typical band's floor. Jared's $14k-on-$495k case (2.83%) was scoring
      // 5 with the old threshold — well within the "well-supported" zone.
      function applySoftballAskFloor(score, ask, purchasePrice) {
        if (!purchasePrice || purchasePrice <= 0) return score;
        if (!ask || ask <= 0) return score;
        const pct = ask / purchasePrice;
        // D51 (2026-05-12): stepped floor replacing the binary 3.5% cliff.
        // Pre-D51 was: pct ≤ 3.5% → floor 7, otherwise no effect. Paired with
        // weak-leverage reports that score raw bin 4, the 3.5% boundary
        // produced a 3-bin drop (7→4) for a $1k ask change. Stepped version
        // preserves the ≤3.5% behavior (Andrew's validation zone unchanged)
        // and paves the gap between the floor zone and D31's cap at >5%.
        //
        //   pct ≤ 3.5%       →  floor 7   (unchanged — Andrew/D48-validated)
        //   3.5%  – 4.5%     →  floor 6
        //   4.5%  – 5.0%     →  floor 5   (bridges to D31 cap at >5%)
        //   pct > 5.0%       →  no floor (D31 governs)
        //
        // Purely additive: no score below 3.5% changes, no score above 5%
        // changes. Cliff narrows from up to 3 bins to at most 1 bin.
        if (pct <= 0.035) return Math.max(score, 7);
        if (pct <= 0.045) return Math.max(score, 6);
        if (pct <= 0.050) return Math.max(score, 5);
        return score;
      }

      function probabilityToScore(probability) {
        const bins = [
          { max: 0.15, score: 1 }, { max: 0.30, score: 2 }, { max: 0.42, score: 3 },
          { max: 0.52, score: 4 }, { max: 0.62, score: 5 }, { max: 0.72, score: 6 },
          { max: 0.80, score: 7 }, { max: 0.87, score: 8 }, { max: 0.93, score: 9 },
          { max: 1.00, score: 10 }
        ];
        for (const bin of bins) { if (probability <= bin.max) return bin.score; }
        return 10;
      }

      function probabilityToContinuousScore(probability) {
        const boundaries = [0, 0.15, 0.30, 0.42, 0.52, 0.62, 0.72, 0.80, 0.87, 0.93, 1.00];
        const scores    = [1, 2,    3,    4,    5,    6,    7,    8,    9,    10,   10];
        const p = Math.max(0, Math.min(1, probability));
        for (let i = 0; i < boundaries.length - 1; i++) {
          if (p <= boundaries[i + 1]) {
            const span = boundaries[i + 1] - boundaries[i] || 1;
            const frac = (p - boundaries[i]) / span;
            return scores[i] + frac * (scores[i + 1] - scores[i]);
          }
        }
        return 10.0;
      }

      // Display-layer helper (2026-05-11). Returns a probability that AGREES
      // with the *displayed* (post-floor / post-cap) score. When neither
      // D31 catastrophic ask cap nor D33 softball ask floor binds, this
      // just returns the raw p_deal. When either binds, the raw probability
      // and the displayed score disagree (the floor/cap changed the score
      // but never the underlying probability) — so we re-derive a probability
      // from the displayed score's bin midpoint. The hero score and the
      // "Probability of close" line then tell the same story.
      //
      // Direction of error: when floor binds (raises score), the displayed
      // probability rises too — more optimistic, by design. When cap binds
      // (lowers score), it falls — consistent with the cap's safety intent.
      // Engine math is untouched; audit history (DB columns + score_computations)
      // continues to record the raw p_deal.
      function displayedProbabilityFor(state) {
        if (!state || typeof state.score !== 'number') {
          return state?.probability ?? null;
        }
        if (!state.floorWasApplied && !state.capWasApplied) {
          return state.probability;
        }
        // Bin midpoints — must stay in sync with probabilityToScore's bin
        // boundaries above. Index = displayed score (1..10).
        const MIDPOINTS = {
          1: 0.075, 2: 0.225, 3: 0.36, 4: 0.47, 5: 0.57,
          6: 0.67,  7: 0.76,  8: 0.835, 9: 0.90, 10: 0.965
        };
        const s = Math.max(1, Math.min(10, Math.round(state.score)));
        return MIDPOINTS[s];
      }

      function computeConfidenceTier(posteriorAlpha, posteriorBeta) {
        const ab = posteriorAlpha + posteriorBeta;
        const mean = posteriorAlpha / ab;
        const variance = (posteriorAlpha * posteriorBeta) / (ab * ab * (ab + 1));
        const stdDev = Math.sqrt(Math.max(0, variance));
        const ciLower = Math.max(0, mean - 1.96 * stdDev);
        const ciUpper = Math.min(1, mean + 1.96 * stdDev);
        const scoreLower = probabilityToContinuousScore(ciLower);
        const scoreUpper = probabilityToContinuousScore(ciUpper);
        const ciWidth = scoreUpper - scoreLower;
        const cfg = GamePlanScoreConfig;
        let tier;
        if (ciWidth < cfg.CI_HIGH_THRESHOLD) tier = 'high';
        else if (ciWidth < cfg.CI_MODERATE_THRESHOLD) tier = 'moderate';
        else tier = 'limited';
        return { tier, ciWidth, ciLower: scoreLower, ciUpper: scoreUpper };
      }

      async function runSniffTest(scoreResult, reportIdForLogging) {
        const cfg = GamePlanScoreConfig;
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), cfg.SNIFF_TEST_TIMEOUT_MS);
        try {
          // D53: include _ppgMeta so the worker can label this row in
          // claude_usage_events. /sniff-test endpoint isn't auth'd so we
          // pass reportId through the body — user_id stays null on the row.
          const _d53Body = { ...scoreResult, _ppgMeta: { reportId: reportIdForLogging || null } };
          const response = await fetch(cfg.SNIFF_TEST_ENDPOINT, {
            method: 'POST',
            headers: await getAuthHeaders(),
            body: JSON.stringify(_d53Body),
            signal: controller.signal
          });
          clearTimeout(timeoutId);
          if (!response.ok) throw new Error(`Sniff test HTTP ${response.status}`);
          const result = await response.json();
          if (!result.verdict || !['concurs', 'flag', 'adjust'].includes(result.verdict)) {
            throw new Error('Invalid sniff test response shape');
          }
          return {
            status: 'ok',
            verdict: result.verdict,
            suggestedScore: result.suggestedScore ?? result.suggested_score ?? null,
            concern: result.concern,
            reasoning: result.reasoning,
            // D17 richer fields
            summary: result.summary || null,
            concerns: Array.isArray(result.concerns) ? result.concerns : [],
            layer_coherence: result.layer_coherence || 'aligned'
          };
        } catch (err) {
          clearTimeout(timeoutId);
          console.error('Sniff test error:', err);
          return { status: 'error', error: err.message };
        }
      }

      async function computeGamePlanScore(dealContext, historicalOutcomes) {
        const cfg = GamePlanScoreConfig;
        const outcomes = Array.isArray(historicalOutcomes) ? historicalOutcomes : [];

        const s_L = computeLeverageScore(dealContext.leverageScore);
        // D26: pass purchasePrice so Market Realism can fall back to a property-value anchor
        // when segment data is degraded or absent.
        const s_M = computeMarketRealismScore(
          dealContext.ask,
          dealContext.expectedConcession,
          dealContext.segmentStdDev,
          dealContext.purchasePrice
        );
        // D45: Ask Justification replaces Property Specifics. Returns null when
        // the justifiable repair pool is zero (no priced high/medium findings),
        // which the blend below handles by redistributing weight to remaining
        // components.
        const s_AJ = computeAskJustificationScore(
          dealContext.inspectionFindings,
          dealContext.ask
        );
        // D45: pool snapshot — used by applyPoolJustifiedAskFloor below. Engine
        // -internal only; never surfaced via UI or sent to the supervisor sniff.
        const pool = _justifiableRepairPool(dealContext.inspectionFindings);

        const similarityResult = computeOutcomeSimilarityScore(dealContext, outcomes);
        const s_O = similarityResult.score;
        const n_eff = similarityResult.effectiveSampleSize;
        const simWeights = similarityResult.similarityWeights || [];

        // D26: pass marketDataQuality so weights can redistribute away from Market Realism
        // when the underlying segment data is the fallback (no ZIP match).
        const weights = computeWeights(n_eff, dealContext.marketDataQuality);

        // D45: blend now handles two independent nullable components (s_O and
        // s_AJ). Available-weight redistribution mirrors the existing s_O=null
        // pattern. When both are null we fall back to L+M only.
        const hasOutcome = !(s_O === null || n_eff === 0);
        const hasAJ = (s_AJ !== null);
        let p_raw;
        if (hasOutcome && hasAJ) {
          p_raw = weights.w_L * s_L + weights.w_M * s_M + weights.w_AJ * s_AJ + weights.w_O * s_O;
        } else if (hasOutcome && !hasAJ) {
          const avail = weights.w_L + weights.w_M + weights.w_O;
          p_raw = (weights.w_L / avail) * s_L + (weights.w_M / avail) * s_M + (weights.w_O / avail) * s_O;
        } else if (!hasOutcome && hasAJ) {
          const avail = weights.w_L + weights.w_M + weights.w_AJ;
          p_raw = (weights.w_L / avail) * s_L + (weights.w_M / avail) * s_M + (weights.w_AJ / avail) * s_AJ;
        } else {
          const avail = weights.w_L + weights.w_M;
          p_raw = (weights.w_L / avail) * s_L + (weights.w_M / avail) * s_M;
        }

        const bayesian = computeBayesianProbability(p_raw, outcomes, simWeights);
        const p_deal = bayesian.probability;

        let score = probabilityToScore(p_deal);
        const continuousScore = probabilityToContinuousScore(p_deal);

        if (cfg.BOOTSTRAP_ACTIVE) {
          score = Math.max(cfg.BOOTSTRAP_SCORE_MIN, Math.min(cfg.BOOTSTRAP_SCORE_MAX, score));
        }

        const confidence = computeConfidenceTier(bayesian.alpha, bayesian.beta);

        let sniffTest = null;
        if (cfg.SNIFF_TEST_ENABLED && dealContext.reportSummary) {
          try {
            const topFindings = (Array.isArray(dealContext.inspectionFindings) ? dealContext.inspectionFindings : [])
              .filter(f => !(f && f.selected === false))
              .map(f => ({
                severity: _normalizeSeverity(f) || 'green',
                category: f.category || f.type || '',
                summary: f.summary || f.description || f.title || ''
              }))
              .slice(0, 6);

            sniffTest = await runSniffTest({
              mathScore: score,
              probability: p_deal,
              components: { leverage: s_L, marketRealism: s_M, askJustification: s_AJ, outcomeSimilarity: s_O },
              confidence: confidence.tier,
              dealContext: {
                propertyAddress: dealContext.propertyAddress,
                ask: dealContext.ask,
                purchasePrice: dealContext.purchasePrice,
                daysOnMarket: dealContext.daysOnMarket,
                segment: dealContext.segment,
                topFindings,
                reportSummary: dealContext.reportSummary
              }
            }, dealContext.reportId || null);
          } catch (err) {
            console.error('Sniff test failed:', err);
            sniffTest = { status: 'error', error: err.message };
          }
        }

        // D45 (2026-05-11): cap/floor order reversed — floors first, cap last.
        // D33's floor and D31's cap were disjoint by ask% of property value, so
        // ordering was inert. D45's pool-based floor and D31's value-based cap
        // CAN both trigger on the same case (e.g. 30% of property value AND
        // 25% of pool). Catastrophic cap is the safety net; floors raise the
        // score but a genuinely disproportionate ask must still cap.
        //
        // D33: Softball ask floor — raises score when ask ≤ 2% of property
        // value. One-directional.
        const d33Floored = applySoftballAskFloor(score, dealContext.ask, dealContext.purchasePrice);
        const d33FiredRaw = (d33Floored > score);
        // D45: Pool-Justified Ask Floor — raises score when ask is small
        // relative to the justifiable repair pool. Inert when pool is zero.
        const afterPoolFloor = applyPoolJustifiedAskFloor(d33Floored, dealContext.ask, pool);
        const poolFiredRaw = (afterPoolFloor > d33Floored);
        // D31: Catastrophic cap — lowers score for asks disproportionate to
        // property value. Applied last so a 113% ask can't be "saved" by a
        // favorable pool ratio. Cap is the final word.
        const finalScore = applyCatastrophicAskCap(afterPoolFloor, dealContext.ask, dealContext.purchasePrice);
        const capWasApplied = (finalScore < afterPoolFloor);
        // Effective floor flags: if the cap subsequently lowered the score,
        // the floor didn't survive — surface only the cap. This preserves the
        // existing "cap and floor cannot both be applied" invariant.
        const d33FloorWasApplied = d33FiredRaw && !capWasApplied;
        const poolFloorWasApplied = poolFiredRaw && !capWasApplied;
        const floorWasApplied = d33FloorWasApplied || poolFloorWasApplied;
        const askPercentOfValue = (dealContext.purchasePrice > 0 && dealContext.ask > 0)
          ? (dealContext.ask / dealContext.purchasePrice)
          : null;

        return {
          score: finalScore,
          continuousScore,
          probability: p_deal,
          components: {
            leverage: s_L,
            marketRealism: s_M,
            askJustification: s_AJ,
            outcomeSimilarity: s_O
          },
          weights,
          confidence,
          bayesian: { alpha: bayesian.alpha, beta: bayesian.beta, effectiveSampleSize: n_eff },
          sniffTest,
          // D31: cap metadata — drives UI annotation when cap binds. uncappedScore
          // is the post-floors, pre-cap value (what the score would have been if
          // the cap hadn't applied).
          capWasApplied,
          uncappedScore: capWasApplied ? afterPoolFloor : null,
          // D33 + D45: floor metadata. floorWasApplied is true if EITHER floor
          // bound AND survived the cap. Sub-flags distinguish which. No new
          // visible UI annotation in D45 — pool floor binding pending Andrew's
          // calibration confirmation.
          floorWasApplied,
          d33FloorWasApplied,
          poolFloorWasApplied,
          unflooredScore: floorWasApplied ? score : null,
          askPercentOfValue,
          timestamp: new Date().toISOString()
        };
      }

      if (typeof window !== 'undefined') {
        window.GamePlanScore = {
          config: GamePlanScoreConfig,
          computeLeverageScore,
          computeMarketRealismScore,
          computePropertyValueAnchorScore,  // D26
          applyCatastrophicAskCap,  // D31
          applySoftballAskFloor,  // D33
          computeAskJustificationScore,  // D45
          applyPoolJustifiedAskFloor,    // D45
          computeOutcomeSimilarityScore,
          computeWeights,
          computeBayesianProbability,
          probabilityToScore,
          probabilityToContinuousScore,
          displayedProbabilityFor,
          computeConfidenceTier,
          runSniffTest,
          computeGamePlanScore
        };

        window.testGamePlanScore = async function() {
          console.log('🧪 Testing Game Plan Score Engine...');

          const case1 = await computeGamePlanScore({
            leverageScore: 10,
            inspectionFindings: [
              { severity: 'yellow', category: 'Roof', summary: 'Aging shingles' },
              { severity: 'green', category: 'Plumbing', summary: 'Minor leaks' }
            ],
            daysOnMarket: 45,
            priceReductions: 1,
            sellerSignals: { relocation: true },
            ask: 8000,
            purchasePrice: 550000,
            segment: 'C',
            expectedConcession: 7500,
            segmentStdDev: 3000,
            reportSummary: 'Overall sound property. Roof is aging but functional. Minor electrical panel concerns noted.'
          });
          console.log('Case 1 (expect score 6-8):', case1);

          const case2 = await computeGamePlanScore({
            leverageScore: -8,
            inspectionFindings: [
              { severity: 'red', category: 'Structural', summary: 'Foundation cracks' },
              { severity: 'red', category: 'Electrical', summary: 'K&T wiring throughout' },
              { severity: 'yellow', category: 'Roof', summary: 'End of life' }
            ],
            daysOnMarket: 12,
            priceReductions: 0,
            sellerSignals: {},
            ask: 25000,
            purchasePrice: 725000,
            segment: 'A',
            expectedConcession: 12000,
            segmentStdDev: 5000,
            reportSummary: 'Historic 1925 home. Foundation shows horizontal cracking. Knob and tube wiring present in most of home. Active moisture in basement.'
          });
          console.log('Case 2 (expect score 2-4):', case2);

          const case3 = await computeGamePlanScore({
            leverageScore: 0,
            inspectionFindings: [],
            daysOnMarket: null,
            priceReductions: 0,
            sellerSignals: {},
            ask: 0,
            purchasePrice: 500000,
            segment: 'C',
            expectedConcession: null,
            segmentStdDev: null,
            reportSummary: null
          });
          console.log('Case 3 (neutral, expect ~5):', case3);

          // D26 regression: 1980 16th St case — $6,200 ask on $500K with intentionally
          // tight (broken) segment data. Pre-D26 scored 2 because Market Realism collapsed
          // to 0.00 at 40% weight. Post-D26 should score 5-7 because the property-value
          // anchor catches that 1.24% is a reasonable ask regardless of segment data.
          const case4 = await computeGamePlanScore({
            leverageScore: 0,
            inspectionFindings: [
              { severity: 'yellow', category: 'Electrical', summary: 'Federal Pacific panel' },
              { severity: 'green', category: 'Plumbing', summary: 'Minor drip' }
            ],
            daysOnMarket: 14,
            priceReductions: 0,
            sellerSignals: {},
            ask: 6200,
            purchasePrice: 500000,
            segment: 'south_sw_premium',
            expectedConcession: 2450,
            segmentStdDev: 1500,
            reportSummary: 'Federal Pacific panel flagged. Minor plumbing concerns.'
          });
          console.log('Case 4 (D26 regression — should be 5-7, NOT 2):', case4);

          // D31 test cases — catastrophic ask cap regression locks
          const d31_pathological = await computeGamePlanScore({
            leverageScore: 9,
            inspectionFindings: [
              { severity: 'red', category: 'Electrical', summary: 'Federal Pacific panel typo case' }
            ],
            daysOnMarket: 30,
            priceReductions: 0,
            sellerSignals: {},
            ask: 555650,
            purchasePrice: 500000,
            segment: 'south_sw_premium',
            expectedConcession: 5880,
            segmentStdDev: 4000,
            reportSummary: 'Pathological 113% ask — should cap at 1.'
          });
          console.log('D31 Case 1 (113% pathological — should be 1, capWasApplied=true):', d31_pathological.score, 'cap:', d31_pathological.capWasApplied);

          const d31_aggressive_30 = await computeGamePlanScore({
            leverageScore: 5,
            inspectionFindings: [{ severity: 'yellow', category: 'Roof', summary: 'roof' }],
            daysOnMarket: 30, priceReductions: 0, sellerSignals: {},
            ask: 150000, purchasePrice: 500000,
            segment: 'C', expectedConcession: 6000, segmentStdDev: 3000,
            reportSummary: '30% ask — should cap at 3.'
          });
          console.log('D31 Case 2 (30% — should cap at ≤3):', d31_aggressive_30.score, 'cap:', d31_aggressive_30.capWasApplied);

          const d31_stretch_8 = await computeGamePlanScore({
            leverageScore: 5,
            inspectionFindings: [{ severity: 'yellow', category: 'Roof', summary: 'roof' }],
            daysOnMarket: 30, priceReductions: 0, sellerSignals: {},
            ask: 40000, purchasePrice: 500000,
            segment: 'C', expectedConcession: 6000, segmentStdDev: 3000,
            reportSummary: '8% ask — should cap at 6.'
          });
          console.log('D31 Case 3 (8% — should cap at ≤6):', d31_stretch_8.score, 'cap:', d31_stretch_8.capWasApplied);

          const d31_normal = await computeGamePlanScore({
            leverageScore: 5,
            inspectionFindings: [{ severity: 'green', category: 'Plumbing', summary: 'minor' }],
            daysOnMarket: 30, priceReductions: 0, sellerSignals: {},
            ask: 6200, purchasePrice: 500000,
            segment: 'C', expectedConcession: 6000, segmentStdDev: 3000,
            reportSummary: '1.2% — no cap.'
          });
          console.log('D31 Case 4 (1.2% normal — no cap, capWasApplied=false):', d31_normal.score, 'cap:', d31_normal.capWasApplied);

          const d31_zero = await computeGamePlanScore({
            leverageScore: 0,
            inspectionFindings: [],
            daysOnMarket: null, priceReductions: 0, sellerSignals: {},
            ask: 0, purchasePrice: 500000,
            segment: null, expectedConcession: null, segmentStdDev: null,
            reportSummary: null
          });
          console.log('D31 Case 5 (zero ask — cap should NOT fire):', d31_zero.score, 'cap:', d31_zero.capWasApplied);

          // D33 test cases — softball ask floor regression locks
          // Validation case: $5,500 / $500,000 = 1.10% → must produce Score ≥7 with floor binding.
          const d33_validation_1980 = await computeGamePlanScore({
            leverageScore: -4,
            inspectionFindings: [{ severity: 'red', category: 'Electrical', summary: 'Federal Pacific panel' }],
            daysOnMarket: 24, priceReductions: 1, sellerSignals: {},
            ask: 5500, purchasePrice: 500000,
            segment: 'C', expectedConcession: 6000, segmentStdDev: 3000,
            reportSummary: '1.10% validation case (1980 16th St). Pre-D33 = 5; post-D33 must be ≥7.'
          });
          console.log('D33 Case 1 (1.10% validation — should be ≥7, floorWasApplied=true):', d33_validation_1980.score, 'floor:', d33_validation_1980.floorWasApplied, 'unfloored:', d33_validation_1980.unflooredScore);

          // Cream puff: 1% ask, neutral leverage → floor must bind to 7.
          const d33_creampuff = await computeGamePlanScore({
            leverageScore: 0,
            inspectionFindings: [{ severity: 'green', category: 'Plumbing', summary: 'minor' }],
            daysOnMarket: 30, priceReductions: 0, sellerSignals: {},
            ask: 5000, purchasePrice: 500000,
            segment: 'C', expectedConcession: 6000, segmentStdDev: 3000,
            reportSummary: '1.0% cream puff — should be ≥7, floor binds.'
          });
          console.log('D33 Case 2 (1.0% cream puff — should be ≥7):', d33_creampuff.score, 'floor:', d33_creampuff.floorWasApplied);

          // No-regression: strong leverage + low ask should already be ≥8 and stay there.
          // Floor must not down-rank earned high scores; Math.max guarantees this.
          const d33_strong_no_regression = await computeGamePlanScore({
            leverageScore: 12,
            inspectionFindings: [
              { severity: 'red', category: 'Roof', summary: 'major roof' },
              { severity: 'red', category: 'HVAC', summary: 'failing HVAC' }
            ],
            daysOnMarket: 90, priceReductions: 3, sellerSignals: { vacant: true, relocation: true },
            ask: 5000, purchasePrice: 500000,
            segment: 'C', expectedConcession: 6000, segmentStdDev: 3000,
            reportSummary: '1.0% ask + strong leverage — score should be ≥8 on its own merits, floor inert.'
          });
          console.log('D33 Case 3 (strong score — floor must not regress 8+ scores):', d33_strong_no_regression.score, 'floor:', d33_strong_no_regression.floorWasApplied);

          // Above-threshold (post-D48): 4.0% ask should NOT trigger floor.
          // (D48 raised threshold from 2% → 3.5% to align with NAR's typical band.)
          const d33_above_threshold = await computeGamePlanScore({
            leverageScore: 0,
            inspectionFindings: [{ severity: 'green', category: 'Plumbing', summary: 'minor' }],
            daysOnMarket: 30, priceReductions: 0, sellerSignals: {},
            ask: 20000, purchasePrice: 500000,
            segment: 'C', expectedConcession: 6000, segmentStdDev: 3000,
            reportSummary: '4.0% ask — outside floor range, floor must not fire.'
          });
          console.log('D33 Case 4 (4.0% above threshold — floor should NOT fire):', d33_above_threshold.score, 'floor:', d33_above_threshold.floorWasApplied);

          // D31 cross-check: 113% case must still cap at 1 — floor and cap are disjoint by ask%.
          console.log('D33 Case 5 (D31 113% pathological cross-check — cap still binds, floor inert):', d31_pathological.score, 'cap:', d31_pathological.capWasApplied, 'floor:', d31_pathological.floorWasApplied);

          console.log('✅ Tests complete. Review output above.');
          return {
            case1, case2, case3, case4,
            d31_pathological, d31_aggressive_30, d31_stretch_8, d31_normal, d31_zero,
            d33_validation_1980, d33_creampuff, d33_strong_no_regression, d33_above_threshold
          };
        };

        // ============================================================
        // D30 Addendum: Invariant pass + narrative consistency
        // ============================================================
        // Hard contractual rules the score engine must always satisfy. Each rule is
        // a deterministic assertion — pass/fail. Run via `await window.testGamePlanScoreInvariants()`
        // from the browser console. Every score-engine directive's completion report
        // must include this output as a regression check.
        window.testGamePlanScoreInvariants = async function() {
          console.log('🔒 Game Plan Score Invariants...');
          let pass = 0, fail = 0;
          const failures = [];
          const expect = (condition, label) => {
            if (condition) { pass++; console.log(`  ✅ ${label}`); }
            else { fail++; failures.push(label); console.error(`  ❌ ${label}`); }
          };

          const compute = async (overrides) => computeGamePlanScore({
            leverageScore: 0,
            inspectionFindings: [],
            daysOnMarket: 30,
            priceReductions: 0,
            sellerSignals: {},
            ask: 6000, purchasePrice: 500000,
            segment: 'C', expectedConcession: 6000, segmentStdDev: 3000,
            reportSummary: null,
            ...overrides
          }, []);

          // === Range / shape invariants ===
          const baseline = await compute({});
          expect(Number.isInteger(baseline.score), 'score is an integer');
          expect(baseline.score >= 1 && baseline.score <= 10, 'score is in [1, 10]');
          expect(typeof baseline.continuousScore === 'number' && baseline.continuousScore >= 1 && baseline.continuousScore <= 10, 'continuousScore is in [1, 10]');
          expect(typeof baseline.probability === 'number' && baseline.probability >= 0 && baseline.probability <= 1, 'probability is in [0, 1]');
          expect(['high', 'moderate', 'limited'].includes(baseline.confidence?.tier), 'confidence.tier is high/moderate/limited');
          // D45: propertySpecifics → askJustification (component rename).
          ['leverage', 'marketRealism', 'askJustification', 'outcomeSimilarity'].forEach(k => {
            const v = baseline.components[k];
            expect(v === null || (v >= 0 && v <= 1), `components.${k} is null or in [0, 1]`);
          });

          // === D31 Catastrophic Ask Cap invariants ===
          const r_113pct = await compute({ ask: 565000 });
          expect(r_113pct.score === 1, 'ask% > 100% → score === 1 (D31 cap)');
          expect(r_113pct.capWasApplied === true, 'ask% > 100% → capWasApplied true');

          const r_50pct = await compute({ ask: 250000 });
          expect(r_50pct.score <= 3, 'ask% > 40% → score ≤ 3 (D31 cap binds aggressively)');

          const r_15pct = await compute({ ask: 75000 });
          expect(r_15pct.score <= 4, 'ask% in (10%, 20%] → score ≤ 4 (D31 cap)');

          const r_8pct = await compute({ ask: 40000 });
          expect(r_8pct.score <= 6, 'ask% in (5%, 10%] → score ≤ 6 (D31 cap)');

          // === D33 Softball Ask Floor invariants (threshold raised 2% → 3.5% in D48) ===
          const r_1pct = await compute({ ask: 5000 });
          expect(r_1pct.score >= 7, 'ask% ≤ 3.5% → score ≥ 7 (D33 floor)');
          expect(r_1pct.floorWasApplied === true || baseline.score >= 7, 'ask% ≤ 3.5% → floorWasApplied true (or score earned ≥7)');

          const r_2pct_boundary = await compute({ ask: 10000 });
          expect(r_2pct_boundary.score >= 7, 'ask% === 2% → score ≥ 7 (D33 floor)');

          // D48: 2.83% (Jared's $14k-on-$495k case scaled to $500k = $14,150)
          // should now floor at 7. This was the calibration miss that motivated
          // the D33 threshold raise from 2% → 3.5%.
          const r_283pct = await compute({ ask: 14150 });
          expect(r_283pct.score >= 7, 'ask% === 2.83% → score ≥ 7 (D33 floor, post-D48)');

          // D48 upper-boundary: 3.5% exactly should still floor.
          const r_35pct_boundary = await compute({ ask: 17500 });
          expect(r_35pct_boundary.score >= 7, 'ask% === 3.5% (boundary) → score ≥ 7 (D33 floor, post-D48)');

          // D51 (2026-05-12): stepped softball floor replaces the 3.5% binary
          // cliff. The 4.0% case now floors to 6 instead of being inert; new
          // bands cover 3.5-4.5% (floor 6) and 4.5-5% (floor 5).
          //
          // 4.0% should floor to 6 (in the 3.5-4.5% band).
          const r_4pct = await compute({ ask: 20000 });
          expect(r_4pct.score >= 6, 'ask% === 4.0% → score ≥ 6 (D51 stepped floor)');
          expect(r_4pct.d33FloorWasApplied === true || r_4pct.score >= 6, 'ask% === 4.0% → d33FloorWasApplied true (or earned ≥6)');

          // 3.6% (just above old cliff) should also floor to 6.
          const r_36pct = await compute({ ask: 18000 });
          expect(r_36pct.score >= 6, 'ask% === 3.6% → score ≥ 6 (D51 stepped floor — closes pre-D51 cliff)');

          // 4.5% upper boundary of the floor-6 band — still ≥ 6.
          const r_45pct_boundary = await compute({ ask: 22500 });
          expect(r_45pct_boundary.score >= 6, 'ask% === 4.5% (boundary) → score ≥ 6 (D51 stepped floor)');

          // 4.6% drops into the floor-5 band.
          const r_46pct = await compute({ ask: 23000 });
          expect(r_46pct.score >= 5, 'ask% === 4.6% → score ≥ 5 (D51 stepped floor)');

          // 5.0% exactly is the top of the floor-5 band.
          const r_5pct_boundary = await compute({ ask: 25000 });
          expect(r_5pct_boundary.score >= 5 || r_5pct_boundary.capWasApplied, 'ask% === 5.0% (boundary) → score ≥ 5 unless D31 cap binds');

          // 5.1% is above all D33 zones — floor inert, D31 cap governs.
          const r_51pct = await compute({ ask: 25500 });
          expect(r_51pct.d33FloorWasApplied === false, 'ask% === 5.1% → D33 floor inert (D31 cap zone)');

          // === Cap and floor are disjoint ===
          const cases = [r_113pct, r_50pct, r_15pct, r_8pct, r_1pct, r_2pct_boundary, r_283pct, r_35pct_boundary, r_4pct, r_36pct, r_45pct_boundary, r_46pct, r_5pct_boundary, r_51pct, baseline];
          cases.forEach((c, i) => {
            expect(!(c.capWasApplied && c.floorWasApplied), `case ${i}: cap and floor cannot both be applied`);
          });

          // === uncappedScore / unflooredScore consistency ===
          if (r_113pct.capWasApplied) {
            expect(r_113pct.uncappedScore != null && r_113pct.uncappedScore >= r_113pct.score, 'cap binds → uncappedScore ≥ score');
          }
          if (r_1pct.floorWasApplied) {
            expect(r_1pct.unflooredScore != null && r_1pct.unflooredScore <= r_1pct.score, 'floor binds → unflooredScore ≤ score');
          }

          // === Zero ask (degenerate) ===
          const r_zero = await compute({ ask: 0 });
          expect(r_zero.capWasApplied === false, 'zero ask → cap does not fire');
          expect(r_zero.floorWasApplied === false, 'zero ask → floor does not fire');

          // === D45 Pool-Justified Ask Floor invariants ===
          // Fixture: $100k justifiable repair pool (one priced red finding).
          // Pool stays internal to the engine — assertions key off score behavior,
          // not on a pool value surfaced anywhere.
          const pooledFindings = [
            { severity: 'red', category: 'Roof', summary: 'Roof replacement', cost: 60000 },
            { severity: 'yellow', category: 'HVAC', summary: 'HVAC end of life', cost: 40000 }
          ];
          // 22% of pool, 4.4% of property value (below cap, above D33 floor) → pool floor binds at 7.
          const r_pool22 = await compute({ inspectionFindings: pooledFindings, ask: 22000 });
          expect(r_pool22.score >= 7, 'ask = 22% of pool → score ≥ 7 (D45 pool floor)');
          expect(r_pool22.poolFloorWasApplied === true || r_pool22.score >= 7, 'ask = 22% of pool → poolFloorWasApplied (or earned ≥7)');
          // 30% of pool (pool floor wants 7) + 6% of value (cap wants ≤6) → cap is the final word.
          // Pool floor fires raw but gets suppressed in the effective flag because the cap
          // subsequently lowered the score. poolFloorWasApplied must be false.
          const r_pool30_cap6 = await compute({ inspectionFindings: pooledFindings, ask: 30000 });
          expect(r_pool30_cap6.score <= 6, 'ask 30% of pool + 6% of value → cap wins (≤6)');
          expect(r_pool30_cap6.capWasApplied === true, 'ask 30% of pool + 6% of value → capWasApplied true');
          expect(r_pool30_cap6.poolFloorWasApplied === false, 'cap overrode pool floor → poolFloorWasApplied false (effective flag)');
          // 70% of pool → above 50%, pool floor inert; ask is 14% of property value → cap binds.
          const r_pool70 = await compute({ inspectionFindings: pooledFindings, ask: 70000 });
          expect(r_pool70.poolFloorWasApplied === false, 'ask > 50% of pool → pool floor inert');
          // Zero pool (no priced findings) → pool floor inert regardless of ask.
          const r_zero_pool = await compute({ ask: 5000 }); // empty findings = zero pool
          expect(r_zero_pool.poolFloorWasApplied === false, 'zero pool → pool floor inert');
          // Range invariants for the new flag.
          [r_pool22, r_pool30_cap6, r_pool70, r_zero_pool, baseline].forEach((c, i) => {
            expect(typeof c.poolFloorWasApplied === 'boolean', `case ${i}: poolFloorWasApplied is boolean`);
            expect(typeof c.d33FloorWasApplied === 'boolean', `case ${i}: d33FloorWasApplied is boolean`);
            // Effective floor flag is the union of D33 + D45 sub-flags.
            expect(c.floorWasApplied === (c.d33FloorWasApplied || c.poolFloorWasApplied), `case ${i}: floorWasApplied === d33 || pool`);
            // Cap and floor disjointness invariant still holds (effective flags
            // suppress floor when cap subsequently lowered the score).
            expect(!(c.capWasApplied && c.floorWasApplied), `case ${i}: cap and floor cannot both be applied (effective)`);
          });

          // === D50 Ask Justification curve invariants ===
          // Direct component-score checks against the new 6-bin curve. Pool
          // value is engine-internal — assertions key off the AJ score the
          // engine produces, not on any pool dollar figure exposed to UI.
          const _ajPool = 10000;
          const _ajFindings = [{ severity: 'red', cost: _ajPool, summary: 'Test red' }];
          const ajCases = [
            { ratio: 0.30, expected: 0.90, label: 'D50 AJ ratio 0.30 (conservative)' },
            { ratio: 0.40, expected: 0.90, label: 'D50 AJ ratio 0.40 boundary' },
            { ratio: 0.60, expected: 0.80, label: 'D50 AJ ratio 0.60 (reasonable)' },
            { ratio: 0.70, expected: 0.80, label: 'D50 AJ ratio 0.70 boundary' },
            { ratio: 1.00, expected: 0.65, label: 'D50 AJ ratio 1.00 (tight & complete — was 0.30 pre-D50)' },
            { ratio: 1.05, expected: 0.65, label: 'D50 AJ ratio 1.05 boundary (rounding cushion)' },
            { ratio: 1.20, expected: 0.45, label: 'D50 AJ ratio 1.20 (slight overreach)' },
            { ratio: 1.50, expected: 0.25, label: 'D50 AJ ratio 1.50 (notable overreach)' },
            { ratio: 2.00, expected: 0.10, label: 'D50 AJ ratio 2.00 (substantial overreach)' }
          ];
          ajCases.forEach(({ ratio, expected, label }) => {
            const aj = computeAskJustificationScore(_ajFindings, Math.round(ratio * _ajPool));
            expect(aj === expected, `${label} → ${expected} (got ${aj})`);
          });
          // Zero-pool case still returns null so weights redistribute.
          expect(computeAskJustificationScore([], 5000) === null, 'D50 AJ zero pool → null');
          // Zero-ask case still returns 1.0 (asking nothing is safest).
          expect(computeAskJustificationScore(_ajFindings, 0) === 1.0, 'D50 AJ zero ask → 1.0');

          // === probabilityToScore monotonicity ===
          const probs = [0.1, 0.3, 0.5, 0.7, 0.9];
          const scores = probs.map(p => probabilityToScore(p));
          const monotonic = scores.every((s, i) => i === 0 || s >= scores[i-1]);
          expect(monotonic, 'probabilityToScore is monotonic non-decreasing');

          // === Narrative consistency (D30 addendum) ===
          // Strategy Insight headline tier must match Score tier band.
          const narrativeCases = [
            { state: { score: 9, ask: 5000, purchasePrice: 500000, confidence: { tier: 'high' }, bayesian: { effectiveSampleSize: 0 } }, expectHeadline: 'Strong' },
            { state: { score: 6, ask: 15000, purchasePrice: 500000, confidence: { tier: 'moderate' }, bayesian: { effectiveSampleSize: 0 } }, expectHeadline: 'Solid' },
            { state: { score: 3, ask: 30000, purchasePrice: 500000, confidence: { tier: 'limited' }, bayesian: { effectiveSampleSize: 0 } }, expectHeadline: 'Mixed' },
            { state: { score: 1, ask: 40000, purchasePrice: 500000, confidence: { tier: 'limited' }, bayesian: { effectiveSampleSize: 0 } }, expectHeadline: 'Challenged' }
          ];
          narrativeCases.forEach(({ state, expectHeadline }) => {
            const insight = _computeStrategyInsight(state);
            expect(insight && insight.headline.includes(expectHeadline), `Score ${state.score} → Strategy Insight headline contains "${expectHeadline}" (got: "${insight?.headline}")`);
          });

          // Cap-applied narrative override: body must mention "capped"
          const capState = { score: 1, ask: 565000, purchasePrice: 500000, capWasApplied: true, confidence: { tier: 'limited' }, bayesian: { effectiveSampleSize: 0 } };
          const capInsight = _computeStrategyInsight(capState);
          expect(capInsight && capInsight.body.toLowerCase().includes('cap'), 'capWasApplied → Strategy Insight body mentions "cap"');

          // Floor-applied narrative additive: body must mention "floor"
          const floorState = { score: 7, ask: 5000, purchasePrice: 500000, floorWasApplied: true, confidence: { tier: 'limited' }, bayesian: { effectiveSampleSize: 0 } };
          const floorInsight = _computeStrategyInsight(floorState);
          expect(floorInsight && floorInsight.body.toLowerCase().includes('floor'), 'floorWasApplied → Strategy Insight body mentions "floor"');

          // Tier badge label / Strategy Insight headline must use same tier breakpoints
          [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].forEach(s => {
            const badgeLabel = _gpsTierBadgeLabel(s);
            const dummyState = { score: s, ask: 6000, purchasePrice: 500000, confidence: { tier: 'moderate' }, bayesian: { effectiveSampleSize: 0 } };
            const insight = _computeStrategyInsight(dummyState);
            const headlineTier = insight.headline.split(' ')[0]; // first word: "Strong" / "Solid" / "Mixed" / "Challenged"
            const badgeTier = badgeLabel.split(' ')[0]; // first word
            expect(headlineTier === badgeTier, `Score ${s}: badge "${badgeTier}" matches Strategy Insight "${headlineTier}"`);
          });

          // Summary
          const total = pass + fail;
          if (fail === 0) {
            console.log(`%c✅ ${pass}/${total} invariants passed.`, 'color: #16a34a; font-weight: bold;');
          } else {
            console.error(`%c❌ ${fail}/${total} invariants FAILED:`, 'color: #dc2626; font-weight: bold;');
            failures.forEach(f => console.error(`  • ${f}`));
          }
          return { pass, fail, total, failures };
        };
      }

      // ============================================================
      // GAME PLAN SCORE — D8 ORCHESTRATION (state, persistence, effects)
      // ============================================================

      const [gamePlanScoreState, setGamePlanScoreState] = useState(null);
      const [scoreComputing, setScoreComputing] = useState(false);
      const [scoreDetailsOpen, setScoreDetailsOpen] = useState(false);
      const [lastScoreSig, setLastScoreSig] = useState('');
      // D18c Part 1: supervisor sniff runs async after the score renders. sniffLoading drives
      // the cycling-phrase indicator; sniffPhraseIdx pins which phrase is currently visible.
      const [sniffLoading, setSniffLoading] = useState(false);
      const [sniffPhraseIdx, setSniffPhraseIdx] = useState(0);
      // D21: market rates (Freddie Mac PMMS 30-yr fixed). null = not loaded yet, [] = loaded but empty.
      const [marketRates, setMarketRates] = useState(null);

      // D21: fetch latest market rates once on mount. Endpoint is edge-cached for 1h
      // and silent on failure — panel hides if no data.
      useEffect(() => {
        let cancelled = false;
        (async () => {
          try {
            const resp = await fetch('https://gameplan-ppg-api.jraaschmidt.workers.dev/market-rates/current');
            if (!resp.ok) return;
            const json = await resp.json();
            if (!cancelled) setMarketRates(Array.isArray(json.rates) ? json.rates : []);
          } catch (err) {
            console.warn('D21 market rates fetch failed:', err);
            if (!cancelled) setMarketRates([]);
          }
        })();
        return () => { cancelled = true; };
      }, []);
      // D13: baseline + exploration mode state
      const [baselineRow, setBaselineRow] = useState(null); // { id, score, scenario_label, scenario_findings_snapshot, ... }
      const [savedScenarios, setSavedScenarios] = useState([]); // array of score_computations rows with is_saved_scenario=true
      const [activeScenarioId, setActiveScenarioId] = useState('baseline'); // 'baseline' | scenario_uuid | 'ephemeral'
      const [saveScenarioOpen, setSaveScenarioOpen] = useState(false);
      const [compareScenariosOpen, setCompareScenariosOpen] = useState(false);
      const [baselineLoaded, setBaselineLoaded] = useState(false); // guards against double-firing sniff test
      // D44 Bug 5: snapshot of the inputs the supervisor sniff was anchored on.
      // When the agent navigates back to Page 1 and edits property fields, we
      // compare the current inputs to this snapshot on Step 4 re-entry. If they
      // differ, we force a fresh sniff so the supervisor narrative stops
      // claiming "Purchase price listed at $0" after the price has been fixed.
      const supervisorInputsFingerprintRef = useRef(null);
      const buildSupervisorInputsFingerprint = () => {
        const purchasePrice = parseInt(String(propertyInfo.listPrice || '').replace(/[^0-9]/g, '')) || 0;
        const ask = findings.filter(f => f.selected).reduce((s, f) => s + (f.cost || 0), 0);
        const dom = parseInt(propertyInfo.daysOnMarket) || 0;
        const findingsCount = findings.filter(f => f.selected).length;
        // D49: include leverageScore so Page 3 slider edits invalidate the supervisor
        // anchor — without this, returning to Step 4 after adjusting leverage sliders
        // would leave the cached narrative anchored to the prior leverage state.
        const lev = (typeof leverageScore === 'number') ? leverageScore : '';
        return `${purchasePrice}|${ask}|${dom}|${findingsCount}|${propertyInfo.zipCode || ''}|${lev}`;
      };
      // D15: industry research state
      const [industryResearch, setIndustryResearch] = useState([]);
      const [researchLoading, setResearchLoading] = useState(false);

      // D15: fetch relevant research on Step 4 entry (after baseline exists)
      useEffect(() => {
        if (currentStep !== 4 || !pendingReportId || !gamePlanScoreState || researchLoading) return;
        if (industryResearch.length > 0) return; // already loaded for this session
        setResearchLoading(true);
        (async () => {
          try {
            const headers = await getAuthHeaders();
            const resp = await fetch(
              `https://gameplan-ppg-api.jraaschmidt.workers.dev/research/relevant?report_id=${pendingReportId}`,
              { headers }
            );
            if (resp.ok) {
              const data = await resp.json();
              setIndustryResearch(Array.isArray(data.research) ? data.research : []);
            }
          } catch (err) {
            console.warn('D15 research fetch failed:', err);
          } finally {
            setResearchLoading(false);
          }
        })();
      }, [currentStep, pendingReportId, gamePlanScoreState]);

      const lookupMarketSegment = async (zipCode, purchasePrice) => {
        const fallback = {
          segment: null,
          segmentName: 'Portland metro',
          expectedConcession: purchasePrice * 0.015,
          segmentStdDev: purchasePrice * 0.008,
          // D32-D: signal fields. Null = no local data, helpers fall back to neutral.
          avgSaleToList: null, inventory: null, monthsOfSupply: null,
          homesSold: null, priceDropsPct: null, dataSource: null, lastUpdated: null
        };
        if (!zipCode || !purchasePrice) return fallback;
        try {
          const { data } = await supabaseClient
            .from('market_segments')
            .select('segment, segment_name, expected_concession_pct, concession_std_dev_pct, avg_sale_to_list, inventory, months_of_supply, homes_sold, price_drops_pct, data_source, last_updated')
            .eq('zip_code', String(zipCode).trim())
            .maybeSingle();
          if (!data) return fallback;
          return {
            segment: data.segment,
            segmentName: data.segment_name,
            expectedConcession: purchasePrice * parseFloat(data.expected_concession_pct),
            segmentStdDev: purchasePrice * parseFloat(data.concession_std_dev_pct),
            // D32-D additions — string→number coercion since PostgREST returns NUMERIC as string
            avgSaleToList: data.avg_sale_to_list != null ? parseFloat(data.avg_sale_to_list) : null,
            inventory: data.inventory != null ? parseInt(data.inventory, 10) : null,
            monthsOfSupply: data.months_of_supply != null ? parseFloat(data.months_of_supply) : null,
            homesSold: data.homes_sold != null ? parseInt(data.homes_sold, 10) : null,
            priceDropsPct: data.price_drops_pct != null ? parseFloat(data.price_drops_pct) : null,
            dataSource: data.data_source || null,
            lastUpdated: data.last_updated || null
          };
        } catch (err) {
          console.warn('market_segments lookup failed:', err);
          return fallback;
        }
      };

      // Snapshot of current selected findings (D13 scenario saves)
      const _buildFindingsSnapshot = () => ({
        findings: findings.map(f => ({
          id: f.id,
          item: f.item,
          selected: !!f.selected,
          cost: f.cost ?? null,
          costSource: f.costSource || null,
          priority: f.priority
        }))
      });

      const computeAndStoreGamePlanScore = async ({
        includeSniff = false,
        triggerSource = 'initial',
        scenarioLabel = null,
        isBaseline = false,
        isSavedScenario = false
      } = {}) => {
        try {
          setScoreComputing(true);
          const purchasePrice = parseInt(String(propertyInfo.listPrice || '').replace(/[^0-9]/g, '')) || 0;
          const ask = findings.filter(f => f.selected).reduce((s, f) => s + (f.cost || 0), 0);
          const dom = parseInt(propertyInfo.daysOnMarket) || null;
          const origPrice = parseInt(String(propertyInfo.originalListPrice || '').replace(/[^0-9]/g, '')) || 0;
          const priceReductions = (origPrice > 0 && purchasePrice > 0 && origPrice > purchasePrice) ? 1 : 0;

          const market = await lookupMarketSegment(propertyInfo.zipCode, purchasePrice);
          // D26: distinguish a real segment hit from the Portland-metro fallback so the
          // weight engine can de-rate Market Realism when we know the data is degraded.
          const marketDataQuality = market.segment ? 'segment_match' : 'fallback';

          // D49: detect when the cached supervisor narrative is stale relative to
          // current inputs. Callers like the slider_adjust debounce pass
          // includeSniff:false to skip the Claude call on every keystroke; but if
          // the new compute is anchored against a different ask/leverage/findings
          // set than the cached sniff, the supervisor card silently goes out of
          // sync with the hero score. When fingerprint has drifted from the
          // anchored value we override and re-fire so the AI Review reflects
          // current state. supervisorInputsFingerprintRef stays null until the
          // first sniff resolves, which means cold reloads of already-completed
          // reports do NOT trigger a refire (cost-conservative).
          const _d49CurrentFingerprint = buildSupervisorInputsFingerprint();
          const _d49SupervisorStale = !!supervisorInputsFingerprintRef.current
            && _d49CurrentFingerprint !== supervisorInputsFingerprintRef.current;
          const effectiveIncludeSniff = includeSniff || _d49SupervisorStale;

          const topSelected = findings.filter(f => f.selected).slice(0, 8);
          const reportSummary = effectiveIncludeSniff && topSelected.length > 0
            ? topSelected.map(f => `[${(f.priority || '').toUpperCase()}] ${f.category || 'General'}: ${f.description || f.title || f.summary || ''}`).join('\n')
            : null;

          // D18c Part 1: pass reportSummary=null into computeGamePlanScore so the inner
          // sniff test never fires. We run the supervisor call ourselves below, async,
          // so the score + gauge can render immediately.
          const dealContextForMath = {
            leverageScore,
            inspectionFindings: findings,
            daysOnMarket: dom,
            priceReductions,
            sellerSignals: {},
            ask,
            purchasePrice,
            segment: market.segment,
            expectedConcession: market.expectedConcession,
            segmentStdDev: market.segmentStdDev,
            marketDataQuality,
            propertyAddress: propertyInfo.address,
            reportSummary: null
          };

          const result = await computeGamePlanScore(dealContextForMath, []);
          result.marketSegment = market.segment;
          result.segmentName = market.segmentName;
          result.expectedConcession = market.expectedConcession;
          result.ask = ask;
          result.purchasePrice = purchasePrice;

          // AI-review hydration fix (2026-05-11): when we're recomputing a
          // saved report's score WITHOUT firing a fresh sniff (includeSniff
          // false, the "baseline already exists" branch in the Step 4 entry
          // effect), read the previously-persisted supervisor review off the
          // reports row and merge it into the result. Without this, the
          // Step 4 hero card permanently shows "ⓘ AI review unavailable"
          // on every reload of a previously-analyzed report, even though
          // the supervisor verdict/summary/concerns are sitting in the DB
          // from the first run. Pure local hydration — no Claude credits
          // spent, no new endpoints, no schema change.
          if (!effectiveIncludeSniff && pendingReportId) {
            try {
              const { data: reportRow } = await supabaseClient
                .from('reports')
                .select('supervisor_verdict, supervisor_summary, supervisor_concerns, supervisor_reasoning, supervisor_suggested_score, supervisor_layer_coherence, sniff_test_concern, sniff_test_reasoning, sniff_test_suggested_score')
                .eq('id', pendingReportId)
                .maybeSingle();
              const verdict = reportRow?.supervisor_verdict;
              if (verdict && ['concurs', 'flag', 'adjust'].includes(verdict)) {
                result.sniffTest = {
                  status: 'ok',
                  verdict,
                  suggestedScore: reportRow.supervisor_suggested_score ?? reportRow.sniff_test_suggested_score ?? null,
                  concern: reportRow.sniff_test_concern ?? null,
                  reasoning: reportRow.supervisor_reasoning ?? reportRow.sniff_test_reasoning ?? null,
                  summary: reportRow.supervisor_summary ?? null,
                  concerns: Array.isArray(reportRow.supervisor_concerns) ? reportRow.supervisor_concerns : [],
                  layer_coherence: reportRow.supervisor_layer_coherence ?? 'aligned'
                };
              }
            } catch (e) {
              console.warn('[AI-review hydration] supervisor fetch failed (non-fatal):', e);
            }
          }

          setGamePlanScoreState(result);

          if (pendingReportId) {
            try {
              await supabaseClient.from('reports').update({
                game_plan_score: result.score,
                score_continuous: result.continuousScore,
                score_probability: result.probability,
                score_components: result.components,
                score_weights: result.weights,
                score_confidence_tier: result.confidence.tier,
                score_ci_lower: result.confidence.ciLower,
                score_ci_upper: result.confidence.ciUpper,
                score_ci_width: result.confidence.ciWidth,
                score_bayesian_alpha: result.bayesian.alpha,
                score_bayesian_beta: result.bayesian.beta,
                score_effective_sample_size: result.bayesian.effectiveSampleSize,
                score_engine_version: 'v1.0',
                score_computed_at: result.timestamp,
                score_market_segment: result.marketSegment
                // D18c Part 1: sniff_test_* / supervisor_* fields persist later, after the
                // async sniff resolves (see the runSniffTest block further down).
              }).eq('id', pendingReportId);
            } catch (e) {
              console.warn('Failed to persist Game Plan Score:', e);
            }

            try {
              // Perf Tier 2: was `await supabaseClient.auth.getUser()` here — redundant
              // round-trip since `user` is already in component scope from the auth init.
              const userId = user?.id;
              if (userId) {
                const insertRow = {
                  report_id: pendingReportId,
                  agent_id: userId,
                  score: result.score,
                  continuous_score: result.continuousScore,
                  probability: result.probability,
                  confidence_tier: result.confidence.tier,
                  ask_amount: ask,
                  engine_version: 'v1.0',
                  trigger_source: triggerSource,
                  scenario_label: scenarioLabel || (isBaseline ? 'Baseline' : null),
                  is_baseline: isBaseline,
                  is_saved_scenario: isSavedScenario,
                  scenario_findings_snapshot: (isBaseline || isSavedScenario) ? _buildFindingsSnapshot() : null
                };
                const { data: inserted } = await supabaseClient
                  .from('score_computations')
                  .insert(insertRow).select().single();
                if (isBaseline && inserted) {
                  setBaselineRow(inserted);
                  setActiveScenarioId('baseline');
                }
                if (isSavedScenario && inserted) {
                  setSavedScenarios(prev => [...prev, inserted]);
                  setActiveScenarioId(inserted.id);
                }
              }
            } catch (e) {
              console.warn('Failed to log score_computations:', e);
            }
          }

          // D18c Part 1: kick off the supervisor sniff test async (does NOT block render).
          // Score and gauge are already on screen. When the sniff returns, merge it into
          // gamePlanScoreState and persist sniff fields. On error or timeout, the existing
          // "AI review unavailable" graceful state takes over.
          // D49: effectiveIncludeSniff includes the staleness override so a
          // slider_adjust compute whose inputs have drifted from the anchored
          // fingerprint refires the sniff automatically.
          if (effectiveIncludeSniff && reportSummary) {
            setSniffLoading(true);
            setSniffPhraseIdx(0);
            const topFindingsForSniff = findings
              .filter(f => !(f && f.selected === false))
              .map(f => ({
                severity: _normalizeSeverity(f) || 'green',
                category: f.category || f.type || '',
                summary: f.summary || f.description || f.title || ''
              }))
              .slice(0, 6);
            (async () => {
              try {
                const sniff = await runSniffTest({
                  // 2026-05-11 consistency fix: send the DISPLAYED probability
                  // (matched to the floored/capped score) so the supervisor
                  // Claude anchors its narrative on the same numbers the agent
                  // sees on the page. Previously sent raw p_deal alongside the
                  // floored mathScore — the disagreement caused Claude to write
                  // summaries like "The 5/10 score..." even when the hero showed
                  // 7/10. Engine math unchanged; this is display-input only.
                  mathScore: result.score,
                  probability: displayedProbabilityFor(result),
                  components: result.components,
                  confidence: result.confidence.tier,
                  dealContext: {
                    propertyAddress: propertyInfo.address,
                    ask,
                    purchasePrice,
                    daysOnMarket: dom,
                    segment: market.segment,
                    topFindings: topFindingsForSniff,
                    reportSummary
                  }
                }, pendingReportId || null);
                setGamePlanScoreState(prev => prev ? { ...prev, sniffTest: sniff } : prev);
                // D44 Bug 5: snapshot the inputs that anchored this sniff so a
                // later Page 1 edit can detect the supervisor narrative is stale.
                supervisorInputsFingerprintRef.current = buildSupervisorInputsFingerprint();
                if (pendingReportId) {
                  try {
                    await supabaseClient.from('reports').update({
                      sniff_test_verdict: sniff?.verdict || 'skipped',
                      sniff_test_suggested_score: sniff?.suggestedScore ?? null,
                      sniff_test_concern: sniff?.concern ?? null,
                      sniff_test_reasoning: sniff?.reasoning ?? null,
                      sniff_test_computed_at: new Date().toISOString(),
                      supervisor_verdict: sniff?.verdict || 'skipped',
                      supervisor_summary: sniff?.summary ?? null,
                      supervisor_suggested_score: sniff?.suggestedScore ?? null,
                      supervisor_concerns: Array.isArray(sniff?.concerns) ? sniff.concerns : null,
                      supervisor_reasoning: sniff?.reasoning ?? null,
                      supervisor_layer_coherence: sniff?.layer_coherence ?? null,
                      supervisor_reviewed_at: new Date().toISOString()
                    }).eq('id', pendingReportId);
                  } catch (e) {
                    console.warn('Failed to persist sniff test fields:', e);
                  }
                }
              } catch (err) {
                console.error('Async sniff test failed:', err);
                setGamePlanScoreState(prev => prev ? { ...prev, sniffTest: { status: 'error', error: err.message } } : prev);
              } finally {
                setSniffLoading(false);
              }
            })();
          }

          return result;
        } finally {
          setScoreComputing(false);
        }
      };

      // D13: On Step 4 entry, check for existing baseline. If present, load it + saved scenarios.
      // If absent (new report), compute + establish baseline (fires sniff test).
      useEffect(() => {
        if (currentStep !== 4 || verdictPhase !== 'complete' || baselineLoaded || scoreComputing) return;
        if (!pendingReportId) return;
        (async () => {
          try {
            const { data: rows } = await supabaseClient
              .from('score_computations')
              .select('*')
              .eq('report_id', pendingReportId)
              .or('is_baseline.eq.true,is_saved_scenario.eq.true')
              .order('computed_at', { ascending: true });
            const baseline = (rows || []).find(r => r.is_baseline);
            const scenarios = (rows || []).filter(r => r.is_saved_scenario);
            setBaselineLoaded(true);
            if (baseline) {
              setBaselineRow(baseline);
              setSavedScenarios(scenarios);
              // D44 Bug 5: if the agent edited Page 1 (or findings) after the
              // supervisor sniff was anchored, the cached narrative is stale.
              // Refire sniff so the prestige page shows current numbers
              // everywhere — not "Purchase price listed at $0" alongside fresh
              // Strategy Insight math. Ref is null on cold reload, which means
              // we still hydrate the cached narrative for already-completed
              // reports (no refire credit cost on idle reopens).
              const currentFingerprint = buildSupervisorInputsFingerprint();
              const supervisorIsDirty = supervisorInputsFingerprintRef.current
                && currentFingerprint !== supervisorInputsFingerprintRef.current;
              if (supervisorIsDirty) {
                computeAndStoreGamePlanScore({
                  includeSniff: true,
                  triggerSource: 'page1_edit_refire'
                });
              } else if (!gamePlanScoreState) {
                computeAndStoreGamePlanScore({ includeSniff: false, triggerSource: 'recompute' });
              }
            } else {
              // First time on Step 4 for this report — establish baseline + fire sniff test
              computeAndStoreGamePlanScore({
                includeSniff: true,
                triggerSource: 'initial',
                scenarioLabel: 'Baseline',
                isBaseline: true
              });
            }
          } catch (err) {
            console.warn('D13 baseline lookup failed:', err);
            setBaselineLoaded(true);
            if (!gamePlanScoreState) {
              computeAndStoreGamePlanScore({ includeSniff: true, triggerSource: 'initial' });
            }
          }
        })();
      }, [currentStep, verdictPhase, pendingReportId, baselineLoaded]);

      // D27 fix: the score-recompute debounce useEffect that references leverageScore
      // in its deps array was originally HERE, but esbuild's strict ESM/IIFE output
      // hits a TDZ violation because leverageScore (a useMemo declared further down)
      // hasn't initialized at hook-call time. Babel-standalone tolerated the reference
      // due to its different transformation semantics; esbuild does not. The effect
      // was relocated to immediately after leverageScore's declaration (search for
      // "D27 fix: relocated score-recompute useEffect" below).

      useEffect(() => {
        if (currentStep === 1) {
          setGamePlanScoreState(null);
          setScoreDetailsOpen(false);
          setLastScoreSig('');
          // D13: reset scenario state
          setBaselineRow(null);
          setSavedScenarios([]);
          setActiveScenarioId('baseline');
          setBaselineLoaded(false);
          // D15: reset research state
          setIndustryResearch([]);
          setResearchLoading(false);
        }
      }, [currentStep, pendingReportId]);

      // D18c Part 1: cycle the supervisor-loading phrases. 3.5s per phrase, hold on the
      // last phrase rather than looping (looping signals "stuck"). Resets when sniff
      // finishes (regardless of success or failure).
      useEffect(() => {
        if (!sniffLoading) {
          setSniffPhraseIdx(0);
          return;
        }
        const t1 = setTimeout(() => setSniffPhraseIdx(1), 3500);
        const t2 = setTimeout(() => setSniffPhraseIdx(2), 7000);
        return () => { clearTimeout(t1); clearTimeout(t2); };
      }, [sniffLoading]);

      // D13: helpers for scenario save + switch
      const saveCurrentAsScenario = async (label) => {
        if (!gamePlanScoreState || !pendingReportId) {
          alert('No current score to save.');
          return;
        }
        const cleanLabel = (label || '').trim().slice(0, 120) || 'Untitled scenario';
        await computeAndStoreGamePlanScore({
          includeSniff: false,
          triggerSource: 'manual',
          scenarioLabel: cleanLabel,
          isSavedScenario: true
        });
        setSaveScenarioOpen(false);
      };

      const _applyFindingsSnapshot = (snapshot) => {
        const snap = snapshot?.findings || [];
        setFindings(prev => prev.map(f => {
          const match = snap.find(s => s.id === f.id);
          if (!match) return { ...f, selected: false }; // findings not in snapshot: deselect
          return {
            ...f,
            selected: !!match.selected,
            cost: match.cost ?? f.cost,
            costSource: match.costSource ?? f.costSource
          };
        }));
      };

      const switchToScenario = (scenarioId) => {
        if (scenarioId === 'baseline') {
          if (baselineRow?.scenario_findings_snapshot) {
            _applyFindingsSnapshot(baselineRow.scenario_findings_snapshot);
          }
          setActiveScenarioId('baseline');
        } else {
          const scn = savedScenarios.find(s => s.id === scenarioId);
          if (scn?.scenario_findings_snapshot) {
            _applyFindingsSnapshot(scn.scenario_findings_snapshot);
          }
          setActiveScenarioId(scenarioId);
        }
        // Signature will drift on next findings update; debounced effect will recompute
        setLastScoreSig('__switched_' + scenarioId);
      };

      // Mark as 'ephemeral' (unsaved exploration) whenever findings diverge from current active scenario
      useEffect(() => {
        if (!baselineRow || activeScenarioId === 'ephemeral') return;
        const activeSnap = activeScenarioId === 'baseline'
          ? baselineRow.scenario_findings_snapshot
          : savedScenarios.find(s => s.id === activeScenarioId)?.scenario_findings_snapshot;
        if (!activeSnap?.findings) return;
        const snapMap = new Map(activeSnap.findings.map(s => [s.id, s]));
        const diverged = findings.some(f => {
          const s = snapMap.get(f.id);
          if (!s) return !!f.selected; // finding not in snap but now selected → diverged
          return (!!f.selected) !== (!!s.selected) || (f.cost ?? null) !== (s.cost ?? null);
        });
        if (diverged) setActiveScenarioId('ephemeral');
      }, [findings, activeScenarioId, baselineRow, savedScenarios]);

      const _gpsTierLabels = {
        10: 'Exceptional position', 9: 'Very strong position', 8: 'Strong position',
        7: 'Solid position', 6: 'Favorable position', 5: 'Balanced position',
        4: 'Contested position', 3: 'Weak position', 2: 'Very weak position', 1: 'Poor position'
      };
      // D47 Task 1: scores 4-6 moved off the amber/orange palette onto muted
      // slate-blue. The math says these are "workable, in-zone" deals — the
      // old amber pattern-matched to a failing-grade interpretation that's
      // both wrong (statistically) and harmful for demo optics. Slate-600 →
      // slate-500 reads as neutral/informational like a credit-score card.
      // Scores 1-3 (alarm-red) and 7+ (bright blue / green) untouched.
      const _gpsTierGradient = (score) => {
        if (score >= 8) return 'linear-gradient(135deg, #059669, #10b981)';
        if (score === 7) return 'linear-gradient(135deg, #2563eb, #3b82f6)';
        if (score >= 4) return 'linear-gradient(135deg, #475569, #64748b)';
        return 'linear-gradient(135deg, #dc2626, #ef4444)';
      };
      // D30: solid tier color for PDF surfaces (badges, gauge labels) where gradients
      // don't render reliably under html2canvas. Mirrors _gpsTierGradient intent.
      const _gpsTierColor = (score) => {
        if (score >= 8) return '#059669';
        if (score === 7) return '#2563eb';
        if (score >= 4) return '#475569';
        return '#dc2626';
      };
      // D30: short tier label for PDF Page 1 hero badge. Distinct from _gpsTierLabels
      // (which is the per-integer label set used in the in-app GPS card hero).
      // Returns 4 buckets matching Strategy Insight headline tiers.
      // ============================================================
      // Hero Number Client Explanation V2 (2026-05-06)
      // Per-integer copy for the client-facing buyer card and the agent-facing
      // tagline. Copy is LOCKED — multi-hour Andrew/Jeff/Lori-informed editorial
      // decisions went into every word. Em-dashes are intentional (—), as are
      // semicolons. Do not paraphrase.
      // System never delivers 1 or 10, so copy covers scores 2-9.
      // ============================================================
      const SCORE_BUYER_COPY = {
        9: "Your offer is in a strong position. The ask aligns with what sellers in similar situations typically accept, and the leverage factors line up in your favor. Because this is a conservative position, there may be room for additional leverage — talk it over with your agent and decide together what your priorities are for this deal. This isn't a guarantee, but you can move forward with confidence in what's currently proposed.",
        8: "Your offer is in a solid position with real leverage on your side. The ask is well-supported by the market, and the seller has reasons to engage with what you're proposing. Like every deal, there are unknowns — but the combination of factors here works in your favor. Your agent will guide the conversation from here.",
        7: "Your offer is in a reasonable position. The ask is in line with what the market generally supports, and while it's not a slam-dunk, the factors here give you a genuine path forward. Sellers in similar situations have accepted asks like this — but every deal has its own dynamics. Your agent will guide the conversation from here.",
        6: "Your offer is leaning toward the aggressive side, but it's not unreasonable. You're asking for more than the typical seller grants in this situation. That's a real choice, not a mistake. Remember why you made an offer on this house in the first place; the goal isn't to 'win' the negotiation, it's to land a deal that works for you. Your agent will guide the conversation from here.",
        5: "Your offer carries some risk. There's a chance the seller pushes back or counter-offers significantly — and that's worth being prepared for. There are reasons behind this strategy, and those reasons matter. Remember why you made an offer on this house in the first place; the goal is to land a deal that works for you, even if it takes some back-and-forth. Your agent will guide the conversation from here.",
        4: "Your offer is in a difficult position. There's a meaningful chance the seller rejects this outright or counter-offers in ways that pull the deal apart. There are reasons behind this strategy, and those reasons matter — but the math here is leaning against you. Think back to what drew you to this house in the first place; the back-and-forth ahead may be tougher than expected, and a deal that works is worth more than a deal that maximizes. Your agent will guide the conversation from here.",
        3: "Your offer is in an unlikely position. The seller will probably push back hard, and the deal could be at risk over what's being asked. There are reasons behind this strategy, and those reasons matter — sometimes a big ask is exactly what the situation calls for. Think back to what drew you to this house in the first place; the road ahead may be tough, and there's a real choice between reshaping the offer or holding firm. Your agent will guide the conversation from here.",
        2: "Your offer is in an anomalous position. What's being asked falls well outside what sellers in this market typically grant, and the data here doesn't support a likely close. There are reasons behind this strategy, and those reasons matter — but the math is clear, and an ask at this level is rare for a reason. Think back to what drew you to this house in the first place, and have a candid conversation with your agent about whether to reshape the offer or hold firm. Your agent will guide the conversation from here."
      };

      // D47 Task 1: reframed 4-6 from alarm/at-risk to neutral/workable. The
      // math says these are in-zone, normal-distribution deals — the copy
      // now reflects that. Scores 1-3 (alarm) and 7+ (favorable) left alone.
      const SCORE_AGENT_TAGLINE = {
        9: { line1: "Strong position.",       line2: "Both sides win when the deal closes." },
        8: { line1: "Solid leverage.",        line2: "Both sides win when the deal closes." },
        7: { line1: "Reasonable ask.",        line2: "Both sides win when the deal closes." },
        6: { line1: "Solid Position.",        line2: "Your ask is well-supported. Likely to close with most items landing as requested." },
        5: { line1: "Workable Position.",     line2: "Standard inspection negotiation zone. The deal is likely to close — final terms shape up in the back-and-forth." },
        4: { line1: "Workable Position.",     line2: "Likely to close, but expect counters. Be ready to trade items or reduce scope to land the deal." },
        3: { line1: "Difficult position.",    line2: "Both sides win when the deal closes." },
        2: { line1: "Unlikely position.",     line2: "Both sides win when the deal closes." }
      };

      const DISCLAIMER_FOOTER = "This information is meant to support conversations with your agent. Negotiation decisions belong with you and your agent based on your specific situation.";

      // PRESERVED-BUT-INACTIVE backup layout option (do not delete). If the
      // hero+tagline layout feels too sparse, this position-label set can be
      // reactivated as a subhead between the integer and the tagline. When
      // activated, the agent tagline's line1 needs rephrasing to avoid duplicating
      // the position word. See directive Backup Layout Option section.
      // eslint-disable-next-line no-unused-vars
      const SCORE_POSITION_LABEL = {
        9: "Strong",
        8: "Solid",
        7: "Reasonable",
        6: "Stretching",
        5: "Risky",
        4: "At Risk",
        3: "Difficult",
        2: "Anomalous"
      };

      // Industry Context box render flag (default OFF until live MLS data is wired).
      // The component + ingestion pipelines (D15/D24) stay in the codebase; this
      // flag only gates the Page 4 render. Flip to true when MLS data flows.
      const SHOW_INDUSTRY_CONTEXT_BOX = false;

      // Leverage Position box render flag (D35-A3, Andrew session 2026-05-06).
      // The verdict logic produced a contradictory read on the 1980 16th St dev
      // case — buyer-favorable concessions in reality, but the bullet rendered
      // "the seller has the stronger hand". Component + leverage calc stay in
      // place; this flag gates the in-app + PDF render until the verdict logic
      // is reworked. Flip to true when the rework lands.
      const SHOW_LEVERAGE_POSITION_BOX = false;

      const _gpsTierBadgeLabel = (score) => {
        if (score >= 8) return 'Strong position';
        if (score >= 5) return 'Solid position';
        if (score >= 3) return 'Mixed signals';
        return 'Challenged position';
      };
      // D30: canonical Strategy Insight derivation. Returns the same string the
      // in-app surface renders, so PDF and screen agree by construction. Pure
      // function of gamePlanScoreState — no DOM dependencies — so it's safe to
      // call from PDF generators.
      const _computeStrategyInsight = (state) => {
        if (!state) return null;
        const ask = state.ask || 0;
        const purchasePrice = state.purchasePrice || 0;
        const score = state.score;
        const tier = state.confidence?.tier || 'moderate';
        const askPctOfValue = purchasePrice > 0 ? (ask / purchasePrice * 100) : null;
        const askStr = `$${Math.round(ask).toLocaleString()}`;
        const pctStr = askPctOfValue !== null ? `${askPctOfValue.toFixed(1)}% of property value` : null;

        let headline;
        if (score >= 8) headline = 'Strong position.';
        else if (score >= 5) headline = 'Solid position with room to negotiate.';
        else if (score >= 3) headline = 'Mixed signals — negotiate carefully.';
        else headline = 'Challenged position — manage client expectations.';

        let body;
        // D35-B1 (Andrew session 2026-05-06): drop the "2–5% typical band"
        // framing — it created internal inconsistency with the per-integer
        // score copy on the Client Explanation tab. Replace with score-band
        // calibration copy that reads naturally alongside the integer score.
        if (ask === 0) {
          body = 'No ask configured yet — add costs on Step 2 to see strategy guidance.';
        } else if (askPctOfValue === null) {
          body = `Your ask of ${askStr} reflects ${state.bayesian?.effectiveSampleSize >= 1 ? 'comparable deal patterns' : 'documented findings'}.`;
        } else if (score >= 8) {
          body = `${askStr} is ${pctStr} — conservative given this ZIP and inspection findings.`;
        } else if (score >= 5) {
          body = `${askStr} is ${pctStr} — calibrated for this ZIP and inspection findings.`;
        } else {
          body = `${askStr} is ${pctStr} — aggressive for this ZIP and inspection findings.`;
        }

        const confidenceTag = tier === 'limited'
          ? ' (limited comparable data — treat as a directional read, not a precise prediction)'
          : '';

        // D31 cap override
        if (state.capWasApplied && askPctOfValue !== null) {
          body = `Score capped at ${score} — your ${askStr} ask is ${pctStr}, which falls outside any defensible negotiation band. Recheck the inputs before sending.`;
        }
        // D33/D45 floor annotation (additive, not override — floor doesn't change the
        // narrative direction, just notes the contractual lift). Copy is neutral
        // between D33 (softball ask) and D45 (pool-justified ask) since both can
        // surface floorWasApplied; D45 specifically avoids naming the pool.
        if (state.floorWasApplied && askPctOfValue !== null) {
          body += ` (Score floored at ${score} — ask within a defensible band.)`;
        }

        return {
          headline,
          body,
          confidenceTag,
          fullText: `${headline} ${body}${confidenceTag}`
        };
      };

      const _gpsComponentLabel = (key, value) => {
        if (value == null) {
          if (key === 'outcomeSimilarity') return 'No historical comparable deals yet';
          return '—';
        }
        const v = value;
        if (key === 'leverage') {
          if (v >= 0.80) return 'Your negotiating position is strong';
          if (v >= 0.60) return 'You have the stronger hand';
          if (v >= 0.40) return 'The leverage is roughly balanced';
          if (v >= 0.20) return 'The seller has the stronger hand';
          return 'Your leverage position is weak';
        }
        if (key === 'marketRealism') {
          if (v >= 0.80) return 'Your ask matches what typically closes in this segment';
          if (v >= 0.60) return 'Your ask is in the typical range for this segment';
          if (v >= 0.40) return 'Your ask is stretching the typical range';
          return 'Your ask is well above what typically closes here';
        }
        if (key === 'askJustification') {
          // D50 (2026-05-12): descriptor thresholds + copy updated to match
          // the new AJ curve. Old copy treated ratio ≈ 1.0 as "aggressive",
          // which was structurally wrong — asking for exactly what the
          // inspection justifies is well-supported, not aggressive. Bands:
          //   ≥ 0.85  conservative   (ratio ≤ 0.40)
          //   ≥ 0.75  reasonable     (ratio 0.40 – 0.70)
          //   ≥ 0.55  tight match    (ratio 0.70 – 1.05) — was "aggressive"
          //   ≥ 0.35  slight stretch (ratio 1.05 – 1.30)
          //   ≥ 0.20  notable stretch(ratio 1.30 – 1.75)
          //   below   overreach
          // Copy still avoids the pool dollar figure (D39 liability surface).
          if (v >= 0.85) return 'Conservative — ask is well below what the inspection justifies';
          if (v >= 0.75) return 'Reasonable — ask is well within what the inspection justifies';
          if (v >= 0.55) return 'Well-supported — ask matches the documented findings';
          if (v >= 0.35) return 'Slight stretch — ask is modestly above what the inspection justifies';
          if (v >= 0.20) return 'Notable stretch — ask materially exceeds the inspection ceiling';
          return 'Overreaching — ask substantially exceeds what the inspection justifies';
        }
        if (key === 'outcomeSimilarity') {
          if (v >= 0.70) return 'Similar deals have mostly closed';
          if (v >= 0.50) return 'Similar deals show mixed outcomes';
          if (v >= 0.30) return 'Similar deals have often fallen through';
          return 'Similar deals rarely closed at comparable terms';
        }
        return '';
      };

      // ============================================================
      // CLIENT PRICING — D11a (agent UI for upload/request + handlers)
      // ============================================================
      const [clientPricingModal, setClientPricingModal] = useState(null); // { type: 'upload'|'request', findingId }
      // D22: tracks the per-finding inline manual-dev cost input. Object keyed by findingId
      // -> typed string. Presence of a key means the inline input is open for that finding.
      const [manualDevInputs, setManualDevInputs] = useState({});
      const [clientPricingBusy, setClientPricingBusy] = useState(false);

      // D39: contractor quote upload sub-state. Drives which view the upload
      // modal renders: drop zone (idle), spinner (extracting), confirmation
      // (confirm — single | line_items | multi_option | unclear), override
      // form (override), or post-multi-option waiting state.
      const [quoteUploadState, setQuoteUploadState] = useState({
        step: 'idle',
        file: null,
        filename: null,
        extraction: null,
        error: null
      });
      // D39: reset upload sub-state every time the upload modal opens, so
      // a stale extraction from a prior open doesn't leak into a fresh
      // attempt for a different finding.
      // D40 Task 2: 'override-existing' opens the modal directly to the
      // override step — no PDF, no extraction, just reasons + amount.
      useEffect(() => {
        if (clientPricingModal?.type === 'upload') {
          setQuoteUploadState({ step: 'idle', file: null, filename: null, extraction: null, error: null });
        } else if (clientPricingModal?.type === 'override-existing') {
          setQuoteUploadState({ step: 'override', file: null, filename: null, extraction: null, error: null });
        }
      }, [clientPricingModal]);

      // D40 Task 1: Pending Inputs Gate (PIG) state. The gate is a hard
      // interstitial between Step 3 → Step 4. When the agent clicks
      // "Generate Strategy" we check both async input tables (buyer
      // subjective responses + client pricing requests) for outstanding
      // dispatches. If anything is still awaiting a reply, the gate
      // renders and blocks advancement until either (a) all outstanding
      // items resolve, or (b) the agent uses the DEV bypass. Once
      // reports.inputs_complete_at is set for a given report, the gate
      // never re-renders for that report — locked decision per directive.
      const [pigState, setPigState] = useState({
        showing: false,
        loading: false,
        pendingBuyer: [],          // [{ id, question_key, sms_sent_at, last_reminder_at, created_at, status }]
        pendingClient: [],         // [{ id, finding_id, finding_snapshot, client_name, client_phone, created_at, last_reminder_at }]
        reminderCooldownUntil: null,
        bypassing: false
      });

      // D40 Task 1: reset PIG state on report change. Without this, a
      // gate left open mid-dashboard-jump could leak into the next
      // report's Step 3 view.
      useEffect(() => {
        setPigState({
          showing: false, loading: false, pendingBuyer: [], pendingClient: [],
          reminderCooldownUntil: null, bypassing: false
        });
      }, [pendingReportId]);

      // D37-A: controlled state for the "Request price from client" modal so we can
      // detect when the agent overrides the phone number off the Page 1 attested
      // value (and require a fresh consent attestation before Send Request enables).
      // overrideConsent is the second checkbox; only relevant when isOverride below.
      const [modalRequestForm, setModalRequestForm] = useState({
        clientName: '',
        clientPhone: '',
        deliveryMode: 'sms_conversation',
        overrideConsent: false
      });
      // Reset modal form whenever the request modal opens (so old values from a
      // prior open don't leak into a fresh request for a different finding).
      useEffect(() => {
        if (clientPricingModal?.type === 'request') {
          setModalRequestForm({
            clientName: propertyInfo.clientName || '',
            clientPhone: propertyInfo.clientPhone || '',
            deliveryMode: computeHybridDeliveryMode(null),
            overrideConsent: false
          });
        }
      }, [clientPricingModal]);

      // D12 follow-up: quota limit modal state. Listens for the `ppg-quota-hit` CustomEvent
      // dispatched by Claude fetch sites when Worker returns 429.
      const [quotaLimitInfo, setQuotaLimitInfo] = useState(null);
      useEffect(() => {
        const handler = (e) => setQuotaLimitInfo(e.detail || {});
        if (typeof window !== 'undefined') {
          window.addEventListener('ppg-quota-hit', handler);
          return () => window.removeEventListener('ppg-quota-hit', handler);
        }
      }, []);
      // Imperative overlay so the modal floats over any step of the app without threading
      // JSX through every render branch.
      useEffect(() => {
        if (!quotaLimitInfo) return;
        const daily = quotaLimitInfo.daily || {};
        const monthly = quotaLimitInfo.monthly || {};
        const safeMessage = (quotaLimitInfo.message || "You've reached your daily analysis limit. Try again tomorrow or contact jared@gambitlab.org.").replace(/[<>]/g, '');
        const overlay = document.createElement('div');
        overlay.setAttribute('role', 'dialog');
        overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.7);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;';
        const card = document.createElement('div');
        card.style.cssText = 'background:#1c1917;border:1px solid rgba(255,255,255,0.1);border-radius:16px;padding:24px;max-width:480px;width:100%;color:white;font-family:Inter,sans-serif;';
        const h = document.createElement('h2');
        h.textContent = 'Daily limit reached';
        h.style.cssText = 'font-size:20px;font-weight:500;margin:0 0 8px;';
        const p = document.createElement('p');
        p.textContent = safeMessage;
        p.style.cssText = 'color:#94a3b8;line-height:1.6;margin:0 0 16px;';
        const meta = document.createElement('p');
        meta.textContent = `Daily: ${daily.used ?? '?'}/${daily.limit ?? '?'} · Monthly: ${monthly.used ?? '?'}/${monthly.limit ?? '?'}`;
        meta.style.cssText = 'color:#6b7280;font-size:13px;margin:0 0 24px;';
        const actions = document.createElement('div');
        actions.style.cssText = 'text-align:right;';
        const btn = document.createElement('button');
        btn.textContent = 'Okay';
        btn.style.cssText = 'padding:10px 20px;background:#7b8bff;color:white;border:none;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;';
        const close = () => { setQuotaLimitInfo(null); };
        btn.addEventListener('click', close);
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
        actions.appendChild(btn);
        card.appendChild(h);
        card.appendChild(p);
        card.appendChild(meta);
        card.appendChild(actions);
        overlay.appendChild(card);
        document.body.appendChild(overlay);
        return () => { overlay.remove(); };
      }, [quotaLimitInfo]);

      // Hybrid mode helper — counts existing pending requests to this client on this report
      const computeHybridDeliveryMode = (clientPhone) => {
        if (!clientPhone) return 'sms_conversation';
        const otherPending = findings.filter(f => f.pendingRequest?.clientPhone === clientPhone).length;
        const totalWithThis = otherPending + 1;
        return totalWithThis >= 4 ? 'magic_link' : 'sms_conversation';
      };

      // D39: shared persist step — uploads PDF to storage, INSERTs the
      // contractor_quotes row (with the LLM extraction_response if available),
      // and returns { quoteRow, signedUrl } so the caller can decide how to
      // update finding state (single-confirm, override, multi-option dispatch,
      // unclear-with-manual-entry — all flow through this).
      const persistContractorQuotePdf = async ({ findingId, file, totalAmount, extractionResponse, notes }) => {
        const { data: { user } } = await supabaseClient.auth.getUser();
        if (!user) throw new Error('Not signed in');
        const ts = Date.now();
        const ext = (file.name.split('.').pop() || 'bin').toLowerCase();
        const storagePath = `${user.id}/${pendingReportId || 'unsaved'}/${findingId}-${ts}.${ext}`;
        const { error: uploadErr } = await supabaseClient.storage
          .from('contractor-quotes').upload(storagePath, file, { contentType: file.type });
        if (uploadErr) throw uploadErr;
        const { data: signed } = await supabaseClient.storage
          .from('contractor-quotes').createSignedUrl(storagePath, 60 * 60 * 24 * 365);
        const signedUrl = signed?.signedUrl || null;
        const insertPayload = {
          report_id: pendingReportId,
          finding_id: String(findingId),
          uploaded_by: user.id,
          quote_pdf_url: storagePath,
          original_filename: file.name,
          mime_type: file.type,
          total_amount: typeof totalAmount === 'number' ? totalAmount : parseInt(totalAmount),
          notes: notes || null,
          extraction_response: extractionResponse || null,
          quote_date: extractionResponse?.quote_date || null
        };
        const { data: quoteRow, error: quoteErr } = await supabaseClient
          .from('contractor_quotes').insert(insertPayload).select().single();
        if (quoteErr) throw quoteErr;
        return { quoteRow, signedUrl, agentId: user.id };
      };

      // D39: drop-zone entry point. Extracts text from the PDF client-side via
      // PDF.js, then POSTs to the Worker /extract-contractor-quote endpoint.
      // The Worker returns a structured shape: single | line_items |
      // multi_option | unclear. State transitions to 'confirm' so the modal
      // body switches to the extraction-result UI.
      const handleQuoteFileSelected = async (findingId, file) => {
        if (!file) return;
        setQuoteUploadState({ step: 'extracting', file, filename: file.name, extraction: null, error: null });
        try {
          let extractedText = '';
          if ((file.type || '').includes('pdf')) {
            extractedText = await extractTextFromQuotePdf(file);
          }
          if (!extractedText || extractedText.length < 10) {
            setQuoteUploadState({
              step: 'confirm', file, filename: file.name, error: null,
              extraction: { type: 'unclear', reason: 'Could not read text from this file. Please enter the amount manually.', confidence: 'low' }
            });
            return;
          }
          const findingLabel = findings.find(f => f.id === findingId)?.item || '';
          const session = (await supabaseClient.auth.getSession()).data.session;
          const token = session?.access_token;
          const resp = await fetch(`${WORKER_BASE_URL}/extract-contractor-quote`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            },
            body: JSON.stringify({ extracted_text: extractedText, finding_label: findingLabel })
          });
          if (!resp.ok) {
            const body = await resp.text();
            throw new Error(`Extraction service ${resp.status}: ${body.slice(0, 200)}`);
          }
          const extraction = await resp.json();
          setQuoteUploadState({ step: 'confirm', file, filename: file.name, extraction, error: null });
        } catch (err) {
          console.error('[D39] handleQuoteFileSelected error:', err);
          setQuoteUploadState({
            step: 'confirm', file, filename: file.name, error: null,
            extraction: { type: 'unclear', reason: 'Extraction failed. Please enter the amount manually.', confidence: 'low' }
          });
        }
      };

      // D39: agent confirmed the LLM-extracted single (or line_items total)
      // amount. Persists the quote, populates the finding, closes the modal.
      const handleQuoteSingleConfirm = async (findingId) => {
        const { file, extraction } = quoteUploadState;
        if (!file || !extraction) return;
        const amount = extraction.type === 'single' ? extraction.amount : extraction.total;
        if (typeof amount !== 'number' || !Number.isFinite(amount)) {
          alert('No usable amount in extraction. Use override.');
          return;
        }
        setClientPricingBusy(true);
        try {
          const { quoteRow, signedUrl } = await persistContractorQuotePdf({
            findingId, file, totalAmount: amount, extractionResponse: extraction
          });
          if (isQuoteStale(extraction.quote_date, quoteRow.created_at)) {
            console.warn('[D39] Stale quote (>60d): quote_date=%s uploaded=%s quoteId=%s',
              extraction.quote_date, quoteRow.created_at, quoteRow.id);
          }
          setFindings(prev => prev.map(f => f.id === findingId ? {
            ...f,
            cost: amount,
            costSource: 'contractor',
            costSourceUrl: signedUrl,
            costSourceQuoteId: quoteRow.id,
            costSourceQuoteDate: extraction.quote_date || null,
            costSourceSetAt: new Date().toISOString(),
            pendingRequest: null
          } : f));
          setClientPricingModal(null);
          setQuoteUploadState({ step: 'idle', file: null, filename: null, extraction: null, error: null });
        } catch (err) {
          console.error('[D39] handleQuoteSingleConfirm failed:', err);
          alert('Save failed: ' + (err.message || 'unknown error'));
        } finally {
          setClientPricingBusy(false);
        }
      };

      // D39: escape hatch submit. Persists quote + writes a contractor_quote_overrides
      // audit row + populates the finding with the agent's amount. Override
      // metadata is internal-only — no part of it surfaces in customer-facing copy.
      const handleQuoteOverride = async (findingId, overrideAmount, overrideReason, overrideReasonText) => {
        const { file, extraction } = quoteUploadState;
        if (!file) return;
        const llmAmount = (() => {
          if (!extraction) return null;
          if (extraction.type === 'single') return extraction.amount ?? null;
          if (extraction.type === 'line_items') return extraction.total ?? null;
          return null;
        })();
        setClientPricingBusy(true);
        try {
          const { quoteRow, signedUrl, agentId } = await persistContractorQuotePdf({
            findingId, file, totalAmount: overrideAmount, extractionResponse: extraction || null
          });
          const { error: ovErr } = await supabaseClient.from('contractor_quote_overrides').insert({
            contractor_quote_id: quoteRow.id,
            agent_id: agentId,
            llm_extracted_amount: llmAmount,
            agent_override_amount: overrideAmount,
            override_reason: overrideReason,
            override_reason_other_text: overrideReason === 'other' ? (overrideReasonText || null) : null
          });
          if (ovErr) console.warn('[D39] override audit row INSERT failed (non-fatal):', ovErr);
          setFindings(prev => prev.map(f => f.id === findingId ? {
            ...f,
            cost: overrideAmount,
            costSource: 'contractor',
            costSourceUrl: signedUrl,
            costSourceQuoteId: quoteRow.id,
            costSourceQuoteDate: extraction?.quote_date || null,
            costSourceSetAt: new Date().toISOString(),
            pendingRequest: null
          } : f));
          setClientPricingModal(null);
          setQuoteUploadState({ step: 'idle', file: null, filename: null, extraction: null, error: null });
        } catch (err) {
          console.error('[D39] handleQuoteOverride failed:', err);
          alert('Override failed: ' + (err.message || 'unknown error'));
        } finally {
          setClientPricingBusy(false);
        }
      };

      // D40 Task 2: standalone override on an already-populated cost.
      // No file, no extraction, no costSource change — just write an
      // override row (with contractor_quote_id pointing to the existing
      // quote if there is one, NULL if the existing cost came from a
      // client text or pre-D39 manual entry) and update finding.cost.
      const handleStandaloneOverride = async (findingId, overrideAmount, overrideReason, overrideReasonText) => {
        setClientPricingBusy(true);
        try {
          const { data: { user: u } } = await supabaseClient.auth.getUser();
          if (!u) throw new Error('Not signed in');
          const finding = findings.find(f => f.id === findingId);
          const previousAmount = (finding && typeof finding.cost === 'number') ? finding.cost : null;
          const existingQuoteId = finding?.costSourceQuoteId || null;
          const { error: ovErr } = await supabaseClient.from('contractor_quote_overrides').insert({
            contractor_quote_id: existingQuoteId,
            agent_id: u.id,
            llm_extracted_amount: previousAmount,
            agent_override_amount: overrideAmount,
            override_reason: overrideReason,
            override_reason_other_text: overrideReason === 'other' ? (overrideReasonText || null) : null
          });
          if (ovErr) console.warn('[D40] standalone override INSERT failed (non-fatal):', ovErr);
          setFindings(prev => prev.map(f => f.id === findingId ? {
            ...f,
            cost: overrideAmount,
            costSourceSetAt: new Date().toISOString()
          } : f));
          setClientPricingModal(null);
          setQuoteUploadState({ step: 'idle', file: null, filename: null, extraction: null, error: null });
        } catch (err) {
          console.error('[D40] handleStandaloneOverride failed:', err);
          alert('Override failed: ' + (err.message || 'unknown error'));
        } finally {
          setClientPricingBusy(false);
        }
      };

      // D46 Task 5: Override-to-client text dispatch. Replaces the D39 manual
      // amount entry as the PRIMARY path when an agent flags a contractor
      // quote as wrong. The agent identifies *that* the system got it wrong
      // and *why*; the buyer provides the corrected number via SMS reply.
      //
      // Two entry paths:
      //   (a) Fresh upload → agent clicked "This number is wrong" on the
      //       confirm screen. quoteUploadState.file is set. We persist the
      //       PDF first, then dispatch.
      //   (b) Standalone override → finding already has costSourceQuoteId
      //       from a prior upload. We reuse that quote row.
      //
      // SMS dispatch is stub-mode (writes the client_pricing_requests row,
      // doesn't actually text). Pool/score effects: finding gets
      // pendingRequest set; cost stays null; D44 Task 4 cost gate sees the
      // pendingRequest as satisfying the value-path requirement. D40
      // Pending Inputs Gate sees this as a pending input and blocks Step 4
      // until the buyer responds (which, until Twilio is live, requires a
      // dev-side response simulation — out of scope for this directive).
      const handleQuoteOverrideDispatch = async (findingId, overrideReason, overrideReasonText, viewToken, isStandalone) => {
        const e164 = normalizePhoneE164(propertyInfo.clientPhone);
        if (!e164) {
          alert('No valid client phone on file. Return to Page 1 to add one.');
          return;
        }
        const att = await verifyBuyerDispatchAttestation(e164);
        if (!att.ok) {
          alert(`Cannot send: ${att.reason}`);
          return;
        }
        setClientPricingBusy(true);
        try {
          const finding = findings.find(f => f.id === findingId);
          if (!finding) throw new Error('Finding not found');
          let quoteId = null;
          let signedUrlForFinding = null;
          let llmExtractedForAudit = null;
          if (isStandalone) {
            // (b) Standalone path. Existing quote row required (the directive
            // explicitly says this flow is for contractor-priced items —
            // override on a client-text-sourced cost falls back to the verbal
            // escape valve).
            quoteId = finding.costSourceQuoteId || null;
            signedUrlForFinding = finding.costSourceUrl || null;
            llmExtractedForAudit = typeof finding.cost === 'number' ? finding.cost : null;
            if (!quoteId) {
              alert('Cannot send a price-correction text for an item without a contractor quote on file. Use "Client provided number verbally" instead, or upload a quote first.');
              setClientPricingBusy(false);
              return;
            }
          } else {
            // (a) Fresh upload path. Persist the PDF first, then proceed.
            const { file, extraction } = quoteUploadState;
            if (!file) throw new Error('No file to dispatch.');
            const llm = extraction?.type === 'single' ? extraction.amount
                      : extraction?.type === 'line_items' ? extraction.total
                      : null;
            llmExtractedForAudit = typeof llm === 'number' ? llm : null;
            const { quoteRow, signedUrl } = await persistContractorQuotePdf({
              findingId, file, totalAmount: 0, extractionResponse: extraction || null
            });
            quoteId = quoteRow.id;
            signedUrlForFinding = signedUrl;
          }
          // Stamp the view token + 7-day expiry onto the quote row. Same
          // token survives across dispatch retries; resending the text reuses
          // the existing link rather than churning storage signed URLs.
          const expiresAt = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString();
          const { error: tokErr } = await supabaseClient
            .from('contractor_quotes')
            .update({
              view_token: viewToken,
              view_token_issued_at: new Date().toISOString(),
              view_token_expires_at: expiresAt
            })
            .eq('id', quoteId);
          if (tokErr) console.warn('[D46] view_token update failed (non-fatal):', tokErr);

          // Audit row: agent_override_amount NULL because the buyer will
          // supply the corrected figure later. Reason + LLM-extracted amount
          // captured now so the audit trail is intact even if the buyer
          // never responds.
          const { error: ovErr } = await supabaseClient.from('contractor_quote_overrides').insert({
            contractor_quote_id: quoteId,
            agent_id: user.id,
            llm_extracted_amount: llmExtractedForAudit,
            agent_override_amount: null,
            override_reason: overrideReason,
            override_reason_other_text: overrideReason === 'other' ? (overrideReasonText || null) : null
          });
          if (ovErr) console.warn('[D46] override audit row INSERT failed (non-fatal):', ovErr);

          // Dispatch row. Stub mode until Twilio Campaign approval; the row
          // is the durable audit + state, and a buyer-response handler (out
          // of scope this directive) will read it when reply SMS lands.
          const dispatchPayload = {
            report_id: pendingReportId,
            finding_id: String(findingId),
            client_name: propertyInfo.clientName || null,
            client_phone: e164,
            delivery_mode: 'sms_conversation',
            request_kind: 'override_review',
            request_payload: {
              quote_id: quoteId,
              view_token: viewToken,
              view_token_expires_at: expiresAt,
              override_reason: overrideReason,
              override_reason_other_text: overrideReason === 'other' ? (overrideReasonText || null) : null,
              dispatch_mode: SMS_DISPATCH_MODE
            }
          };
          const { error: reqErr } = await supabaseClient.from('client_pricing_requests').insert(dispatchPayload);
          if (reqErr) console.warn('[D46] override_review dispatch row INSERT failed (non-fatal):', reqErr);
          if (SMS_DISPATCH_MODE !== 'live') {
            console.log('[D46] SMS_DISPATCH_MODE=%s — would have texted %s with override-review link for quote %s (token %s)',
              SMS_DISPATCH_MODE, e164, quoteId, viewToken);
          }

          // Flip the finding into "awaiting client response" state. cost +
          // costSource cleared so the cost gate (D44 Task 4) and Pending
          // Inputs Gate (D40) both see this as a pending input until the
          // buyer responds with a corrected amount.
          setFindings(prev => prev.map(f => f.id === findingId ? {
            ...f,
            cost: null,
            costSource: null,
            costSourceUrl: signedUrlForFinding,
            costSourceQuoteId: quoteId,
            costSourceSetAt: null,
            pendingRequest: {
              clientName: propertyInfo.clientName,
              clientPhone: e164,
              kind: 'override_review',
              quoteId,
              sentAt: new Date().toISOString()
            }
          } : f));
          setClientPricingModal(null);
          setQuoteUploadState({ step: 'idle', file: null, filename: null, extraction: null, error: null });
        } catch (err) {
          console.error('[D46] handleQuoteOverrideDispatch failed:', err);
          alert('Send failed: ' + (err.message || 'unknown error'));
        } finally {
          setClientPricingBusy(false);
        }
      };

      // D39: multi-option dispatch. Stub-mode — writes quote + a
      // client_pricing_requests row (multi_option payload), but does not
      // actually send SMS (Twilio TCR pending). When SMS_DISPATCH_MODE flips
      // to 'live', the same call site triggers real Twilio dispatch via D11b.
      const handleQuoteMultiOptionDispatch = async (findingId, clientName, clientPhone) => {
        const { file, extraction } = quoteUploadState;
        if (!file || !extraction || extraction.type !== 'multi_option') return;
        const e164 = normalizePhoneE164(clientPhone);
        if (!e164) {
          alert('Enter a valid 10-digit US phone number for the client.');
          return;
        }
        // D40 Task 3: attestation guard before multi-option dispatch.
        const att = await verifyBuyerDispatchAttestation(e164);
        if (!att.ok) {
          console.warn(`[D39] multi-option dispatch refused — no attestation row for phone ${e164}: ${att.reason}`);
          alert(`Cannot send: ${att.reason}`);
          return;
        }
        setClientPricingBusy(true);
        try {
          const { quoteRow } = await persistContractorQuotePdf({
            findingId, file, totalAmount: 0, extractionResponse: extraction
          });
          const dispatchPayload = {
            report_id: pendingReportId,
            finding_id: String(findingId),
            client_name: clientName || null,
            client_phone: e164,
            delivery_mode: 'sms_conversation',
            request_kind: 'multi_option',
            request_payload: {
              quote_id: quoteRow.id,
              options: extraction.options || [],
              dispatch_mode: SMS_DISPATCH_MODE
            }
          };
          const { error: reqErr } = await supabaseClient.from('client_pricing_requests').insert(dispatchPayload);
          if (reqErr) console.warn('[D39] multi-option dispatch row INSERT failed (non-fatal):', reqErr);
          if (SMS_DISPATCH_MODE !== 'live') {
            console.log('[D39] SMS_DISPATCH_MODE=%s — would have texted %s with %d options for quote %s',
              SMS_DISPATCH_MODE, e164, (extraction.options || []).length, quoteRow.id);
          }
          setFindings(prev => prev.map(f => f.id === findingId ? {
            ...f,
            costSourceQuoteId: quoteRow.id,
            costSourceQuoteDate: extraction.quote_date || null,
            pendingRequest: { clientName, clientPhone: e164, kind: 'multi_option', sentAt: new Date().toISOString() }
          } : f));
          setQuoteUploadState({ step: 'awaiting_client', file: null, filename: null, extraction: null, error: null });
          setClientPricingModal(null);
        } catch (err) {
          console.error('[D39] handleQuoteMultiOptionDispatch failed:', err);
          alert('Send failed: ' + (err.message || 'unknown error'));
        } finally {
          setClientPricingBusy(false);
        }
      };

      // D40 Task 3: SMS attestation guard. Before any buyer-bound dispatch,
      // require a matching sms_consent_attestations row from a buyer-side
      // source (page1 or page2_override) with phone_number === e164. If no
      // matching row exists, refuse the dispatch and log it. This ensures
      // when D11b flips dispatch to live, we cannot accidentally text a
      // number that never received a recorded consent attestation.
      //
      // Returns { ok: true } or { ok: false, reason: string }.
      const verifyBuyerDispatchAttestation = async (e164) => {
        if (!e164) return { ok: false, reason: 'No phone number provided.' };
        try {
          const { data, error } = await supabaseClient
            .from('sms_consent_attestations')
            .select('id, source')
            .eq('phone_number', e164)
            .in('source', ['page1', 'page2_override'])
            .limit(1);
          if (error) {
            // Fail-closed on query error: refuse dispatch rather than
            // silently dispatching without a verified attestation.
            console.warn('[D40] verifyBuyerDispatchAttestation query failed:', error);
            return { ok: false, reason: 'Could not verify consent attestation. Try again or sign out and back in.' };
          }
          if (!data || data.length === 0) {
            return { ok: false, reason: 'No SMS consent attestation on file for this number.' };
          }
          return { ok: true };
        } catch (err) {
          console.warn('[D40] verifyBuyerDispatchAttestation threw:', err);
          return { ok: false, reason: 'Consent attestation verification failed.' };
        }
      };

      const handleRequestFromClient = async (findingId, clientName, clientPhone, deliveryMode) => {
        setClientPricingBusy(true);
        try {
          const { data: { user } } = await supabaseClient.auth.getUser();
          if (!user) throw new Error('Not signed in');
          // Phone E.164 normalization (very light)
          const normalizedPhone = clientPhone.replace(/[^\d+]/g, '');
          const e164 = normalizedPhone.startsWith('+') ? normalizedPhone : `+1${normalizedPhone.replace(/^1/, '')}`;
          // Opt-out block
          const { data: optOut } = await supabaseClient
            .from('sms_opt_outs').select('phone_number').eq('phone_number', e164).maybeSingle();
          if (optOut) throw new Error('This number has opted out of SMS. Choose a different contact method.');
          // D40 Task 3: attestation guard — refuse dispatch without recorded consent.
          const att = await verifyBuyerDispatchAttestation(e164);
          if (!att.ok) {
            console.warn(`[D11a] Dispatch refused — no attestation row for phone ${e164}: ${att.reason}`);
            throw new Error(`Cannot send: ${att.reason}`);
          }
          const finding = findings.find(f => f.id === findingId);
          const snapshot = {
            item: finding?.item,
            description: finding?.description,
            category: finding?.category,
            priority: finding?.priority,
            reasoning: finding?.reasoning,
            propertyAddress: propertyInfo.address,
            zip: propertyInfo.zipCode
          };
          const { data: reqRow, error: reqErr } = await supabaseClient
            .from('client_pricing_requests')
            .insert({
              report_id: pendingReportId,
              finding_id: String(findingId),
              agent_id: user.id,
              delivery_mode: deliveryMode || 'sms_conversation',
              client_phone: e164,
              client_name: clientName,
              finding_snapshot: snapshot,
              conversation_state: 'awaiting_reply',
              delivery_status: 'queued'
            })
            .select().single();
          if (reqErr) throw reqErr;
          // D11a: stub — no real SMS send until D11b wires Twilio
          console.log(`[D11a stub] Would send ${deliveryMode} to ${e164}:`, snapshot);
          setFindings(prev => prev.map(f => f.id === findingId ? {
            ...f,
            pendingRequest: {
              id: reqRow?.id,
              clientName,
              clientPhone: e164,
              deliveryMode: deliveryMode || 'sms_conversation',
              sentAt: new Date().toISOString()
            }
          } : f));
          setClientPricingModal(null);
        } catch (err) {
          console.error('Request from client failed:', err);
          alert('Request failed: ' + (err.message || 'unknown error'));
        } finally {
          setClientPricingBusy(false);
        }
      };

      // D22: dev-only manual cost entry. Sets costSource='manual_dev' so the TEST DATA
      // banner triggers downstream. Gated upstream by isDevCostEntryEnabled(user).
      // 2026-07-28: user-entered cost estimate. costSource 'manual_user' is a first-class
      // real cost — counts as priced in the Step 2→3 gate (filter(f => f.costSource)) and,
      // unlike 'manual_dev', does NOT trigger the TEST DATA banner (which keys on 'manual_dev').
      const handleManualDevEntry = (findingId, amount) => {
        const num = parseInt(String(amount).replace(/[^0-9]/g, ''));
        if (!num || num < 1) return;
        setFindings(prev => prev.map(f => f.id === findingId ? {
          ...f,
          cost: num,
          costSource: 'manual_user',
          costSourceUrl: null,
          costSourceQuoteId: null,
          costSourceRequestId: null,
          costSourceClientName: null,
          costSourceSetAt: new Date().toISOString(),
          pendingRequest: null
        } : f));
      };

      const handleLooksWrong = async (finding) => {
        if (!window.confirm('Flag this price as wrong and start over? The audit trail will be preserved.')) return;
        try {
          if (finding.costSourceRequestId) {
            await supabaseClient.from('client_pricing_requests')
              .update({ flagged_by_agent: true, flagged_reason: 'Agent flagged via "Looks wrong"' })
              .eq('id', finding.costSourceRequestId);
          }
        } catch (err) { console.warn('Flag write failed:', err); }
        setFindings(prev => prev.map(f => f.id === finding.id ? {
          ...f,
          cost: null,
          costSource: null,
          costSourceUrl: null,
          costSourceQuoteId: null,
          costSourceRequestId: null,
          costSourceClientName: null,
          costSourceSetAt: null,
          pendingRequest: null
        } : f));
      };

      const handleResendRequest = async (finding) => {
        if (!finding.pendingRequest) return;
        const { clientName, clientPhone, deliveryMode, id: oldId } = finding.pendingRequest;
        setClientPricingBusy(true);
        try {
          const { data: { user } } = await supabaseClient.auth.getUser();
          const snapshot = {
            item: finding.item, description: finding.description, category: finding.category,
            priority: finding.priority, reasoning: finding.reasoning,
            propertyAddress: propertyInfo.address, zip: propertyInfo.zipCode
          };
          const { data: newReq, error } = await supabaseClient
            .from('client_pricing_requests')
            .insert({
              report_id: pendingReportId, finding_id: String(finding.id),
              agent_id: user.id, delivery_mode: deliveryMode,
              client_phone: clientPhone, client_name: clientName,
              finding_snapshot: snapshot, conversation_state: 'awaiting_reply', delivery_status: 'queued'
            }).select().single();
          if (error) throw error;
          if (oldId) {
            await supabaseClient.from('client_pricing_requests')
              .update({ superseded_by: newReq.id, conversation_state: 'closed' }).eq('id', oldId);
          }
          setFindings(prev => prev.map(f => f.id === finding.id ? {
            ...f,
            pendingRequest: { id: newReq.id, clientName, clientPhone, deliveryMode, sentAt: new Date().toISOString() }
          } : f));
        } catch (err) {
          console.error('Resend failed:', err);
          alert('Resend failed: ' + (err.message || 'unknown error'));
        } finally {
          setClientPricingBusy(false);
        }
      };

      const handleCancelRequest = async (finding) => {
        if (!finding.pendingRequest) return;
        if (!window.confirm('Cancel this request? The client will stop receiving messages for this item.')) return;
        try {
          if (finding.pendingRequest.id) {
            await supabaseClient.from('client_pricing_requests')
              .update({ conversation_state: 'closed' }).eq('id', finding.pendingRequest.id);
          }
        } catch (err) { console.warn('Cancel write failed:', err); }
        setFindings(prev => prev.map(f => f.id === finding.id ? { ...f, pendingRequest: null } : f));
      };

      // ============================================================
      // D40 Task 1: Pending Inputs Gate (PIG) helpers
      // ============================================================

      // Reads both async input tables and returns whatever is still
      // awaiting a reply. Buyer subjective rows are pending when status
      // is literally 'pending' (received / dev_override / declined are
      // all terminal). Client pricing rows are pending when responded_at
      // is NULL AND conversation_state = 'awaiting_reply' (closed /
      // superseded rows don't count).
      const fetchPigPending = async (reportId) => {
        if (!reportId) return { buyer: [], client: [] };
        try {
          const [buyerRes, clientRes] = await Promise.all([
            supabaseClient
              .from('buyer_subjective_responses')
              .select('id, question_key, sms_sent_at, last_reminder_at, created_at, status, response_received_at')
              .eq('report_id', reportId)
              .eq('status', 'pending'),
            supabaseClient
              .from('client_pricing_requests')
              .select('id, finding_id, finding_snapshot, client_name, client_phone, delivery_mode, created_at, last_reminder_at, responded_at, conversation_state, request_kind')
              .eq('report_id', reportId)
              .is('responded_at', null)
              .eq('conversation_state', 'awaiting_reply')
          ]);
          if (buyerRes.error) console.warn('[D40 PIG] buyer pending query failed:', buyerRes.error);
          if (clientRes.error) console.warn('[D40 PIG] client pending query failed:', clientRes.error);
          return {
            buyer: buyerRes.data || [],
            client: clientRes.data || []
          };
        } catch (err) {
          console.warn('[D40 PIG] fetchPigPending threw:', err);
          return { buyer: [], client: [] };
        }
      };

      // Looks up the current value of reports.inputs_complete_at. We
      // re-check this on the click handler so a previously-cleared
      // report skips the gate entirely (locked decision per directive).
      const fetchInputsCompleteAt = async (reportId) => {
        if (!reportId) return null;
        try {
          const { data, error } = await supabaseClient
            .from('reports')
            .select('inputs_complete_at')
            .eq('id', reportId)
            .maybeSingle();
          if (error) {
            console.warn('[D40 PIG] inputs_complete_at fetch failed:', error);
            return null;
          }
          return data?.inputs_complete_at || null;
        } catch (err) {
          console.warn('[D40 PIG] inputs_complete_at fetch threw:', err);
          return null;
        }
      };

      // Stub agent ready text. When SMS_DISPATCH_MODE flips to 'live',
      // replace the console.log with a Worker-side Twilio call. Guarded
      // by both (a) the agent having a phone on profile (D40 Task 4) and
      // (b) a signup attestation row from D38. Either missing → silent
      // skip with a console note, never blocks the gate clear.
      const dispatchAgentReadyText = async () => {
        try {
          if (!user?.id) return;
          const { data: profile } = await supabaseClient
            .from('profiles').select('phone_number').eq('id', user.id).maybeSingle();
          const agentPhone = profile?.phone_number || null;
          if (!agentPhone) {
            console.log('[D40 PIG] agent ready text — skipped: no phone on profile');
            return;
          }
          const { data: attRows } = await supabaseClient
            .from('sms_consent_attestations')
            .select('id').eq('agent_id', user.id).eq('source', 'signup').limit(1);
          if (!attRows || attRows.length === 0) {
            console.log('[D40 PIG] agent ready text — skipped: no signup attestation');
            return;
          }
          if (SMS_DISPATCH_MODE === 'live') {
            console.log('[D40 PIG] LIVE mode placeholder — would dispatch agent ready text via worker to', agentPhone);
          } else {
            console.log('[D40 PIG STUB] would send agent ready text to', agentPhone, '(SMS_DISPATCH_MODE=' + SMS_DISPATCH_MODE + ')');
          }
        } catch (err) {
          console.warn('[D40 PIG] dispatchAgentReadyText threw (non-fatal):', err);
        }
      };

      // Marks the report as having cleared the gate and dispatches the
      // agent ready text. Idempotent: if inputs_complete_at is already
      // set we don't overwrite it (it's a "first-clear" timestamp).
      const markInputsCompleteAndDispatch = async (reportId) => {
        if (!reportId) return;
        try {
          const existing = await fetchInputsCompleteAt(reportId);
          if (existing) {
            console.log('[D40 PIG] inputs_complete_at already set; skipping write but still no-op-dispatching agent text');
            return;
          }
          const nowIso = new Date().toISOString();
          const { error } = await supabaseClient
            .from('reports').update({ inputs_complete_at: nowIso }).eq('id', reportId);
          if (error) {
            console.warn('[D40 PIG] inputs_complete_at write failed:', error);
            return;
          }
          await dispatchAgentReadyText();
        } catch (err) {
          console.warn('[D40 PIG] markInputsCompleteAndDispatch threw (non-fatal):', err);
        }
      };

      // Bulk reminder. Stub-mode behavior: bumps last_reminder_at on
      // every visible pending row in BOTH tables, sets a 60s cooldown
      // on the gate's reminder button, and console-logs the would-send
      // for each row. Live-mode: same DB writes, plus the actual SMS
      // dispatch via the Worker (replace the stub branch).
      const handleSendReminders = async () => {
        if (!pendingReportId) return;
        const cooldownUntil = pigState.reminderCooldownUntil;
        if (cooldownUntil && new Date(cooldownUntil).getTime() > Date.now()) {
          console.log('[D40 PIG] reminder still in cooldown until', cooldownUntil);
          return;
        }
        const nowIso = new Date().toISOString();
        const buyerIds = pigState.pendingBuyer.map(r => r.id);
        const clientIds = pigState.pendingClient.map(r => r.id);
        try {
          if (buyerIds.length > 0) {
            const { error } = await supabaseClient
              .from('buyer_subjective_responses')
              .update({ last_reminder_at: nowIso })
              .in('id', buyerIds);
            if (error) console.warn('[D40 PIG] buyer last_reminder_at update failed:', error);
          }
          if (clientIds.length > 0) {
            const { error } = await supabaseClient
              .from('client_pricing_requests')
              .update({ last_reminder_at: nowIso })
              .in('id', clientIds);
            if (error) console.warn('[D40 PIG] client last_reminder_at update failed:', error);
          }
          if (SMS_DISPATCH_MODE !== 'live') {
            console.log(`[D40 PIG STUB] would resend ${buyerIds.length} buyer reminders + ${clientIds.length} client reminders`);
          } else {
            console.log('[D40 PIG] LIVE placeholder — Worker reminder dispatch path');
          }
          // 60-second cooldown so an agent can't spam the button
          const until = new Date(Date.now() + 60_000).toISOString();
          // Re-fetch so the UI immediately shows updated last_reminder_at values
          const refreshed = await fetchPigPending(pendingReportId);
          setPigState(prev => ({
            ...prev,
            pendingBuyer: refreshed.buyer,
            pendingClient: refreshed.client,
            reminderCooldownUntil: until
          }));
        } catch (err) {
          console.warn('[D40 PIG] handleSendReminders threw:', err);
        }
      };

      // D43 Task 2 (2026-05-11): branded computation screen between Step 3 → 4.
      // The withSpinner path now (a) shows the screen IMMEDIATELY, (b) flips
      // currentStep + verdictPhase under the screen so the engine effect
      // fires in the background, (c) skips the progressive section-by-section
      // reveal animation (the screen is the reveal), and (d) dismisses only
      // when BOTH the engine has resolved AND a minimum 1.2s has elapsed
      // (handled by the dismiss-watch effect below).
      const proceedToStep4 = (withSpinner = true) => {
        if (!withSpinner) {
          // No-spinner path: PIG polling auto-clear after the gate is open.
          // The user has already been watching the gate — drop them into
          // Step 4 with the standard verdict-reveal animation.
          setReportReady(true);
          handleNextStep(3);
          return;
        }

        // Debounce: ignore a second click while the loading screen is up.
        if (isGenerating) return;

        setGeneratingStartedAt(Date.now());
        setIsGenerating(true);

        // Skip the progressive reveal — jump directly to the terminal state
        // so Page 4 is fully painted when the screen dismisses. The auto-
        // trigger startVerdictReveal effect short-circuits on the
        // verdictPhase !== 'hidden' check we set up here.
        setVerdictPhase('complete');
        setShowSummary(true);
        setShowAssessments(true);
        setShowFunnel(true);

        // Pre-compute the final needle rotation (verbatim anti-snap math from
        // startVerdictReveal) so the gauge lands in the same place it would
        // have after the animation.
        try {
          const outlookData = calculateOutlookScore(leverageScore, findings);
          const clampedScore = Math.max(-20, Math.min(20, outlookData.outlookScore));
          let normalized = (clampedScore + 20) / 40;
          const tickPositions = [0.15, 0.35, 0.50, 0.70, 0.85];
          const deadZone = 0.02;
          const nudgeAmount = 0.03;
          for (const tick of tickPositions) {
            if (Math.abs(normalized - tick) < deadZone) {
              if (tick === 0.50 && clampedScore === 0) {
                normalized = tick + nudgeAmount;
              } else if (normalized >= tick) {
                normalized = tick + nudgeAmount;
              } else {
                normalized = tick - nudgeAmount;
              }
              break;
            }
          }
          normalized = Math.max(0.02, Math.min(0.98, normalized));
          const adjustedScore = (normalized * 40) - 20;
          const targetRotation = (adjustedScore / 20) * 90;
          setNeedleRotation(Math.max(-90, Math.min(90, targetRotation)));
        } catch (e) {
          console.warn('[D43] needle pre-compute failed (non-fatal):', e);
        }

        setReportReady(true);
        handleNextStep(3);  // currentStep → 4; engine effect fires under the screen
      };

      // D43 Task 2: dismiss-watch effect. Holds the loading screen until both
      // (a) the engine has fully resolved (gamePlanScoreState populated AND
      // not scoreComputing) and (b) a minimum 1.2s has elapsed. 30s error
      // ceiling so a stuck engine never leaves the agent on an infinite hold.
      useEffect(() => {
        if (!isGenerating || !generatingStartedAt) return;
        const MIN_HOLD_MS = 1200;
        const ERROR_TIMEOUT_MS = 30000;
        let timer = null;

        const tryDismiss = () => {
          const elapsed = Date.now() - generatingStartedAt;

          if (elapsed > ERROR_TIMEOUT_MS) {
            console.error('[D43] computation screen timed out after', ERROR_TIMEOUT_MS, 'ms');
            setIsGenerating(false);
            setGeneratingStartedAt(null);
            return;
          }

          const engineReady = !!gamePlanScoreState && !scoreComputing;
          const minHoldMet = elapsed >= MIN_HOLD_MS;

          if (engineReady && minHoldMet) {
            setIsGenerating(false);
            setGeneratingStartedAt(null);
            return;
          }

          const waitMs = !minHoldMet ? MIN_HOLD_MS - elapsed + 20 : 100;
          timer = setTimeout(tryDismiss, waitMs);
        };

        timer = setTimeout(tryDismiss, 50);
        return () => { if (timer) clearTimeout(timer); };
      }, [isGenerating, generatingStartedAt, scoreComputing, gamePlanScoreState]);

      // The Step 3 → Step 4 click is wrapped through this. Three exits:
      //  (1) gate already cleared on this report → advance immediately
      //  (2) no pending items → mark complete, dispatch agent text, advance
      //  (3) something pending → open the gate, do not advance
      const attemptStep3Continue = async () => {
        if (!pendingReportId) {
          // No report row yet (rare — saveReportAtStep typically creates it
          // before Step 3 transitions, but belt-and-suspenders). Without a
          // report ID we can't gate; just advance.
          proceedToStep4(true);
          return;
        }
        setPigState(prev => ({ ...prev, loading: true }));
        try {
          const existing = await fetchInputsCompleteAt(pendingReportId);
          if (existing) {
            // Already cleared this report — locked decision, never re-render.
            proceedToStep4(true);
            return;
          }
          const pending = await fetchPigPending(pendingReportId);
          if (pending.buyer.length === 0 && pending.client.length === 0) {
            await markInputsCompleteAndDispatch(pendingReportId);
            proceedToStep4(true);
            return;
          }
          setPigState(prev => ({
            ...prev,
            showing: true,
            pendingBuyer: pending.buyer,
            pendingClient: pending.client,
            loading: false
          }));
        } catch (err) {
          console.warn('[D40 PIG] attemptStep3Continue threw:', err);
          // Fail-open — don't trap the agent if the gate query errors.
          proceedToStep4(true);
        } finally {
          setPigState(prev => ({ ...prev, loading: false }));
        }
      };

      // DEV-only bypass. Marks the report cleared, dispatches the agent
      // text, advances. Allowlisted upstream where the button is
      // rendered. The bypass DOES still set inputs_complete_at — once
      // bypassed, the gate is permanently retired for that report.
      const handlePigBypass = async () => {
        if (!pendingReportId) {
          proceedToStep4(true);
          return;
        }
        setPigState(prev => ({ ...prev, bypassing: true }));
        try {
          await markInputsCompleteAndDispatch(pendingReportId);
          setPigState(prev => ({
            ...prev, showing: false, bypassing: false,
            pendingBuyer: [], pendingClient: []
          }));
          proceedToStep4(false);
        } catch (err) {
          console.warn('[D40 PIG] handlePigBypass threw:', err);
          setPigState(prev => ({ ...prev, bypassing: false }));
        }
      };

      // 30s polling while the gate is open. If both lists transition to
      // empty mid-poll (a buyer responded, an agent flagged a quote
      // resolved, etc.) we auto-clear, mark complete, dispatch agent
      // text, and advance. The polling stops as soon as the gate closes.
      useEffect(() => {
        if (!pigState.showing || !pendingReportId) return;
        let cancelled = false;
        const tick = async () => {
          const pending = await fetchPigPending(pendingReportId);
          if (cancelled) return;
          if (pending.buyer.length === 0 && pending.client.length === 0) {
            await markInputsCompleteAndDispatch(pendingReportId);
            if (cancelled) return;
            setPigState(prev => ({
              ...prev, showing: false, pendingBuyer: [], pendingClient: []
            }));
            proceedToStep4(false);
            return;
          }
          setPigState(prev => ({
            ...prev,
            pendingBuyer: pending.buyer,
            pendingClient: pending.client
          }));
        };
        const interval = setInterval(tick, 30_000);
        return () => { cancelled = true; clearInterval(interval); };
      }, [pigState.showing, pendingReportId]);

      // ================================================================
      // v4.4: WEIGHTED LEVERAGE CALCULATION (Research-Backed)
      // With +2 baseline for buyer momentum (under contract advantage)
      // ================================================================
      const LEVERAGE_BASELINE = 2; // Buyer has transaction momentum

      const leverageScore = useMemo(() => {
        // v5.2: If we loaded a saved report, use the persisted leverage score directly
        // This guarantees stable display regardless of formula changes (Directive 12)
        if (loadedLeverageScore !== null && loadedLeverageScore !== undefined) {
          return loadedLeverageScore;
        }

        const enabledBuyer = buyerFactors.filter(f => f.enabled);
        const enabledSeller = sellerFactors.filter(f => f.enabled);

        // Calculate weighted scores for buyer factors (user-input)
        // Normalize 1-10 scale to same range as old 1-5 scale: (value - 5.5) / 2.25 gives -2 to +2 range
        const buyerWeightedSum = enabledBuyer.reduce((sum, f) => sum + ((f.value - 5.5) / 2.25 * f.weight), 0);

        // Add auto-calculated buyer factors
        const autoInspectionSeverity = (getInspectionSeverityScore() - 3) * AUTO_WEIGHTS.inspectionSeverity;
        const autoDaysOnMarket = (getDaysOnMarketScore() - 3) * AUTO_WEIGHTS.daysOnMarket;
        // D32-D: market-data signals from Redfin (cooling, inventory). Post-Andrew
        // round 2: comparables auto-calc removed — was overpromising precision on
        // ZIP-aggregate inventory count. Both return 1-5 with 3 = neutral.
        const autoMarketCooling = (getMarketCoolingScore(marketSegmentData) - 3) * AUTO_WEIGHTS.marketCooling;
        const autoInventory     = (getInventoryScore(marketSegmentData) - 3) * AUTO_WEIGHTS.inventory;
        const totalBuyerWeighted = buyerWeightedSum + autoInspectionSeverity + autoDaysOnMarket + autoMarketCooling + autoInventory;

        // Calculate weighted scores for seller factors (user-input)
        // Normalize 1-10 scale to same range as old 1-5 scale
        const sellerWeightedSum = enabledSeller.reduce((sum, f) => sum + ((f.value - 5.5) / 2.25 * f.weight), 0);

        // Post-Andrew polish: inspectionCleanliness auto-calc dropped (was the
        // mathematical inverse of inspectionSeverity, doubling the same signal).
        const totalSellerWeighted = sellerWeightedSum;

        // Calculate net score
        const netScore = totalBuyerWeighted - totalSellerWeighted;

        // Normalize to approximately -20 to +20 range
        // D32-D: include the 3 new auto-calc weights in buyerMaxPossible so the
        // ratio normalization stays mathematically honest.
        const buyerMaxPossible = enabledBuyer.reduce((sum, f) => sum + (2 * f.weight), 0)
          + (2 * AUTO_WEIGHTS.inspectionSeverity) + (2 * AUTO_WEIGHTS.daysOnMarket)
          + (2 * AUTO_WEIGHTS.marketCooling) + (2 * AUTO_WEIGHTS.inventory);
        // Post-Andrew polish: inspectionCleanliness term removed from sellerMaxPossible
        // since the auto-calc was dropped above. Keeps normalization mathematically honest.
        const sellerMaxPossible = enabledSeller.reduce((sum, f) => sum + (2 * f.weight), 0);
        const totalMaxPossible = (buyerMaxPossible || 1) + (sellerMaxPossible || 1);

        // v4.4: Add baseline for buyer momentum, then clamp to -20 to +20
        const rawScore = Math.round((netScore / totalMaxPossible) * 40) + LEVERAGE_BASELINE;
        return Math.max(-20, Math.min(20, rawScore));
      }, [buyerFactors, sellerFactors, findings, propertyInfo.daysOnMarket, loadedLeverageScore, marketSegmentData]);

      // D32-D: fetch market segment data when ZIP + purchase price are known.
      // Stored in marketSegmentData state, consumed by the leverageScore useMemo
      // and the Page 3 "Auto-Calculated from Your Data" tiles. Re-fires when
      // either input changes. Null result (non-target ZIP) is fine — auto-calc
      // helpers fall back to neutral.
      useEffect(() => {
        const zip = propertyInfo.zipCode;
        const priceStr = propertyInfo.contractPrice || propertyInfo.listPrice || '0';
        const price = parseFloat(String(priceStr).replace(/[^0-9.]/g, '')) || 0;
        if (!zip || price <= 0) { setMarketSegmentData(null); return; }
        let cancelled = false;
        (async () => {
          const result = await lookupMarketSegment(zip, price);
          if (!cancelled) setMarketSegmentData(result);
        })();
        return () => { cancelled = true; };
      }, [propertyInfo.zipCode, propertyInfo.contractPrice, propertyInfo.listPrice]);

      // D27 fix: relocated score-recompute useEffect (originally lived ~400 lines above
      // alongside the other GPS effects). Moved here so its `leverageScore` dep-array
      // reference resolves cleanly under esbuild's strict TDZ semantics. Functionally
      // identical to the original; only the position in the hook order changed.
      useEffect(() => {
        if (currentStep !== 4 || !gamePlanScoreState) return;
        const selCount = findings.filter(f => f.selected).length;
        const selTotal = findings.filter(f => f.selected).reduce((s, f) => s + (f.cost || 0), 0);
        // D18c Part 2: include leverageScore in the signature so that when an agent
        // returns from Step 3 with adjusted sliders on a saved report, the GPS recomputes.
        const sig = `${findings.length}:${selCount}:${selTotal}:${leverageScore}`;
        if (sig === lastScoreSig) return;
        const t = setTimeout(() => {
          setLastScoreSig(sig);
          computeAndStoreGamePlanScore({ includeSniff: false, triggerSource: 'slider_adjust' });
        }, 400);
        return () => clearTimeout(t);
      }, [findings, currentStep, leverageScore]);

      const getLeverageCategory = (score) => {
        if (score >= 8) return 'strong';      // Strong buyer leverage
        if (score >= 3) return 'moderate';    // Moderate buyer leverage
        if (score >= -2) return 'balanced';   // Balanced/Neutral
        if (score >= -7) return 'weak';       // Weak buyer position
        return 'poor';                        // Poor buyer position
      };

      const getLeveragePosition = (score) => {
        const category = getLeverageCategory(score);
        switch (category) {
          case 'strong': return { position: 'Strong', color: 'text-green-400', description: 'You have significant negotiating leverage' };
          case 'moderate': return { position: 'Favorable', color: 'text-brand-400', description: 'Conditions favor the buyer' };
          case 'balanced': return { position: 'Balanced', color: 'text-yellow-400', description: 'Neither party has clear advantage' };
          case 'weak': return { position: 'Limited', color: 'text-orange-400', description: 'Seller has some leverage' };
          default: return { position: 'Weak', color: 'text-red-400', description: 'Significant seller leverage' };
        }
      };

      // ================================================================
      // CREDIT CALCULATIONS
      // ================================================================
      const totalRepairCost = useMemo(() => {
        return findings
          .filter(f => f.selected)
          .reduce((sum, f) => sum + (f.cost || 0), 0);
      }, [findings]);

      const calculateRecommendedCredit = () => {
        const score = leverageScore; // Use the weighted leverageScore
        const base = totalRepairCost;

        // Map the -20 to +20 range score to multipliers
        let multiplier;
        if (score >= 8) multiplier = 0.85;       // Strong buyer leverage
        else if (score >= 3) multiplier = 0.75;  // Moderate buyer leverage
        else if (score >= -2) multiplier = 0.60; // Balanced
        else if (score >= -7) multiplier = 0.45; // Weak buyer position
        else multiplier = 0.35;                  // Poor buyer position

        const recommended = Math.round(base * multiplier);
        const conservative = Math.round(recommended * 0.65);
        const aggressive = Math.round(recommended * 1.18);

        return { conservative, recommended, aggressive };
      };

      // Closing Cost Ceiling Calculation
      const calculateClosingCostOverage = () => {
        // Parse closing cost values (remove non-numeric chars)
        const estimatedCosts = parseInt(String(propertyInfo.estimatedClosingCosts).replace(/[^0-9]/g, '')) || 0;
        const creditsNegotiated = parseInt(String(propertyInfo.creditsAlreadyNegotiated).replace(/[^0-9]/g, '')) || 0;

        // Parse down payment values
        const minimumDownPayment = parseInt(String(propertyInfo.minimumDownPayment).replace(/[^0-9]/g, '')) || 0;
        const plannedDownPayment = parseInt(String(propertyInfo.plannedDownPayment).replace(/[^0-9]/g, '')) || 0;

        // If no closing costs entered, return null (feature disabled)
        if (estimatedCosts === 0) return null;

        // Calculate available capacity
        const availableCapacity = estimatedCosts - creditsNegotiated;

        // Calculate total credit asks from selected findings
        const totalCreditAsk = findings
          .filter(f => f.selected && (f.requestType || 'credit') === 'credit')
          .reduce((sum, f) => sum + (f.cost || 0), 0);

        // Calculate overage
        const overage = totalCreditAsk - availableCapacity;

        // Calculate down payment cushion (for price reduction strategy)
        const downPaymentCushion = plannedDownPayment - minimumDownPayment;
        const hasDownPaymentCushion = minimumDownPayment > 0 && plannedDownPayment > 0 && downPaymentCushion > 0;

        return {
          estimatedCosts,
          creditsNegotiated,
          availableCapacity,
          totalCreditAsk,
          overage,
          hasOverage: overage > 0,
          // Down payment info
          minimumDownPayment,
          plannedDownPayment,
          downPaymentCushion,
          hasDownPaymentCushion,
          // Can use price reduction strategy if cushion covers overage
          canUsePriceReduction: hasDownPaymentCushion && overage > 0,
          cushionCoversOverage: hasDownPaymentCushion && downPaymentCushion >= overage
        };
      };

      // Seller Motivation Calculation
      // Factors in: price reduction + credits already negotiated at offer
      const calculateSellerMotivation = () => {
        const originalPrice = parseInt(String(propertyInfo.originalListPrice).replace(/[^0-9]/g, '')) || 0;
        const currentPrice = parseInt(String(propertyInfo.listPrice).replace(/[^0-9]/g, '')) || 0;
        const daysOnMarket = parseInt(propertyInfo.daysOnMarket) || 0;
        const creditsNegotiated = parseInt(String(propertyInfo.creditsAlreadyNegotiated).replace(/[^0-9]/g, '')) || 0;

        // If no original price or no current price, can't calculate motivation
        if (originalPrice === 0 || currentPrice === 0) return null;

        // Calculate price reduction
        const priceReduction = originalPrice - currentPrice;

        // Calculate TOTAL seller concessions (price drop + credits already given)
        const totalConcession = priceReduction + creditsNegotiated;
        const concessionPercent = originalPrice > 0 ? (totalConcession / originalPrice) * 100 : 0;

        // Also track just price reduction percent for display
        const priceReductionPercent = originalPrice > 0 ? (priceReduction / originalPrice) * 100 : 0;

        // Determine motivation level based on TOTAL concession % and DOM
        let motivation, description, strategyTip;

        // Build description parts
        const concessionParts = [];
        if (priceReduction > 0) concessionParts.push(`${formatCurrency(priceReduction)} price drop`);
        if (creditsNegotiated > 0) concessionParts.push(`${formatCurrency(creditsNegotiated)} in credits`);
        const concessionSummary = concessionParts.length > 0 ? concessionParts.join(' + ') : 'no concessions';

        if (concessionPercent > 4 && daysOnMarket < 14) {
          motivation = 'VERY_DESPERATE';
          description = `Early panic — ${concessionPercent.toFixed(1)}% total concession in first two weeks`;
          strategyTip = 'Seller is highly motivated with early aggressive concessions. Strong position to negotiate. Push your full ask.';
        } else if (concessionPercent > 6) {
          motivation = 'DESPERATE';
          description = `Aggressive concessions — ${concessionPercent.toFixed(1)}% total (${concessionSummary})`;
          strategyTip = 'Significant concessions indicate highly motivated seller. Strong position to negotiate.';
        } else if (concessionPercent >= 4 && daysOnMarket > 30) {
          motivation = 'MOTIVATED';
          description = `Real movement — ${concessionPercent.toFixed(1)}% total concession over ${daysOnMarket} days`;
          strategyTip = `Seller has conceded ${formatCurrency(totalConcession)} (${concessionPercent.toFixed(1)}%) via ${concessionSummary}. They want to move. Push your full ask.`;
        } else if (concessionPercent >= 1 && daysOnMarket > 30) {
          motivation = 'TESTING';
          description = `Moderate concessions — ${concessionPercent.toFixed(1)}% total (${concessionSummary})`;
          strategyTip = 'Some concessions suggest seller is open to negotiation. May need to educate on repair costs.';
        } else if (concessionPercent === 0 && daysOnMarket > 45) {
          motivation = 'STUCK';
          description = `No concessions in ${daysOnMarket}+ days`;
          strategyTip = 'No price reductions or credits suggests seller may be underwater or inflexible. Consider seller repairs paid at closing, or be prepared to walk.';
        } else if (concessionPercent === 0 && daysOnMarket < 14) {
          motivation = 'FRESH';
          description = 'New listing — not enough data yet';
          strategyTip = 'Not enough market data yet. Standard approach — lead with safety items.';
        } else {
          motivation = 'NEUTRAL';
          // D35-A2 (Andrew session 2026-05-06): the "Standard positioning — N% concession"
          // line read as canned data posing as signal. Suppress for NEUTRAL; the badge
          // and strategy tip remain.
          description = '';
          strategyTip = 'Standard negotiating position. Lead with safety and high-cost items.';
        }

        return {
          originalPrice,
          currentPrice,
          priceReduction,
          priceReductionPercent,
          creditsNegotiated,
          totalConcession,
          concessionPercent,
          daysOnMarket,
          motivation,
          description,
          strategyTip
        };
      };


      // ================================================================
      // V5.8: DEAL CONTEXT SCORE CALCULATION (renamed from Market Position)
      // ================================================================
      const calculateMarketPositionScore = () => {
        const dom = parseInt(propertyInfo.daysOnMarket) || 0;
        const financing = marketContext.financingType || 'conventional';

        // v5.8: Base score = 0 (removed phantom marketTemperature lookup)
        let score = 0;

        // DOM modifier (-3 to +5) — real data from user input
        if (dom < 7) score -= 3;        // Fresh — seller confident
        else if (dom < 14) score -= 1;  // Still early
        else if (dom < 30) score += 0;  // Normal
        else if (dom < 60) score += 2;  // Getting stale
        else if (dom < 90) score += 3;  // Seller anxious
        else score += 5;                // Desperate territory

        // Financing modifier (-2 to +2) — real data from user input
        if (financing === 'cash') score += 2;         // Cash is king
        else if (financing === 'conventional') score += 0;
        else if (financing === 'fha') score -= 1;     // More restrictions
        else if (financing === 'va') score -= 1;      // More restrictions

        // Clamp to -10 to +10
        return Math.max(-10, Math.min(10, score));
      };

      // v5.8: getMarketPositionData kept for bar color logic only (label no longer displayed)
      const getMarketPositionData = (score) => {
        if (score >= 6) return { label: 'STRONG BUYER MARKET', color: '#16a34a' };
        if (score >= 2) return { label: 'BUYER-LEANING', color: '#22c55e' };
        if (score >= -2) return { label: 'BALANCED MARKET', color: '#eab308' };
        if (score >= -6) return { label: 'SELLER-LEANING', color: '#7b8bff' };
        return { label: 'STRONG SELLER MARKET', color: '#dc2626' };
      };


      // ================================================================
      // V5.8: SELLER SIGNALS SCORE CALCULATION (renamed from Seller Profile)
      // ================================================================
      const calculateSellerProfileScore = () => {
        const sellerData = calculateSellerMotivation();
        // v5.3: SHORT-CIRCUIT — return saved value for loaded reports (Directive 12.5)
        if (loadedSellerProfileScore !== null && loadedSellerProfileScore !== undefined) {
          return {
            score: loadedSellerProfileScore,
            hasData: !!sellerData,
            sellerData
          };
        }
        if (!sellerData) return { score: 0, hasData: false };

        const motivationScores = {
          'VERY_DESPERATE': 10,   // Significant movement
          'DESPERATE': 7,         // Significant movement
          'MOTIVATED': 4,         // Active flexibility
          'TESTING': 1,           // Some movement
          'NEUTRAL': 0,           // No movement yet
          'FRESH': -2,            // Too early to read
          'STUCK': -4             // Holding firm
        };

        return {
          score: motivationScores[sellerData.motivation] || 0,
          hasData: true,
          sellerData
        };
      };

      // v5.8: Updated labels - describe observed behavior, not inferred personality
      const getSellerProfileData = (score, motivation) => {
        if (motivation === 'VERY_DESPERATE' || motivation === 'DESPERATE') {
          return { label: 'SIGNIFICANT MOVEMENT', color: '#16a34a' };
        }
        if (motivation === 'MOTIVATED') return { label: 'ACTIVE FLEXIBILITY', color: '#22c55e' };
        if (motivation === 'TESTING') return { label: 'SOME MOVEMENT', color: '#84cc16' };
        if (motivation === 'NEUTRAL') return { label: 'NO MOVEMENT YET', color: '#eab308' };
        if (motivation === 'FRESH') return { label: 'TOO EARLY TO READ', color: '#6b7280' };
        if (motivation === 'STUCK') return { label: 'HOLDING FIRM', color: '#ef4444' };
        return { label: 'UNKNOWN', color: '#6b7280' };
      };


      // ================================================================
      // V3.6: REALISTIC CAPTURE RATE CALCULATION
      // ================================================================

      const calculateRealisticCaptureRate = (marketCtx, leverageScoreValue) => {
        // Base rates by market temperature
        const baseRates = {
          'hot':         { low: 0.05, high: 0.15 },
          'competitive': { low: 0.15, high: 0.25 },
          'balanced':    { low: 0.25, high: 0.40 },
          'cooling':     { low: 0.40, high: 0.55 },
          'cold':        { low: 0.55, high: 0.70 }
        };

        let { low, high } = baseRates[marketCtx.marketTemperature] || baseRates.balanced;

        // Modifiers

        // Financing type
        if (marketCtx.financingType === 'cash') {
          low += 0.05;
          high += 0.10;
        } else if (marketCtx.financingType === 'fha' || marketCtx.financingType === 'va') {
          // FHA/VA can force seller's hand on safety items
          low += 0.03;
          high += 0.05;
        }

        // Price already reduced
        if (marketCtx.originalListPrice && propertyInfo.listPrice) {
          const origPrice = parseFloat(String(marketCtx.originalListPrice).replace(/[^0-9.]/g, '')) || 0;
          const currPrice = parseFloat(String(propertyInfo.listPrice).replace(/[^0-9.]/g, '')) || 0;
          if (origPrice > 0 && currPrice > 0) {
            const reduction = (origPrice - currPrice) / origPrice;
            if (reduction > 0.05) {
              low += 0.05;  // Seller has shown flexibility
              high += 0.05;
            }
          }
        }

        // Leverage score adjustment (-20 to +20 scale)
        // Strong buyer leverage = higher capture rate
        const leverageModifier = (leverageScoreValue / 20) * 0.10;  // ±10% max
        low += leverageModifier;
        high += leverageModifier;

        // Seller situation bonuses
        const motivatedSellers = ['relocation', 'estate', 'divorce'];
        if (motivatedSellers.includes(marketCtx.sellerSituation)) {
          low += 0.05;
          high += 0.10;
        }

        // Clamp to reasonable bounds
        low = Math.max(0.05, Math.min(0.80, low));
        high = Math.max(0.10, Math.min(0.90, high));

        return { low, high };
      };


      // ================================================================
      // V3.6: CLASSIFICATION KEYWORD LISTS (Shared)
      // ================================================================

      // TIER 1: CRITICAL SAFETY — Always Must-Have
      // These are lender requirements, insurance deal-breakers, habitability
      const CRITICAL_SAFETY_KEYWORDS = [
        // Electrical - immediate hazards
        'federal pacific', 'fpe', 'stab-lok', 'stab lok',
        'knob and tube', 'knob-and-tube',
        'double-tapped', 'double tapped', 'overloaded panel',
        'aluminum wiring',
        // Structural - affects habitability
        'foundation crack', 'foundation failure', 'structural damage',
        'load-bearing', 'joist failure', 'beam failure',
        'active leak', 'active water intrusion',
        // Systems - non-functional essentials
        'furnace not functioning', 'no heat', 'inoperable furnace',
        'hvac failed', 'hvac not functioning',
        'water heater failed', 'no hot water',
        // Environmental - lender/insurance requirements
        'mold confirmed', 'active mold', 'mold remediation required',
        'asbestos confirmed', 'asbestos present',
        // Explicit code/safety flags
        'fire hazard', 'safety hazard', 'code violation', 'condemned',
        'not to code', 'fails code'
      ];

      // TIER 2: INSURANCE TRIGGERS — Must-Have regardless of cost
      // These can prevent insurance binding
      const INSURANCE_TRIGGER_KEYWORDS = [
        'roof replacement', 'roof end of life', 'roof beyond useful life',
        'polybutylene', 'poly-b', 'pb pipe',
        'galvanized supply', 'galvanized water lines',
        'federal pacific',
        'wood shake roof',
        'underground oil tank'
      ];

      // TIER 3: ANCILLARY SAFETY — Only Must-Have if EXPENSIVE (>$2000)
      // Real but not deal-critical
      const ANCILLARY_SAFETY_KEYWORDS = [
        'handrail', 'hand rail', 'guardrail', 'guard rail',
        'railing', 'baluster spacing', 'baluster',
        'smoke detector', 'co detector', 'carbon monoxide',
        'anti-tip', 'anti tip', 'range bracket', 'stove bracket',
        'stair riser', 'uneven stairs',
        'tempered glass', 'safety glass',
        // GFCI - technically a safety issue but deals close without it every day
        'no gfci', 'missing gfci', 'gfci required', 'gfci protection', 'gfci outlet'
      ];

      // TIER 5: PETTY ITEMS — Always Concessions
      // Never worth fighting over
      const PETTY_KEYWORDS = [
        'caulk', 'caulking', 'weatherstrip', 'weather strip',
        'seismic strap', 'earthquake strap',
        'battery', 'batteries',
        'touch-up', 'touch up', 'cosmetic',
        'cleaning', 'clean',
        'filter', 'filters'
      ];

      // TIER 4: SEVERITY DOWNGRADES pattern
      const SEVERITY_DOWNGRADE_PATTERN = /loose|repair|tighten|secure|adjustment|minor|worn|weathered|aged/i;


      // ================================================================
      // V3.6: ITEM CLASSIFICATION SYSTEM (Tiered Safety Logic)
      // ================================================================

      const classifyFinding = (finding) => {
        const { item, description, priority, cost, category } = finding;
        const text = `${item || ''} ${description || ''}`.toLowerCase();

        const hasSeverityDowngrade = SEVERITY_DOWNGRADE_PATTERN.test(text);

        // Check for petty items first (always concession)
        const isPetty = PETTY_KEYWORDS.some(kw => text.includes(kw));
        if (isPetty && cost < 500) {
          return 'concession';
        }

        // Check critical safety (always must-have unless downgraded)
        const isCriticalSafety = CRITICAL_SAFETY_KEYWORDS.some(kw => text.includes(kw));
        if (isCriticalSafety && !hasSeverityDowngrade) {
          return 'must-have';
        }

        // Check insurance triggers (always must-have)
        const isInsuranceTrigger = INSURANCE_TRIGGER_KEYWORDS.some(kw => text.includes(kw));
        if (isInsuranceTrigger) {
          return 'must-have';
        }

        // Check ancillary safety (must-have ONLY if expensive)
        const isAncillarySafety = ANCILLARY_SAFETY_KEYWORDS.some(kw => text.includes(kw));
        if (isAncillarySafety) {
          if (cost > 2000 && !hasSeverityDowngrade) {
            return 'must-have';
          } else if (cost > 500) {
            return 'strong-ask';
          } else {
            return 'concession';
          }
        }

        // High-cost critical items (>$3K and high priority)
        if (cost > 3000 && priority === 'high') {
          return 'must-have';
        }

        // Standard priority-based classification
        if (priority === 'high') {
          return 'strong-ask';
        }

        if (priority === 'medium' && cost >= 1000 && cost <= 5000) {
          return 'strong-ask';
        }

        // Low-cost items default to tradeable or concession
        if (cost < 300) {
          return 'concession';
        }

        if (priority === 'low' && cost < 500) {
          return 'concession';
        }

        // Everything else is tradeable
        return 'tradeable';
      };

      // ================================================================
      // V3.6: STRATEGY GENERATION (with Realistic Capture Rates)
      // ================================================================

      const generateStrategy = () => {
        const selectedFindings = findings.filter(f => f.selected);

        // Classify all findings into buckets
        const buckets = {
          mustHaves: [],
          strongAsks: [],
          tradeables: [],
          concessions: []
        };

        selectedFindings.forEach(finding => {
          const classification = classifyFinding(finding);
          switch (classification) {
            case 'must-have': buckets.mustHaves.push(finding); break;
            case 'strong-ask': buckets.strongAsks.push(finding); break;
            case 'tradeable': buckets.tradeables.push(finding); break;
            case 'concession': buckets.concessions.push(finding); break;
          }
        });

        // Calculate totals
        const totals = {
          mustHaves: buckets.mustHaves.reduce((sum, f) => sum + (f.cost || 0), 0),
          strongAsks: buckets.strongAsks.reduce((sum, f) => sum + (f.cost || 0), 0),
          tradeables: buckets.tradeables.reduce((sum, f) => sum + (f.cost || 0), 0),
          concessions: buckets.concessions.reduce((sum, f) => sum + (f.cost || 0), 0),
          allItems: totalRepairCost
        };

        // Determine leverage position
        const position = getLeveragePosition(leverageScore);

        // V3.6: Identify deal-critical items (items that could actually kill the deal)
        const dealCriticalItems = buckets.mustHaves.filter(f => {
          const text = `${f.item || ''} ${f.description || ''}`.toLowerCase();
          return CRITICAL_SAFETY_KEYWORDS.some(kw => text.includes(kw)) ||
                 INSURANCE_TRIGGER_KEYWORDS.some(kw => text.includes(kw));
        });
        const dealCriticalTotal = dealCriticalItems.reduce((sum, f) => sum + (f.cost || 0), 0);

        // V3.6: Calculate realistic capture rate
        const captureRate = calculateRealisticCaptureRate(marketContext, leverageScore);
        const realisticCreditLow = Math.round(totals.allItems * captureRate.low);
        const realisticCreditHigh = Math.round(totals.allItems * captureRate.high);

        // Strategy recommendations
        const strategy = {
          // Anchoring number (full documented repairs)
          anchorTotal: totals.allItems,

          // Deal-critical items (must be addressed somehow)
          dealCriticalItems,
          dealCriticalTotal,

          // Realistic credit target (based on market)
          realisticCreditLow,
          realisticCreditHigh,
          realisticCreditMid: Math.round((realisticCreditLow + realisticCreditHigh) / 2),

          // Capture rate for display
          captureRateLow: captureRate.low,
          captureRateHigh: captureRate.high,

          // Legacy fields for backward compatibility
          openingAsk: totals.mustHaves + totals.strongAsks,
          expectedLandingLow: totals.mustHaves,
          expectedLandingHigh: totals.mustHaves + Math.round(totals.strongAsks * 0.7),
          walkAwayThreshold: dealCriticalTotal || totals.mustHaves,
          leveragePosition: position.position.toLowerCase()
        };

        // Generate scripts
        const scripts = generateScripts(buckets, totals, strategy, position);

        return { buckets, totals, strategy, scripts, position };
      };

      // ================================================================
      // V3: SCRIPT GENERATION
      // ================================================================
      
      const generateScripts = (buckets, totals, strategy, position) => {
        const scripts = {};
        const clientName = propertyInfo.clientName || 'my client';
        
        // Get top items for reference
        const getTopItems = (items, count) => {
          return items.slice(0, count).map(f => f.item).join(' and ');
        };
        
        // Opening script varies by leverage
        if (position.position === 'Strong' || position.position === 'Favorable') {
          scripts.opening = `Based on the inspection findings totaling ${formatCurrency(totals.allItems)}, we're requesting a credit of ${formatCurrency(strategy.openingAsk)}. The ${buckets.mustHaves.length} critical items—including ${getTopItems(buckets.mustHaves, 2) || 'safety concerns'}—affect insurability and must be addressed.`;
        } else {
          scripts.opening = `The inspection revealed ${formatCurrency(totals.allItems)} in needed repairs. We understand market conditions and are focusing our request on the ${buckets.mustHaves.length} items that affect safety and insurability, totaling ${formatCurrency(totals.mustHaves)}.`;
        }
        
        // Must-have justification
        scripts.mustHaveScript = "These items affect insurability and our lender may require them addressed before closing.";
        
        // Strong ask script
        scripts.strongAskScript = "We'd like this addressed—whether that's a credit or the seller handling the repair directly, we're flexible.";
        
        // Tradeable script
        scripts.tradeableScript = "We've included these in our request, but there may be room to discuss.";
        
        // Concession script
        if (buckets.concessions.length > 0) {
          const concessionItems = buckets.concessions.slice(0, 3).map(f => f.item).join(', ');
          scripts.concessionScript = `In the interest of moving forward smoothly, we're not asking for credits on minor items like ${concessionItems}.`;
        }
        
        // Walk-away line
        scripts.walkAway = `Our minimum to move forward is ${formatCurrency(totals.mustHaves)}. Below that, ${clientName} will need to seriously reconsider whether this transaction makes sense.`;
        
        // Prepared concession offer
        if (buckets.tradeables.length > 0) {
          scripts.concessionOffer = `In the interest of reaching an agreement, we're prepared to remove some of the tradeable items from our request—a reduction of up to ${formatCurrency(totals.tradeables)}.`;
        }
        
        return scripts;
      };


      // ================================================================
      // VALIDATION SYSTEM
      // ================================================================
      const generateReportId = () => {
        const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789';
        let id = 'RPT-';
        for (let i = 0; i < 8; i++) {
          if (i === 4) id += '-';
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      };

      const [reportId] = useState(generateReportId());

      const calculateChecksum = () => {
        const data = JSON.stringify({
          address: propertyInfo.address,
          findings: findings.filter(f => f.selected).map(f => ({ item: f.item, cost: f.cost })),
          total: totalRepairCost
        });
        let hash = 0;
        for (let i = 0; i < data.length; i++) {
          const char = data.charCodeAt(i);
          hash = ((hash << 5) - hash) + char;
          hash = hash & hash;
        }
        return Math.abs(hash).toString(16).toUpperCase().substring(0, 8);
      };

      // ================================================================
      // RENDER HELPERS
      // ================================================================
      const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(amount);
      };

      const getPriorityColor = (priority) => {
        switch (priority) {
          case 'high': return 'bg-red-500/20 text-red-400 border-red-500/30';
          case 'medium': return 'bg-brand-500/20 text-brand-400 border-brand-500/30';
          case 'low': return 'bg-stone-500/20 text-stone-400 border-stone-500/30';
          default: return 'bg-stone-500/20 text-stone-400 border-stone-500/30';
        }
      };

      // ================================================================
      // STEP COMPONENTS
      // ================================================================

      // Step 1: Property Information
      const Step1PropertyInfo = () => {
        // D18c Part 2: inspection PDF and property info stay locked on saved reports —
        // this is the liability boundary. Agents paid to ingest one inspection per report.
        // Tied to readOnlyMode (not loadedLeverageScore) so the lock survives slider edits.
        const inspectionLocked = readOnlyMode;
        const isFrozen = inspectionLocked;
        return (
        <div className="space-y-8 animate-fade-in-up">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-white mb-2">Property Information</h2>
            <p className="text-stone-400">Enter the property details or upload your inspection documents</p>
            {inspectionLocked && (
              <p className="text-xs text-stone-500 italic mt-2">This deal already has an inspection on file. To analyze a new property, start a new report from your dashboard.</p>
            )}
          </div>

          <div style={{ pointerEvents: isFrozen ? 'none' : 'auto' }}>

          {/* PDF Upload */}
          <div className="glass rounded-2xl p-6 card-hover">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
              <svg className="w-5 h-5 text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Upload Inspection Report(s)
            </h3>

            <div
              className={`border-2 border-dashed rounded-xl p-8 text-center transition-all cursor-pointer
                ${pdfUploading ? 'border-brand-500 bg-brand-500/10' : 'border-stone-600 hover:border-brand-500 hover:bg-brand-500/5'}`}
              onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
              onDrop={(e) => {
                e.preventDefault();
                e.stopPropagation();
                const droppedFiles = Array.from(e.dataTransfer.files).filter(f => f.type === 'application/pdf');
                if (droppedFiles.length > 0) {
                  parsePdfForFindings(droppedFiles);
                }
              }}
              onClick={() => document.getElementById('pdf-upload').click()}
            >
              <input
                type="file"
                id="pdf-upload"
                accept=".pdf"
                multiple
                className="hidden"
                onChange={(e) => {
                  const selectedFiles = Array.from(e.target.files).filter(f => f.type === 'application/pdf');
                  if (selectedFiles.length > 0) parsePdfForFindings(selectedFiles);
                }}
              />

              {pdfUploading ? (
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 border-4 border-brand-500/30 border-t-brand-500 rounded-full animate-spin mb-4"></div>
                  <p className="text-brand-400 font-medium">Analyzing {pdfFileNames.length > 1 ? `${pdfFileNames.length} documents` : 'report'} with AI...</p>
                  <p className="text-stone-500 text-sm mt-1">This may take a moment</p>
                </div>
              ) : pdfParseStatus === 'success' || pdfParseStatus === 'partial' ? (
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center mb-4">
                    <svg className="w-6 h-6 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <p className="text-green-400 font-medium">{pdfFileNames.length > 1 ? 'Documents analyzed successfully!' : 'Report analyzed successfully!'}</p>
                  {pdfFileNames.map((name, i) => (
                    <p key={i} className="text-stone-400 text-sm mt-1">&#10003; {name}</p>
                  ))}
                  <p className="text-stone-500 text-sm mt-2">{findings.length} findings extracted</p>
                </div>
              ) : (
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 bg-brand-500/20 rounded-full flex items-center justify-center mb-4">
                    <svg className="w-6 h-6 text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                    </svg>
                  </div>
                  <p className="text-white font-medium">Drop inspection report(s) here or click to upload</p>
                  <p className="text-stone-500 text-sm mt-1">Upload multiple files if you have a sewer scope, pest, radon, or septic report</p>
                </div>
              )}
            </div>
          </div>

          {/* Property Details Form */}
          <div className="glass rounded-2xl p-6">
            <h3 className="text-lg font-semibold text-white mb-4">Property Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Street Address</label>
                <input
                  type="text"
                  value={propertyInfo.address}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, address: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="123 Main Street"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">City, State</label>
                <input
                  type="text"
                  value={propertyInfo.city}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, city: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="West Linn, OR"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">ZIP Code</label>
                <input
                  type="text"
                  value={propertyInfo.zipCode}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, zipCode: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="97068"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Client Name</label>
                <input
                  type="text"
                  value={propertyInfo.clientName}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, clientName: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="John Smith"
                />
              </div>
              {/* D37-A: Client phone — required for fresh reports, drives Twilio dispatch
                  in D11b. Consent (below) resets to false whenever this field changes,
                  so a new phone always requires a fresh attestation. */}
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">
                  Client Phone Number <span className="text-red-400">*</span>
                </label>
                <input
                  type="tel"
                  value={propertyInfo.clientPhone}
                  onChange={(e) => {
                    const next = e.target.value;
                    setPropertyInfo(prev => ({
                      ...prev,
                      clientPhone: next,
                      // Any phone change invalidates prior consent — re-attestation required.
                      clientSmsConsent: prev.clientPhone === next ? prev.clientSmsConsent : false
                    }));
                    if (validationErrors.clientPhone || validationErrors.clientSmsConsent) {
                      setValidationErrors(prev => ({ ...prev, clientPhone: null, clientSmsConsent: null }));
                    }
                  }}
                  className={`w-full bg-stone-800/50 border rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-1 focus:ring-brand-500 ${validationErrors.clientPhone ? 'border-red-500 focus:border-red-500' : 'border-stone-700 focus:border-brand-500'}`}
                  placeholder="(503) 555-1234"
                />
                {validationErrors.clientPhone && (
                  <p className="text-xs text-red-400 mt-1">{validationErrors.clientPhone}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Original List Price</label>
                <input
                  type="text"
                  value={propertyInfo.originalListPrice}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, originalListPrice: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="$475,000"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Current List Price</label>
                <input
                  type="text"
                  value={propertyInfo.listPrice}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, listPrice: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="$450,000"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Under Contract At</label>
                <input
                  type="text"
                  value={propertyInfo.contractPrice}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, contractPrice: e.target.value }))}
                  onFocus={(e) => { if (e.target.value === '') e.target.placeholder = ''; }}
                  onBlur={(e) => { if (e.target.value === '') e.target.placeholder = '$425,000'; }}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="$425,000"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Days on Market</label>
                <input
                  type="number"
                  value={propertyInfo.daysOnMarket}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, daysOnMarket: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="14"
                />
              </div>
            </div>

            {/* D37-A: SMS consent attestation. Full-verbatim language per directive
                (Twilio TCR Error 30909 fix). Checkbox is unchecked by default
                (TCR rule 30925 prohibits pre-check). Required to advance Step 1 for
                fresh reports. Resets to false on phone-number change. */}
            <div className="mt-4 pt-4 border-t border-stone-700/50">
              <label htmlFor="clientSmsConsentCheckbox" className="flex items-start gap-3 cursor-pointer">
                <input
                  id="clientSmsConsentCheckbox"
                  type="checkbox"
                  checked={propertyInfo.clientSmsConsent}
                  onChange={(e) => {
                    const next = e.target.checked;
                    setPropertyInfo(prev => ({ ...prev, clientSmsConsent: next }));
                    if (validationErrors.clientSmsConsent) {
                      setValidationErrors(prev => ({ ...prev, clientSmsConsent: null }));
                    }
                  }}
                  className="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-stone-600 bg-stone-800 text-brand-500 focus:ring-brand-500 focus:ring-offset-0 cursor-pointer"
                />
                <span className={`text-xs leading-relaxed ${validationErrors.clientSmsConsent ? 'text-red-300' : 'text-stone-400'}`}>
                  <span className="text-red-400 mr-1">*</span>
                  {SMS_CONSENT_ATTESTATION_TEXT}
                </span>
              </label>
              {validationErrors.clientSmsConsent && (
                <p className="text-xs text-red-400 mt-2 ml-7">{validationErrors.clientSmsConsent}</p>
              )}
            </div>
          </div>

          {/* Closing Cost Info (Optional) */}
          <div className="glass rounded-2xl p-6">
            <div className="flex items-center gap-2 mb-4">
              <h3 className="text-lg font-semibold text-white">Closing Cost Info</h3>
              <span className="text-xs text-stone-500 bg-stone-800 px-2 py-0.5 rounded">Optional</span>
            </div>
            <p className="text-stone-500 text-sm mb-4">
              Help us warn you if credit requests exceed what your buyer can use at closing.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Buyer's Estimated Closing Costs</label>
                <input
                  type="text"
                  value={propertyInfo.estimatedClosingCosts}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, estimatedClosingCosts: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="$0"
                />
                <p className="text-xs text-stone-600 mt-1">Total closing costs + prepaids from lender estimate</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Credits Already in Contract</label>
                <input
                  type="text"
                  value={propertyInfo.creditsAlreadyNegotiated}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, creditsAlreadyNegotiated: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="$0"
                />
                <p className="text-xs text-stone-600 mt-1">Seller credits negotiated at offer (if any)</p>
              </div>
            </div>

            {/* Down Payment Fields */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 pt-4 border-t border-stone-700/50">
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Minimum Down Payment Required</label>
                <input
                  type="text"
                  value={propertyInfo.minimumDownPayment}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, minimumDownPayment: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="$0"
                />
                <p className="text-xs text-stone-600 mt-1">Minimum to qualify for loan product</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-stone-400 mb-1">Planned Down Payment</label>
                <input
                  type="text"
                  value={propertyInfo.plannedDownPayment}
                  onChange={(e) => setPropertyInfo(prev => ({ ...prev, plannedDownPayment: e.target.value }))}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
                  placeholder="$0"
                />
                <p className="text-xs text-stone-600 mt-1">What buyer plans to put down</p>
              </div>
            </div>
          </div>

          {/* Next Button - v3.7: Uses handleNextStep for sequential flow */}
          {/* D13 Fix 3b: Hide Continue button when viewing a saved report (use step indicator to navigate) */}
          {!isFrozen && (
            <div className="flex justify-end">
              <button
                onClick={() => handleNextStep(1)}
                className="px-8 py-3 bg-gradient-to-r from-brand-500 to-brand-600 text-white font-semibold rounded-xl hover:from-brand-600 hover:to-brand-700 transition-all shadow-lg shadow-brand-500/25"
              >
                Continue to Findings
              </button>
            </div>
          )}

          </div>
        </div>
        );
      };

      // Step 2: Inspection Findings
      const Step2Findings = () => {
        // D18c Part 2: split the legacy `isFrozen` into two lanes.
        // - inspectionLocked: the inspection PDF and the structured findings list cannot be edited.
        //   Tied to readOnlyMode so the lock survives slider edits (which clear loadedLeverageScore).
        // - Toggles, request-type radios, and pricing affordances stay interactive on saved reports
        //   so agents can model alternate scenarios. The D13 scenario bar captures these.
        const inspectionLocked = readOnlyMode;
        const isFrozen = inspectionLocked;
        // D11a: modal-local form state (lives inside Step2Findings so it resets on open)
        const modalFinding = clientPricingModal ? findings.find(f => f.id === clientPricingModal.findingId) : null;
        return (
        <div className="space-y-8 animate-fade-in-up">
          {/* D11a: Client-pricing modals (upload contractor quote / request from client) */}
          {/* Portaled to document.body so `position: fixed` anchors to the viewport, not any transformed ancestor. */}
          {clientPricingModal && modalFinding && clientPricingModal.type === 'upload' && ReactDOM.createPortal(
            <ContractorQuoteUploadModal
              key={`quote-modal-${modalFinding.id}`}
              finding={modalFinding}
              uploadState={quoteUploadState}
              busy={clientPricingBusy}
              propertyClientName={propertyInfo?.clientName}
              propertyClientPhone={propertyInfo?.clientPhone}
              onClose={() => !clientPricingBusy && setClientPricingModal(null)}
              onFileSelected={(file) => handleQuoteFileSelected(modalFinding.id, file)}
              onConfirmSingle={() => handleQuoteSingleConfirm(modalFinding.id)}
              onOverrideStart={() => setQuoteUploadState(prev => ({ ...prev, step: 'override' }))}
              onOverrideSubmit={(amount, reason, otherText) => handleQuoteOverride(modalFinding.id, amount, reason, otherText)}
              onOverrideDispatch={(reason, otherText, token, isStandalone) => handleQuoteOverrideDispatch(modalFinding.id, reason, otherText, token, isStandalone)}
              onMultiOptionDispatch={(name, phone) => handleQuoteMultiOptionDispatch(modalFinding.id, name, phone)}
            />,
            document.body
          )}
          {/* D40 Task 2: standalone override on an already-populated cost.
              Same modal component but jumps straight to the override view
              and routes its submit to handleStandaloneOverride. */}
          {clientPricingModal && modalFinding && clientPricingModal.type === 'override-existing' && ReactDOM.createPortal(
            <ContractorQuoteUploadModal
              key={`override-modal-${modalFinding.id}`}
              finding={modalFinding}
              uploadState={quoteUploadState}
              busy={clientPricingBusy}
              propertyClientName={propertyInfo?.clientName}
              propertyClientPhone={propertyInfo?.clientPhone}
              isStandaloneOverride
              onClose={() => !clientPricingBusy && setClientPricingModal(null)}
              onFileSelected={() => {}}
              onConfirmSingle={() => {}}
              onOverrideStart={() => {}}
              onOverrideSubmit={(amount, reason, otherText) => handleStandaloneOverride(modalFinding.id, amount, reason, otherText)}
              onOverrideDispatch={(reason, otherText, token, isStandalone) => handleQuoteOverrideDispatch(modalFinding.id, reason, otherText, token, isStandalone)}
              onMultiOptionDispatch={() => {}}
            />,
            document.body
          )}
          {clientPricingModal && modalFinding && clientPricingModal.type === 'request' && ReactDOM.createPortal(
            (() => {
              // D37-A: derive override state on each render. modalPhoneE164 is null while
              // the agent is mid-typing an invalid number — in that case the override
              // block doesn't show, but Send Request stays disabled because phone fails
              // validation. Override only registers once the modal phone is fully valid
              // AND differs from the Page 1 attested value.
              const modalPhoneE164 = normalizePhoneE164(modalRequestForm.clientPhone);
              const isOverride = !!modalPhoneE164 && !!propertyInfo.clientPhone && modalPhoneE164 !== propertyInfo.clientPhone;
              const sendDisabled = clientPricingBusy || !modalPhoneE164 || (isOverride && !modalRequestForm.overrideConsent);
              return (
            <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => !clientPricingBusy && setClientPricingModal(null)}>
              <div className="bg-stone-900 rounded-2xl p-6 max-w-md w-full border border-stone-700" onClick={(e) => e.stopPropagation()}>
                <h3 className="text-xl font-bold text-white mb-1">Request price from client</h3>
                <p className="text-sm text-stone-400 mb-4">For: <em>{modalFinding.item}</em></p>
                <form onSubmit={async (e) => {
                  e.preventDefault();
                  const name = (modalRequestForm.clientName || '').trim();
                  const phone = (modalRequestForm.clientPhone || '').trim();
                  const mode = modalRequestForm.deliveryMode;
                  const e164 = normalizePhoneE164(phone);
                  if (!e164) return alert('Enter a valid 10-digit US phone number.');
                  if (isOverride && !modalRequestForm.overrideConsent) {
                    return alert('Please confirm the new client has consented before sending.');
                  }
                  // D37-A: capture override attestation row before dispatching the request.
                  // Fire-and-forget on error: failing to insert the audit row should not
                  // block the agent's send; we log and continue.
                  if (isOverride) {
                    try {
                      await supabaseClient.from('sms_consent_attestations').insert({
                        report_id: pendingReportId || null,
                        agent_id: user.id,
                        phone_number: e164,
                        attestation_text: SMS_CONSENT_ATTESTATION_TEXT,
                        source: 'page2_override'
                      });
                    } catch (err) {
                      console.warn('[D37-A] page2_override attestation INSERT failed (non-fatal):', err);
                    }
                  }
                  handleRequestFromClient(modalFinding.id, name, e164, mode);
                }}>
                  <label className="block text-xs text-stone-400 uppercase tracking-wide mb-1">Client name</label>
                  <input
                    name="clientName"
                    type="text"
                    placeholder="e.g. Jane Homebuyer"
                    value={modalRequestForm.clientName}
                    onChange={(e) => setModalRequestForm(prev => ({ ...prev, clientName: e.target.value }))}
                    className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-white mb-4 focus:border-brand-500 focus:outline-none"
                  />
                  <label className="block text-xs text-stone-400 uppercase tracking-wide mb-1">Client phone (required)</label>
                  <input
                    name="clientPhone"
                    type="tel"
                    required
                    placeholder="(503) 555-1234"
                    value={modalRequestForm.clientPhone}
                    onChange={(e) => setModalRequestForm(prev => ({
                      ...prev,
                      clientPhone: e.target.value,
                      // Clear override consent any time the phone changes — applies
                      // whether the new value is another override or a revert to
                      // the Page 1 value (in the latter case the block disappears
                      // anyway, but the boolean reset keeps state coherent).
                      overrideConsent: false
                    }))}
                    className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-white mb-4 focus:border-brand-500 focus:outline-none"
                  />
                  <label className="block text-xs text-stone-400 uppercase tracking-wide mb-1">Delivery mode</label>
                  <select
                    name="deliveryMode"
                    value={modalRequestForm.deliveryMode}
                    onChange={(e) => setModalRequestForm(prev => ({ ...prev, deliveryMode: e.target.value }))}
                    className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-white mb-2 focus:border-brand-500 focus:outline-none"
                  >
                    <option value="sms_conversation">Text conversation (one message per item)</option>
                    <option value="magic_link">Magic link (single page with all items)</option>
                  </select>
                  <p className="text-xs text-stone-500 italic mb-4">D11a stub — no real text will be sent yet. D11b wires up Twilio.</p>

                  {/* D37-A: override re-attestation. Appears only when the modal phone
                      is fully valid AND differs from the Page 1 attested phone. Dark-
                      amber palette matches the existing TEST DATA banner so the
                      compliance signal lands without clashing with the dark modal. */}
                  {isOverride && (
                    <div className="rounded-lg p-3 mb-4" style={{
                      background: 'rgba(251,191,36,0.12)',
                      border: '1px solid rgba(251,191,36,0.55)'
                    }}>
                      <label htmlFor="page2OverrideConsent" className="flex items-start gap-2 cursor-pointer">
                        <input
                          id="page2OverrideConsent"
                          type="checkbox"
                          checked={modalRequestForm.overrideConsent}
                          onChange={(e) => setModalRequestForm(prev => ({ ...prev, overrideConsent: e.target.checked }))}
                          className="mt-0.5 h-4 w-4 flex-shrink-0 rounded border-amber-700 bg-stone-900 cursor-pointer"
                          style={{ accentColor: '#fbbf24' }}
                        />
                        <span className="text-xs leading-relaxed" style={{ color: '#fcd34d' }}>
                          <span className="font-semibold block mb-1">Different number — fresh consent required</span>
                          {SMS_CONSENT_ATTESTATION_TEXT}
                        </span>
                      </label>
                    </div>
                  )}

                  <div className="flex justify-end gap-2">
                    <button type="button" disabled={clientPricingBusy} onClick={() => setClientPricingModal(null)} className="px-4 py-2 text-sm text-stone-400 hover:text-white">Cancel</button>
                    <button type="submit" disabled={sendDisabled} className="px-4 py-2 text-sm bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-600 disabled:opacity-50">
                      {clientPricingBusy ? 'Saving…' : 'Send request'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
              );
            })(),
            document.body
          )}
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-white mb-2">Inspection Findings</h2>
            <p className="text-stone-400">Review and select items to include in negotiation</p>
            {inspectionLocked && (
              <p className="text-xs text-stone-500 italic mt-2">Your inspection findings are locked. Toggle items below to explore scenarios.</p>
            )}
          </div>

          {/* D18c Part 2: wrapper no longer locks pointer events on saved reports — toggles and
              pricing affordances stay interactive. The "Add Custom Item" section below is hidden
              on saved reports so the findings list can't grow beyond what was extracted. */}
          <div>

          {findings.length > 0 ? (
            <>
              {/* v4.2: Findings Controls - Select All / Deselect All */}
              <div className="findings-controls">
                <button
                  className="select-all-btn"
                  onClick={() => setFindings(findings.map(f => ({ ...f, selected: true })))}
                >
                  ✓ Select All
                </button>
                <button
                  className="deselect-all-btn"
                  onClick={() => setFindings(findings.map(f => ({ ...f, selected: false })))}
                >
                  ✕ Deselect All
                </button>
                <span className="selection-count">
                  {findings.filter(f => f.selected).length} of {findings.length} selected
                </span>
              </div>

              {/* Summary Bar */}
              <div className="glass rounded-2xl p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-4">
                    <span className="text-stone-400">
                      {findings.filter(f => f.selected).length} of {findings.length} items selected
                    </span>
                  </div>
                  {(() => {
                    const selected = findings.filter(f => f.selected);
                    const priced = selected.filter(f => f.costSource);
                    const pending = selected.filter(f => !f.costSource && f.pendingRequest);
                    const unpriced = selected.length - priced.length - pending.length;
                    const pricedTotal = priced.reduce((s, f) => s + (f.cost || 0), 0);
                    if (priced.length === 0) {
                      return (
                        <span className="text-sm text-stone-500 italic">
                          Attach quotes or request client prices to see totals
                        </span>
                      );
                    }
                    return (
                      <div className="text-right">
                        <div className="text-2xl font-bold text-emerald-400">{formatCurrency(pricedTotal)}</div>
                        <div className="text-xs text-emerald-400/70">
                          {priced.length} priced{pending.length > 0 ? ` · ${pending.length} awaiting client` : ''}{unpriced > 0 ? ` · ${unpriced} no cost yet` : ''}
                        </div>
                      </div>
                    );
                  })()}
                </div>

                {/* Sort Dropdown */}
                <div className="flex items-center gap-3 pt-3 border-t border-stone-700/50">
                  <span className="text-stone-500 text-sm">Sort by:</span>
                  <select
                    value={findingsSort}
                    onChange={(e) => setFindingsSort(e.target.value)}
                    className="bg-stone-800/80 border border-stone-600 rounded-lg px-3 py-1.5 text-sm text-white focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 cursor-pointer"
                  >
                    <option value="category-grouped">Category + Price (Recommended)</option>
                    <option value="cost-high">Highest Cost First</option>
                    <option value="cost-low">Lowest Cost First</option>
                    <option value="priority">Priority (Critical First)</option>
                    <option value="house-flow">House Walkthrough (Roof to Foundation)</option>
                    <option value="alphabetical">Alphabetical (A-Z)</option>
                  </select>
                  {findingsSort === 'house-flow' && (
                    <span className="text-xs text-brand-400/70 italic">Top of house to bottom</span>
                  )}
                  {findingsSort === 'category-grouped' && (
                    <span className="text-xs text-brand-400/70 italic">Super-priority items first</span>
                  )}
                </div>
              </div>

              {/* Methodology Note — PPG: agents attach quotes or have clients enter costs */}
              <p style={{ color: '#78716c', fontSize: '13px', textAlign: 'center', marginTop: '8px' }}>
                Attach a contractor quote or have your client enter a number for each item before finalizing.
              </p>

              {/* D46 Task 1: replaced the "Use Recommended Settings" button (which
                  perpetuated the wrong mental model — Game Plan recommends nothing)
                  with an unobtrusive Jump-to-Continue affordance for long reports.
                  The canonical advance remains the "Continue to Leverage" button
                  at the bottom of the page. */}
              <div style={{ textAlign: 'center', marginTop: '8px', marginBottom: '20px' }}>
                <button
                  onClick={() => {
                    const target = document.getElementById('step2-continue-button');
                    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }}
                  style={{
                    background: 'transparent',
                    border: '1px solid rgba(123, 139, 255, 0.25)',
                    borderRadius: '8px',
                    padding: '6px 14px',
                    color: 'rgba(123, 139, 255, 0.85)',
                    fontSize: '12px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.background = 'rgba(123, 139, 255, 0.08)';
                    e.currentTarget.style.borderColor = 'rgba(123, 139, 255, 0.5)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.borderColor = 'rgba(123, 139, 255, 0.25)';
                  }}
                >
                  Jump to Continue ↓
                </button>
              </div>

              {/* Findings List */}
              <div className="space-y-3">
                {getSortedFindings.map((finding, index) => {
                  // Determine if we need a section header
                  let showHeader = false;
                  let headerLabel = '';
                  let headerIcon = '';

                  if (findingsSort === 'house-flow') {
                    const currentSection = getHousePosition(finding);
                    const prevSection = index > 0 ? getHousePosition(getSortedFindings[index - 1]) : null;
                    if (currentSection !== prevSection) {
                      showHeader = true;
                      const section = HOUSE_SECTIONS[currentSection];
                      headerLabel = section?.label || 'Other';
                      headerIcon = section?.icon || '•';
                    }
                  } else if (findingsSort === 'category' || findingsSort === 'category-grouped') {
                    const currentCategory = finding.category || 'General';
                    const prevCategory = index > 0 ? (getSortedFindings[index - 1].category || 'General') : null;
                    if (currentCategory !== prevCategory) {
                      showHeader = true;
                      headerLabel = currentCategory;
                    }
                  }

                  // v3.7: Get seller repair hint
                  const sellerHint = getSellerRepairHint(finding);
                  const showSuperPriority = isSuperPriority(finding);
                  // D46 Task 4: per-card flag when the cost gate is active and
                  // this finding is selected without a value path.
                  const isCostGateOffender = costGateActive
                    && finding.selected
                    && !finding.costSource
                    && !finding.pendingRequest;

                  return (
                    <React.Fragment key={finding.id}>
                      {showHeader && (
                        <div className="flex items-center gap-3 pt-4 pb-2 mt-2 first:mt-0 first:pt-0">
                          <div className="w-8 h-8 rounded-lg bg-brand-500/20 flex items-center justify-center overflow-hidden p-0.5">
                            <img src={window.KNIGHT_LOGO_SRC} alt="" className="w-full h-full object-contain" />
                          </div>
                          <h3 className="text-lg font-semibold text-white">{headerLabel}</h3>
                          <div className="flex-1 h-px bg-gradient-to-r from-brand-500/30 to-transparent"></div>
                        </div>
                      )}
                      <div
                        id={`finding-card-${finding.id}`}
                        className={`glass rounded-xl p-4 transition-all card-hover
                          ${finding.selected ? 'border-brand-500/50' : 'opacity-60'}
                          ${finding.isCustom ? 'border-l-4 border-l-emerald-500' : ''}`}
                        style={isCostGateOffender ? {
                          background: 'rgba(251,191,36,0.12)',
                          borderColor: 'rgba(251,191,36,0.55)',
                          boxShadow: '0 0 0 1px rgba(251,191,36,0.30)'
                        } : undefined}
                      >
                      {isCostGateOffender && (
                        <div
                          className="rounded-lg px-3 py-2 text-xs mb-3"
                          style={{
                            background: 'rgba(251,191,36,0.10)',
                            border: '1px solid rgba(251,191,36,0.40)',
                            color: '#fcd34d'
                          }}
                        >
                          This item is selected for the analysis but has no quote uploaded and no price request sent. Upload a quote or send a price request to your client before continuing.
                        </div>
                      )}
                    <div className="flex items-start gap-4">
                      {/* Checkbox */}
                      <div
                        className={`w-6 h-6 rounded-md border-2 flex items-center justify-center mt-1 transition-all cursor-pointer
                          ${finding.selected ? 'bg-brand-500 border-brand-500' : 'border-stone-600'}`}
                        onClick={() => {
                          setFindings(prev => prev.map(f =>
                            f.id === finding.id ? { ...f, selected: !f.selected } : f
                          ));
                        }}
                      >
                        {finding.selected && (
                          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                          </svg>
                        )}
                      </div>

                      {/* Content */}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1 flex-wrap">
                          <h4 className="font-semibold text-white">{finding.item}</h4>
                          {/* v4.2: Urgency Badge */}
                          <UrgencyBadge tier={finding.urgencyTier || classifyUrgency(finding.description || '')} />
                          <span className={`text-xs px-2 py-0.5 rounded-full border ${getPriorityColor(finding.priority)}`}>
                            {finding.priority}
                          </span>
                          {/* v3.7: Super Priority Badge */}
                          {showSuperPriority && (
                            <span className="text-xs px-2 py-0.5 rounded-full bg-red-500/20 text-red-400 border border-red-500/30">
                              ⚠️ CRITICAL
                            </span>
                          )}
                          {/* v3.7: Custom Item Badge */}
                          {finding.isCustom && (
                            <span className="text-xs px-2 py-0.5 rounded-full bg-emerald-500/20 text-emerald-400 border border-emerald-500/30">
                              Custom
                            </span>
                          )}
                        </div>
                        <p className="text-stone-400 text-sm">{finding.description}</p>
                        {finding.reasoning && (
                          <p className="text-stone-500 text-xs mt-2 italic">{finding.reasoning}</p>
                        )}
                      </div>

                      {/* D11a: Cost column — 4 states (priced-contractor, priced-client, pending, unpriced) */}
                      <div className="text-right min-w-[180px]">
                        {finding.costSource === 'contractor' ? (
                          <>
                            <div className="text-xl font-bold text-emerald-400">{formatCurrency(finding.cost)}</div>
                            <div className="text-xs text-emerald-400/80">
                              📎 From contractor
                              {finding.costSourceUrl && (<> · <a href={finding.costSourceUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className="underline">view</a></>)}
                            </div>
                            <div className="text-xs text-stone-500 mt-1">Regional: {formatCurrency(finding.lowEstimate)}–{formatCurrency(finding.highEstimate)}</div>
                            {/* D44 Bug 3: collapsed redundant "Looks wrong" button — the
                                Override modal's reason list (D40) captures the same intent
                                with a stronger audit trail. One affordance, one path. */}
                            <div className="flex gap-3 mt-1 justify-end">
                              <button onClick={(e) => { e.stopPropagation(); setClientPricingModal({ type: 'override-existing', findingId: finding.id }); }} className="text-xs text-stone-400 hover:text-stone-200" title="Override this amount with audit-logged reason">✎ Override</button>
                            </div>
                          </>
                        ) : finding.costSource === 'client' ? (
                          <>
                            <div className="text-xl font-bold text-emerald-400">{formatCurrency(finding.cost)}</div>
                            <div className="text-xs text-emerald-400/80" title={finding.costSourceSetAt ? `Received ${new Date(finding.costSourceSetAt).toLocaleDateString()}` : ''}>
                              👤 From {finding.costSourceClientName || 'client'}
                            </div>
                            <div className="text-xs text-stone-500 mt-1">Regional: {formatCurrency(finding.lowEstimate)}–{formatCurrency(finding.highEstimate)}</div>
                            <div className="flex gap-3 mt-1 justify-end">
                              <button onClick={(e) => { e.stopPropagation(); setClientPricingModal({ type: 'override-existing', findingId: finding.id }); }} className="text-xs text-stone-400 hover:text-stone-200" title="Override this amount with audit-logged reason">✎ Override</button>
                            </div>
                          </>
                        ) : finding.costSource === 'manual_dev' ? (
                          <>
                            <div className="text-xl font-bold" style={{ color: '#fbbf24' }}>{formatCurrency(finding.cost)}</div>
                            <div className="text-xs" style={{ color: '#fbbf24', opacity: 0.85 }}>
                              🛠 DEV manual entry
                            </div>
                            <div className="text-xs text-stone-500 mt-1">Regional: {formatCurrency(finding.lowEstimate)}–{formatCurrency(finding.highEstimate)}</div>
                            <button onClick={(e) => { e.stopPropagation(); handleLooksWrong(finding); }} className="text-xs text-amber-400 hover:text-amber-300 mt-1" title="Clear and re-enter">⟲ Clear</button>
                          </>
                        ) : finding.costSource === 'manual_user' ? (
                          <>
                            {/* 2026-07-28: user-entered cost + reveal-our-estimate-after-commit */}
                            <div className="text-xl font-bold text-emerald-400">{formatCurrency(finding.cost)}</div>
                            <div className="text-xs text-emerald-400/80">✏️ Your estimate</div>
                            <div className="text-xs text-stone-500 mt-1">Our estimate: {formatCurrency(finding.lowEstimate)}–{formatCurrency(finding.highEstimate)}</div>
                            <button onClick={(e) => { e.stopPropagation(); handleLooksWrong(finding); }} className="text-xs text-stone-400 hover:text-stone-200 mt-1" title="Clear and re-enter">⟲ Clear</button>
                          </>
                        ) : finding.pendingRequest ? (
                          <>
                            <div className="text-sm text-blue-400 font-medium">📨 Requested</div>
                            <div className="text-xs text-stone-400">{finding.pendingRequest.clientName || 'client'}</div>
                            <div className="text-xs text-stone-600">awaiting reply</div>
                            <div className="flex gap-2 mt-2 justify-end">
                              <button onClick={(e) => { e.stopPropagation(); handleResendRequest(finding); }} className="text-xs text-blue-400 hover:text-blue-300">Resend</button>
                              <button onClick={(e) => { e.stopPropagation(); handleCancelRequest(finding); }} className="text-xs text-stone-500 hover:text-stone-400">Cancel</button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="flex flex-col gap-2">
                              <button
                                onClick={(e) => { e.stopPropagation(); setClientPricingModal({ type: 'upload', findingId: finding.id }); }}
                                className="px-3 py-2 text-xs bg-stone-700/70 hover:bg-stone-600 rounded-lg text-white border border-stone-600 transition-colors">
                                📎 Upload contractor quote
                              </button>
                              {/* 2026-07-28: user-entered cost estimate. Replaces the SMS "Request from
                                  client" button (dead in stub mode) and the dev-only manual entry. Shown to
                                  all users. On apply -> costSource 'manual_user' (see handleManualDevEntry). */}
                              {manualDevInputs[finding.id] !== undefined ? (
                                <div className="flex flex-col gap-1 p-2 rounded-lg" style={{ background: 'rgba(123,139,255,0.1)', border: '1px solid rgba(123,139,255,0.4)' }}>
                                  <label className="text-[10px] uppercase tracking-wider" style={{ color: '#7b8bff' }}>Enter cost estimate</label>
                                  <div className="flex gap-1 items-center">
                                    <span style={{ color: '#7b8bff' }}>$</span>
                                    <input
                                      type="number"
                                      min="1"
                                      autoFocus
                                      value={manualDevInputs[finding.id]}
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={(e) => setManualDevInputs(prev => ({ ...prev, [finding.id]: e.target.value }))}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                          e.stopPropagation();
                                          handleManualDevEntry(finding.id, manualDevInputs[finding.id]);
                                          setManualDevInputs(prev => { const n = { ...prev }; delete n[finding.id]; return n; });
                                        } else if (e.key === 'Escape') {
                                          e.stopPropagation();
                                          setManualDevInputs(prev => { const n = { ...prev }; delete n[finding.id]; return n; });
                                        }
                                      }}
                                      placeholder="0"
                                      className="flex-1 bg-stone-800 border border-stone-600 rounded px-2 py-1 text-xs text-white focus:outline-none"
                                    />
                                  </div>
                                  <div className="flex gap-1">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleManualDevEntry(finding.id, manualDevInputs[finding.id]);
                                        setManualDevInputs(prev => { const n = { ...prev }; delete n[finding.id]; return n; });
                                      }}
                                      className="flex-1 px-2 py-1 text-[11px] rounded font-medium"
                                      style={{ background: '#7b8bff', color: '#0c0a09' }}>
                                      Apply
                                    </button>
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setManualDevInputs(prev => { const n = { ...prev }; delete n[finding.id]; return n; });
                                      }}
                                      className="px-2 py-1 text-[11px] text-stone-400 hover:text-white">
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setManualDevInputs(prev => ({ ...prev, [finding.id]: '' }));
                                  }}
                                  className="px-3 py-2 text-xs bg-stone-700/70 hover:bg-stone-600 rounded-lg text-white border border-stone-600 transition-colors">
                                  ✏️ Input cost estimate
                                </button>
                              )}
                            </div>
                            <div className="text-xs text-stone-500 italic mt-2">No cost yet</div>
                          </>
                        )}
                      </div>
                    </div>

                    {/* v3.7: Request Type Toggle */}
                    <div className="mt-3 pt-3 border-t border-stone-700/50">
                      <div className="flex items-center gap-4 flex-wrap">
                        <span className="text-xs text-stone-500">Request as:</span>
                        <div className="flex gap-2">
                          <label className="flex items-center gap-1.5 cursor-pointer">
                            <input
                              type="radio"
                              name={`requestType-${finding.id}`}
                              value="credit"
                              checked={(finding.requestType || 'credit') === 'credit'}
                              onChange={() => updateFindingRequestType(finding.id, 'credit')}
                              className="text-brand-500"
                            />
                            <span className={`text-xs ${(finding.requestType || 'credit') === 'credit' ? 'text-brand-400' : 'text-stone-400'}`}>
                              Credit
                            </span>
                          </label>
                          <label className="flex items-center gap-1.5 cursor-pointer">
                            <input
                              type="radio"
                              name={`requestType-${finding.id}`}
                              value="seller_repair"
                              checked={finding.requestType === 'seller_repair'}
                              onChange={() => updateFindingRequestType(finding.id, 'seller_repair')}
                              className="text-blue-500"
                            />
                            <span className={`text-xs ${finding.requestType === 'seller_repair' ? 'text-blue-400' : 'text-stone-400'}`}>
                              Seller Repair
                            </span>
                          </label>
                          <label className="flex items-center gap-1.5 cursor-pointer">
                            <input
                              type="radio"
                              name={`requestType-${finding.id}`}
                              value="exclude"
                              checked={finding.requestType === 'exclude'}
                              onChange={() => updateFindingRequestType(finding.id, 'exclude')}
                              className="text-stone-500"
                            />
                            <span className={`text-xs ${finding.requestType === 'exclude' ? 'text-stone-300' : 'text-stone-400'}`}>
                              Exclude
                            </span>
                          </label>
                        </div>
                      </div>

                      {/* v3.7: Seller Repair Hint */}
                      {sellerHint && (finding.requestType || 'credit') === 'credit' && (
                        <div className="mt-2 p-2 bg-blue-500/10 border border-blue-500/20 rounded-lg">
                          <p className="text-xs text-blue-300">💡 {sellerHint}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </React.Fragment>
                );
              })}
              </div>

              {/* v3.7: Add Custom Item Section */}
              {/* D18c Part 2: hidden on saved reports — adding findings beyond what was extracted
                  from the original inspection PDF crosses the liability boundary. */}
              {!inspectionLocked && (
              <div className="mt-6">
                {!showCustomItemForm ? (
                  <button
                    onClick={() => setShowCustomItemForm(true)}
                    className="w-full py-3 border-2 border-dashed border-stone-600 rounded-xl text-stone-400 hover:border-emerald-500 hover:text-emerald-400 transition-all flex items-center justify-center gap-2"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    Add Custom Item
                  </button>
                ) : (
                  <div className="glass rounded-xl p-4 border border-emerald-500/30">
                    <h4 className="text-white font-semibold mb-4 flex items-center gap-2">
                      <span className="text-emerald-400">+</span> Add Custom Item
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs text-stone-400 mb-1">Item Name *</label>
                        <input
                          type="text"
                          value={customItemData.name}
                          onChange={(e) => setCustomItemData({...customItemData, name: e.target.value})}
                          placeholder="e.g., Deck Railing Repair"
                          className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-3 py-2 text-white placeholder-stone-500 focus:border-emerald-500 focus:outline-none text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-stone-400 mb-1">Estimated Cost *</label>
                        <div className="relative">
                          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-stone-400">$</span>
                          <input
                            type="number"
                            value={customItemData.cost}
                            onChange={(e) => setCustomItemData({...customItemData, cost: e.target.value})}
                            placeholder="0"
                            className="w-full bg-stone-800/50 border border-stone-700 rounded-lg pl-7 pr-3 py-2 text-white placeholder-stone-500 focus:border-emerald-500 focus:outline-none text-sm"
                          />
                        </div>
                      </div>
                      <div className="md:col-span-2">
                        <label className="block text-xs text-stone-400 mb-1">Description</label>
                        <input
                          type="text"
                          value={customItemData.description}
                          onChange={(e) => setCustomItemData({...customItemData, description: e.target.value})}
                          placeholder="Brief description of the issue"
                          className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-3 py-2 text-white placeholder-stone-500 focus:border-emerald-500 focus:outline-none text-sm"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-stone-400 mb-1">Category</label>
                        <select
                          value={customItemData.category}
                          onChange={(e) => setCustomItemData({...customItemData, category: e.target.value})}
                          className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-3 py-2 text-white focus:border-emerald-500 focus:outline-none text-sm"
                        >
                          {CATEGORY_ORDER.map(cat => (
                            <option key={cat} value={cat}>{cat}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs text-stone-400 mb-1">Priority</label>
                        <select
                          value={customItemData.priority}
                          onChange={(e) => setCustomItemData({...customItemData, priority: e.target.value})}
                          className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-3 py-2 text-white focus:border-emerald-500 focus:outline-none text-sm"
                        >
                          <option value="high">High</option>
                          <option value="medium">Medium</option>
                          <option value="low">Low</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex justify-end gap-3 mt-4">
                      <button
                        onClick={() => {
                          setShowCustomItemForm(false);
                          setCustomItemData({ name: '', description: '', cost: '', category: 'General', priority: 'medium' });
                        }}
                        className="px-4 py-2 text-stone-400 hover:text-white transition-all text-sm"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={addCustomFinding}
                        disabled={!customItemData.name || !customItemData.cost}
                        className={`px-4 py-2 bg-emerald-600 text-white rounded-lg text-sm transition-all ${
                          !customItemData.name || !customItemData.cost ? 'opacity-50 cursor-not-allowed' : 'hover:bg-emerald-700'
                        }`}
                      >
                        Add Item
                      </button>
                    </div>
                  </div>
                )}
              </div>
              )}
            </>
          ) : (
            <div className="glass rounded-2xl p-12 text-center">
              <div className="w-16 h-16 bg-stone-800 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-stone-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-white mb-2">No Findings Yet</h3>
              <p className="text-stone-400 mb-4">Upload an inspection report to extract findings automatically</p>
              <button
                onClick={() => goToStep(1)}
                className="px-6 py-2 bg-brand-500/20 text-brand-400 rounded-lg hover:bg-brand-500/30 transition-all"
              >
                Go Back to Upload
              </button>
            </div>
          )}

          </div>

          {/* Navigation — D13 Fix 3b legacy hid Continue when frozen; D18c relaxed scenario lock so this just gates on the inspection-PDF lock now. */}
          {!inspectionLocked && (() => {
            // D46 Task 4: live offender count for the banner above Continue.
            // Recomputed every render so it decrements as the agent resolves items.
            const liveOffenders = findings.filter(f => f.selected && !f.costSource && !f.pendingRequest);
            const showCostGate = costGateActive && liveOffenders.length > 0;
            return (
              <div className="space-y-3">
                {showCostGate && (
                  <div
                    className="rounded-xl px-4 py-3 text-sm"
                    style={{
                      background: 'rgba(251,191,36,0.12)',
                      border: '1px solid rgba(251,191,36,0.55)',
                      color: '#fcd34d'
                    }}
                  >
                    {liveOffenders.length === 1
                      ? '1 selected item needs a quote or client price request before you can continue.'
                      : `${liveOffenders.length} selected items need a quote or client price request before you can continue.`}
                  </div>
                )}
                <div className="flex justify-between">
                  <button
                    onClick={() => goToStep(1)}
                    className="px-6 py-3 bg-stone-800 text-white rounded-xl hover:bg-stone-700 transition-all"
                  >
                    Back
                  </button>
                  <button
                    id="step2-continue-button"
                    onClick={attemptStep2Continue}
                    className="px-8 py-3 bg-gradient-to-r from-brand-500 to-brand-600 text-white font-semibold rounded-xl hover:from-brand-600 hover:to-brand-700 transition-all shadow-lg shadow-brand-500/25"
                  >
                    Continue to Leverage
                  </button>
                </div>
              </div>
            );
          })()}
        </div>
        );
      };

      // Step 3: Leverage Factors (Sophisticated weighted system)
      const Step3Leverage = () => {
        // D18c Part 2: sliders are now interactive on saved reports — agents need to model
        // alternate scenarios (e.g. "what if I drop HVAC and add panel repair"). Inspection
        // is still locked upstream in Step 1.
        const inspectionLocked = readOnlyMode;
        return (
        <div className="space-y-8 animate-fade-in-up">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-white mb-2">Your Negotiation Position</h2>
            <p className="text-stone-400">What's working for and against you in this deal</p>
            {inspectionLocked && (
              <p className="text-xs text-stone-500 italic mt-2">Adjust sliders to explore how leverage factors change your Game Plan Score.</p>
            )}
          </div>

          <div>

          {/* Auto-Calculated Factors Banner */}
          <div className="glass rounded-xl p-4 border border-brand-500/30 bg-brand-500/5">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-8 h-8 bg-brand-500/20 rounded-lg flex items-center justify-center">
                <svg className="w-4 h-4 text-brand-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <span className="text-sm font-medium text-brand-400">Auto-Calculated from Your Data</span>
            </div>
            {/* Post-Andrew polish: tile redesign to address "fractions worksheet"
                visual. Hierarchy: small label → bold tier word (defensible plain-
                English read) → small raw-data subtitle. The N/5 fraction was the
                noisy element with no semantic clarity for the agent — it was the
                contribution to the leverage calc, but the tier word + raw value
                tell the same story in human terms. Both new D32-D tiles AND the
                pre-existing 3 tiles (Inspection Severity / DOM / Cleanliness) get
                the same treatment for visual consistency. */}
            {(() => {
              const mkt = marketSegmentData;
              // Post-Andrew polish: dropped Inspection Cleanliness (mathematical
              // inverse of Severity — same signal, opposite sign). Renamed
              // "Comparables" → "Active Listings (ZIP)" to be honest about what
              // the data actually represents — Redfin's free TSV gives ZIP-wide
              // SFR inventory, not price/sqft-matched comps. Down to 5 tiles in
              // a clean 5-column row (single-row, no divider needed).
              const tiles = [
                { label: 'Inspection Severity', ...getInspectionSeverityContext(), explain: 'Highest-priority signal in your inspection findings. Even one critical (red-flagged) item drives the tier — CRITICAL or SIGNIFICANT means there\'s defensible leverage to negotiate. CLEAN means no critical findings to anchor the ask around.' },
                { label: 'Days on Market',      ...getDaysOnMarketContext(),       explain: 'How long the listing has been active. Longer DOM signals a less-bid-up property — sellers grow more open to terms. FRESH = just listed (seller-favorable); STALE = 60+ days (buyer-favorable).' },
                { label: 'Market Trend',        ...getMarketCoolingContext(mkt),   explain: 'Sale-to-list ratio: average closing price ÷ asking price for this ZIP. <96% = COOLING (buyers paying well below ask); 99-101% = BALANCED; >103% = HOT (over-asking common). Portland metro typically sits 96-102%.' },
                { label: 'Local Inventory',     ...getInventoryContext(mkt),       explain: 'Months of housing supply at the current sales pace (active listings ÷ monthly sales). <2 months = TIGHT (seller\'s market); 4-6 = BALANCED; >6 = OVERSUPPLIED (buyer\'s market). NAR-standard formula.' }
                // Active Listings (ZIP) tile removed (post-Andrew round 2): was reading
                // ZIP-aggregate inventory as "matched comps" which overpromised precision.
                // Local Inventory above already digests the same source data more
                // rigorously via NAR's months-of-supply formula. Per-listing comp
                // matching by price/sqft requires MLS data; deferred to post-pilot.
              ];
              return (
                <>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 gap-y-4 text-center">
                    {tiles.map((t, i) => (
                      <div key={i} className="px-1">
                        <div className="text-[10px] uppercase tracking-wider text-stone-500 mb-1">{t.label}</div>
                        <div className={`text-base font-semibold tracking-wide ${t.tier === '—' ? 'text-stone-500' : 'text-white'}`}>{t.tier}</div>
                        <div className="text-[11px] text-stone-400 mt-0.5">{t.raw}</div>
                      </div>
                    ))}
                  </div>
                  {/* Post-Andrew polish: optional explanation panel — collapsed by default
                      so the tile grid stays clean, but available for agents who want to
                      learn what each metric means and why the tier word is what it is. */}
                  <details className="mt-3 group">
                    <summary className="text-[11px] text-stone-400 cursor-pointer hover:text-stone-300 transition-colors select-none list-none flex items-center gap-1">
                      <span className="group-open:rotate-90 inline-block transition-transform">▶</span>
                      What do these mean?
                    </summary>
                    <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-2.5 text-[11px] text-stone-400 leading-snug pt-2 border-t border-stone-700/30">
                      {tiles.map((t, i) => (
                        <div key={i} className="px-2">
                          <span className="text-stone-300 font-medium">{t.label}:</span>{' '}{t.explain}
                        </div>
                      ))}
                    </div>
                  </details>
                </>
              );
            })()}
            {/* D32-D: data source attribution + fallback message */}
            {marketSegmentData && marketSegmentData.dataSource ? (
              <div className="text-[10px] text-stone-500 mt-3 text-center">
                Source: Redfin{marketSegmentData.lastUpdated ? `, refreshed ${new Date(marketSegmentData.lastUpdated).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}` : ''}
              </div>
            ) : (
              propertyInfo.zipCode && (
                <div className="text-[10px] text-amber-400/70 mt-3 text-center">
                  Local market data not available for this ZIP — using regional averages.
                </div>
              )
            )}
          </div>

          {/* D32-C: Page 3 reorganized by input source (Buyer vs Agent) instead of
              by leverage direction. Neutral palette + no directional helper text =
              no roadmap for an agent to reverse-engineer the score math. The 4
              "Buyer Inputs" sliders will become SMS-pending placeholders in D32-B;
              for now they're agent-fillable just like the Agent Inputs section. */}
          {(() => {
            // Helper: route a factor's onUpdate back to whichever array it lives in.
            const routeFactorUpdate = (factor, updated) => {
              if (loadedLeverageScore !== null) setLoadedLeverageScore(null);
              const buyerIdx = buyerFactors.findIndex(f => f.id === factor.id);
              if (buyerIdx >= 0) {
                const next = [...buyerFactors]; next[buyerIdx] = updated; setBuyerFactors(next); return;
              }
              const sellerIdx = sellerFactors.findIndex(f => f.id === factor.id);
              if (sellerIdx >= 0) {
                const next = [...sellerFactors]; next[sellerIdx] = updated; setSellerFactors(next); return;
              }
            };
            const allFactors = [...buyerFactors, ...sellerFactors];
            const buyerInputFactors = allFactors.filter(f => D32C_BUYER_INPUT_IDS.has(f.id));
            const agentInputFactors = allFactors.filter(f => D32C_AGENT_INPUT_IDS.has(f.id));

            // D32-C punchlist: variant prop differentiates agent-input sliders
            // (no checkbox, no "Add context" note, justification dropdown is the
            // only context UI) from buyer-input sliders (current behavior preserved
            // until D32-B replaces them with SMS-pending placeholders).
            const renderSlider = (factor, variant) => (
              <FactorInput
                key={factor.id}
                factor={factor}
                colorScheme="neutral"
                variant={variant}
                justificationOptions={variant === 'agent-input' ? D32C_JUSTIFICATION_OPTIONS[factor.id] : undefined}
                justification={justifications[factor.id]}
                isLegacyReport={isLegacyJustificationReport}
                onUpdate={(updated) => routeFactorUpdate(factor, updated)}
                onJustificationChange={(j) => {
                  setJustifications(prev => {
                    const next = { ...prev };
                    if (j === null) delete next[factor.id];
                    else next[factor.id] = j;
                    return next;
                  });
                }}
              />
            );

            return (
              <div className="space-y-6">
                {/* D32-B: Top: Buyer Inputs section. Each card shows pending or
                    received state. Pending = "Waiting on buyer/client to submit"
                    + dev-override button (allowlisted). Received = static, non-
                    interactive slider showing the buyer's value. SMS dispatch is
                    stubbed until Twilio Campaign approval. */}
                <div className="glass rounded-2xl p-6">
                  <div className="flex items-center gap-2 mb-4">
                    <h3 className="font-bold text-stone-200">Buyer Inputs</h3>
                    <span className="text-xs text-stone-400 ml-2">(you fill these in)</span>
                    {isDevBuyerOverrideEnabled(user) && (
                      <div className="ml-auto flex items-center gap-2">
                        {(() => {
                          const allReceived = buyerInputFactors.every(f => buyerResponses[f.id]);
                          if (allReceived) return null;
                          return (
                            <button
                              type="button"
                              onClick={async () => {
                                // Auto-fill any still-pending buyer inputs with realistic
                                // synthetic values. Stable across runs for predictable testing.
                                const synthetic = { emotional: 7, timePressure: 5, uniquelySuited: 6, buyerFinancialStrength: 7 };
                                for (const f of buyerInputFactors) {
                                  if (buyerResponses[f.id]) continue;
                                  const v = synthetic[f.id] ?? 6;
                                  await setBuyerResponseDevOverride(f.id, v);
                                }
                              }}
                              className="text-xs px-3 py-1.5 rounded-lg bg-amber-500/15 border border-amber-500/40 text-amber-300 hover:bg-amber-500/25 transition-colors"
                              title="DEV: auto-fill all pending buyer inputs with synthetic values for testing"
                            >
                              ⚡ Dev: auto-fill all
                            </button>
                          );
                        })()}
                        {Object.keys(buyerResponses).length > 0 && (
                          <button
                            type="button"
                            onClick={resetBuyerResponsesDev}
                            className="text-xs px-3 py-1.5 rounded-lg bg-stone-700/40 border border-stone-600/50 text-stone-300 hover:bg-stone-700/70 transition-colors"
                            title="DEV: clear all buyer responses and return cards to pending state (for red-team testing)"
                          >
                            ↺ Dev: reset
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                  {/* 2026-07-28: the buyer now fills these four inputs directly on Page 3 —
                      no SMS, no waiting. Routed through the same editable FactorInput slider
                      the Agent Inputs use: bound to buyerFactors, persisted via
                      buyer_factors_json, and mirrored into the leverage score. No pending
                      buyer_subjective_responses rows are created, so the D40 Pending Inputs
                      Gate passes naturally. (Reverts the D32-B SMS-pending placeholder UI.) */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 items-start">
                    {buyerInputFactors.map(f => renderSlider(f, 'buyer-input'))}
                  </div>
                </div>

                {/* Bottom: Agent Inputs (require justification when moved off default) */}
                <div className="glass rounded-2xl p-6">
                  <div className="flex items-center gap-2 mb-4">
                    <h3 className="font-bold text-stone-200">Agent Inputs</h3>
                  </div>
                  {/* D32-C punchlist: items-start prevents the grid from stretching
                      sibling cards to match the tallest in the row, which left empty
                      space at the bottom of cards whose dropdowns weren't yet visible. */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 items-start">
                    {agentInputFactors.map(f => renderSlider(f, 'agent-input'))}
                  </div>
                </div>
              </div>
            );
          })()}

          {/* v4.0: Leverage preview removed - "The Prestige" reveal happens in Step 4 */}

          {/* V3.6: Market Context Panel */}
          <div className="glass rounded-2xl p-6">
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl">🏠</span>
              <h3 className="font-bold text-white">Market Context</h3>
              <span className="text-xs text-stone-400 ml-2">Help us calibrate realistic expectations</span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Financing Type */}
              <div>
                <label className="block text-sm text-stone-400 mb-2">Financing Type</label>
                <select
                  value={marketContext.financingType}
                  onChange={(e) => setMarketContext({...marketContext, financingType: e.target.value})}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none"
                >
                  <option value="conventional">Conventional</option>
                  <option value="fha">FHA (lender may require repairs)</option>
                  <option value="va">VA (lender may require repairs)</option>
                  <option value="cash">Cash (maximum leverage)</option>
                </select>
              </div>

              {/* Market Temperature - only show if no original list price (data-driven motivation replaces this) */}
              {!propertyInfo.originalListPrice && (
                <div>
                  <label className="block text-sm text-stone-400 mb-2">Market Temperature</label>
                  <select
                    value={marketContext.marketTemperature}
                    onChange={(e) => setMarketContext({...marketContext, marketTemperature: e.target.value})}
                    className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none"
                  >
                    <option value="hot">Hot — multiple offers common, over ask</option>
                    <option value="competitive">Competitive — low inventory, sellers have leverage</option>
                    <option value="balanced">Balanced — neither side dominates</option>
                    <option value="cooling">Cooling — DOM increasing, more price reductions</option>
                    <option value="cold">Cold — buyer's market, significant room</option>
                  </select>
                </div>
              )}

              {/* Seller Situation */}
              <div>
                <label className="block text-sm text-stone-400 mb-2">Seller's Situation (if known)</label>
                <select
                  value={marketContext.sellerSituation}
                  onChange={(e) => setMarketContext({...marketContext, sellerSituation: e.target.value})}
                  className="w-full bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-2 text-white focus:border-brand-500 focus:outline-none"
                >
                  <option value="unknown">Unknown</option>
                  <option value="buying_another">Buying another home</option>
                  <option value="relocation">Relocation (motivated)</option>
                  <option value="estate">Estate sale (motivated)</option>
                  <option value="divorce">Divorce (motivated)</option>
                  <option value="investor">Investor/flipper</option>
                </select>
              </div>
            </div>

            <div className="mt-4 p-3 bg-brand-500/10 border border-brand-500/30 rounded-lg">
              <p className="text-sm text-stone-300">
                <span className="text-brand-400 font-medium">Why this matters:</span> Market context helps us calculate realistic credit expectations. A hot market means you'll likely get less; motivated sellers mean more flexibility.
              </p>
            </div>
          </div>

          </div>

          {/* Navigation — was hidden when viewing saved reports; D18c lets agents navigate freely so we only hide if the inspection lock is on. */}
          {!inspectionLocked && (() => {
            // D32-C + post-Andrew polish: gate the Continue button on justification
            // completeness for ALL enabled agent-input sliders, regardless of whether
            // they've been moved off default. Per Jared 2026-05-05: even a
            // default-position rating is a rating the agent owns and must defend.
            // Legacy reports skip the requirement (per directive Part 7: editing an
            // old report's slider does NOT retroactively require justification).
            // 'OTHER' selections also need text content (warning at <30 chars;
            // blocking only at zero chars).
            const allAgentFactors = [...buyerFactors, ...sellerFactors].filter(f => D32C_AGENT_INPUT_IDS.has(f.id));
            const requiredAgentFactors = allAgentFactors.filter(f => f.enabled);
            const missingJustifications = isLegacyJustificationReport ? [] : requiredAgentFactors.filter(f => {
              const j = justifications[f.id];
              if (!j || !j.type) return true;
              if (j.type === D32C_OTHER_SENTINEL && (!j.text || j.text.trim().length === 0)) return true;
              return false;
            });
            // D46 Task 3: gating is scoped to AGENT input sliders ONLY. D44 Bug 6
            // also gated dev-override buyer-input sliders on a note, but buyer
            // sliders carry the buyer's number (delivered via text or dev
            // override) — asking the agent to justify the buyer's value re-opens
            // the liability surface D37–D39 closed. Buyer slider gating is
            // handled by the Pending Inputs Gate (D40), not here.
            const justificationsValid = missingJustifications.length === 0;
            const totalMissing = missingJustifications.length;
            return (
              <div className="space-y-3">
                {!justificationsValid && (
                  <div className="flex items-center justify-end">
                    <span className="text-xs text-amber-400">
                      {totalMissing === 1
                        ? 'Please provide a reason for the adjusted seller signal before continuing.'
                        : `Please provide a reason for each adjusted seller signal before continuing (${totalMissing} remaining).`}
                    </span>
                  </div>
                )}
                <div className="flex justify-between">
                  <button
                    onClick={() => goToStep(2)}
                    className="px-6 py-3 bg-stone-800 text-white rounded-xl hover:bg-stone-700 transition-all"
                  >
                    Back
                  </button>
                  <button
                    disabled={!justificationsValid || pigState.loading}
                    onClick={() => {
                      if (!justificationsValid || pigState.loading) return;
                      // D40 Task 1: routes through the Pending Inputs Gate.
                      // attemptStep3Continue either advances directly (gate
                      // pre-cleared, or nothing pending) or opens the gate.
                      attemptStep3Continue();
                    }}
                    className={`px-8 py-3 font-semibold rounded-xl transition-all shadow-lg ${
                      justificationsValid
                        ? 'bg-gradient-to-r from-brand-500 to-brand-600 text-white hover:from-brand-600 hover:to-brand-700 shadow-brand-500/25 glow-pulse'
                        : 'bg-stone-700 text-stone-400 cursor-not-allowed shadow-none'
                    }`}
                  >
                    {pigState.loading ? 'Checking pending inputs…' : 'Generate Strategy'}
                  </button>
                </div>
              </div>
            );
          })()}

          {/* D40 Task 1: Pending Inputs Gate (PIG) — hard interstitial that
              fires when the agent clicks "Generate Strategy" while async
              dispatched inputs are still outstanding. Portaled so it floats
              above the entire viewport. */}
          {pigState.showing && ReactDOM.createPortal(
            (() => {
              const fmtRelative = (iso) => {
                if (!iso) return '—';
                const ms = Date.now() - new Date(iso).getTime();
                if (ms < 60_000) return 'just now';
                const mins = Math.floor(ms / 60_000);
                if (mins < 60) return `${mins}m ago`;
                const hrs = Math.floor(mins / 60);
                if (hrs < 24) return `${hrs}h ago`;
                const days = Math.floor(hrs / 24);
                return `${days}d ago`;
              };
              const fmtAbs = (iso) => iso ? new Date(iso).toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';
              const lookupBuyerLabel = (qKey) => {
                const all = [...buyerFactors, ...sellerFactors];
                return all.find(f => f.id === qKey)?.label || qKey;
              };
              const cooldownLeft = pigState.reminderCooldownUntil
                ? Math.max(0, Math.ceil((new Date(pigState.reminderCooldownUntil).getTime() - Date.now()) / 1000))
                : 0;
              const reminderDisabled = cooldownLeft > 0
                || (pigState.pendingBuyer.length === 0 && pigState.pendingClient.length === 0);
              const totalPending = pigState.pendingBuyer.length + pigState.pendingClient.length;
              const devBypassVisible = isDevModeEnabled(user);
              return (
                <div className="fixed inset-0 bg-black/80 z-[60] flex items-center justify-center p-4">
                  <div className="bg-stone-900 rounded-2xl border border-stone-700 max-w-2xl w-full max-h-[85vh] overflow-y-auto">
                    <div className="p-6 border-b border-stone-800">
                      <div className="flex items-center gap-3 mb-2">
                        <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: 'rgba(251,191,36,0.15)', border: '1px solid rgba(251,191,36,0.4)' }}>
                          <span style={{ color: '#fcd34d' }}>⏳</span>
                        </div>
                        <h3 className="text-xl font-bold text-white">Pending inputs from your client and contractors</h3>
                      </div>
                      <p className="text-sm text-stone-400">
                        {totalPending === 1
                          ? '1 outstanding reply. The strategy is ready as soon as it arrives — we’ll auto-advance once nothing is pending.'
                          : `${totalPending} outstanding replies. The strategy is ready as soon as they arrive — we’ll auto-advance once nothing is pending.`}
                      </p>
                    </div>

                    <div className="p-6 space-y-6">
                      {pigState.pendingClient.length > 0 && (
                        <div>
                          <h4 className="text-xs uppercase tracking-wide text-stone-500 mb-2">Pricing requests</h4>
                          <ul className="space-y-2">
                            {pigState.pendingClient.map(row => {
                              const itemLabel = row.finding_snapshot?.item || `Finding ${row.finding_id}`;
                              return (
                                <li key={row.id} className="flex justify-between items-start gap-3 rounded-lg p-3" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
                                  <div className="flex-1 min-w-0">
                                    <div className="text-sm text-stone-200 font-medium truncate">{itemLabel}</div>
                                    <div className="text-xs text-stone-500">
                                      To {row.client_name || 'client'} · sent {fmtRelative(row.created_at)}
                                      {row.last_reminder_at && (<> · reminded {fmtRelative(row.last_reminder_at)}</>)}
                                    </div>
                                  </div>
                                  <span className="text-xs px-2 py-0.5 rounded-full bg-blue-500/15 text-blue-300 border border-blue-500/30 flex-shrink-0">awaiting reply</span>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                      {pigState.pendingBuyer.length > 0 && (
                        <div>
                          <h4 className="text-xs uppercase tracking-wide text-stone-500 mb-2">Buyer questions</h4>
                          <ul className="space-y-2">
                            {pigState.pendingBuyer.map(row => (
                              <li key={row.id} className="flex justify-between items-start gap-3 rounded-lg p-3" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
                                <div className="flex-1 min-w-0">
                                  <div className="text-sm text-stone-200 font-medium truncate">{lookupBuyerLabel(row.question_key)}</div>
                                  <div className="text-xs text-stone-500">
                                    sent {fmtRelative(row.sms_sent_at || row.created_at)}
                                    {row.last_reminder_at && (<> · reminded {fmtRelative(row.last_reminder_at)}</>)}
                                  </div>
                                </div>
                                <span className="text-xs px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-300 border border-amber-500/30 flex-shrink-0">awaiting reply</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                      {pigState.pendingBuyer.length === 0 && pigState.pendingClient.length === 0 && (
                        <p className="text-sm text-stone-400 italic">All replies received — advancing…</p>
                      )}
                    </div>

                    <div className="p-6 border-t border-stone-800 flex flex-wrap gap-3 items-center justify-between">
                      <div className="flex gap-3 items-center flex-wrap">
                        <button
                          type="button"
                          onClick={() => setPigState(prev => ({ ...prev, showing: false }))}
                          className="px-4 py-2 text-sm text-stone-400 hover:text-white"
                        >
                          Back to sliders
                        </button>
                        <button
                          type="button"
                          disabled={reminderDisabled}
                          onClick={handleSendReminders}
                          className="px-4 py-2 text-sm bg-stone-800 text-stone-200 border border-stone-700 rounded-lg hover:bg-stone-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {cooldownLeft > 0 ? `Reminder sent (${cooldownLeft}s)` : `Send reminders (${totalPending})`}
                        </button>
                      </div>
                      {devBypassVisible && (
                        <button
                          type="button"
                          disabled={pigState.bypassing}
                          onClick={handlePigBypass}
                          className="px-4 py-2 text-sm rounded-lg disabled:opacity-50"
                          style={{ background: 'rgba(251,191,36,0.15)', border: '1px solid rgba(251,191,36,0.5)', color: '#fcd34d' }}
                          title="DEV: bypass the gate without waiting on replies"
                        >
                          {pigState.bypassing ? 'Bypassing…' : '🛠 Bypass (DEV)'}
                        </button>
                      )}
                    </div>
                    <div className="px-6 pb-6">
                      <p className="text-xs text-stone-600 italic">
                        We re-check for replies every 30 seconds. Once everything is in, you’ll auto-advance to the strategy.
                      </p>
                    </div>
                  </div>
                </div>
              );
            })(),
            document.body
          )}
        </div>
        );
      };

      // ================================================================
      // V3.7: STEP 4 HELPER DATA AND FUNCTIONS
      // ================================================================

      // Portland Market Data (placeholder for MVP)
      const PORTLAND_MARKET_DATA = {
        medianDOM: 24,
        concessionRate: 62,
        avgCredit: 8400,
        trend: [
          { month: 'Aug', dom: 18 },
          { month: 'Sep', dom: 20 },
          { month: 'Oct', dom: 22 },
          { month: 'Nov', dom: 24 },
          { month: 'Dec', dom: 26 },
          { month: 'Jan', dom: 24 },
        ],
        condition: 'balanced'
      };

      // ================================================================
      // v4.2: URGENCY CLASSIFICATION SYSTEM
      // 4 tiers based on inspector language
      // ================================================================
      const URGENCY_KEYWORDS = {
        immediate: [
          'active leak', 'actively leaking', 'safety hazard', 'failed', 'inoperable',
          'requires immediate', 'immediate attention', 'hazardous', 'unsafe',
          'no longer functioning', 'not functioning', 'must be replaced', 'must be repaired',
          'dangerous', 'fire hazard', 'code violation', 'condemned', 'red-tagged',
          'health hazard', 'structural failure', 'collapsed', 'electrical hazard'
        ],
        nearTerm: [
          'should be repaired', 'should be replaced', 'needs attention', 'recommended',
          'worn', 'deteriorating', 'repair needed', 'should be evaluated', 'requires repair',
          'showing wear', 'needs repair', 'repair recommended', 'replacement recommended',
          'should be addressed', 'attention needed', 'service needed'
        ],
        longTerm: [
          'years of life', 'years remaining', 'useful life', 'end of life', 'lifecycle',
          'monitor', 'aging', 'plan for replacement', 'showing age', 'future replacement',
          'nearing end', 'approaching end', '3-5 years', '5-10 years', '3 to 5 years',
          '5 to 10 years', 'within the next', 'eventually', 'anticipate replacement'
        ],
        cosmetic: [
          'cosmetic', 'aesthetic', 'minor', 'typical wear', 'normal wear',
          'appearance only', 'does not affect function', 'visual only', 'surface',
          'paint', 'scuff', 'scratch', 'discoloration'
        ]
      };

      const classifyUrgency = (descriptionText) => {
        const text = (descriptionText || '').toLowerCase();

        if (URGENCY_KEYWORDS.immediate.some(kw => text.includes(kw))) {
          return 'immediate';
        }
        if (URGENCY_KEYWORDS.nearTerm.some(kw => text.includes(kw))) {
          return 'nearTerm';
        }
        if (URGENCY_KEYWORDS.longTerm.some(kw => text.includes(kw))) {
          return 'longTerm';
        }
        if (URGENCY_KEYWORDS.cosmetic.some(kw => text.includes(kw))) {
          return 'cosmetic';
        }

        return 'nearTerm'; // Default
      };

      const URGENCY_CONFIG = {
        immediate: { icon: '🔴', label: 'IMMEDIATE', color: '#ef4444' },
        nearTerm: { icon: '🟡', label: 'NEAR-TERM', color: '#eab308' },
        longTerm: { icon: '🔵', label: 'LONG-TERM', color: '#3b82f6' },
        cosmetic: { icon: '⚪', label: 'COSMETIC', color: '#9ca3af' }
      };

      const UrgencyBadge = ({ tier }) => {
        const config = URGENCY_CONFIG[tier] || URGENCY_CONFIG.nearTerm;
        return (
          <span className="urgency-badge" style={{ color: config.color }}>
            {config.icon} {config.label}
          </span>
        );
      };

      // ================================================================
      // v4.0: DEAL-KILLER FLAG SYSTEM
      // 54 keywords that indicate high-risk items requiring immediate attention
      // ================================================================
      const DEAL_KILLER_KEYWORDS = [
        // Safety hazards
        'federal pacific', 'fpe', 'stab-lok', 'zinsco', 'knob and tube', 'aluminum wiring',
        'asbestos', 'lead paint', 'mold', 'fungal growth', 'microbial', 'radon',
        'carbon monoxide', 'gas leak', 'fire hazard', 'electrical hazard',
        // Structural
        'foundation crack', 'foundation failure', 'structural damage', 'structural failure',
        'load-bearing', 'settling', 'subsidence', 'major crack', 'bowing wall',
        // Water/Sewer
        'active leak', 'water intrusion', 'sewer backup', 'sewer line replacement',
        'bellied sewer', 'collapsed pipe', 'root intrusion', 'main line',
        'septic failure', 'drain field', 'flooding',
        // Roof/Exterior
        'roof replacement', 'roof failure', 'roof beyond', 'end of life',
        'missing shingles', 'major roof', 'active roof leak',
        // HVAC/Major Systems
        'furnace replacement', 'hvac replacement', 'no heat', 'no cooling',
        'heat exchanger crack', 'condemned', 'red-tagged',
        // Insurance/Lender flags
        'uninsurable', 'insurability', 'lender required', 'fha required', 'va required',
        'health hazard', 'safety hazard', 'code violation', 'permit issue',
        'unpermitted', 'illegal'
      ];

      // Check if finding contains any deal-killer keywords
      const hasDealKillerFlag = (finding) => {
        const text = `${finding.item || ''} ${finding.description || ''}`.toLowerCase();
        return DEAL_KILLER_KEYWORDS.some(keyword => text.includes(keyword.toLowerCase()));
      };

      // Count deal-killer items in findings
      const countDealKillers = (findingsArray) => {
        return findingsArray.filter(f => f.selected && hasDealKillerFlag(f)).length;
      };

      // Get which keywords matched for a finding
      const getDealKillerMatches = (finding) => {
        const text = `${finding.item || ''} ${finding.description || ''}`.toLowerCase();
        return DEAL_KILLER_KEYWORDS.filter(keyword => text.includes(keyword.toLowerCase()));
      };

      // ================================================================
      // v4.4: ASK ASSESSMENT - FIXED SIGN CONVENTION
      // v5.2b: SIGN FLIPPED - Positive = favorable (good), Negative = aggressive (bad)
      // v5.3: Non-linear weighted: Leverage + Ask Favorability (weighted) = Outlook
      // ================================================================
      const calculateAskAssessment = (findingsArray, leverageScoreValue) => {
        const selected = findingsArray.filter(f => f.selected);
        const totalAsk = selected.reduce((sum, f) => sum + (f.cost || 0), 0);

        // Get urgency tier for each item
        const getItemUrgency = (item) => {
          if (item.urgencyTier) return item.urgencyTier;
          return classifyUrgency(item.description || item.reportText || '');
        };

        // Calculate urgency totals for transparency
        const immediateTotal = selected
          .filter(i => getItemUrgency(i) === 'immediate')
          .reduce((sum, i) => sum + (i.cost || 0), 0);
        const nearTermTotal = selected
          .filter(i => getItemUrgency(i) === 'nearTerm')
          .reduce((sum, i) => sum + (i.cost || 0), 0);
        const longTermTotal = selected
          .filter(i => getItemUrgency(i) === 'longTerm' || getItemUrgency(i) === 'cosmetic')
          .reduce((sum, i) => sum + (i.cost || 0), 0);

        const immediatePercent = totalAsk > 0 ? immediateTotal / totalAsk : 0;
        const nearTermPercent = totalAsk > 0 ? nearTermTotal / totalAsk : 0;
        const longTermPercent = totalAsk > 0 ? longTermTotal / totalAsk : 0;

        // Calculate expected range based on all findings (not just selected)
        // Base: expect to capture 40-55% of total documented repair costs
        const allItemsTotal = findingsArray.reduce((sum, f) => sum + (f.cost || 0), 0);

        // Adjust capture rate based on leverage
        // Better leverage = higher expected capture (45-60%)
        // Worse leverage = lower expected capture (35-50%)
        const leverageBonus = leverageScoreValue * 0.005; // +/-10% swing over full range
        const baseLow = 0.40 + leverageBonus;
        const baseHigh = 0.55 + leverageBonus;

        const expectedLow = Math.round(allItemsTotal * Math.max(0.30, baseLow));
        const expectedHigh = Math.round(allItemsTotal * Math.min(0.70, baseHigh));
        const expectedMidpoint = (expectedLow + expectedHigh) / 2;

        // Ask Ratio: how does your ask compare to expected midpoint?
        // 1.0 = asking exactly midpoint, 0.5 = conservative, 1.5 = aggressive
        const askRatio = expectedMidpoint > 0 ? totalAsk / expectedMidpoint : 1;

        // Convert ratio to score: 1.0 = 0, every 0.1 above/below = +/- 1 point
        // v5.2b: NEGATED - POSITIVE = favorable/conservative, NEGATIVE = aggressive
        const rawScore = (askRatio - 1) * 10;
        let score = Math.max(-10, Math.min(10, Math.round(-rawScore)));  // NEGATED

        // v5.9: Property value anchor — how big is the ask relative to the deal?
        // v5.9b: Extended tiers for extreme asks
        const contractPrice = parseFloat(String(propertyInfo.contractPrice || propertyInfo.listPrice || '0').replace(/[^0-9.]/g, '')) || 0;
        let propertyPenalty = 0;
        let askAsPercent = 0;

        if (contractPrice > 0) {
          askAsPercent = totalAsk / contractPrice;

          // Graduated thresholds based on real-world norms:
          // Typical successful asks are 2-5% of property value
          // Beyond 10% enters "unrealistic" territory
          if (askAsPercent > 0.50) {
            propertyPenalty = -10;     // 50%+ of property value — completely unrealistic
          } else if (askAsPercent > 0.35) {
            propertyPenalty = -8;      // 35-50% — extremely unrealistic
          } else if (askAsPercent > 0.20) {
            propertyPenalty = -6;      // 20-35% — very unrealistic
          } else if (askAsPercent > 0.10) {
            propertyPenalty = -4;      // 10-20% — unrealistic
          } else if (askAsPercent > 0.06) {
            propertyPenalty = -2;      // 6-10% — aggressive
          } else if (askAsPercent > 0.03) {
            propertyPenalty = -1;      // 3-6% — slightly aggressive
          }
          // 0-3% = no penalty (normal range)

          score = Math.max(-10, Math.min(10, score + propertyPenalty));
        }

        // v5.3: SHORT-CIRCUIT — use saved score for loaded reports (Directive 12.5)
        // Override happens BEFORE label generation so labels stay consistent with the saved score
        if (loadedAskFavorabilityScore !== null && loadedAskFavorabilityScore !== undefined) {
          score = loadedAskFavorabilityScore;
        }

        // D29 Part 1 (v2): Dual-anchor reconciliation runs AFTER the loaded-score override.
        // Reason: scores saved before D29 shipped don't have the property-value anchor baked in.
        // Without this placement, a saved report would keep showing the pre-D29 punitive score
        // forever (the case Jared saw on the live 1980 16th St report — saved -7 / VERY AGGRESSIVE
        // staying after D29 deploy). Running the anchor post-override makes D29's improvement
        // apply universally without losing the byte-for-byte stability for saved reports where
        // the segment math was correct.
        if (typeof computePropertyValueAnchorScore === 'function' && contractPrice > 0 && totalAsk > 0) {
          const s_pct = computePropertyValueAnchorScore(totalAsk, contractPrice);
          if (s_pct !== null) {
            const s_segment = Math.max(0, Math.min(1, (score + 10) / 20));
            const combined = Math.max(s_segment, s_pct);
            score = Math.max(-10, Math.min(10, Math.round((combined - 0.5) * 20)));
          }
        }

        // Determine label and explanation based on score (thresholds flipped for new sign)
        let label, explanation, color;
        if (score >= 6) {
          label = 'VERY FAVORABLE';
          explanation = 'Asking well below expected range. High chance of acceptance.';
          color = '#22c55e';
        } else if (score >= 2) {
          label = 'FAVORABLE';
          explanation = 'Asking below expected range. Good chance of acceptance.';
          color = '#86efac';
        } else if (score >= -1) {
          label = 'MODERATE';
          explanation = 'Asking within expected range. Reasonable chance of acceptance.';
          color = '#eab308';
        } else if (score >= -5) {
          label = 'AMBITIOUS';
          explanation = 'Asking above expected range. May face some resistance.';
          color = '#f97316';
        } else {
          label = 'VERY AGGRESSIVE';
          explanation = 'Asking well above expected range. Expect significant pushback.';
          color = '#ef4444';
        }

        // Build subtext with specific details
        const subtextParts = [];
        if (askRatio > 1.1) {
          subtextParts.push(`${Math.round((askRatio - 1) * 100)}% above expected midpoint`);
        } else if (askRatio < 0.9) {
          subtextParts.push(`${Math.round((1 - askRatio) * 100)}% below expected midpoint`);
        }
        if (longTermPercent > 0.4) {
          subtextParts.push(`${Math.round(longTermPercent * 100)}% is long-term/cosmetic`);
        }
        if (immediatePercent > 0.6) {
          subtextParts.push('Mostly urgent items');
        }
        const subtext = subtextParts.join('. ') + (subtextParts.length ? '.' : '');

        return {
          score,
          label,
          explanation,
          color,
          subtext,
          totalAsk,
          expectedLow,
          expectedHigh,
          expectedMidpoint,
          askRatio,
          immediateTotal,
          nearTermTotal,
          longTermTotal,
          immediatePercent,
          nearTermPercent,
          longTermPercent,
          dealKillerCount: countDealKillers(findingsArray),
          // v5.9: Property value ratio data
          propertyPenalty,
          askAsPercent,
          contractPrice
        };
      };

      // ================================================================
      // v4.4: COMBINED OUTLOOK CALCULATION
      // v5.3: Non-linear weighted scoring with hard caps
      // - Extreme asks (beyond ±5) have amplified impact
      // - Very aggressive asks cap the outlook to prevent leverage masking
      // ================================================================
      const calculateOutlookScore = (leverageScoreValue, findingsArray) => {
        const askAssessment = calculateAskAssessment(findingsArray, leverageScoreValue);
        const askScore = askAssessment.score;

        // Non-linear weighting: extreme asks have amplified impact
        // Ask score between -5 and +5: weight 1x (normal)
        // Ask score between -6/-8 or +6/+8: weight 1.5x
        // Ask score beyond -8 or +8: weight 2x
        let weightedAsk;
        const absAsk = Math.abs(askScore);
        if (absAsk <= 5) {
          weightedAsk = askScore;
        } else if (absAsk <= 8) {
          // Scale the portion beyond 5 at 1.5x
          const sign = askScore > 0 ? 1 : -1;
          weightedAsk = sign * (5 + (absAsk - 5) * 1.5);
        } else {
          // Scale the portion beyond 8 at 2x
          const sign = askScore > 0 ? 1 : -1;
          weightedAsk = sign * (5 + (3 * 1.5) + (absAsk - 8) * 2);
        }

        let outlookScore = leverageScoreValue + weightedAsk;

        // Hard cap: if ask is Very Aggressive (score <= -6) or Very Favorable (score >= 6),
        // cap the outlook to prevent leverage from masking an extreme ask
        if (askScore <= -6) {
          // Very aggressive ask: outlook cannot be higher than -3 ("Challenging")
          outlookScore = Math.min(outlookScore, -3);
        } else if (askScore >= 6) {
          // Very favorable ask: outlook cannot be lower than +3 ("Favorable")
          outlookScore = Math.max(outlookScore, 3);
        }

        // v5.1: Realistic property value percentage caps
        // In real estate, asking 3% is reasonable, 5%+ is aggressive, 10%+ is extreme
        if (askAssessment.askAsPercent > 0.25) {
          // 25%+ of property value: force to UNREALISTIC tier
          outlookScore = Math.min(outlookScore, -15);
        } else if (askAssessment.askAsPercent > 0.15) {
          // 15-25%: deep DIFFICULT territory
          outlookScore = Math.min(outlookScore, -12);
        } else if (askAssessment.askAsPercent > 0.10) {
          // 10-15%: DIFFICULT tier - this is an extreme ask
          outlookScore = Math.min(outlookScore, -8);
        } else if (askAssessment.askAsPercent > 0.05) {
          // 5-10%: Aggressive territory - cap at CHALLENGING
          outlookScore = Math.min(outlookScore, -5);
        }

        // Clamp to valid range
        outlookScore = Math.max(-20, Math.min(20, Math.round(outlookScore)));

        // v5.3: SHORT-CIRCUIT — use saved outlook score for loaded reports (Directive 12.5)
        // Applied AFTER all caps and clamps so the saved value is the final say
        if (loadedOutlookScore !== null && loadedOutlookScore !== undefined) {
          outlookScore = loadedOutlookScore;
        }

        return {
          outlookScore,
          leverageScore: leverageScoreValue,
          askAssessment
        };
      };

      // Get verdict based on Outlook score (not just leverage)
      const getOutlookVerdictData = (outlookScore) => {
        if (outlookScore >= 12) return {
          text: 'DOMINANT POSITION',
          color: '#15803d',
          summary: "Excellent position with strong justification. Push confidently."
        };
        if (outlookScore >= 7) return {
          text: 'STRONG OUTLOOK',
          color: '#22c55e',
          summary: "You have meaningful leverage and a well-supported ask."
        };
        if (outlookScore >= 3) return {
          text: 'FAVORABLE OUTLOOK',
          color: '#86efac',
          summary: "Good position. Stay strategic with your priorities."
        };
        if (outlookScore >= -2) return {
          text: 'BALANCED OUTLOOK',
          color: '#eab308',
          summary: "Even ground—preparation and documentation are key."
        };
        if (outlookScore >= -6) return {
          text: 'CHALLENGING OUTLOOK',
          color: '#7b8bff',
          summary: "Uphill negotiation. Focus on critical items."
        };
        // v5.9b: Added tier for extreme/unrealistic asks
        if (outlookScore >= -12) return {
          text: 'DIFFICULT OUTLOOK',
          color: '#ef4444',
          summary: "Tough position. Prioritize must-haves and be prepared to compromise."
        };
        return {
          text: 'UNREALISTIC OUTLOOK',
          color: '#991b1b',  // Dark red - darker than #ef4444
          summary: "This ask falls far outside typical negotiation range. Consider focusing on critical safety items only."
        };
      };

      // Get leverage assessment label
      // v5.9: Thresholds updated for ±10 display scale (pass displayLeverageScore, not raw)
      const getLeverageAssessmentData = (displayScoreValue) => {
        if (displayScoreValue >= 5) return { label: 'STRONG', color: '#22c55e', explanation: 'Market conditions and property factors favor the buyer significantly.' };
        if (displayScoreValue >= 3) return { label: 'FAVORABLE', color: '#86efac', explanation: 'Several factors work in your favor. Good foundation for negotiation.' };
        if (displayScoreValue >= 0) return { label: 'BALANCED', color: '#eab308', explanation: 'Neither party has a clear advantage. Results depend on execution.' };
        if (displayScoreValue >= -3) return { label: 'LIMITED', color: '#7b8bff', explanation: 'Seller has some advantages. Be strategic with your asks.' };
        return { label: 'WEAK', color: '#ef4444', explanation: 'Market favors the seller. Focus on must-haves only.' };
      };

      // Justification Cards for common repair items
      const JUSTIFICATION_CARDS = [
        {
          id: 'federal_pacific',
          patterns: ['federal pacific', 'fpe', 'stab-lok', 'stab lok', 'zinsco'],
          title: 'Federal Pacific Panel',
          icon: '🔌',
          issue: 'Federal Pacific Stab-Lok panels have documented breaker failures. Breakers may not trip during overloads, creating fire risk.',
          whyItMatters: [
            'Many insurers won\'t write policies with FPE panels',
            'Those that will often require replacement within 30 days',
            'This affects insurability, not just preference'
          ],
          pushbackResponse: 'Our buyers need this addressed for their insurance to bind. This isn\'t a preference item — it\'s a requirement.'
        },
        {
          id: 'aging_furnace',
          patterns: ['furnace', 'hvac', 'heat pump'],
          title: 'Aging HVAC System',
          icon: '🔥',
          issue: 'HVAC systems over 15-20 years are at end of life. Efficiency drops significantly and failure risk increases.',
          whyItMatters: [
            'Average furnace lifespan is 15-20 years',
            'Older units may not qualify for home warranty coverage',
            'Carbon monoxide risk increases with age'
          ],
          pushbackResponse: 'At [X] years old, this system is past its expected lifespan. Our buyers need to budget for imminent replacement — that\'s what this credit covers.'
        },
        {
          id: 'roof_eol',
          patterns: ['roof replacement', 'roof end of life', 'roof beyond useful'],
          title: 'Roof End of Life',
          icon: '🏠',
          issue: 'Roof is at or past expected service life. Risk of leaks and damage to interior/structure.',
          whyItMatters: [
            'Insurance may not cover roof-related claims',
            'Some insurers require roof under 15-20 years',
            'Deferred roof work leads to secondary damage'
          ],
          pushbackResponse: 'The roof\'s age affects insurability. Our buyers will need to budget for this regardless — we\'re asking the seller to participate in that cost.'
        },
        {
          id: 'sewer_issues',
          patterns: ['sewer', 'main line', 'bellied', 'belly', 'scope'],
          title: 'Sewer Line Issues',
          icon: '🚰',
          issue: 'Sewer scope revealed issues requiring repair. These problems worsen over time and can lead to backup/failure.',
          whyItMatters: [
            'Sewer repairs can uncover additional issues',
            'Cleanup from backup is costly and hazardous',
            'This affects habitability, not cosmetics'
          ],
          pushbackResponse: 'Sewer line issues affect the basic function of the home. This isn\'t optional maintenance — it\'s addressing a known defect.'
        },
        {
          id: 'mold',
          patterns: ['mold', 'fungal', 'microbial'],
          title: 'Mold Presence',
          icon: '🦠',
          issue: 'Mold identified in the home. Requires professional remediation following proper protocols.',
          whyItMatters: [
            'Health risk for occupants, especially sensitive individuals',
            'Can spread if not properly addressed',
            'Lenders may require remediation before closing'
          ],
          pushbackResponse: 'Mold remediation requires professional handling. This is a health and safety issue that needs to be resolved before our buyers move in.'
        },
        {
          id: 'foundation',
          patterns: ['foundation', 'structural', 'settling'],
          title: 'Foundation/Structural',
          icon: '🏗️',
          issue: 'Foundation or structural issues identified. These are fundamental to the home\'s integrity.',
          whyItMatters: [
            'Structural issues can worsen significantly over time',
            'May affect insurability and resale',
            'Often requires engineering evaluation'
          ],
          pushbackResponse: 'Foundation issues affect the core integrity of the structure. Our buyers need confidence this is addressed before purchasing.'
        },
        {
          id: 'water_heater',
          patterns: ['water heater'],
          title: 'Water Heater',
          icon: '🔥',
          issue: 'Water heater is at or past expected lifespan (typically 10-15 years). Risk of failure or leak.',
          whyItMatters: [
            'Water heater failure can cause significant water damage',
            'Older units less efficient and more costly to operate',
            'May not meet current code requirements'
          ],
          pushbackResponse: 'At [X] years, this water heater has exceeded its expected lifespan. We\'re asking for credit toward the replacement that will be needed soon.'
        },
        {
          id: 'electrical_wiring',
          patterns: ['knob and tube', 'aluminum wiring', 'double tapped'],
          title: 'Electrical Wiring Issues',
          icon: '⚡',
          issue: 'Outdated or improper electrical wiring identified. Creates safety and insurance concerns.',
          whyItMatters: [
            'Knob & tube and aluminum wiring are insurance red flags',
            'Creates fire risk without proper remediation',
            'May not support modern electrical loads'
          ],
          pushbackResponse: 'This wiring issue affects insurability and safety. Most carriers require this addressed before they\'ll write a policy.'
        }
      ];

      // Get relevant justification cards for current findings
      const getRelevantJustificationCards = (findingsArray) => {
        return JUSTIFICATION_CARDS.filter(card =>
          findingsArray.some(f =>
            card.patterns.some(p =>
              `${f.item || ''} ${f.description || ''}`.toLowerCase().includes(p)
            )
          )
        );
      };

      // Calculate request totals by type
      const calculateRequestTotals = (findingsArray) => {
        const selected = findingsArray.filter(f => f.selected);
        const creditItems = selected.filter(f => (f.requestType || 'credit') === 'credit');
        const sellerRepairItems = selected.filter(f => f.requestType === 'seller_repair');
        const excludedItems = selected.filter(f => f.requestType === 'exclude');

        return {
          creditTotal: creditItems.reduce((sum, f) => sum + (f.cost || 0), 0),
          creditItems,
          sellerRepairTotal: sellerRepairItems.reduce((sum, f) => sum + (f.cost || 0), 0),
          sellerRepairItems,
          excludedTotal: excludedItems.reduce((sum, f) => sum + (f.cost || 0), 0),
          excludedItems,
          totalValue: creditItems.reduce((sum, f) => sum + (f.cost || 0), 0) + sellerRepairItems.reduce((sum, f) => sum + (f.cost || 0), 0)
        };
      };

      // Copy to clipboard helper
      const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
          // Simple toast notification would go here
          alert('Copied to clipboard!');
        });
      };

      // ================================================================
      // v5.0: PDF EXPORT SYSTEM
      // ================================================================

      // Helper: Sanitize filename for safe file saving
      const sanitizeFilename = (str) => {
        if (!str) return 'Report';
        return str.replace(/[^a-zA-Z0-9\s-]/g, '').replace(/\s+/g, '-').substring(0, 50);
      };

      // Note: PDF templates removed - now using hybrid section-based capture approach
      // See exportStrategyPDF() and exportClientPDF() for the new implementation

      // PDF TEMPLATES REMOVED - Using hybrid section-based capture now
      // Old generateStrategyPDF and generateClientPDF templates deleted
      // The new exportStrategyPDF() and exportClientPDF() capture the actual rendered page


      // Master PDF Export Function - Routes to appropriate export method
      const exportPDF = async (type) => {
        if (type === 'strategy') {
          await exportStrategyPDF();
        } else if (type === 'client') {
          await exportClientPDF();
        }
      };

      // v5.6: Canvas-based gauge for PDF - fixed arc rendering
      const drawGaugeForPdf = (outlookScore) => {
        const canvas = document.createElement('canvas');
        canvas.width = 400;
        canvas.height = 220;
        const ctx = canvas.getContext('2d');

        const centerX = 200;
        const centerY = 180;
        const radius = 140;
        const lineWidth = 32;  // v5.7: Thicker arc for better visibility

        // v5.12: FIXED gauge math for UPPER semicircle
        // Upper semicircle: PI (9 o'clock/left) → 3PI/2 (12 o'clock/top) → 2PI (3 o'clock/right)
        // Mapping: angle = PI + (position * PI)
        //   position 0.0 → PI (left)
        //   position 0.5 → 1.5*PI (top)
        //   position 1.0 → 2*PI (right)
        const clampedScore = Math.max(-20, Math.min(20, outlookScore));
        const normalized = (clampedScore + 20) / 40; // 0 to 1

        // v5.12b: Anti-snap logic - prevent needle from landing on tick marks or dead center
        // This makes the gauge look more "calculated" and analog rather than snapping to presets
        const tickPositions = [0.15, 0.35, 0.50, 0.70, 0.85];
        const deadZone = 0.02;   // ±2% around each tick
        const nudgeAmount = 0.03; // Push 3% away from the tick

        let adjustedNormalized = normalized;

        for (const tick of tickPositions) {
          if (Math.abs(adjustedNormalized - tick) < deadZone) {
            // Nudge away from the tick mark
            // For center (0.50) with exact zero score: nudge toward buyer side (right/positive)
            if (tick === 0.50 && clampedScore === 0) {
              adjustedNormalized = tick + nudgeAmount; // Lean slightly toward buyer
            } else if (adjustedNormalized >= tick) {
              adjustedNormalized = tick + nudgeAmount;
            } else {
              adjustedNormalized = tick - nudgeAmount;
            }
            break;
          }
        }

        // Clamp to valid range (keep needle within gauge bounds)
        adjustedNormalized = Math.max(0.02, Math.min(0.98, adjustedNormalized));

        const needleAngle = Math.PI + (adjustedNormalized * Math.PI); // PI (left) to 2*PI (right)

        const segments = [
          { start: 0.0, end: 0.15, color: '#dc2626' },   // bright red - Difficult (leftmost)
          { start: 0.15, end: 0.35, color: '#ea580c' },  // bright orange - Challenging
          { start: 0.35, end: 0.50, color: '#ca8a04' },  // deep yellow - Balanced
          { start: 0.50, end: 0.70, color: '#65a30d' },  // lime green - Favorable
          { start: 0.70, end: 0.85, color: '#16a34a' },  // green - Strong
          { start: 0.85, end: 1.0, color: '#15803d' },   // dark green - Dominant (rightmost)
        ];

        // Draw each colored segment on the UPPER semicircle
        segments.forEach(seg => {
          const startAngle = Math.PI + (seg.start * Math.PI);
          const endAngle = Math.PI + (seg.end * Math.PI);

          ctx.beginPath();
          ctx.arc(centerX, centerY, radius, startAngle, endAngle, false);  // clockwise = short arc
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = seg.color;
          ctx.lineCap = 'butt';
          ctx.stroke();
        });

        // v5.12: Tick marks at segment boundaries (same angle mapping)
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 4;
        [0.15, 0.35, 0.50, 0.70, 0.85].forEach(pos => {
          const angle = Math.PI + (pos * Math.PI);
          const innerR = radius - lineWidth / 2 - 2;
          const outerR = radius + lineWidth / 2 + 2;
          ctx.beginPath();
          // For upper semicircle (angles PI to 2PI), sin is negative, so + sin moves up
          ctx.moveTo(centerX + innerR * Math.cos(angle), centerY + innerR * Math.sin(angle));
          ctx.lineTo(centerX + outerR * Math.cos(angle), centerY + outerR * Math.sin(angle));
          ctx.stroke();
        });

        // Draw needle (same angle mapping)
        const needleLength = radius - lineWidth / 2 - 10;
        const needleX = centerX + needleLength * Math.cos(needleAngle);
        const needleY = centerY + needleLength * Math.sin(needleAngle);  // + sin (negative in upper half)

        // Needle shadow
        ctx.beginPath();
        ctx.moveTo(centerX + 2, centerY + 2);
        ctx.lineTo(needleX + 2, needleY + 2);
        ctx.strokeStyle = 'rgba(0,0,0,0.2)';
        ctx.lineWidth = 5;
        ctx.lineCap = 'round';
        ctx.stroke();

        // Needle
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.lineTo(needleX, needleY);
        ctx.strokeStyle = '#1f2937';
        ctx.lineWidth = 4;
        ctx.lineCap = 'round';
        ctx.stroke();

        // Center dot
        ctx.beginPath();
        ctx.arc(centerX, centerY, 12, 0, Math.PI * 2);
        ctx.fillStyle = '#1f2937';
        ctx.fill();
        ctx.beginPath();
        ctx.arc(centerX, centerY, 6, 0, Math.PI * 2);
        ctx.fillStyle = '#ffffff';
        ctx.fill();

        return canvas.toDataURL('image/png');
      };

      // D30: Canvas-based gauge for the GPS Score (1-10). Mirrors drawGaugeForPdf
      // but with the GPS palette and 1-10 normalization. Returns a data URL.
      const drawGpsGaugeForPdf = (score) => {
        const canvas = document.createElement('canvas');
        canvas.width = 320;
        canvas.height = 180;
        const ctx = canvas.getContext('2d');

        const centerX = 160;
        const centerY = 150;
        const radius = 115;
        const lineWidth = 28;

        const clampedScore = Math.max(1, Math.min(10, score || 1));
        // Normalize 1→0, 10→1
        const normalized = (clampedScore - 1) / 9;
        const needleAngle = Math.PI + (normalized * Math.PI);

        // Segments aligned with _gpsTierColor: red (1-3), amber (4-5), blue (6-7), emerald (8-10)
        // Boundary positions on the 0-1 normalized axis: 3→2/9, 5→4/9, 7→6/9
        const segments = [
          { start: 0,    end: 2/9, color: '#dc2626' }, // 1-3 red
          { start: 2/9,  end: 4/9, color: '#d97706' }, // 4-5 amber
          { start: 4/9,  end: 6/9, color: '#2563eb' }, // 6-7 blue
          { start: 6/9,  end: 1,   color: '#059669' }, // 8-10 emerald
        ];

        segments.forEach(seg => {
          const startAngle = Math.PI + (seg.start * Math.PI);
          const endAngle = Math.PI + (seg.end * Math.PI);
          ctx.beginPath();
          ctx.arc(centerX, centerY, radius, startAngle, endAngle, false);
          ctx.lineWidth = lineWidth;
          ctx.strokeStyle = seg.color;
          ctx.lineCap = 'butt';
          ctx.stroke();
        });

        // Tick marks at segment boundaries
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 3;
        [2/9, 4/9, 6/9].forEach(pos => {
          const angle = Math.PI + (pos * Math.PI);
          const innerR = radius - lineWidth / 2 - 2;
          const outerR = radius + lineWidth / 2 + 2;
          ctx.beginPath();
          ctx.moveTo(centerX + innerR * Math.cos(angle), centerY + innerR * Math.sin(angle));
          ctx.lineTo(centerX + outerR * Math.cos(angle), centerY + outerR * Math.sin(angle));
          ctx.stroke();
        });

        // Needle
        const needleLength = radius - lineWidth / 2 - 8;
        const needleX = centerX + needleLength * Math.cos(needleAngle);
        const needleY = centerY + needleLength * Math.sin(needleAngle);

        ctx.beginPath();
        ctx.moveTo(centerX + 2, centerY + 2);
        ctx.lineTo(needleX + 2, needleY + 2);
        ctx.strokeStyle = 'rgba(0,0,0,0.2)';
        ctx.lineWidth = 4;
        ctx.lineCap = 'round';
        ctx.stroke();

        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.lineTo(needleX, needleY);
        ctx.strokeStyle = '#1f2937';
        ctx.lineWidth = 4;
        ctx.lineCap = 'round';
        ctx.stroke();

        // Center dot
        ctx.beginPath();
        ctx.arc(centerX, centerY, 10, 0, Math.PI * 2);
        ctx.fillStyle = '#1f2937';
        ctx.fill();
        ctx.beginPath();
        ctx.arc(centerX, centerY, 5, 0, Math.PI * 2);
        ctx.fillStyle = '#ffffff';
        ctx.fill();

        return canvas.toDataURL('image/png');
      };

      // v5.10: Section header band for PDF - creates visual separation between evidence sections
      const createPdfSectionHeader = (title, rightText = null) => {
        const header = document.createElement('div');
        header.style.cssText = `
          background: #f1f5f9;
          border-bottom: 2px solid #e2e8f0;
          padding: 10px 20px;
          margin-bottom: 12px;
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 6px 6px 0 0;
        `;

        const titleEl = document.createElement('span');
        titleEl.style.cssText = 'font-size: 12px; font-weight: 700; color: #1e293b; text-transform: uppercase; letter-spacing: 0.5px;';
        titleEl.textContent = title;
        header.appendChild(titleEl);

        if (rightText) {
          const rightEl = document.createElement('span');
          rightEl.style.cssText = 'font-size: 10px; font-weight: 500; color: #64748b;';
          rightEl.textContent = rightText;
          header.appendChild(rightEl);
        }

        return header;
      };

      // Strategy PDF - Captures actual rendered page sections (v5.1: offscreen cloning, no flash)
      const exportStrategyPDF = async () => {
        setPdfGenerating(true);
        setPdfDropdownOpen(false);

        // v6.10: Save current tab outside try block so catch handler can restore it
        const savedActiveTab = activeTab;

        try {
          // 1. Save current state of ALL collapsible sections
          const savedExpandedState = { ...expandedSections };
          const savedShowFunnel = showFunnel;
          const savedShowCalcReceipt = showCalcReceipt;
          const savedShowAssessments = showAssessments;
          const savedClosingCostTip = closingCostTipExpanded;

          // 2. Expand ALL collapsibles and switch to strategy tab
          setActiveTab('strategy');
          setExpandedSections({
            'section-ask-breakdown': true,
            'section-market-context': true,
            'section-critical-items': true
          });
          if (!showFunnel) setShowFunnel(true);
          if (!showCalcReceipt) setShowCalcReceipt(true);
          if (!showAssessments) setShowAssessments(true);
          setClosingCostTipExpanded(true);

          // 3. Wait for React to re-render expanded content
          await new Promise(resolve => setTimeout(resolve, 500));

          // 4. Create offscreen container (no visible flash)
          const offscreen = document.createElement('div');
          offscreen.className = 'print-mode';
          offscreen.style.cssText = 'position: absolute; left: -9999px; top: 0; width: 8.5in; background: #ffffff; z-index: -1;';
          document.body.appendChild(offscreen);

          // 5. Inject branding hero as first section (if profile exists)
          // v6.0: Executive design - dark navy header
          if (profile && (profile.first_name || profile.headshot_url)) {
            const brandingHero = document.createElement('div');
            brandingHero.className = 'print-mode';
            brandingHero.setAttribute('data-pdf-hero', 'true');
            brandingHero.style.cssText = 'background: #1e3a5f !important; border: none !important; border-radius: 0; padding: 32px; margin-bottom: 16px; display: flex; align-items: center; justify-content: space-between;';

            const leftSide = document.createElement('div');
            leftSide.style.cssText = 'display: flex; align-items: center; gap: 24px;';

            if (profile.headshot_url) {
              const headshot = document.createElement('img');
              headshot.src = `https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${profile.headshot_url}`;
              headshot.crossOrigin = 'anonymous';
              headshot.setAttribute('data-pdf-headshot', 'true');
              headshot.style.cssText = 'width: 128px; height: 128px; border-radius: 50% !important; object-fit: cover; border: 3px solid #ffffff;';
              leftSide.appendChild(headshot);
            }

            const info = document.createElement('div');

            const name = document.createElement('div');
            name.style.setProperty('font-size', '24px', 'important');
            name.style.setProperty('font-weight', '700', 'important');
            name.style.setProperty('color', '#ffffff', 'important');
            name.style.setProperty('margin-bottom', '4px', 'important');
            name.textContent = `${profile.first_name || ''} ${profile.last_name || ''}`.trim();
            if (profile.designations) {
              const desig = document.createElement('span');
              desig.style.setProperty('font-size', '14px', 'important');
              desig.style.setProperty('font-weight', '400', 'important');
              desig.style.setProperty('color', '#94a3b8', 'important');
              desig.style.setProperty('margin-left', '8px', 'important');
              desig.textContent = profile.designations;
              name.appendChild(desig);
            }
            info.appendChild(name);

            if (profile.brokerage) {
              const brokerage = document.createElement('div');
              brokerage.style.setProperty('font-size', '16px', 'important');
              brokerage.style.setProperty('color', '#e2e8f0', 'important');
              brokerage.style.setProperty('margin-bottom', '2px', 'important');
              brokerage.textContent = profile.brokerage;
              info.appendChild(brokerage);
            }

            const details = document.createElement('div');
            details.style.setProperty('font-size', '13px', 'important');
            details.style.setProperty('color', '#94a3b8', 'important');
            const detailParts = [];
            if (profile.license_number) detailParts.push(`License #${profile.license_number}`);
            if (profile.phone_number) detailParts.push(profile.phone_number);
            details.textContent = detailParts.join('  |  ');
            info.appendChild(details);

            leftSide.appendChild(info);
            brandingHero.appendChild(leftSide);

            if (profile.brokerage_logo_url) {
              // D14: Wrap logo in a fixed-size box so tall/skinny logos can't expand the hero badge
              // and push the assessment cards to page 2
              // D30 v2: previous fix (height 120, overflow allowed) made the logo dominate
              // the agent header. Cleaner approach: keep wrapper at original 96h but cap
              // the IMG with explicit pixel max-height (80px) instead of relying on
              // object-fit: contain (which html2canvas honors unreliably). This makes the
              // logo behave as a brand mark — scales down to fit, never overflows, works
              // for square / tall / wide aspect ratios uniformly.
              const logoWrapper = document.createElement('div');
              logoWrapper.style.cssText = 'width: 160px; height: 96px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;';
              const logo = document.createElement('img');
              logo.src = `https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${profile.brokerage_logo_url}`;
              logo.crossOrigin = 'anonymous';
              logo.style.cssText = 'max-width: 140px; max-height: 80px; width: auto; height: auto; display: block;';
              logoWrapper.appendChild(logo);
              brandingHero.appendChild(logoWrapper);
            }

            offscreen.appendChild(brandingHero);
          }

          // 5a-D30: GPS Score hero block — injected between branding hero and context bar.
          // This is THE headline of the PDF: the 1-10 number, tier label, confidence pill,
          // gauge image, and cap/floor annotation if applicable. Reads exclusively from
          // gamePlanScoreState (no parallel computation).
          if (gamePlanScoreState) {
            const gpsHero = document.createElement('div');
            gpsHero.setAttribute('data-pdf-gps-hero', 'true');
            gpsHero.style.cssText = 'background: #ffffff !important; border: 1px solid #d1d5db !important; padding: 24px 28px; margin-bottom: 8px; display: flex; align-items: center; gap: 28px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);';

            // Gauge (left)
            const gaugeDataUrl = drawGpsGaugeForPdf(gamePlanScoreState.score);
            const gaugeImg = document.createElement('img');
            gaugeImg.src = gaugeDataUrl;
            gaugeImg.style.cssText = 'width: 200px; height: 113px; flex-shrink: 0;';
            gpsHero.appendChild(gaugeImg);

            // Hero text (center-right)
            const heroText = document.createElement('div');
            heroText.style.cssText = 'flex: 1;';

            const heroLabel = document.createElement('div');
            heroLabel.style.cssText = 'font-size: 11px; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 1.5px;';
            heroLabel.textContent = 'GAME PLAN SCORE';
            heroText.appendChild(heroLabel);

            const heroNumber = document.createElement('div');
            heroNumber.style.cssText = `font-size: 56px; font-weight: 700; color: ${_gpsTierColor(gamePlanScoreState.score)}; line-height: 1.0; margin-top: 4px;`;
            heroNumber.textContent = `${gamePlanScoreState.score} / 10`;
            heroText.appendChild(heroNumber);

            const heroTier = document.createElement('div');
            heroTier.style.cssText = 'font-size: 18px; font-weight: 600; color: #1a1a1a; margin-top: 6px;';
            heroTier.textContent = (gamePlanScoreState.capWasApplied && gamePlanScoreState.score === 1)
              ? 'Pathological ask — recheck inputs'
              : (_gpsTierLabels[gamePlanScoreState.score] || _gpsTierBadgeLabel(gamePlanScoreState.score));
            heroText.appendChild(heroTier);

            const heroConfidence = document.createElement('div');
            heroConfidence.style.cssText = 'font-size: 13px; color: #4b5563; margin-top: 4px; text-transform: capitalize;';
            const _confTier = gamePlanScoreState.confidence?.tier || 'moderate';
            heroConfidence.textContent = _confTier === 'limited' ? 'Limited data' : `${_confTier} confidence`;
            heroText.appendChild(heroConfidence);

            // D31 cap annotation
            if (gamePlanScoreState.capWasApplied && gamePlanScoreState.askPercentOfValue != null) {
              const capNote = document.createElement('div');
              capNote.style.cssText = 'font-size: 12px; color: #92400e; font-style: italic; margin-top: 8px;';
              capNote.textContent = `ⓘ Score capped at ${gamePlanScoreState.score} due to ask size (${(gamePlanScoreState.askPercentOfValue * 100).toFixed(1)}% of property value).`;
              heroText.appendChild(capNote);
            }
            // D33 floor annotation
            if (gamePlanScoreState.floorWasApplied && gamePlanScoreState.askPercentOfValue != null) {
              const floorNote = document.createElement('div');
              floorNote.style.cssText = 'font-size: 12px; color: #166534; font-style: italic; margin-top: 8px;';
              floorNote.textContent = `ⓘ Score floored at ${gamePlanScoreState.score} — ask is ${(gamePlanScoreState.askPercentOfValue * 100).toFixed(1)}% of property value, within typical range.`;
              heroText.appendChild(floorNote);
            }

            gpsHero.appendChild(heroText);
            offscreen.appendChild(gpsHero);
          }

          // 5a-D30b: Industry Context citations — between GPS Score and context bar.
          // Reads the same industryResearch array the in-app panel renders. Section
          // is omitted entirely if zero citations match (per directive Part 8.1).
          // No "why am I seeing this?" tooltip on PDF (PDFs don't tooltip).
          // Hero Number V2 (2026-05-06): PDF Industry Context render also gated on
          // SHOW_INDUSTRY_CONTEXT_BOX. Keeps the PDF in sync with the in-app render.
          if (SHOW_INDUSTRY_CONTEXT_BOX && Array.isArray(industryResearch) && industryResearch.length > 0) {
            const contextBlock = document.createElement('div');
            contextBlock.setAttribute('data-pdf-industry-context', 'true');
            contextBlock.style.cssText = 'background: #f8fafc !important; border: 1px solid #e2e8f0 !important; padding: 16px 20px; margin-bottom: 8px;';

            const ctxLabel = document.createElement('div');
            ctxLabel.style.cssText = 'font-size: 11px; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 1.5px; margin-bottom: 10px;';
            ctxLabel.textContent = 'INDUSTRY CONTEXT';
            contextBlock.appendChild(ctxLabel);

            industryResearch.forEach((item, idx) => {
              const row = document.createElement('div');
              row.style.cssText = idx > 0
                ? 'padding-top: 10px; margin-top: 10px; border-top: 1px solid #e2e8f0;'
                : '';

              const stat = document.createElement('div');
              stat.style.cssText = 'font-size: 13px; line-height: 1.5; color: #1e293b;';
              stat.textContent = item.statistic_text || '';
              row.appendChild(stat);

              const src = document.createElement('div');
              src.style.cssText = 'font-size: 11px; color: #64748b; font-style: italic; margin-top: 4px;';
              const srcName = item.citation_short || item.source_name || 'Source';
              const srcDate = item.source_date ? `, ${item.source_date}` : '';
              src.textContent = `Source: ${srcName}${srcDate}`;
              row.appendChild(src);

              contextBlock.appendChild(row);
            });

            offscreen.appendChild(contextBlock);
          }

          // 5b. v5.4: Inject context bar with CORRECT outlook data (not leverage)
          // D30: badge text now derives from gamePlanScoreState (single source of truth).
          // Legacy outlookData/outlookVerdict still computed for back-compat shape only —
          // GPS hero block above is the canonical headline now.
          const outlookDataForPdf = calculateOutlookScore(leverageScore, findings);
          const outlookVerdictForPdf = getOutlookVerdictData(outlookDataForPdf.outlookScore);
          // D30: GPS-derived badge values. Falls back to legacy outlook if GPS state
          // somehow absent (defensive — should never happen at PDF export time).
          const gpsBadgeForPdf = gamePlanScoreState
            ? {
                text: _gpsTierBadgeLabel(gamePlanScoreState.score),
                color: _gpsTierColor(gamePlanScoreState.score),
                score: gamePlanScoreState.score
              }
            : { text: outlookVerdictForPdf.text, color: outlookVerdictForPdf.color, score: null };

          const contextBar = document.createElement('div');
          contextBar.setAttribute('data-pdf-context-bar', 'true');
          // v6.0: Executive design - clean white with subtle shadow
          contextBar.style.cssText = `background: #ffffff !important; border: 1px solid #d1d5db !important; border-radius: 0; padding: 20px 24px; margin-bottom: 8px; display: flex; align-items: center; justify-content: space-between; box-shadow: 0 1px 3px rgba(0,0,0,0.1);`;

          const contextLeft = document.createElement('div');
          // v5.10b: Full address on two lines (street / city, state ZIP)
          const addressLine1 = document.createElement('div');
          addressLine1.style.cssText = 'font-size: 18px; font-weight: 600; color: #1a1a1a; line-height: 1.3;';
          addressLine1.textContent = propertyInfo.address || 'Property Address';
          contextLeft.appendChild(addressLine1);

          const addressLine2 = document.createElement('div');
          addressLine2.style.cssText = 'font-size: 14px; font-weight: 500; color: #4b5563; line-height: 1.3;';
          const cityStateZip = [
            propertyInfo.city,
            propertyInfo.state,
            propertyInfo.zipCode
          ].filter(Boolean).join(', ').replace(/, (\d)/, ' $1'); // "City, State ZIP" format
          addressLine2.textContent = cityStateZip || '';
          if (cityStateZip) contextLeft.appendChild(addressLine2);

          const clientEl = document.createElement('div');
          clientEl.style.cssText = 'font-size: 13px; color: #6b7280; margin-top: 4px;';
          clientEl.textContent = `Prepared for: ${propertyInfo.clientName || 'Client'}`;
          contextLeft.appendChild(clientEl);
          contextBar.appendChild(contextLeft);

          // Outlook badge with correct verdict - solid color background
          // v6.9: DEEP FIX - Use setProperty with !important for maximum override
          // D30: badge now reads gpsBadgeForPdf (GPS Score-derived). Old execColor
          // mapping retained but expanded to cover the new GPS palette colors
          // (#dc2626 red, #d97706 amber, #2563eb blue, #059669 emerald).
          const outlookBadge = document.createElement('div');
          outlookBadge.setAttribute('data-outlook-badge', 'true');
          // Darker variants for Executive look — covers both legacy outlook palette
          // and D30's GPS tier palette.
          const _badgeColor = gpsBadgeForPdf.color;
          const execColor =
            _badgeColor === '#ef4444' || _badgeColor === '#dc2626' ? '#7f1d1d' :
            _badgeColor === '#f59e0b' || _badgeColor === '#d97706' ? '#92400e' :
            _badgeColor === '#10b981' || _badgeColor === '#059669' ? '#166534' :
            _badgeColor === '#2563eb' ? '#1e40af' :
            _badgeColor;
          // Determine text color: white for dark backgrounds, dark for light (yellow/orange)
          const badgeTextColor = (execColor === '#92400e') ? '#1f2937' : '#ffffff';
          // Apply ALL styles with !important using setProperty for maximum CSS specificity
          outlookBadge.style.setProperty('background-color', execColor, 'important');
          outlookBadge.style.setProperty('color', badgeTextColor, 'important');
          outlookBadge.style.setProperty('height', '40px', 'important');
          outlookBadge.style.setProperty('line-height', '40px', 'important');
          outlookBadge.style.setProperty('padding', '0 20px', 'important');
          outlookBadge.style.setProperty('border-radius', '0', 'important');
          outlookBadge.style.setProperty('display', 'inline-block', 'important');
          outlookBadge.style.setProperty('flex-shrink', '0', 'important');
          outlookBadge.style.setProperty('box-sizing', 'border-box', 'important');
          outlookBadge.style.setProperty('font-size', '12px', 'important');
          outlookBadge.style.setProperty('font-weight', '700', 'important');
          outlookBadge.style.setProperty('text-transform', 'uppercase', 'important');
          outlookBadge.style.setProperty('letter-spacing', '2px', 'important');
          outlookBadge.style.setProperty('text-align', 'center', 'important');
          outlookBadge.style.setProperty('white-space', 'nowrap', 'important');
          // Direct text content - no nested span
          // D30: badge text now reads from gpsBadgeForPdf (GPS Score-derived)
          outlookBadge.textContent = gpsBadgeForPdf.text;
          contextBar.appendChild(outlookBadge);

          offscreen.appendChild(contextBar);

          // v5.10: Generate executive summary via Claude API (with fallback)
          const selectedFindingsForSummary = findings.filter(f => f.selected);
          const totalAskForSummary = selectedFindingsForSummary.reduce((sum, f) => sum + (f.cost || 0), 0);
          const askDataForSummary = calculateAskAssessment(findings, leverageScore);
          const displayLevScoreForSummary = Math.round(leverageScore / 2);
          const levDataForSummary = getLeverageAssessmentData(displayLevScoreForSummary);
          const sellerProfileResultForSummary = calculateSellerProfileScore();
          const sellerDataForSummary = sellerProfileResultForSummary.sellerData;
          const sellerProfileForSummary = sellerDataForSummary
            ? getSellerProfileData(sellerProfileResultForSummary.score, sellerDataForSummary.motivation)
            : { label: 'MORE DATA NEEDED', color: '#6b7280' };
          const requestTotalsForSummary = calculateRequestTotals(findings);
          const closingCostCapacity = parseFloat(String(propertyInfo.closingCostCapacity || '0').replace(/[^0-9.]/g, '')) || 0;
          const creditTotal = requestTotalsForSummary?.creditTotal || 0;
          const hasClosingCostWarning = closingCostCapacity > 0 && creditTotal > closingCostCapacity;
          const closingCostOverageAmt = creditTotal - closingCostCapacity;

          // Build the prompt
          // v5.10b: Enhanced prompt with ask-as-percentage and clearer framing
          const contractPriceForSummary = parseFloat(String(propertyInfo.contractPrice || propertyInfo.listPrice || '0').replace(/[^0-9.]/g, '')) || 0;
          const askAsPercentForSummary = contractPriceForSummary > 0 ? ((totalAskForSummary / contractPriceForSummary) * 100).toFixed(1) : 0;

          // D30: prompt now leads with GPS Score (the canonical headline number) so the
          // generated narrative agrees with the badge and Strategy Insight. Legacy
          // outlook text appended only as supplementary context for back-compat with
          // the model's tuning, not as the primary frame.
          const _gpsScoreForPrompt = gamePlanScoreState?.score;
          const _gpsTierForPrompt = _gpsScoreForPrompt != null ? _gpsTierBadgeLabel(_gpsScoreForPrompt) : null;
          const _capNote = gamePlanScoreState?.capWasApplied ? ` (D31 catastrophic ask cap binding — ask is outside any defensible negotiation band)` : '';
          const _floorNote = gamePlanScoreState?.floorWasApplied ? ` (D33 softball ask floor binding — ask is at the conservative end of the typical band)` : '';
          const summaryPromptData = `
Property: ${propertyInfo.address || 'Unknown'}, ${propertyInfo.city || ''}, ${propertyInfo.state || ''} ${propertyInfo.zipCode || ''}
Contract Price: ${formatCurrency(contractPriceForSummary)}
Days on Market: ${propertyInfo.daysOnMarket || 'Unknown'}

GAME PLAN SCORE: ${_gpsScoreForPrompt != null ? `${_gpsScoreForPrompt} / 10 — ${_gpsTierForPrompt}${_capNote}${_floorNote}` : 'unavailable'} (THIS IS THE HEADLINE — frame your summary around this)

Inspection Findings: ${selectedFindingsForSummary.length} items selected, ${formatCurrency(totalAskForSummary)} total ask
  - Ask as % of property value: ${askAsPercentForSummary}% (typical successful range: 2-5%)
  - Credits requested: ${formatCurrency(creditTotal)}
  - Seller repairs requested: ${formatCurrency(requestTotalsForSummary?.sellerRepairTotal || 0)}
  - Deal-critical items: ${askDataForSummary.dealKillerCount}

Component Scores (for context, not headline):
  - Leverage Score: ${displayLevScoreForSummary} out of ±10 (${levDataForSummary.label})
  - Ask Favorability: ${askDataForSummary.score} out of ±10 (${askDataForSummary.label})

Seller Signals: ${sellerProfileForSummary.label}
  - Total concessions so far: ${formatCurrency(sellerDataForSummary?.totalConcession || 0)} (${(sellerDataForSummary?.concessionPercent || 0).toFixed(1)}%)
  - Price reduced: ${formatCurrency(sellerDataForSummary?.priceReduction || 0)}

Expected Landing Range: ${formatCurrency(askDataForSummary.expectedLow)} – ${formatCurrency(askDataForSummary.expectedHigh)}

${hasClosingCostWarning ? `WARNING: Credit request exceeds closing cost capacity by ${formatCurrency(closingCostOverageAmt)}. Agent should consider converting some credits to seller repairs.` : ''}

Write a 3-5 sentence executive summary. Focus on the most actionable insight. The Game Plan Score above is the headline — your narrative must agree with its tier (Strong / Solid / Mixed / Challenged).`;

          // D30: fallback summary — also keyed off GPS Score so screen and PDF agree
          // even when the API call fails.
          const _fallbackTier = _gpsTierForPrompt ? _gpsTierForPrompt.toLowerCase() : 'mixed signals';
          const fallbackSummary = `This analysis identifies ${formatCurrency(totalAskForSummary)} in documented repairs across ${selectedFindingsForSummary.length} findings${askDataForSummary.dealKillerCount > 0 ? `, including ${askDataForSummary.dealKillerCount} deal-critical item${askDataForSummary.dealKillerCount > 1 ? 's' : ''} affecting safety and insurability` : ''}. ${_gpsScoreForPrompt != null ? `Your Game Plan Score is ${_gpsScoreForPrompt}/10 (${_fallbackTier})` : `With a leverage score of ${displayLevScoreForSummary > 0 ? '+' : ''}${displayLevScoreForSummary} (${levDataForSummary.label})`}. ${askDataForSummary.expectedLow && askDataForSummary.expectedHigh ? `Expect to land in the ${formatCurrency(askDataForSummary.expectedLow)}–${formatCurrency(askDataForSummary.expectedHigh)} range.` : ''} ${hasClosingCostWarning ? 'Note: the credit request exceeds closing cost capacity — consider converting some items to seller repairs.' : ''}`;

          // Make API call with 8 second timeout
          let executiveSummary = fallbackSummary;
          try {
            const summaryController = new AbortController();
            const summaryTimeout = setTimeout(() => summaryController.abort(), 8000);

            const summaryResponse = await fetch(API_CONFIG.claudeApi.proxyUrl, {
              method: 'POST',
              headers: await getAuthHeaders(),
              body: JSON.stringify({
                _ppgMeta: { callSite: 'proxy_executive_summary', reportId: pendingReportId || null },
                model: 'claude-sonnet-4-6',
                max_tokens: 300,
                output_config: { effort: 'low' },
                system: `You are a senior real estate negotiation analyst writing a brief executive summary for a property inspection negotiation report. Write 3-5 sentences in confident, professional prose. No bullet points. No hedging language. Address the agent directly using "you/your."

CRITICAL RULES:
1. The Game Plan Score (1-10) is the headline. Frame your summary around the Score and its tier label (Strong / Solid / Mixed / Challenged). Component scores like Leverage and Ask Favorability are supporting context, not the headline.
2. If the D31 catastrophic ask cap is binding (Score ≤ 2 with cap note), LEAD with the fact that the ask is outside any defensible band. Tell the agent to recheck inputs before sending.
3. If the D33 softball ask floor is binding (Score ≥ 7 with floor note), the deal is structurally low-risk on the ask side. Frame as a defensible position.
4. Do not contradict the Score's tier. If the Score is 8 (Strong position), do not write hedging language that implies a weak position. If the Score is 3 (Challenged), do not write language that implies the agent should push hard.
5. Be direct about what needs to change. If the ask is too high, say so. If items should be cut, suggest it.
6. Typical successful inspection credit asks in the Portland metro area are 2-5% of property value. Use this as your baseline for what's "normal."

Keep it under 80 words. Focus on the single most actionable insight.`,
                messages: [{ role: 'user', content: summaryPromptData }]
              }),
              signal: summaryController.signal
            });

            clearTimeout(summaryTimeout);

            if (summaryResponse.ok) {
              const summaryResult = await summaryResponse.json();
              if (summaryResult.content && summaryResult.content[0] && summaryResult.content[0].text) {
                executiveSummary = summaryResult.content[0].text;
              }
            }
          } catch (summaryError) {
            console.warn('Executive summary API failed, using fallback:', summaryError.message);
          }

          // v5.11: Generate "Strategy Insight" content to fill white space on pages
          // v5.11b: Added detailed logging and extended timeout
          let strategyInsightContent = null;
          console.log('[Strategy Insight] Checking condition:', {
            hasClosingCostWarning,
            closingCostCapacity,
            creditTotal
          });

          if (hasClosingCostWarning) {
            console.log('[Strategy Insight] Condition met, calling Claude API...');
            try {
              const insightController = new AbortController();
              const insightTimeout = setTimeout(() => insightController.abort(), 15000);  // Increased to 15s

              const insightPromptData = `
You're explaining to a real estate agent why their credit request exceeding closing cost capacity matters and what to do about it.

THE SPECIFIC SITUATION:
- Credit request: ${formatCurrency(creditTotal)}
- Closing cost capacity: ${formatCurrency(closingCostCapacity)}
- Overage amount: ${formatCurrency(closingCostOverageAmt)}
- Contract price: ${formatCurrency(contractPriceForSummary)}
- Deal-critical items: ${askDataForSummary.dealKillerCount}

Write 2-3 short paragraphs (150 words max) explaining:
1. WHY this matters (lender limits, financing complications)
2. The KEY DECISION: which items should become seller repairs vs. credits
3. One specific tactical suggestion using their actual numbers

Be direct and practical. No fluff. Use "you/your" to address the agent.`;

              const insightResponse = await fetch(API_CONFIG.claudeApi.proxyUrl, {
                method: 'POST',
                headers: await getAuthHeaders(),
                body: JSON.stringify({
                  _ppgMeta: { callSite: 'proxy_strategy_insight', reportId: pendingReportId || null },
                  model: 'claude-sonnet-4-6',
                  max_tokens: 250,
                  output_config: { effort: 'low' },
                  system: 'You are a real estate negotiation coach. Write practical, actionable advice. Be concise and direct. No hedging or disclaimers.',
                  messages: [{ role: 'user', content: insightPromptData }]
                }),
                signal: insightController.signal
              });

              clearTimeout(insightTimeout);
              console.log('[Strategy Insight] API response status:', insightResponse.status);

              if (insightResponse.ok) {
                const insightResult = await insightResponse.json();
                console.log('[Strategy Insight] API result:', insightResult);
                if (insightResult.content && insightResult.content[0] && insightResult.content[0].text) {
                  strategyInsightContent = insightResult.content[0].text;
                  console.log('[Strategy Insight] Content captured:', strategyInsightContent.substring(0, 100) + '...');
                } else {
                  console.warn('[Strategy Insight] Response OK but no content found');
                }
              } else {
                const errorText = await insightResponse.text();
                console.error('[Strategy Insight] API error:', insightResponse.status, errorText);
                // v5.12b: Add fallback content when API fails
                strategyInsightContent = generateStrategyInsightFallback(creditTotal, closingCostCapacity, closingCostOverageAmt);
              }
            } catch (insightError) {
              console.warn('[Strategy Insight] Failed:', insightError.message);
              // v5.12b: Add fallback content when API fails
              strategyInsightContent = generateStrategyInsightFallback(creditTotal, closingCostCapacity, closingCostOverageAmt);
            }
          } else {
            console.log('[Strategy Insight] Skipped - no closing cost warning');
          }

          // v5.12b: Fallback function for Strategy Insight
          function generateStrategyInsightFallback(creditAmt, capacity, overage) {
            return `Your credit request of ${formatCurrency(creditAmt)} exceeds the ${formatCurrency(capacity)} closing cost capacity by ${formatCurrency(overage)}. This creates a financing obstacle that must be addressed before the deal can close.

The most effective solution is to convert some of your credit items into seller repair requests. Focus on high-cost items like major systems repairs (HVAC, roofing, electrical) that contractors can complete before closing. This keeps your credit request within lender limits while still getting the repairs addressed.

Consider prioritizing deal-critical items as seller repairs, since these must be resolved regardless. Leave smaller, cosmetic items as credits where the buyer can choose their own contractors after closing.`;
          }

          // 6. Clone each section into the offscreen container
          // v5.4: Restructured order - context bar first, then outlook, then details
          // v6.10: Split by tab — strategy sections live in strategy tab, negotiation sections live in negotiation tab.
          // We must switch tabs between them so React renders the content into the DOM.
          const strategySectionOrder = [
            'credit-capacity-alert', // Credit capacity warning (if applicable)
            'prestige',           // Outlook score hero display
            'strategy-insight',   // D30: canonical Strategy Insight (was tagged but never captured)
            'assessments',        // Leverage + Ask Favorability cards
            'agent-reasoning',    // D32-C: justifications for the 3 agent-input sliders
            'concession-probability-curve', // D36: bespoke insight tile (mockup-as-feature)
            'funnel',
            'seller-motivation',
            'closing-cost-warning',
            'ask-breakdown',
            'market-context',
            'critical-items'
          ];
          const negotiationSectionOrder = [
            'credit-table',
            'repair-table',
            'excluded-items',
            'justification-cards',
            'concessions',
            'negotiation-dynamics'
          ];
          const sectionOrder = [...strategySectionOrder, ...negotiationSectionOrder];

          // v6.10: Track which sections need a tab switch before cloning
          const sectionTabMap = {};
          strategySectionOrder.forEach(name => { sectionTabMap[name] = 'strategy'; });
          negotiationSectionOrder.forEach(name => { sectionTabMap[name] = 'negotiation'; });

          const clonedSections = [];
          let currentExportTab = 'strategy'; // We already switched to strategy at the top
          for (const name of sectionOrder) {
            // v6.10: Switch tabs if this section lives on a different tab than what's currently rendered
            const requiredTab = sectionTabMap[name];
            if (requiredTab && requiredTab !== currentExportTab) {
              setActiveTab(requiredTab);
              currentExportTab = requiredTab;
              // Wait for React to mount the new tab's content
              await new Promise(resolve => setTimeout(resolve, 500));
            }

            const el = document.querySelector(`[data-pdf-section="${name}"]`);
            if (el && el.offsetHeight > 0) {
              const clone = el.cloneNode(true);
              clone.style.marginBottom = '12px';

              // v5.2a: Remove elements marked for PDF hiding (like duplicate agent branding)
              clone.querySelectorAll('[data-pdf-hide]').forEach(hideEl => hideEl.remove());

              // v6.0: Strip emojis from all text content (professional PDF output)
              // Don't strip from assessment-icon containers - we'll handle those separately
              // D30 fix: removed .trim() — it was destroying boundary whitespace between
              // sibling text nodes in JSX (e.g., `<span>X</span> <span>Y</span>` produces
              // a text node " " whose content trim() → "", collapsing "X Y" into "XY").
              // This was the root cause of `$5,500credit`, `26-46%of repairs`, etc.
              // Multi-space collapse retained because emoji replacement leaves runs of
              // whitespace that should compress to single spaces.
              const stripEmojis = (text) => {
                return text.replace(/[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{231A}-\u{231B}]|[\u{23E9}-\u{23F3}]|[\u{23F8}-\u{23FA}]|[\u{25AA}-\u{25AB}]|[\u{25B6}]|[\u{25C0}]|[\u{25FB}-\u{25FE}]|[\u{2614}-\u{2615}]|[\u{2648}-\u{2653}]|[\u{267F}]|[\u{2693}]|[\u{26A1}]|[\u{26AA}-\u{26AB}]|[\u{26BD}-\u{26BE}]|[\u{26C4}-\u{26C5}]|[\u{26CE}]|[\u{26D4}]|[\u{26EA}]|[\u{26F2}-\u{26F3}]|[\u{26F5}]|[\u{26FA}]|[\u{26FD}]|[\u{2702}]|[\u{2705}]|[\u{2708}-\u{270D}]|[\u{270F}]|[\u{2712}]|[\u{2714}]|[\u{2716}]|[\u{271D}]|[\u{2721}]|[\u{2728}]|[\u{2733}-\u{2734}]|[\u{2744}]|[\u{2747}]|[\u{274C}]|[\u{274E}]|[\u{2753}-\u{2755}]|[\u{2757}]|[\u{2763}-\u{2764}]|[\u{2795}-\u{2797}]|[\u{27A1}]|[\u{27B0}]|[\u{27BF}]|[\u{2934}-\u{2935}]|[\u{2B05}-\u{2B07}]|[\u{2B1B}-\u{2B1C}]|[\u{2B50}]|[\u{2B55}]|[\u{3030}]|[\u{303D}]|[\u{3297}]|[\u{3299}]/gu, ' ').replace(/\s+/g, ' ');
              };
              clone.querySelectorAll('*').forEach(el => {
                // Skip assessment-icon containers - we'll replace those with SVGs
                if (el.classList && el.classList.contains('assessment-icon')) return;
                if (el.childNodes) {
                  el.childNodes.forEach(node => {
                    if (node.nodeType === Node.TEXT_NODE && node.textContent) {
                      node.textContent = stripEmojis(node.textContent);
                    }
                  });
                }
              });

              // v6.0: Replace assessment-icon emojis with clean SVG icons
              clone.querySelectorAll('.assessment-icon').forEach(icon => {
                const box = icon.closest('.assessment-box');
                if (!box) return;

                // Clear emoji content
                icon.textContent = '';
                icon.style.cssText = 'width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; background: transparent !important; color: #6b7280;';

                // Inject appropriate SVG based on box class
                let svgContent = '';
                if (box.classList.contains('leverage-box')) {
                  svgContent = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:100%;height:100%"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>';
                } else if (box.classList.contains('ask-assessment-box')) {
                  svgContent = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:100%;height:100%"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>';
                } else if (box.classList.contains('market-position-box')) {
                  svgContent = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:100%;height:100%"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>';
                } else if (box.classList.contains('seller-profile-box')) {
                  svgContent = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:100%;height:100%"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
                }
                icon.innerHTML = svgContent;
              });

              // v6.0: Remove other empty icon containers (not assessment-icons)
              clone.querySelectorAll('.text-xl').forEach(el => {
                if (!el.textContent.trim() && !el.querySelector('svg')) {
                  el.remove();
                }
              });

              // v5.2a: Remove any calc-receipt elements that might have snuck in
              clone.querySelectorAll('.calc-receipt-toggle, .calc-receipt-content, [data-pdf-section="calc-receipt"]').forEach(el => el.remove());

              // v5.6: For prestige section, create gauge + verdict display (no integer score)
              if (name === 'prestige') {
                const outlookData = calculateOutlookScore(leverageScore, findings);
                const verdict = getOutlookVerdictData(outlookData.outlookScore);

                // Remove property-card (we have context bar now)
                clone.querySelectorAll('.property-card, [data-pdf-section="property-info"]').forEach(el => el.remove());

                // Remove the SVG gauge container entirely
                clone.querySelectorAll('.gauge-container, svg').forEach(el => {
                  const parent = el.closest('div');
                  if (parent && parent.classList.contains('gauge-container')) {
                    parent.remove();
                  } else {
                    el.remove();
                  }
                });

                // Remove old score display and verdict text
                clone.querySelectorAll('.score-display, .verdict-text').forEach(el => el.remove());

                // Find the verdict container and rebuild it cleanly
                const verdictContainer = clone.querySelector('.verdict-fade-in');
                if (verdictContainer) {
                  // v5.3: Kill the fade-in animation that leaves text at low opacity in PDF capture
                  verdictContainer.classList.remove('verdict-fade-in');
                  verdictContainer.style.setProperty('animation', 'none', 'important');
                  verdictContainer.style.setProperty('opacity', '1', 'important');
                  verdictContainer.style.setProperty('transform', 'none', 'important');
                  // Clear everything inside
                  verdictContainer.innerHTML = '';

                  // Create clean hero-style outlook display with gauge
                  // v5.10: Reduced padding from 32px to 24px to fit more on page 1
                  // v5.10d: Darker border for intentional appearance
                  const heroDisplay = document.createElement('div');
                  heroDisplay.style.cssText = 'text-align: center; padding: 24px 24px; background: #ffffff !important; border: 3px solid #000000 !important; border-radius: 12px;';

                  // Generate and insert canvas gauge image
                  const gaugeDataUrl = drawGaugeForPdf(outlookData.outlookScore);
                  const gaugeImg = document.createElement('img');
                  gaugeImg.src = gaugeDataUrl;
                  gaugeImg.style.cssText = 'width: 300px; height: 165px; display: block; margin: 0 auto 20px auto;';
                  heroDisplay.appendChild(gaugeImg);

                  // Verdict label - BOLD, DARK (not verdict color - that was too light)
                  const labelEl = document.createElement('div');
                  labelEl.style.cssText = 'font-size: 28px; font-weight: 800; color: #1a1a2e; text-transform: uppercase; letter-spacing: 2px; margin: 0 0 12px 0; opacity: 1;';
                  labelEl.textContent = verdict.text;
                  heroDisplay.appendChild(labelEl);

                  // Summary text - darker gray for readability
                  const summaryEl = document.createElement('div');
                  summaryEl.style.cssText = 'font-size: 16px; font-weight: 500; color: #4b5563; margin: 0; max-width: 450px; margin-left: auto; margin-right: auto; line-height: 1.5; opacity: 1;';
                  summaryEl.textContent = verdict.summary;
                  heroDisplay.appendChild(summaryEl);

                  verdictContainer.appendChild(heroDisplay);
                }

                // v5.7: Style the prestige container and all children for clean white PDF rendering
                // v6.11: Added breathing room below dial so assessment boxes don't visually crowd it
                clone.style.cssText = 'background: #ffffff !important; padding: 0; margin-bottom: 36px; width: 100%;';

                // Force white background on prestige-card (removes dark gradient)
                // v5.10d: Darker border for intentional appearance
                clone.querySelectorAll('.prestige-card').forEach(card => {
                  card.style.cssText = 'background: #ffffff !important; border: 3px solid #000000 !important; border-radius: 12px; padding: 0; box-shadow: none !important;';
                });

                // Remove any dial glows or decorative elements
                clone.querySelectorAll('.dial-glow, .glow, [class*="glow"]').forEach(el => el.remove());
              }

              // v6.1: For assessments section - COMPLETE REBUILD to match Executive sandbox design
              if (name === 'assessments') {
                // Style the wrapper - NO margin-top positioning (causes overlay issues)
                clone.style.cssText = 'background: #ffffff; padding: 0; margin: 0; margin-bottom: 16px; width: 100%; box-sizing: border-box;';

                clone.querySelectorAll('.assessment-boxes-wrapper').forEach(wrapper => {
                  wrapper.style.cssText = 'width: 100%; padding: 0; margin: 0;';
                });

                const container = clone.querySelector('.assessment-boxes-container');
                if (container) {
                  // v6.1b: Use explicit pixel widths to ensure all 4 columns fit
                  // v6.6: Compact white container to fit on page 1
                  container.style.cssText = 'display: grid; grid-template-columns: repeat(4, 1fr); gap: 0; width: 100%; padding: 16px; box-sizing: border-box; align-items: stretch; background: #ffffff; box-shadow: 0 2px 8px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06); border-radius: 4px;';
                }

                // v6.1: Completely rebuild each assessment box to match sandbox Executive design
                clone.querySelectorAll('.assessment-box').forEach(box => {
                  // v6.1c: Remove animation classes that may hide boxes (opacity: 0)
                  box.classList.remove('assessment-fade-in', 'assessment-delay-1', 'assessment-delay-2');
                  box.style.opacity = '1';
                  box.style.visibility = 'visible';
                  box.style.animation = 'none';

                  // Extract data from existing box before clearing
                  const isLeverage = box.classList.contains('leverage-box');
                  const isAsk = box.classList.contains('ask-assessment-box');
                  const isDealContext = box.classList.contains('market-position-box');
                  const isSellerSignals = box.classList.contains('seller-profile-box');

                  // Get existing values
                  const scoreEl = box.querySelector('.assessment-score');
                  const labelEl = box.querySelector('.assessment-label');
                  const explainEl = box.querySelector('.assessment-explanation');
                  const labelLargeEl = box.querySelector('.assessment-label-large');
                  const statsContainer = box.querySelector('.card-stats-container');

                  let scoreText = scoreEl ? scoreEl.textContent.trim() : '';
                  let labelText = labelEl ? labelEl.textContent.trim() : '';
                  let explainText = explainEl ? explainEl.textContent.trim() : '';
                  let labelLargeText = labelLargeEl ? labelLargeEl.textContent.trim() : '';

                  // v6.5: Calculate score color explicitly based on score value (not extracted from DOM)
                  let scoreColor = '#6b7280'; // default gray
                  let barColor = '#10b981'; // default green
                  if (isLeverage) {
                    const score = parseInt(scoreText) || 0;
                    // Leverage: positive = green, near-zero = yellow, negative = red
                    scoreColor = score >= 3 ? '#16a34a' : score >= 0 ? '#ca8a04' : '#dc2626';
                    barColor = scoreColor;
                  } else if (isAsk) {
                    const score = parseInt(scoreText) || 0;
                    // Ask: positive = green (favorable), negative = red (aggressive)
                    scoreColor = score >= 0 ? '#16a34a' : score >= -5 ? '#ca8a04' : '#dc2626';
                    barColor = scoreColor;
                  } else if (isDealContext) {
                    scoreColor = '#6b7280'; // gray for zip code
                    barColor = '#3b82f6'; // blue for market
                  } else if (isSellerSignals) {
                    barColor = '#10b981'; // green for seller signals
                  }

                  // Get title based on box type
                  // v6.3: Use data URL SVGs for html2canvas compatibility
                  let titleLine1 = '', titleLine2 = '';
                  let svgDataUrl = '';
                  const svgColor = '%236b7280'; // URL-encoded #6b7280
                  if (isLeverage) {
                    titleLine1 = 'LEVERAGE'; titleLine2 = 'SCORE';
                    svgDataUrl = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${svgColor}' stroke-width='2'%3E%3Cpath d='M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5'/%3E%3C/svg%3E`;
                  } else if (isAsk) {
                    titleLine1 = 'ASK'; titleLine2 = 'FAVORABILITY';
                    svgDataUrl = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${svgColor}' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Ccircle cx='12' cy='12' r='6'/%3E%3Ccircle cx='12' cy='12' r='2'/%3E%3C/svg%3E`;
                  } else if (isDealContext) {
                    titleLine1 = 'DEAL'; titleLine2 = 'CONTEXT';
                    svgDataUrl = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${svgColor}' stroke-width='2'%3E%3Crect x='3' y='3' width='18' height='18' rx='2'/%3E%3Cpath d='M3 9h18M9 21V9'/%3E%3C/svg%3E`;
                  } else if (isSellerSignals) {
                    titleLine1 = 'SELLER'; titleLine2 = 'SIGNALS';
                    svgDataUrl = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${svgColor}' stroke-width='2'%3E%3Cpath d='M22 11.08V12a10 10 0 1 1-5.93-9.14'/%3E%3Cpolyline points='22 4 12 14.01 9 11.01'/%3E%3C/svg%3E`;
                  }

                  // v6.5: Calculate progress bar position and use segmented colors for html2canvas compatibility
                  let barProgress = 50; // default middle
                  let barSegments = []; // Array of {width, color} for building gradient manually
                  if (isLeverage || isAsk) {
                    const score = parseInt(scoreText) || 0;
                    // Score ranges -10 to +10, map to 0-100%
                    barProgress = Math.max(0, Math.min(100, ((score + 10) / 20) * 100));
                    // Red → Yellow → Green segments
                    barSegments = [
                      { width: '35%', color: '#ef4444' },
                      { width: '30%', color: '#f59e0b' },
                      { width: '35%', color: '#22c55e' }
                    ];
                  } else if (isDealContext) {
                    // Use DOM to determine position (higher DOM = more favorable)
                    const dom = parseInt(propertyInfo.daysOnMarket) || 0;
                    barProgress = Math.max(0, Math.min(100, Math.min(dom / 60, 1) * 100));
                    // Red → Yellow → Blue segments
                    barSegments = [
                      { width: '35%', color: '#ef4444' },
                      { width: '30%', color: '#f59e0b' },
                      { width: '35%', color: '#3b82f6' }
                    ];
                  } else if (isSellerSignals) {
                    barProgress = 50;
                    // Gray → Green segments
                    barSegments = [
                      { width: '50%', color: '#9ca3af' },
                      { width: '50%', color: '#22c55e' }
                    ];
                  }

                  // Build stats HTML for Deal Context and Seller Signals
                  let statsHtml = '';
                  if (statsContainer && (isDealContext || isSellerSignals)) {
                    const rows = statsContainer.querySelectorAll('.card-stat-row');
                    rows.forEach(row => {
                      const labelSpan = row.querySelector('.card-stat-label');
                      const valueSpan = row.querySelector('.card-stat-value');
                      if (labelSpan && valueSpan) {
                        const statLabel = labelSpan.textContent.trim();
                        const statValue = valueSpan.textContent.trim();
                        statsHtml += `<div style="font-size: 11px; color: #6b7280; margin-bottom: 2px;">${statLabel}:</div>`;
                        statsHtml += `<div style="font-size: 11px; color: #1f2937; font-weight: 500; margin-bottom: 8px;">${statValue}</div>`;
                      }
                    });
                  }

                  // Clear and rebuild the box
                  // v6.6: Reduced min-height to fit on page 1
                  box.innerHTML = '';
                  box.style.cssText = 'background: transparent; border: none; border-left: 3px solid #e5e7eb; padding: 10px; padding-left: 14px; display: flex; flex-direction: column; min-height: 160px; width: 100%; box-sizing: border-box;';

                  // Build new content
                  // v6.7: Larger SVG icons (48px) for clear visibility
                  let newHtml = `
                    <div style="display: flex; align-items: flex-start; gap: 12px; margin-bottom: 12px;">
                      <img src="${svgDataUrl}" style="width: 48px; height: 48px; flex-shrink: 0;" alt="" />
                      <div style="font-size: 11px; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: 0.5px; line-height: 1.3; padding-top: 14px;">
                        ${titleLine1}<br>${titleLine2}
                      </div>
                    </div>
                  `;

                  // v6.2: Reduced score font sizes from 42px to 28px for better balance
                  if (isDealContext) {
                    // Deal Context: ZIP as score, city/state as label, then stats
                    const parts = labelLargeText.split('·').map(s => s.trim());
                    const zipCode = parts[0] || '';
                    const cityState = parts[1] || '';
                    newHtml += `
                      <div style="font-size: 28px; font-weight: 700; color: #6b7280; line-height: 1; margin-bottom: 4px;">${zipCode}</div>
                      <div style="font-size: 13px; font-weight: 600; color: #1a1a1a; text-transform: uppercase; margin-bottom: 12px;">${cityState}</div>
                      ${statsHtml}
                    `;
                  } else if (isSellerSignals) {
                    // v6.4: Seller Signals - show calculated score with color coding
                    const sellerResult = calculateSellerProfileScore();
                    const sellerScore = sellerResult.score || 0;
                    const sellerHasData = sellerResult.hasData;
                    // Color based on score: green (favorable signals) to red (holding firm)
                    const sellerScoreColor = sellerScore >= 4 ? '#16a34a' : sellerScore >= 1 ? '#84cc16' : sellerScore >= -1 ? '#eab308' : '#ef4444';
                    const sellerScoreText = sellerHasData ? (sellerScore >= 0 ? `+${sellerScore}` : `${sellerScore}`) : '—';
                    // Update bar progress based on seller score (-4 to +10 mapped to 0-100%)
                    barProgress = Math.max(0, Math.min(100, ((sellerScore + 4) / 14) * 100));
                    newHtml += `
                      <div style="font-size: 28px; font-weight: 700; color: ${sellerScoreColor}; line-height: 1; margin-bottom: 4px;">${sellerScoreText}</div>
                      <div style="font-size: 13px; font-weight: 600; color: #1a1a1a; text-transform: uppercase; margin-bottom: 12px;">${labelLargeText}</div>
                      ${statsHtml}
                    `;
                  } else {
                    // Leverage and Ask: score, label, description
                    newHtml += `
                      <div style="font-size: 28px; font-weight: 700; color: ${scoreColor}; line-height: 1; margin-bottom: 4px;">${scoreText}</div>
                      <div style="font-size: 13px; font-weight: 600; color: #1a1a1a; text-transform: uppercase; margin-bottom: 8px;">${labelText}</div>
                      <div style="font-size: 12px; color: #6b7280; line-height: 1.4;">${explainText}</div>
                    `;
                  }

                  // v6.8: Smooth gradient bars with 50 micro-segments, no gray track, clamped 10-90%
                  // Helper: interpolate between two hex colors
                  const lerpColor = (c1, c2, t) => {
                    const r1 = parseInt(c1.slice(1,3), 16), g1 = parseInt(c1.slice(3,5), 16), b1 = parseInt(c1.slice(5,7), 16);
                    const r2 = parseInt(c2.slice(1,3), 16), g2 = parseInt(c2.slice(3,5), 16), b2 = parseInt(c2.slice(5,7), 16);
                    const r = Math.round(r1 + (r2 - r1) * t), g = Math.round(g1 + (g2 - g1) * t), b = Math.round(b1 + (b2 - b1) * t);
                    return '#' + [r,g,b].map(x => x.toString(16).padStart(2,'0')).join('');
                  };

                  let barHtml = '';
                  const numSegments = 50; // Many segments for smooth gradient

                  if (isLeverage || isAsk) {
                    const score = parseInt(scoreText) || 0;
                    let rawPercent = ((score + 10) / 20) * 100;
                    // Clamp to 10-90% range (never 0% or 100%)
                    const fillPercent = Math.max(10, Math.min(90, rawPercent));
                    // Red (#ef4444) → Green (#22c55e) smooth gradient
                    let segments = '';
                    const filledSegments = Math.round((fillPercent / 100) * numSegments);
                    for (let i = 0; i < filledSegments; i++) {
                      const t = i / (numSegments - 1);
                      const color = lerpColor('#ef4444', '#22c55e', t);
                      segments += `<div style="flex: 1; height: 100%; background: ${color};"></div>`;
                    }
                    barHtml = `
                      <div style="flex-grow: 1;"></div>
                      <div style="width: ${fillPercent}%; height: 6px; margin-top: 10px; display: flex; overflow: hidden;">
                        ${segments}
                      </div>
                    `;
                  } else if (isDealContext) {
                    const dom = parseInt(propertyInfo.daysOnMarket) || 0;
                    let rawPercent = (dom / 60) * 100;
                    const fillPercent = Math.max(10, Math.min(90, rawPercent));
                    // Red (#ef4444) → Blue (#3b82f6) smooth gradient
                    let segments = '';
                    const filledSegments = Math.round((fillPercent / 100) * numSegments);
                    for (let i = 0; i < filledSegments; i++) {
                      const t = i / (numSegments - 1);
                      const color = lerpColor('#ef4444', '#3b82f6', t);
                      segments += `<div style="flex: 1; height: 100%; background: ${color};"></div>`;
                    }
                    barHtml = `
                      <div style="flex-grow: 1;"></div>
                      <div style="width: ${fillPercent}%; height: 6px; margin-top: 10px; display: flex; overflow: hidden;">
                        ${segments}
                      </div>
                    `;
                  } else {
                    // Seller Signals
                    const sellerScoreVal = (typeof sellerResult !== 'undefined') ? (sellerResult.score || 0) : 0;
                    let rawPercent = ((sellerScoreVal + 4) / 14) * 100;
                    const fillPercent = Math.max(10, Math.min(90, rawPercent));
                    // Gray (#9ca3af) → Green (#22c55e) smooth gradient
                    let segments = '';
                    const filledSegments = Math.round((fillPercent / 100) * numSegments);
                    for (let i = 0; i < filledSegments; i++) {
                      const t = i / (numSegments - 1);
                      const color = lerpColor('#9ca3af', '#22c55e', t);
                      segments += `<div style="flex: 1; height: 100%; background: ${color};"></div>`;
                    }
                    barHtml = `
                      <div style="flex-grow: 1;"></div>
                      <div style="width: ${fillPercent}%; height: 6px; margin-top: 10px; display: flex; overflow: hidden;">
                        ${segments}
                      </div>
                    `;
                  }
                  newHtml += barHtml;

                  box.innerHTML = newHtml;
                });

              }

              // v5.10: Inject section headers before evidence sections
              const selectedFindings = findings.filter(f => f.selected);
              const totalAskAmount = selectedFindings.reduce((sum, f) => sum + (f.cost || 0), 0);
              const askAssessmentForPdf = calculateAskAssessment(findings, leverageScore);
              const expectedLowPdf = askAssessmentForPdf.expectedLow;
              const expectedHighPdf = askAssessmentForPdf.expectedHigh;
              const floorPdf = selectedFindings
                .filter(f => ['immediate', 'nearTerm'].includes(f.urgencyTier || classifyUrgency(f.description || '')))
                .filter(f => {
                  const text = (f.description || f.reportText || '').toLowerCase();
                  return DEAL_KILLER_KEYWORDS.some(kw => text.includes(kw));
                })
                .reduce((sum, f) => sum + (f.cost || 0), 0);

              // v5.10c: Removed standalone section header bands (they duplicated box headers)
              // Box headers are now styled with tinted backgrounds instead (see Fix 3)

              // v5.12b: Removed colored left borders - user wants all black borders
              // (Previously had blue for credits, orange for repairs)
              if (name === 'credit-table' || name === 'repair-table') {
                clone.style.paddingLeft = '16px';
              }

              // v6.0: Executive design - subtle shadows, sharp corners
              const boxHeaderConfigs = {
                'closing-cost-warning': { bg: '#fef3c7', accent: '#92400e' },
                'ask-breakdown': { bg: '#f8fafc', accent: '#1e3a5f' },
                'market-context': { bg: '#f8fafc', accent: '#1e3a5f' },
                'critical-items': { bg: '#fef2f2', accent: '#7f1d1d' }
              };
              if (boxHeaderConfigs[name]) {
                const config = boxHeaderConfigs[name];

                // v6.0: Extra top margin for closing-cost-warning
                if (name === 'closing-cost-warning') {
                  clone.style.setProperty('margin-top', '20px', 'important');
                }

                // v6.0: Executive - no heavy border, shadow instead, sharp corners
                clone.style.setProperty('border', 'none', 'important');
                clone.style.setProperty('border-radius', '0', 'important');
                clone.style.setProperty('overflow', 'hidden');
                clone.style.setProperty('background', '#ffffff', 'important');
                clone.style.setProperty('box-shadow', '0 1px 3px rgba(0,0,0,0.1)', 'important');

                const headerBtn = clone.querySelector('button');
                if (headerBtn) {
                  headerBtn.style.cssText = `
                    background: ${config.bg};
                    padding: 10px 16px;
                    border-radius: 0;
                    font-weight: 700;
                    font-size: 12px;
                    color: #1e293b;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    border-bottom: none;
                    border-left: 4px solid ${config.accent};
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  `;
                }
                // Style the content area below header
                const contentDiv = clone.querySelector('div.px-4');
                if (contentDiv) {
                  contentDiv.style.background = '#ffffff';
                  contentDiv.style.padding = '12px 16px';
                }
              }

              // v5.10: Tighten page 1 spacing
              if (['prestige', 'assessments', 'funnel', 'seller-motivation'].includes(name)) {
                clone.style.marginBottom = '8px';
              }

              offscreen.appendChild(clone);
              clonedSections.push({ name, element: clone });

              // v5.10: Add executive summary and Game Plan watermark after seller-motivation (end of page 1)
              // v5.10b: Add Deal Summary after assessment cards (on page 1)
              if (name === 'assessments') {
                // Executive summary card - placed after the four assessment cards
                // v6.0: Executive design - white with shadow, no heavy border
                const summaryCard = document.createElement('div');
                summaryCard.style.cssText = `background: #ffffff !important; border: none !important; border-radius: 0; padding: 20px 24px; margin-top: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);`;

                // v5.10d: Bigger + centered title
                const summaryLabel = document.createElement('div');
                summaryLabel.style.cssText = 'font-size: 14px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 12px; text-align: center;';
                summaryLabel.textContent = 'DEAL SUMMARY';
                summaryCard.appendChild(summaryLabel);

                const summaryText = document.createElement('div');
                summaryText.style.cssText = 'font-size: 13px; color: #1e293b; line-height: 1.6;';
                summaryText.textContent = executiveSummary;
                summaryCard.appendChild(summaryText);

                const summaryAttrib = document.createElement('div');
                summaryAttrib.style.cssText = 'font-size: 9px; color: #9ca3af; font-style: italic; margin-top: 10px;';
                summaryAttrib.textContent = 'Generated by Game Plan PPG™ based on inspection analysis and market data';
                summaryCard.appendChild(summaryAttrib);

                offscreen.appendChild(summaryCard);
                clonedSections.push({ name: 'executive-summary', element: summaryCard });

                // Game Plan watermark - end of page 1 content
                const watermark = document.createElement('div');
                watermark.style.cssText = 'text-align: center; padding: 12px 0; margin-top: 8px;';
                watermark.innerHTML = '<span style="font-size: 10px; color: #9ca3af; font-weight: 500;">Analysis by Game Plan PPG™</span>';
                offscreen.appendChild(watermark);
                clonedSections.push({ name: 'watermark', element: watermark });
              }

              if (name === 'seller-motivation') {
                // v5.10b: Remove emoji icon from seller motivation (doesn't render well in PDF)
                clone.querySelectorAll('.text-xl').forEach(el => {
                  if (el.textContent.includes('📊')) {
                    el.remove();
                  }
                });
                // v5.10e: Apply inline styles to badge (Tailwind classes don't work in PDF)
                clone.querySelectorAll('.rounded').forEach(badge => {
                  if (badge.classList.contains('text-white') && badge.classList.contains('text-xs')) {
                    // This is the motivation badge - apply inline background color
                    const bgClass = Array.from(badge.classList).find(c => c.startsWith('bg-'));
                    if (bgClass) {
                      const colorMap = {
                        'bg-green-500': '#22c55e',
                        'bg-emerald-500': '#10b981',
                        'bg-yellow-500': '#eab308',
                        'bg-red-500': '#ef4444',
                        'bg-stone-500': '#78716c',
                        'bg-brand-500': '#7b8bff'  // iced violet
                      };
                      const bgColor = colorMap[bgClass] || '#6b7280';
                      badge.style.cssText = `background: ${bgColor}; color: #ffffff; font-size: 10px; font-weight: 600; padding: 2px 8px; border-radius: 4px; display: inline-block;`;
                    }
                  }
                });
              }

              // v5.11: Insert Strategy Insight box after closing-cost-warning if we have content
              // This fills white space on pages where the next section doesn't fit
              console.log('[Strategy Insight] Checking render condition:', { name, hasContent: !!strategyInsightContent });
              if (name === 'closing-cost-warning' && strategyInsightContent) {
                console.log('[Strategy Insight] Creating insight box...');
                const insightBox = document.createElement('div');
                insightBox.style.cssText = `
                  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
                  border: 2px solid #0ea5e9;
                  border-radius: 12px;
                  padding: 20px 24px;
                  margin-top: 16px;
                `;

                const insightHeader = document.createElement('div');
                insightHeader.style.cssText = 'display: flex; align-items: center; gap: 10px; margin-bottom: 12px;';
                insightHeader.innerHTML = `
                  <span style="font-size: 20px;">💡</span>
                  <span style="font-size: 14px; font-weight: 700; color: #0369a1; text-transform: uppercase; letter-spacing: 0.5px;">Strategy Insight</span>
                `;
                insightBox.appendChild(insightHeader);

                const insightBody = document.createElement('div');
                insightBody.style.cssText = 'font-size: 13px; color: #1e293b; line-height: 1.7;';
                // Convert line breaks to paragraphs
                const paragraphs = strategyInsightContent.split('\n\n').filter(p => p.trim());
                paragraphs.forEach((para, idx) => {
                  const p = document.createElement('p');
                  p.style.cssText = idx < paragraphs.length - 1 ? 'margin: 0 0 10px 0;' : 'margin: 0;';
                  p.textContent = para.trim();
                  insightBody.appendChild(p);
                });
                insightBox.appendChild(insightBody);

                offscreen.appendChild(insightBox);
                clonedSections.push({ name: 'strategy-insight', element: insightBox });
                console.log('Strategy Insight box added to PDF');
              }
            }
          }

          // 6a-2: Source Attribution Note (for cost estimates)
          const sourceNote = document.createElement('div');
          sourceNote.style.cssText = 'margin-top: 16px; padding: 12px 16px; text-align: center;';
          sourceNote.innerHTML = `
            <p style="margin: 0; font-size: 10px; color: #78716c; font-style: italic;">
              Cost estimates based on 2025-2026 Portland metro contractor data. Verify with local bids for final negotiations.
            </p>
          `;
          offscreen.appendChild(sourceNote);
          clonedSections.push({ name: 'source-attribution', element: sourceNote });

          // 6b. v5.6: Add professional disclaimer as final section
          // v5.10d: Darker border for intentional appearance
          const disclaimer = document.createElement('div');
          disclaimer.style.cssText = 'margin-top: 32px; padding: 20px 24px; background: #f8f9fa !important; border-radius: 8px; border: 3px solid #000000 !important; font-size: 11px; color: #6b7280; line-height: 1.6;';
          disclaimer.innerHTML = `
            <div style="font-weight: 700; font-size: 12px; color: #374151; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 1px;">
              Disclaimer
            </div>
            <p style="margin: 0 0 10px 0;">
              This Game Plan PPG™ report is a decision-support tool designed to assist licensed real estate
              professionals in preparing for repair negotiations. It is not a substitute for professional
              judgment, legal advice, or the expertise of a licensed real estate agent.
            </p>
            <p style="margin: 0 0 10px 0;">
              All cost estimates, negotiation strategies, and market assessments provided in this report
              are approximations based on available data and should be independently verified. Actual
              negotiation outcomes depend on numerous factors beyond the scope of this analysis, including
              but not limited to seller motivation, market conditions, property-specific circumstances,
              and the skill of the negotiating parties.
            </p>
            <p style="margin: 0 0 10px 0;">
              Gambit Lab LLC makes no guarantees regarding negotiation outcomes. The licensed real estate
              agent receiving this report bears full responsibility for all negotiation decisions and
              representations made to clients, sellers, and other parties.
            </p>
            <p style="margin: 0;">
              © ${new Date().getFullYear()} Gambit Lab LLC. All rights reserved. Game Plan PPG™ is a product
              of Gambit Lab LLC. This report is confidential and intended solely for the use of the named
              recipient and their client.
            </p>
          `;
          offscreen.appendChild(disclaimer);
          clonedSections.push({ name: 'disclaimer', element: disclaimer });

          // 7. IMMEDIATELY restore live page state (before capture starts)
          setExpandedSections(savedExpandedState);
          if (!savedShowFunnel) setShowFunnel(false);
          if (!savedShowCalcReceipt) setShowCalcReceipt(false);
          if (!savedShowAssessments) setShowAssessments(false);
          if (!savedClosingCostTip) setClosingCostTipExpanded(false);
          // v6.10: Restore the user's original tab
          setActiveTab(savedActiveTab);

          // 8. Force-expand any hidden content in clones (catch-all)
          offscreen.querySelectorAll('[style*="display: none"], [style*="display:none"]').forEach(el => {
            el.style.display = 'block';
          });
          offscreen.querySelectorAll('[style*="max-height"]').forEach(el => {
            el.style.maxHeight = 'none';
            el.style.overflow = 'visible';
          });

          // 9. Wait for cloned elements + images to render
          await new Promise(resolve => setTimeout(resolve, 500));

          if (clonedSections.length === 0) {
            alert('No content sections found for PDF. Please try again.');
            document.body.removeChild(offscreen);
            setPdfGenerating(false);
            return;
          }

          // 10. Capture each cloned section as a canvas
          const captures = [];

          // First capture branding hero if it exists (find by profile info, not generic style)
          const brandingHeroEl = offscreen.querySelector('div:not([data-pdf-context-bar])');
          if (brandingHeroEl && brandingHeroEl.textContent.includes('License #')) {
            try {
              const canvas = await window.html2canvas(brandingHeroEl, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                scrollX: 0,
                scrollY: 0
              });
              captures.push({ name: 'branding-hero', canvas });
            } catch (err) {
              console.warn('Failed to capture branding hero:', err);
            }
          }

          // v5.7: Capture context bar separately (address + client + outlook badge)
          const contextBarEl = offscreen.querySelector('[data-pdf-context-bar]');
          if (contextBarEl) {
            try {
              const canvas = await window.html2canvas(contextBarEl, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                scrollX: 0,
                scrollY: 0
              });
              captures.push({ name: 'context-bar', canvas });
            } catch (err) {
              console.warn('Failed to capture context bar:', err);
            }
          }

          // D30: Capture GPS Score hero block (Score + gauge + tier + cap/floor annotations)
          const gpsHeroEl = offscreen.querySelector('[data-pdf-gps-hero]');
          if (gpsHeroEl) {
            try {
              const canvas = await window.html2canvas(gpsHeroEl, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                scrollX: 0,
                scrollY: 0
              });
              captures.push({ name: 'gps-hero', canvas });
            } catch (err) {
              console.warn('Failed to capture GPS hero:', err);
            }
          }

          // D30: Capture Industry Context citations block (omitted if zero citations)
          const industryContextEl = offscreen.querySelector('[data-pdf-industry-context]');
          if (industryContextEl) {
            try {
              const canvas = await window.html2canvas(industryContextEl, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                scrollX: 0,
                scrollY: 0
              });
              captures.push({ name: 'industry-context', canvas });
            } catch (err) {
              console.warn('Failed to capture industry context:', err);
            }
          }

          // Then capture all other sections
          for (const section of clonedSections) {
            try {
              const canvas = await window.html2canvas(section.element, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                scrollX: 0,
                scrollY: 0
              });
              captures.push({ name: section.name, canvas });
            } catch (err) {
              console.warn(`Failed to capture section ${section.name}:`, err);
            }
          }

          // 11. Clean up offscreen container
          document.body.removeChild(offscreen);

          // 12. Build PDF with intelligent page breaks
          const { jsPDF } = window.jspdf;
          const pdf = new jsPDF({
            unit: 'pt',
            format: 'letter',
            orientation: 'portrait'
          });

          const pageWidth = 612;
          const pageHeight = 792;
          const margin = 36;
          const contentWidth = pageWidth - (margin * 2);
          const contentHeight = pageHeight - (margin * 2) - 30; // Leave room for footer
          let yPosition = margin;
          let isFirstPage = true;

          for (let i = 0; i < captures.length; i++) {
            const capture = captures[i];
            const { canvas, name } = capture;

            const imgWidth = contentWidth;
            const imgHeight = (canvas.height * contentWidth) / canvas.width;

            // v5.10b: Prevent section header orphaning
            // If this is a header and there's not enough room for header + content, push to next page
            const isHeader = name.startsWith('header-');
            const minContentRoom = 100; // Minimum room for header + some content
            if (isHeader && yPosition + imgHeight + minContentRoom > pageHeight - margin - 30) {
              pdf.addPage();
              yPosition = margin;
            } else if (!isFirstPage || yPosition > margin) {
              if (yPosition + imgHeight > pageHeight - margin - 30) {
                pdf.addPage();
                yPosition = margin;
              } else {
                yPosition += 4;  // v5.2a: Tighter section spacing
              }
            }

            let finalHeight = imgHeight;
            let finalWidth = imgWidth;
            if (imgHeight > contentHeight) {
              const scaleFactor = contentHeight / imgHeight;
              finalHeight = contentHeight;
              finalWidth = imgWidth * scaleFactor;
            }

            const imgData = canvas.toDataURL('image/jpeg', 0.95);

            // v5.10b: Smart disclaimer positioning
            // v5.10e: Fixed logic - check if page has real content (not just empty space)
            if (name === 'disclaimer') {
              const footerSpace = 50;
              const availableBottom = pageHeight - footerSpace;
              let disclaimerY = availableBottom - finalHeight;

              // Check if current page has meaningful content (yPosition > margin + small threshold)
              const pageHasContent = yPosition > margin + 50;

              if (pageHasContent && disclaimerY >= yPosition) {
                // Page has content AND disclaimer fits - pin to bottom
                pdf.addImage(imgData, 'JPEG', margin, disclaimerY, finalWidth, finalHeight);
              } else if (pageHasContent) {
                // Page has content but disclaimer doesn't fit - add new page, place at TOP
                pdf.addPage();
                pdf.addImage(imgData, 'JPEG', margin, margin, finalWidth, finalHeight);
              } else {
                // Page is empty/new - place disclaimer at TOP (not floating at bottom)
                pdf.addImage(imgData, 'JPEG', margin, margin, finalWidth, finalHeight);
              }
            } else {
              pdf.addImage(imgData, 'JPEG', margin, yPosition, finalWidth, finalHeight);
              yPosition += finalHeight;
            }
            isFirstPage = false;
          }

          // 13. v5.4: Add improved footer with agent branding to each page
          const totalPages = pdf.internal.getNumberOfPages();
          const now = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
          const fullAddress = [
            propertyInfo.address,
            propertyInfo.city,
            propertyInfo.state
          ].filter(Boolean).join(', ') || 'Property';

          // Build agent info string
          const agentName = profile && (profile.first_name || profile.last_name)
            ? `${profile.first_name || ''} ${profile.last_name || ''}`.trim()
            : null;
          const agentBrokerage = profile?.brokerage || null;
          const agentPhone = profile?.phone_number || null;

          // v5.2: Build outcome tracking URL
          const outcomeUrl = pendingReportId
            ? `https://gameplanppg.ai/#outcome/${pendingReportId}`
            : null;

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);

            // Horizontal rule above footer
            pdf.setDrawColor(200, 200, 200);
            pdf.setLineWidth(0.5);
            pdf.line(margin, pageHeight - 38, pageWidth - margin, pageHeight - 38);

            // v6.1b: Two-line footer to prevent text overlap
            // Line 1: Agent branding (left-aligned, lighter)
            if (agentName || agentBrokerage) {
              pdf.setFontSize(8);
              pdf.setTextColor(120, 120, 120);
              const agentLine = [agentName, agentBrokerage, agentPhone].filter(Boolean).join('  ·  ');
              pdf.text(agentLine, margin, pageHeight - 26);
            }

            // Line 2: Property info (left) and page number (right)
            pdf.setFontSize(8);
            pdf.setTextColor(100, 100, 100);
            pdf.text(
              `Game Plan PPG  ·  ${fullAddress}  ·  ${now}`,
              margin,
              pageHeight - 14
            );

            pdf.text(
              `Page ${i} of ${totalPages}`,
              pageWidth - margin,
              pageHeight - 14,
              { align: 'right' }
            );

            // v5.2: Add outcome tracking link on first page only
            if (i === 1 && outcomeUrl) {
              pdf.setFontSize(7);
              pdf.setTextColor(100, 120, 180);
              const linkText = 'Track outcome at gameplanpro.ai';
              const linkX = pageWidth / 2;
              const linkY = pageHeight - 26;
              pdf.textWithLink(linkText, linkX, linkY, { url: outcomeUrl, align: 'center' });
            }
          }

          // 14. Save
          const filename = `${(propertyInfo.address || 'Strategy').replace(/[^a-zA-Z0-9]/g, '-')}-Strategy.pdf`;

          // Track usage BEFORE save (mobile browsers may interrupt after save)
          // D30: telemetry expanded with score state + citation count for debugging
          // future PDF complaints (e.g., "the PDF Sarah generated last Tuesday looks
          // wrong" — pull the exact state from this log entry).
          await trackUsage('pdf_exported', {
            type: 'strategy',
            property_address: propertyInfo.address,
            filename: filename,
            report_id: pendingReportId || null,
            gps_score: gamePlanScoreState?.score ?? null,
            gps_tier: gamePlanScoreState ? _gpsTierBadgeLabel(gamePlanScoreState.score) : null,
            confidence_tier: gamePlanScoreState?.confidence?.tier ?? null,
            cap_was_applied: !!gamePlanScoreState?.capWasApplied,
            floor_was_applied: !!gamePlanScoreState?.floorWasApplied,
            ask_pct_of_value: gamePlanScoreState?.askPercentOfValue ?? null,
            citation_count: Array.isArray(industryResearch) ? industryResearch.length : 0,
            generated_at: new Date().toISOString()
          });

          pdf.save(filename);

        } catch (error) {
          console.error('PDF export error:', error);
          alert('Error generating PDF: ' + error.message);
          // v6.10: Restore tab on error so user isn't stuck on the wrong tab
          setActiveTab(savedActiveTab);
        }

        setPdfGenerating(false);
      };

      // Client Explanation PDF - Captures client tab sections (v5.1: offscreen cloning, no flash)
      const exportClientPDF = async () => {
        setPdfGenerating(true);
        setPdfDropdownOpen(false);

        const savedTab = activeTab;
        setActiveTab('client');

        // Wait for React to render the client tab content
        await new Promise(resolve => setTimeout(resolve, 500));

        try {
          // Create offscreen container (no visible flash)
          const offscreen = document.createElement('div');
          offscreen.className = 'print-mode';
          offscreen.style.cssText = 'position: absolute; left: -9999px; top: 0; width: 8.5in; background: #ffffff; z-index: -1;';
          document.body.appendChild(offscreen);

          // Clone client sections into offscreen container
          const clientSections = document.querySelectorAll('[data-pdf-section]');
          const clonedSections = [];

          for (const section of clientSections) {
            if (section.offsetHeight > 0) {
              const clone = section.cloneNode(true);
              clone.style.marginBottom = '12px';
              clone.style.background = '#ffffff';

              // Force white backgrounds and proper styling on all elements
              clone.querySelectorAll('*').forEach(el => {
                if (el.style) {
                  // Remove dark backgrounds
                  const bg = window.getComputedStyle(el).backgroundColor;
                  if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
                    const isWhitish = bg.includes('255, 255, 255') || bg.includes('248, 250, 252') || bg.includes('249, 250, 251');
                    if (!isWhitish && !bg.includes('rgb(99,') && !bg.includes('rgb(34,') && !bg.includes('rgb(220,')) {
                      el.style.background = '#ffffff';
                    }
                  }
                  el.style.opacity = '1';
                }
              });

              offscreen.appendChild(clone);
              clonedSections.push(clone);
            }
          }

          // Wait for clones to render
          await new Promise(resolve => setTimeout(resolve, 300));

          // Capture each cloned section
          const captures = [];
          for (const clone of clonedSections) {
            try {
              const canvas = await window.html2canvas(clone, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                scrollX: 0,
                scrollY: 0
              });
              captures.push({ canvas });
            } catch (err) {
              console.warn('Failed to capture client section:', err);
            }
          }

          // Remove offscreen container
          document.body.removeChild(offscreen);

          const { jsPDF } = window.jspdf;
          const pdf = new jsPDF({ unit: 'pt', format: 'letter', orientation: 'portrait' });
          const pageWidth = 612;
          const pageHeight = 792;
          const margin = 36;
          const contentWidth = pageWidth - (margin * 2);
          const contentHeight = pageHeight - (margin * 2);
          let yPosition = margin;

          for (const capture of captures) {
            const imgWidth = contentWidth;
            const imgHeight = (capture.canvas.height * contentWidth) / capture.canvas.width;

            if (yPosition + imgHeight > pageHeight - margin && yPosition > margin) {
              pdf.addPage();
              yPosition = margin;
            } else if (yPosition > margin) {
              yPosition += 4;  // v5.2a: Tighter section spacing
            }

            let finalHeight = imgHeight;
            let finalWidth = imgWidth;
            if (imgHeight > contentHeight) {
              const scaleFactor = contentHeight / imgHeight;
              finalHeight = contentHeight;
              finalWidth = imgWidth * scaleFactor;
            }

            const imgData = capture.canvas.toDataURL('image/jpeg', 0.95);
            pdf.addImage(imgData, 'JPEG', margin, yPosition, finalWidth, finalHeight);
            yPosition += finalHeight;
          }

          const totalPages = pdf.internal.getNumberOfPages();
          const now = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            // Source attribution on first page only
            if (i === 1) {
              pdf.setFontSize(8);
              pdf.setTextColor(120, 113, 108); // #78716c
              pdf.text(
                'Cost estimates based on 2025-2026 Portland metro contractor data. Verify with local bids for final negotiations.',
                pageWidth / 2,
                pageHeight - 32,
                { align: 'center' }
              );
            }
            pdf.setFontSize(8);
            pdf.setTextColor(150, 150, 150);
            pdf.text(
              `Game Plan PPG - ${propertyInfo.address || 'Property'} - ${now} - Page ${i} of ${totalPages}`,
              pageWidth / 2,
              pageHeight - 20,
              { align: 'center' }
            );
          }

          const filename = `${(propertyInfo.address || 'Client').replace(/[^a-zA-Z0-9]/g, '-')}-Client-Explanation.pdf`;

          // Track usage BEFORE save (mobile browsers may interrupt after save)
          await trackUsage('pdf_exported', {
            type: 'client',
            property_address: propertyInfo.address,
            filename: filename
          });

          pdf.save(filename);
          setActiveTab(savedTab);

        } catch (error) {
          console.error('Client PDF export error:', error);
          alert('Error generating PDF: ' + error.message);
          setActiveTab(savedTab);
        }

        setPdfGenerating(false);
      };

      // Legacy function for backward compatibility
      const exportToPDF = () => exportPDF('strategy');

      // ================================================================
      // ================================================================
      // v4.1: HORIZONTAL BAR COMPONENT
      // ================================================================
      const HorizontalBar = ({ score, minScore, maxScore, leftLabel, rightLabel, colorGradient = true }) => {
        const range = maxScore - minScore;
        const position = ((score - minScore) / range) * 100;
        const clampedPosition = Math.max(0, Math.min(100, position));

        return (
          <div className="horizontal-bar-container">
            <div className="horizontal-bar-track">
              {colorGradient && <div className="horizontal-bar-gradient" />}
              <div
                className="horizontal-bar-marker"
                style={{ left: `${clampedPosition}%` }}
              />
            </div>
            <div className="horizontal-bar-labels">
              <span>{leftLabel}</span>
              <span>{rightLabel}</span>
            </div>
          </div>
        );
      };

      // ================================================================
      // v4.2: OUTLOOK VERDICT COMPONENT (Prestige Section)
      // Combines leverage + ask assessment into single "Outlook" score
      // ================================================================

      const OutlookVerdict = ({ outlookData, phase, needleAngle, showSummary, showAssessments, propertyInfo }) => {
        const { outlookScore, leverageScore: levScore, askAssessment } = outlookData;
        // v5.9: Display leverage as ±10 (internal stays ±20 for precision)
        const displayLeverageScore = Math.round(levScore / 2);
        const verdict = getOutlookVerdictData(outlookScore);
        const leverageData = getLeverageAssessmentData(displayLeverageScore);
        const formattedOutlook = outlookScore >= 0 ? `+${outlookScore}` : `${outlookScore}`;

        // Gauge arc gradient stops
        const gradientId = "gaugeGradient";

        // v4.2: Determine dial glow class based on outlook score
        const getGlowClass = () => {
          if (outlookScore >= 3) return 'positive';
          if (outlookScore >= -2) return 'neutral';
          return 'negative';
        };

        // v4.2: Get badge background color
        const getBadgeStyle = () => {
          if (outlookScore >= 5) return { background: 'rgba(34, 197, 94, 0.2)', color: '#22c55e' };
          if (outlookScore >= 0) return { background: 'rgba(234, 179, 8, 0.2)', color: '#eab308' };
          return { background: 'rgba(239, 68, 68, 0.2)', color: '#ef4444' };
        };

        return (
          <>
            {/* D23 finish: prestige-card wrapper removed (was empty after agent + property + Strategy Insight relocation).
                Analyzing-state placeholder retained inline for the phase transition shown during verdict reveal. */}
            {phase === 'analyzing' && (
              <div className="prestige-card" data-pdf-section="prestige">
                <div className="analyzing-container">
                  <div className="analyzing-text">Analyzing your position...</div>
                </div>
              </div>
            )}

            {/* D23 finish: Strategy Insight relocated to render directly below the GPS hero in strategy-report.
                Branding footer retained here as the bottom-of-report watermark. */}
            {showAssessments && (
              <div className="gameplan-branding" data-pdf-section="branding-footer">
                <span className="gameplan-text">Analysis by</span>
                <span className="gameplan-logo">Game Plan PPG™</span>
              </div>
            )}
          </>
        );
      };

      // v4.0: Trigger verdict reveal sequence (now uses Outlook score)
      const startVerdictReveal = () => {
        // Reset state
        setVerdictPhase('analyzing');
        setNeedleRotation(0);
        setShowSummary(false);
        setShowAssessments(false);
        setShowFunnel(false);

        // Calculate the Outlook score for needle animation
        const outlookData = calculateOutlookScore(leverageScore, findings);

        // Phase 1: Analyzing (1000ms)
        setTimeout(() => {
          setVerdictPhase('verdict');
        }, 1000);

        // Phase 2: Needle animation starts (1100ms) - Now uses Outlook score
        setTimeout(() => {
          // v5.12b: Anti-snap logic - prevent needle from landing on tick marks or dead center
          // First normalize the score to 0-1 range
          const clampedScore = Math.max(-20, Math.min(20, outlookData.outlookScore));
          let normalized = (clampedScore + 20) / 40; // 0 to 1

          // Tick positions to avoid (same as PDF gauge)
          const tickPositions = [0.15, 0.35, 0.50, 0.70, 0.85];
          const deadZone = 0.02;   // ±2% around each tick
          const nudgeAmount = 0.03; // Push 3% away from the tick

          for (const tick of tickPositions) {
            if (Math.abs(normalized - tick) < deadZone) {
              // For center (0.50) with exact zero score: nudge toward buyer side (right/positive)
              if (tick === 0.50 && clampedScore === 0) {
                normalized = tick + nudgeAmount; // Lean slightly toward buyer
              } else if (normalized >= tick) {
                normalized = tick + nudgeAmount;
              } else {
                normalized = tick - nudgeAmount;
              }
              break;
            }
          }

          // Clamp to valid range
          normalized = Math.max(0.02, Math.min(0.98, normalized));

          // Convert back to rotation: normalized 0→-90°, 0.5→0°, 1→+90°
          const adjustedScore = (normalized * 40) - 20; // Back to -20 to +20 range
          const targetRotation = (adjustedScore / 20) * 90;
          const clampedRotation = Math.max(-90, Math.min(90, targetRotation));
          setNeedleRotation(clampedRotation);
        }, 1100);

        // Phase 3: Summary appears (1800ms)
        setTimeout(() => {
          setShowSummary(true);
        }, 1800);

        // Phase 4: Assessment boxes appear (2200ms) - v4.0 new step
        setTimeout(() => {
          setShowAssessments(true);
        }, 2200);

        // Phase 5: Funnel loads (2800ms) - delayed to allow assessment reveal
        setTimeout(() => {
          setShowFunnel(true);
          setVerdictPhase('complete');
        }, 2800);
      };

      // v4.0: Auto-trigger verdict reveal when entering Step 4 (handles direct navigation)
      useEffect(() => {
        if (currentStep === 4 && verdictPhase === 'hidden') {
          startVerdictReveal();
        }
        // D13 Fix 1: Scroll to top on every step change so users always start at the top of the new step
        window.scrollTo(0, 0);
      }, [currentStep]);

      // D13 Fix 1b: Scroll to top when switching between Step 4 tabs (Strategy / Client / Negotiation)
      useEffect(() => {
        window.scrollTo(0, 0);
      }, [activeTab]);

      // v6.5 → v5.3: Fix gauge needle for restored reports (Directive 12.5)
      // Removed the `needleRotation === 0` guard so the effect re-fires when navigating
      // back to a saved report (where needleRotation may already be at a previous value).
      // Added loadedOutlookScore as a dependency so the effect re-fires when a saved report loads.
      useEffect(() => {
        if (currentStep === 4 && verdictPhase === 'complete') {
          // Calculate the correct needle position for restored reports
          const outlookData = calculateOutlookScore(leverageScore, findings);
          const clampedScore = Math.max(-20, Math.min(20, outlookData.outlookScore));
          let normalized = (clampedScore + 20) / 40;

          // Anti-snap logic (same as startVerdictReveal)
          const tickPositions = [0.15, 0.35, 0.50, 0.70, 0.85];
          const deadZone = 0.02;
          const nudgeAmount = 0.03;

          for (const tick of tickPositions) {
            if (Math.abs(normalized - tick) < deadZone) {
              if (tick === 0.50 && clampedScore === 0) {
                normalized = tick + nudgeAmount;
              } else if (normalized >= tick) {
                normalized = tick + nudgeAmount;
              } else {
                normalized = tick - nudgeAmount;
              }
              break;
            }
          }

          normalized = Math.max(0.02, Math.min(0.98, normalized));
          const adjustedScore = (normalized * 40) - 20;
          const targetRotation = (adjustedScore / 20) * 90;
          setNeedleRotation(Math.max(-90, Math.min(90, targetRotation)));
        }
      }, [currentStep, verdictPhase, leverageScore, findings, loadedOutlookScore, loadedLeverageScore]);

      // Step 4: Report (V3.7 - Two-Mode Strategy)
      const Step4Report = () => {
        const strategy = generateStrategy();
        const { buckets, totals, strategy: strat, scripts, position } = strategy;

        // v3.7: Calculate request totals by type
        const requestTotals = calculateRequestTotals(findings);
        const relevantCards = getRelevantJustificationCards(findings.filter(f => f.selected));

        // v3.7: Category data for charts
        const categoryData = Object.entries(
          findings.filter(f => f.selected).reduce((acc, f) => {
            const cat = f.category || 'General';
            acc[cat] = (acc[cat] || 0) + (f.cost || 0);
            return acc;
          }, {})
        ).map(([name, value]) => ({ name, value }));

        // v3.7: Priority data for charts
        const priorityData = [
          { name: 'Critical', value: findings.filter(f => f.selected && f.priority === 'high').reduce((sum, f) => sum + (f.cost || 0), 0), color: '#ef4444' },
          { name: 'Major', value: findings.filter(f => f.selected && f.priority === 'medium').reduce((sum, f) => sum + (f.cost || 0), 0), color: '#7b8bff' },
          { name: 'Minor', value: findings.filter(f => f.selected && f.priority === 'low').reduce((sum, f) => sum + (f.cost || 0), 0), color: '#6b7280' }
        ];

        const toggleScript = (key) => {
          setExpandedScripts(prev => ({ ...prev, [key]: !prev[key] }));
        };

        // v3.8: Filter out deal-critical items from mustHaves to avoid duplication
        const displayedMustHaves = buckets.mustHaves.filter(item =>
          !strat.dealCriticalItems.some(dc => dc.id === item.id)
        );
        const displayedMustHavesTotal = displayedMustHaves.reduce((sum, f) => sum + (f.cost || 0), 0);

        // Bucket display config (legacy - keeping for compatibility)
        const bucketConfig = [
          {
            key: 'mustHaves',
            label: 'MUST-HAVES',
            subtitle: strat.dealCriticalItems.length > 0 ? 'Excludes deal-critical items shown above' : 'Fight for these',
            items: displayedMustHaves,
            total: displayedMustHavesTotal,
            color: 'red',
            icon: '🔴',
            script: scripts.mustHaveScript
          },
          {
            key: 'strongAsks',
            label: 'STRONG ASKS',
            subtitle: 'Push hard, flex on method',
            items: buckets.strongAsks,
            total: totals.strongAsks,
            color: 'orange',
            icon: '🟠',
            script: scripts.strongAskScript
          },
          {
            key: 'tradeables',
            label: 'TRADEABLES',
            subtitle: 'Bargaining chips',
            items: buckets.tradeables,
            total: totals.tradeables,
            color: 'yellow',
            icon: '🟡',
            script: scripts.tradeableScript
          },
          { 
            key: 'concessions', 
            label: 'STRATEGIC CONCESSIONS', 
            subtitle: "Don't ask for these",
            items: buckets.concessions,
            total: totals.concessions,
            color: 'stone',
            icon: '⚪',
            script: scripts.concessionScript
          }
        ];

        const colorClasses = {
          red: { bg: 'bg-red-500/10', border: 'border-red-500/30', text: 'text-red-400', badge: 'bg-red-500' },
          orange: { bg: 'bg-brand-500/10', border: 'border-brand-500/30', text: 'text-brand-400', badge: 'bg-brand-500' },
          yellow: { bg: 'bg-yellow-500/10', border: 'border-yellow-500/30', text: 'text-yellow-400', badge: 'bg-yellow-500' },
          stone: { bg: 'bg-stone-500/10', border: 'border-stone-500/30', text: 'text-stone-400', badge: 'bg-stone-500' }
        };

        return (
          <div id="strategy-report" className="space-y-6 animate-fade-in-up">
            {/* D13: Save-scenario modal — portaled for viewport-anchored positioning */}
            {saveScenarioOpen && gamePlanScoreState && ReactDOM.createPortal(
              <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setSaveScenarioOpen(false)}>
                <div className="bg-stone-900 rounded-2xl p-6 max-w-md w-full border border-stone-700" onClick={(e) => e.stopPropagation()}>
                  <h3 className="text-xl font-bold text-white mb-2">Save this version</h3>
                  <p className="text-sm text-stone-400 mb-4">Name this scenario so you can come back to it.</p>
                  <form onSubmit={(e) => { e.preventDefault(); saveCurrentAsScenario(e.target.scenarioName.value); }}>
                    <input name="scenarioName" type="text" required placeholder="e.g., Drop HVAC, keep roof only" maxLength={120} className="w-full bg-stone-800 border border-stone-700 rounded-lg px-3 py-2 text-white mb-4 focus:border-brand-500 focus:outline-none" autoFocus />
                    <div className="text-xs text-stone-500 mb-4">
                      Current score: <span className="text-white font-semibold">{gamePlanScoreState.score}</span> ({gamePlanScoreState.confidence.tier} confidence)<br/>
                      Total ask: <span className="text-white font-semibold">${(gamePlanScoreState.ask || 0).toLocaleString()}</span> across {findings.filter(f => f.selected).length} items
                    </div>
                    <div className="flex justify-end gap-2">
                      <button type="button" onClick={() => setSaveScenarioOpen(false)} className="px-4 py-2 text-sm text-stone-400 hover:text-white">Cancel</button>
                      <button type="submit" className="px-4 py-2 text-sm bg-brand-500 text-white rounded-lg font-medium hover:bg-brand-600">Save scenario</button>
                    </div>
                  </form>
                </div>
              </div>,
              document.body
            )}
            {/* D13: Compare-scenarios modal — portaled */}
            {compareScenariosOpen && ReactDOM.createPortal(
              <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setCompareScenariosOpen(false)}>
                <div className="bg-stone-900 rounded-2xl p-6 max-w-4xl w-full border border-stone-700" style={{ maxHeight: '80vh', overflowY: 'auto' }} onClick={(e) => e.stopPropagation()}>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-xl font-bold text-white">Compare Scenarios</h3>
                    <button onClick={() => setCompareScenariosOpen(false)} className="text-stone-400 hover:text-white text-xl">×</button>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="text-stone-500 text-xs uppercase tracking-wider">
                          <th className="text-left py-2 px-3"></th>
                          {baselineRow && (<th className="text-left py-2 px-3 cursor-pointer hover:text-brand-400" onClick={() => { switchToScenario('baseline'); setCompareScenariosOpen(false); }}>📍 Baseline</th>)}
                          {savedScenarios.slice(0, 3).map(scn => (<th key={scn.id} className="text-left py-2 px-3 cursor-pointer hover:text-brand-400" onClick={() => { switchToScenario(scn.id); setCompareScenariosOpen(false); }}>{scn.scenario_label}</th>))}
                        </tr>
                      </thead>
                      <tbody className="text-stone-300">
                        <tr className="border-t border-stone-800"><td className="py-2 px-3 text-stone-500">Score</td>{baselineRow && <td className="py-2 px-3 text-white font-semibold">{baselineRow.score}</td>}{savedScenarios.slice(0, 3).map(scn => <td key={scn.id} className="py-2 px-3 text-white font-semibold">{scn.score}</td>)}</tr>
                        <tr className="border-t border-stone-800"><td className="py-2 px-3 text-stone-500">Confidence</td>{baselineRow && <td className="py-2 px-3 capitalize">{baselineRow.confidence_tier}</td>}{savedScenarios.slice(0, 3).map(scn => <td key={scn.id} className="py-2 px-3 capitalize">{scn.confidence_tier}</td>)}</tr>
                        <tr className="border-t border-stone-800"><td className="py-2 px-3 text-stone-500">Total ask</td>{baselineRow && <td className="py-2 px-3">${Math.round(parseFloat(baselineRow.ask_amount) || 0).toLocaleString()}</td>}{savedScenarios.slice(0, 3).map(scn => <td key={scn.id} className="py-2 px-3">${Math.round(parseFloat(scn.ask_amount) || 0).toLocaleString()}</td>)}</tr>
                        <tr className="border-t border-stone-800"><td className="py-2 px-3 text-stone-500">Items selected</td>{baselineRow && <td className="py-2 px-3">{baselineRow.scenario_findings_snapshot?.findings?.filter(f => f.selected).length ?? '—'}</td>}{savedScenarios.slice(0, 3).map(scn => <td key={scn.id} className="py-2 px-3">{scn.scenario_findings_snapshot?.findings?.filter(f => f.selected).length ?? '—'}</td>)}</tr>
                      </tbody>
                    </table>
                  </div>
                  <p className="text-xs text-stone-500 mt-4">Click a scenario header to load it into Step 4.</p>
                </div>
              </div>,
              document.body
            )}
            {/* D22 + D32-B: TEST DATA banner — fires whenever any finding has a
                manual_dev cost source OR any buyer subjective input was dev-overridden.
                Cannot be dismissed. Same component renders on Step 4, dashboard tile,
                and the PDF (via the print stylesheet keeping it visible). */}
            {(findings.some(f => f.costSource === 'manual_dev') || Object.values(buyerResponses).some(r => r?.source === 'manual_dev')) && (
              <div className="rounded-xl p-3" style={{
                background: 'rgba(251,191,36,0.12)',
                border: '2px solid rgba(251,191,36,0.55)',
                color: '#fde68a',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                fontSize: '13px',
                lineHeight: 1.5
              }}>
                <span style={{ fontSize: '20px' }}>⚠️</span>
                <span><strong style={{ color: '#fbbf24' }}>TEST DATA</strong> — This report contains manually-entered values for development testing (cost estimates and/or buyer responses). <strong>Not for client use.</strong></span>
              </div>
            )}
            {/* D23: Tabs header (was below GPS+Industry Context). Promoted to top of Step 4 so
                navigation context is the first interactive thing under the page nav / TEST DATA banner. */}
            <div className="strategy-tabs-header no-print">
            <div className="flex justify-between items-center">
              <div className="flex bg-stone-800 rounded-xl p-1">
                <button
                  onClick={() => { setActiveTab('strategy'); setTimeout(() => document.getElementById('step4-tab-content')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 50); }}
                  className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all ${
                    activeTab === 'strategy' ? 'bg-brand-500 text-white' : 'text-stone-400 hover:text-white'
                  }`}
                >
                  Strategy
                </button>
                <button
                  onClick={() => { setActiveTab('client'); setTimeout(() => document.getElementById('step4-tab-content')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 50); }}
                  className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all ${
                    activeTab === 'client' ? 'bg-brand-500 text-white' : 'text-stone-400 hover:text-white'
                  }`}
                >
                  Client Explanation
                </button>
                <button
                  onClick={() => { setActiveTab('negotiation'); setTimeout(() => document.getElementById('step4-tab-content')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 50); }}
                  className={`px-6 py-2.5 rounded-lg text-sm font-medium transition-all ${
                    activeTab === 'negotiation' ? 'bg-brand-500 text-white' : 'text-stone-400 hover:text-white'
                  }`}
                >
                  Seller Negotiation
                </button>
              </div>
              {/* PDF Export Dropdown */}
              <div className="relative">
                <button
                  onClick={() => setPdfDropdownOpen(!pdfDropdownOpen)}
                  disabled={pdfGenerating}
                  className={`px-4 py-2 bg-stone-800 text-white rounded-lg hover:bg-stone-700 transition-all flex items-center gap-2 ${pdfGenerating ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                  {pdfGenerating ? (
                    <>
                      <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Generating...
                    </>
                  ) : (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      Export PDF
                      <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </>
                  )}
                </button>

                {/* Click outside to close PDF dropdown - MUST be inside same relative container, BEFORE dropdown */}
                {pdfDropdownOpen && (
                  <div
                    className="fixed inset-0 z-30"
                    onClick={() => setPdfDropdownOpen(false)}
                  ></div>
                )}

                {/* Dropdown Menu - z-50 beats z-30 within same stacking context */}
                {pdfDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-56 bg-stone-800 border border-stone-700 rounded-lg shadow-xl z-50 overflow-hidden">
                    <button
                      onClick={() => exportPDF('strategy')}
                      className="w-full px-4 py-3 text-left text-white hover:bg-stone-700 transition-colors flex items-center gap-3"
                    >
                      <span className="text-lg">📊</span>
                      <div>
                        <div className="font-medium">Strategy</div>
                        <div className="text-xs text-stone-400">Internal analysis overview</div>
                      </div>
                    </button>
                    <button
                      onClick={() => exportPDF('client')}
                      className="w-full px-4 py-3 text-left text-white hover:bg-stone-700 transition-colors flex items-center gap-3 border-t border-stone-700"
                    >
                      <span className="text-lg">📄</span>
                      <div>
                        <div className="font-medium">Client Explanation</div>
                        <div className="text-xs text-stone-400">Share with your buyer</div>
                      </div>
                    </button>
                  </div>
                )}
              </div>
            </div>
            </div>

            {/* D23: Compressed branding bar — single horizontal row replacing the legacy
                stacked agent + property cards from OutlookVerdict.
                Layout (post-Jared cleanup): agent identity (left), brokerage logo (center,
                next to agent), property context (right). */}
            {(propertyInfo?.address || profile?.first_name || profile?.headshot_url) && (
              <div className="rounded-xl" data-pdf-section="branding-bar" style={{
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(255,255,255,0.08)',
                padding: '14px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                flexWrap: 'wrap'
              }}>
                {/* LEFT: Agent identity */}
                {(profile?.first_name || profile?.last_name || profile?.headshot_url) && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: '0 0 auto' }}>
                    {profile?.headshot_url ? (
                      <img
                        src={`https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${profile.headshot_url}`}
                        alt=""
                        style={{ width: '48px', height: '48px', borderRadius: '9999px', objectFit: 'cover', border: '2px solid rgba(255,255,255,0.1)' }}
                      />
                    ) : (
                      <div style={{
                        width: '48px', height: '48px', borderRadius: '9999px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: 'rgba(255,255,255,0.06)',
                        color: '#cbd5e1', fontSize: '14px', fontWeight: 600
                      }}>
                        {(profile?.first_name?.[0] || '')}{(profile?.last_name?.[0] || '')}
                      </div>
                    )}
                    <div>
                      {(profile?.first_name || profile?.last_name) && (
                        <div style={{ fontSize: '15px', fontWeight: 500, color: '#f1f5f9', lineHeight: 1.3 }}>
                          {profile?.first_name} {profile?.last_name}
                        </div>
                      )}
                      {profile?.brokerage && (
                        <div style={{ fontSize: '12px', color: '#94a3b8', lineHeight: 1.4 }}>{profile.brokerage}</div>
                      )}
                      {profile?.license_number && (
                        <div style={{ fontSize: '11px', color: '#64748b', lineHeight: 1.4 }}>License #{profile.license_number}</div>
                      )}
                    </div>
                  </div>
                )}
                {/* CENTER: Brokerage logo (swapped from right per Jared's UI cleanup) */}
                {profile?.brokerage_logo_url && (
                  <div style={{ flex: '0 0 auto' }}>
                    <img
                      src={`https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${profile.brokerage_logo_url}`}
                      alt="Brokerage"
                      style={{ height: '48px', maxWidth: '120px', objectFit: 'contain' }}
                    />
                  </div>
                )}
                {/* RIGHT: Property context (swapped from center per Jared's UI cleanup) */}
                <div style={{ flex: '1 1 auto', minWidth: '200px', textAlign: 'right' }}>
                  <div style={{ fontSize: '19px', fontWeight: 700, color: 'white', lineHeight: 1.3 }}>
                    {propertyInfo?.address || 'Property Address'}
                  </div>
                  {propertyInfo?.clientName && (
                    <div style={{ fontSize: '13px', color: '#94a3b8', lineHeight: 1.4, marginTop: '2px' }}>
                      Prepared for: {propertyInfo.clientName}
                    </div>
                  )}
                </div>
              </div>
            )}
            {/* D23: Scenario bar relocated below Industry Context (was here, above hero). */}
            {/* D8: Game Plan Score Card — flagship visual */}
            {/* D18a Part 2: GPS card paired with retargeted gauge (side-by-side desktop, stacked mobile) */}
            {/* D23 finish: GPS hero promoted to sit immediately after the compressed branding bar — directive's intended hero placement. */}
            {gamePlanScoreState && (
              <div className="flex flex-col md:flex-row md:items-stretch md:gap-4 no-print">
              <div className="rounded-2xl p-6 flex-1" style={{
                background: _gpsTierGradient(gamePlanScoreState.score),
                boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                color: 'white',
                transition: 'background 400ms ease-out'
              }}>
                <div className="flex flex-col md:flex-row md:items-center md:gap-8">
                  <div className="text-center md:text-left mb-4 md:mb-0 flex-shrink-0">
                    <div className="font-bold leading-none" style={{ fontSize: '96px' }}>
                      {gamePlanScoreState.score}
                    </div>
                    <div className="text-xs uppercase tracking-widest opacity-80 mt-1">/ 10</div>
                    {/* D13: Delta badge — current score vs baseline */}
                    {baselineRow && baselineRow.score !== gamePlanScoreState.score && (
                      <div className="mt-2" style={{
                        display: 'inline-block',
                        padding: '3px 10px',
                        borderRadius: '999px',
                        fontSize: '11px',
                        fontWeight: 500,
                        background: gamePlanScoreState.score > baselineRow.score ? 'rgba(16,185,129,0.35)' : 'rgba(251,146,60,0.35)',
                        border: `1px solid ${gamePlanScoreState.score > baselineRow.score ? 'rgba(16,185,129,0.55)' : 'rgba(251,146,60,0.55)'}`,
                        color: 'white'
                      }} title="Compared to your original (baseline) configuration">
                        {gamePlanScoreState.score > baselineRow.score ? '+' : ''}{gamePlanScoreState.score - baselineRow.score} from baseline
                      </div>
                    )}
                    {baselineRow && baselineRow.score === gamePlanScoreState.score && activeScenarioId === 'baseline' && (
                      <div className="mt-2" style={{
                        display: 'inline-block',
                        padding: '3px 10px',
                        borderRadius: '999px',
                        fontSize: '11px',
                        fontWeight: 500,
                        background: 'rgba(255,255,255,0.12)',
                        border: '1px solid rgba(255,255,255,0.2)',
                        color: 'white'
                      }}>📍 Baseline</div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-xs uppercase tracking-widest opacity-80">Game Plan Score</div>
                    {/* D43 (2026-05-11): plain-English probability subtitle sits between
                        the GAME PLAN SCORE label and the tagline. Uses displayedProbabilityFor
                        so it agrees with the floored/capped hero score AND with the details
                        panel's probability line. Capped 5–95% so we never overclaim or
                        underclaim certainty. Hidden if score is missing. */}
                    {(() => {
                      if (typeof gamePlanScoreState.score !== 'number') return null;
                      const p = displayedProbabilityFor(gamePlanScoreState);
                      if (p == null || !Number.isFinite(p)) return null;
                      const pct = Math.max(5, Math.min(95, Math.round(p * 100)));
                      return (
                        <div className="text-sm opacity-85 mt-1">
                          ~{pct}% chance of close at these terms
                        </div>
                      );
                    })()}
                    {/* Hero Number V2 (2026-05-06): per-integer two-line tagline replaces
                        the generic _gpsTierLabels readout. Same-side-of-the-rope philosophy
                        on line 2 reinforces "Both sides win when the deal closes" across
                        every score view. Cap edge case (D31 score=1 with cap applied)
                        keeps its bespoke "Pathological ask" framing — that's a system
                        signal, not a deal narrative. */}
                    {(gamePlanScoreState.capWasApplied && gamePlanScoreState.score === 1) ? (
                      <div className="text-2xl font-semibold mt-1">Pathological ask — recheck inputs</div>
                    ) : (() => {
                      const tagline = SCORE_AGENT_TAGLINE[gamePlanScoreState.score];
                      if (!tagline) {
                        return <div className="text-2xl font-semibold mt-1">{_gpsTierLabels[gamePlanScoreState.score] || '—'}</div>;
                      }
                      return (
                        <div className="mt-1">
                          <div className="text-2xl font-semibold leading-tight">{tagline.line1}</div>
                          <div className="text-base font-medium opacity-90 mt-1">{tagline.line2}</div>
                        </div>
                      );
                    })()}
                    <div className="flex items-center gap-2 mt-3">
                      {[0, 1, 2].map(i => {
                        const tier = gamePlanScoreState.confidence.tier;
                        const filled = (tier === 'high') || (tier === 'moderate' && i < 2) || (tier === 'limited' && i < 1);
                        return (
                          <div key={i} className="rounded-full" style={{
                            width: '10px', height: '10px',
                            background: filled ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.25)'
                          }}/>
                        );
                      })}
                      <span className="text-sm ml-2 opacity-90" style={{ textTransform: 'capitalize' }}>
                        {gamePlanScoreState.confidence.tier === 'limited' ? 'Limited data' : `${gamePlanScoreState.confidence.tier} confidence`}
                      </span>
                    </div>
                    {/* D43 (2026-05-11): removed "Based on N similar deals" / "Based on
                        Portland metro priors" — methodology context now lives only in the
                        Details panel, per directive. Keeps the hero card focused on the
                        score, the tagline, and confidence. */}
                    <div className="flex flex-wrap items-center gap-3 mt-4">
                      {(() => {
                        const st = gamePlanScoreState.sniffTest;
                        // D43 (2026-05-11): when sniffTest is missing or errored, omit
                        // the AI line entirely (system status doesn't belong on the hero
                        // card). The hydration fix from earlier tonight already restores
                        // cached supervisor reviews on saved-report loads, so this
                        // fallback should be rare in practice.
                        if (!st || st.status === 'error') {
                          return null;
                        }
                        if (st.verdict === 'concurs') {
                          return <span className="text-sm opacity-90">✓ AI concurs</span>;
                        }
                        if (st.verdict === 'flag') {
                          return <span className="text-sm opacity-90" title={st.concern}>⚠ AI notes a concern</span>;
                        }
                        if (st.verdict === 'adjust') {
                          return <span className="text-sm opacity-90" title={st.reasoning}>↕ AI suggests {st.suggestedScore}</span>;
                        }
                        return null;
                      })()}
                      <button
                        onClick={() => setScoreDetailsOpen(v => !v)}
                        className="ml-auto px-3 py-1.5 text-sm rounded-lg transition-all hover:bg-white/30"
                        style={{
                          background: 'rgba(255,255,255,0.2)',
                          color: 'white',
                          border: '1px solid rgba(255,255,255,0.35)'
                        }}>
                        {scoreDetailsOpen ? 'Hide details' : 'Details →'}
                      </button>
                    </div>
                    {scoreComputing && (
                      <div className="text-xs opacity-70 mt-2">Updating...</div>
                    )}
                  </div>
                </div>
                {scoreDetailsOpen && (
                  <div className="mt-6 pt-5" style={{ borderTop: '1px solid rgba(255,255,255,0.25)' }}>
                    <div className="text-sm opacity-85 mb-4">
                      {/* 2026-05-11 consistency fix: use displayedProbabilityFor
                          so the probability text agrees with the floored/capped
                          hero score. See helper near probabilityToContinuousScore. */}
                      Probability of close at proposed terms: {(displayedProbabilityFor(gamePlanScoreState) * 100).toFixed(0)}%
                      {' · '}Confidence: {gamePlanScoreState.confidence.tier}
                    </div>
                    {[
                      { key: 'leverage', label: 'LEVERAGE', weight: gamePlanScoreState.weights.w_L },
                      { key: 'marketRealism', label: 'MARKET REALISM', weight: gamePlanScoreState.weights.w_M },
                      // D45: PROPERTY SPECIFICS → ASK JUSTIFICATION (component swap).
                      { key: 'askJustification', label: 'ASK JUSTIFICATION', weight: gamePlanScoreState.weights.w_AJ },
                      { key: 'outcomeSimilarity', label: 'OUTCOME SIMILARITY', weight: gamePlanScoreState.weights.w_O }
                    ].map(row => {
                      const v = gamePlanScoreState.components[row.key];
                      const pct = v == null ? 0 : Math.round(v * 100);
                      return (
                        <div key={row.key} className="mb-3">
                          <div className="flex justify-between text-xs uppercase tracking-widest opacity-90">
                            <span>{row.label}</span>
                            <span>{v == null ? '—' : v.toFixed(2)}  <span className="opacity-70">(weight: {Math.round(row.weight * 100)}%)</span></span>
                          </div>
                          <div className="rounded-full mt-1" style={{ height: '6px', background: 'rgba(255,255,255,0.18)' }}>
                            <div className="rounded-full" style={{ height: '6px', width: `${pct}%`, background: 'rgba(255,255,255,0.9)', transition: 'width 400ms ease-out' }} />
                          </div>
                          <div className="text-sm opacity-90 mt-1">{_gpsComponentLabel(row.key, v)}</div>
                        </div>
                      );
                    })}
                    {/* D31: cap annotation — fires only when applyCatastrophicAskCap lowered the
                        score. Audit trail so an agent who sees a low score can see WHY when
                        the cap binds, not just the component math. */}
                    {gamePlanScoreState.capWasApplied && gamePlanScoreState.askPercentOfValue != null && (
                      <div className="text-xs mt-2 italic" style={{ color: '#fbbf24' }}>
                        ⓘ Score capped at {gamePlanScoreState.score} due to ask size
                        ({(gamePlanScoreState.askPercentOfValue * 100).toFixed(1)}% of property value).
                        See Strategy Insight for context.
                      </div>
                    )}
                    {/* D33: floor annotation — fires when applySoftballAskFloor raised the score.
                        Mirrors D31's pattern so the audit trail is symmetric. */}
                    {gamePlanScoreState.floorWasApplied && gamePlanScoreState.askPercentOfValue != null && (
                      <div className="text-xs mt-2 italic" style={{ color: '#86efac' }}>
                        ⓘ Score floored at {gamePlanScoreState.score} — your ask is
                        {' '}{(gamePlanScoreState.askPercentOfValue * 100).toFixed(1)}% of property value, within typical range.
                      </div>
                    )}
                    {/* D18a Part 3: Detailed assessment — relocated from the legacy four standalone cards.
                        Same data, compact format, lives one tap deeper. */}
                    {(() => {
                      const askA = calculateAskAssessment(findings, leverageScore);
                      const dispLev = Math.round(leverageScore / 2);
                      const levA = getLeverageAssessmentData(dispLev);
                      const mpScore = calculateMarketPositionScore();
                      const mpData = getMarketPositionData(mpScore);
                      const spResult = calculateSellerProfileScore();
                      const spData = spResult.sellerData
                        ? getSellerProfileData(spResult.score, spResult.sellerData.motivation)
                        : { label: 'MORE DATA NEEDED', color: '#9ca3af' };
                      const askColor = askA.score > 0 ? '#22c55e' : askA.score < 0 ? '#f97316' : '#eab308';
                      const cards = [
                        { title: 'Leverage Score', score: dispLev, prefix: dispLev >= 0 ? '+' : '', label: levA.label, color: levA.color, explanation: levA.explanation },
                        { title: 'Ask Favorability', score: askA.score, prefix: askA.score > 0 ? '+' : '', label: askA.label, color: askColor, explanation: askA.explanation },
                        { title: 'Deal Context', score: mpScore, prefix: mpScore >= 0 ? '+' : '', label: mpData.label, color: mpData.color, explanation: null },
                        { title: 'Seller Signals', score: spResult.score, prefix: spResult.score >= 0 ? '+' : '', label: spData.label, color: spData.color, explanation: null }
                      ];
                      return (
                        <div className="mt-6 pt-5" style={{ borderTop: '1px solid rgba(255,255,255,0.18)' }}>
                          <div className="text-xs uppercase tracking-widest opacity-75 mb-3">Detailed assessment</div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                            {cards.map(c => (
                              <div key={c.title} style={{ background: 'rgba(15,23,42,0.55)', borderRadius: '8px', padding: '10px 12px', border: '1px solid rgba(255,255,255,0.08)' }}>
                                <div className="text-xs uppercase tracking-wider opacity-75 mb-1">{c.title}</div>
                                <div style={{ fontWeight: 600, color: c.color, fontSize: '14px' }}>
                                  {c.prefix}{c.score} <span style={{ opacity: 0.85, fontWeight: 500 }}>· {c.label}</span>
                                </div>
                                {c.explanation && (
                                  <div className="opacity-80 mt-1" style={{ fontSize: '12px', lineHeight: 1.45 }}>{c.explanation}</div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })()}
                    {/* D32-C: agent justifications for the 3 agent-input sliders.
                        Renders only the justifications that exist (skips defaults/empty).
                        Provides the audit trail Lori called out as the missing piece. */}
                    {(() => {
                      const justificationDisplay = [
                        { id: 'sellerDisclosed', label: 'Seller Disclosure' },
                        { id: 'sellerMotivated', label: 'Seller Motivation' },
                        { id: 'backupOffers',    label: 'Backup Offers / Interest' }
                      ].map(item => {
                        const j = justifications[item.id];
                        if (!j || !j.type) return null;
                        const text = j.type === D32C_OTHER_SENTINEL ? (j.text || '') : j.type;
                        if (!text) return null;
                        return { ...item, text };
                      }).filter(Boolean);
                      if (justificationDisplay.length === 0) return null;
                      return (
                        <div className="mt-6 pt-5" style={{ borderTop: '1px solid rgba(255,255,255,0.18)' }} data-pdf-section="agent-reasoning">
                          <div className="text-xs uppercase tracking-widest opacity-75 mb-3">Agent reasoning</div>
                          <div className="space-y-2 text-sm">
                            {justificationDisplay.map(item => (
                              <div key={item.id} style={{ background: 'rgba(15,23,42,0.55)', borderRadius: '8px', padding: '10px 12px', border: '1px solid rgba(255,255,255,0.08)' }}>
                                <div className="text-xs uppercase tracking-wider opacity-75 mb-1">{item.label}</div>
                                <div style={{ fontSize: '13px', lineHeight: 1.45, color: 'rgba(226,232,240,0.92)' }}>{item.text}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })()}
                    <div className="mt-4 text-sm opacity-90">
                      <div>Market segment: {gamePlanScoreState.segmentName || 'Portland metro'}</div>
                      {gamePlanScoreState.expectedConcession > 0 && (
                        <div>Expected concession: ${Math.round(gamePlanScoreState.expectedConcession).toLocaleString()}</div>
                      )}
                      {gamePlanScoreState.ask > 0 && (
                        <div>Your ask: ${Math.round(gamePlanScoreState.ask).toLocaleString()}
                          {gamePlanScoreState.expectedConcession > 0 && (
                            <span className="opacity-80"> ({gamePlanScoreState.ask >= gamePlanScoreState.expectedConcession ? '+' : ''}${Math.round(gamePlanScoreState.ask - gamePlanScoreState.expectedConcession).toLocaleString()} vs segment)</span>
                          )}
                        </div>
                      )}
                    </div>
                    {gamePlanScoreState.sniffTest && gamePlanScoreState.sniffTest.status === 'ok' && gamePlanScoreState.sniffTest.verdict !== 'concurs' && (
                      <div className="mt-4 p-3 rounded-lg" style={{ background: 'rgba(255,255,255,0.18)' }}>
                        <div className="text-xs uppercase tracking-widest opacity-90 mb-1">AI Sniff Test</div>
                        {gamePlanScoreState.sniffTest.concern && (
                          <div className="text-sm"><strong>Concern:</strong> {gamePlanScoreState.sniffTest.concern}</div>
                        )}
                        {gamePlanScoreState.sniffTest.reasoning && (
                          <div className="text-sm mt-1">{gamePlanScoreState.sniffTest.reasoning}</div>
                        )}
                      </div>
                    )}
                    {/* D21: Market Context — current PMMS 30-yr fixed rate from Freddie Mac.
                        Hidden when no data; shows stale indicator when >14 days old. */}
                    {Array.isArray(marketRates) && marketRates.length > 0 && (() => {
                      const r30 = marketRates.find(r => r.rate_type === '30yr_conventional');
                      if (!r30) return null;
                      const pubDate = new Date(r30.source_published_at + 'T00:00:00');
                      const ageDays = Math.floor((Date.now() - pubDate.getTime()) / 86400000);
                      const stale = ageDays > 14;
                      const formattedDate = pubDate.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' });
                      return (
                        <div className="mt-4 p-3 rounded-lg" style={{ background: 'rgba(255,255,255,0.10)' }}>
                          <div className="text-xs uppercase tracking-widest opacity-90 mb-2">📊 Market Context</div>
                          <div className="flex items-baseline justify-between gap-3">
                            <span className="text-sm opacity-90">Current 30-year fixed:</span>
                            <span style={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600, fontSize: '15px' }}>{Number(r30.rate_value).toFixed(3)}%</span>
                          </div>
                          <div className="text-xs opacity-70 mt-1">
                            {stale ? `Last updated ${ageDays} days ago · ` : `As of ${formattedDate} · `}
                            Freddie Mac PMMS
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
              {/* D18a Part 2: Repurposed gauge — needle reflects Game Plan Score (1-10), not legacy outlook */}
              <div className="rounded-2xl p-4 flex flex-col items-center justify-center" style={{
                background: 'rgba(30,41,59,0.5)',
                border: '1px solid rgba(255,255,255,0.06)',
                minWidth: '300px',
                flex: '0 0 auto'
              }}>
                <svg viewBox="0 0 280 160" width="260" height="150">
                  <defs>
                    <linearGradient id="d18aGaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stopColor="#dc2626" />
                      <stop offset="25%" stopColor="#f97316" />
                      <stop offset="50%" stopColor="#eab308" />
                      <stop offset="75%" stopColor="#22c55e" />
                      <stop offset="100%" stopColor="#15803d" />
                    </linearGradient>
                  </defs>
                  {/* Background arc */}
                  <path d="M 20 140 A 120 120 0 0 1 260 140" fill="none" stroke="#374151" strokeWidth="20" strokeLinecap="round" />
                  {/* Colored arc */}
                  <path d="M 20 140 A 120 120 0 0 1 260 140" fill="none" stroke="url(#d18aGaugeGradient)" strokeWidth="16" strokeLinecap="round" />
                  {/* Tick marks + number labels removed per Jared's UI cleanup pass — gauge reads cleaner without them. */}
                  {/* Needle — driven by Game Plan Score */}
                  <g style={{
                    transform: `rotate(${((gamePlanScoreState.score - 1) / 9) * 180 - 90}deg)`,
                    transformOrigin: '140px 140px',
                    transition: 'transform 600ms cubic-bezier(0.4, 0, 0.2, 1)'
                  }}>
                    <polygon points="140,45 135,140 145,140" fill="#e5e7eb" />
                    <circle cx="140" cy="140" r="8" fill="#374151" />
                    <circle cx="140" cy="140" r="4" fill="#e5e7eb" />
                  </g>
                </svg>
                <div style={{ fontSize: '11px', letterSpacing: '0.15em', color: '#94a3b8', textTransform: 'uppercase', marginTop: '4px' }}>
                  Game Plan Score
                </div>
              </div>
              </div>
            )}
            {!gamePlanScoreState && scoreComputing && (
              <div className="rounded-2xl p-6 bg-stone-800/50 text-stone-400 no-print">
                Computing Game Plan Score...
              </div>
            )}
            {/* D23 finish: Strategy Insight rendered directly below GPS hero. */}
            {/* D29 Parts 2+3: rebuilt to read from gamePlanScoreState as single source of truth.
                D30: extracted into _computeStrategyInsight helper so PDF and screen share derivation.
                Single tactical sentence with concrete numbers inline — differentiated from
                Supervisor Synthesis (which is the narrative paragraph). */}
            {gamePlanScoreState && (() => {
              const insight = _computeStrategyInsight(gamePlanScoreState);
              if (!insight) return null;
              return (
                <div className="p-5 rounded-xl border border-brand-500/30 bg-brand-500/5" data-pdf-section="strategy-insight">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-brand-500/20 flex items-center justify-center flex-shrink-0">
                      <svg className="w-5 h-5 text-brand-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-brand-400 uppercase tracking-wide mb-2">Strategy Insight</h3>
                      <p className="text-sm text-stone-300 leading-relaxed">
                        <strong className="text-white">{insight.headline}</strong> {insight.body}{insight.confidenceTag}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })()}
            {/* D17: Supervisor Claude summary lede (renders above Score card when sniff test returned a summary) */}
            {/* D18c Part 1: while the async supervisor call is in flight and no summary has landed yet,
                show a subtle cycling-phrase indicator in the same panel slot so the layout doesn't shift. */}
            {sniffLoading && !gamePlanScoreState?.sniffTest?.summary && (
              <div className="rounded-xl p-4 no-print" style={{
                background: 'rgba(123,139,255,0.06)',
                border: '1px solid rgba(123,139,255,0.14)',
                color: '#cbd5e1',
                minHeight: '76px'
              }}>
                <div style={{ fontSize: '11px', letterSpacing: '0.15em', color: '#9aa6e0', textTransform: 'uppercase', fontWeight: 500, marginBottom: '6px' }}>
                  🧭 AI review in progress…
                </div>
                <div style={{
                  fontSize: '14px',
                  lineHeight: 1.6,
                  opacity: 0.85,
                  animation: 'd18cPhrasePulse 3.5s ease-in-out infinite'
                }} key={sniffPhraseIdx}>
                  {[
                    'Computing your Game Plan Score…',
                    'Reviewing against comparable Portland deals…',
                    'Checking for inconsistencies…'
                  ][sniffPhraseIdx]}
                </div>
              </div>
            )}
            {gamePlanScoreState?.sniffTest?.summary && (
              <div className="rounded-xl p-4 no-print" style={{
                background: 'rgba(123,139,255,0.08)',
                border: '1px solid rgba(123,139,255,0.18)',
                color: '#e2e8f0',
                animation: 'd18cSynthesisFadeIn 200ms ease-in'
              }}>
                <div style={{ fontSize: '11px', letterSpacing: '0.15em', color: '#bfc7ff', textTransform: 'uppercase', fontWeight: 500, marginBottom: '6px' }}>
                  🧭 Supervisor synthesis
                </div>
                <div style={{ fontSize: '14px', lineHeight: 1.6 }}>{gamePlanScoreState.sniffTest.summary}</div>
                {gamePlanScoreState.sniffTest.layer_coherence && gamePlanScoreState.sniffTest.layer_coherence !== 'aligned' && (
                  <div style={{ fontSize: '11px', color: gamePlanScoreState.sniffTest.layer_coherence === 'destructive_tension' ? '#fb923c' : '#94a3b8', marginTop: '8px' }}>
                    {gamePlanScoreState.sniffTest.layer_coherence === 'productive_tension' ? 'Layers show productive tension — each adds a dimension.' : 'Layers disagree — review concerns below.'}
                  </div>
                )}
              </div>
            )}
            {/* D17: Supervisor concerns list (when flag or adjust verdict has concerns) */}
            {Array.isArray(gamePlanScoreState?.sniffTest?.concerns) && gamePlanScoreState.sniffTest.concerns.length > 0 && (
              <div className="rounded-xl p-4 no-print" style={{
                background: 'rgba(251,146,60,0.08)',
                border: '1px solid rgba(251,146,60,0.25)',
                color: '#e2e8f0'
              }}>
                <div style={{ fontSize: '11px', letterSpacing: '0.15em', color: '#fb923c', textTransform: 'uppercase', fontWeight: 500, marginBottom: '8px' }}>
                  ⚠️ Supervisor concerns ({gamePlanScoreState.sniffTest.concerns.length})
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {gamePlanScoreState.sniffTest.concerns.map((c, idx) => (
                    <li key={idx} style={{ marginBottom: '8px', paddingLeft: '12px', borderLeft: `2px solid ${c.severity === 'high' ? '#ef4444' : c.severity === 'medium' ? '#fb923c' : '#94a3b8'}` }}>
                      <div style={{ fontSize: '11px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                        {c.type || 'note'} · {c.severity || 'low'}
                      </div>
                      <div style={{ fontSize: '13px', lineHeight: 1.5, color: '#e2e8f0' }}>{c.message}</div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {/* D23 finish: GPS card + gauge relocated to render before supervisor synthesis (right after compressed branding bar). */}
            {/* D15: Industry Research panel (agent-facing only, hidden on client-shared view) */}
            {/* D24: cap=3 enforced server-side. Panel hides when zero matches (existing guard).
                Per-citation tooltip explains the specific trigger that fired (audit trail for the agent).
                Hero Number V2 (2026-05-06): gated on SHOW_INDUSTRY_CONTEXT_BOX flag.
                Pulled from render until live MLS data is wired (RMLS pricing inquiry
                pending). Andrew session feedback: stale data is worse than no data
                during the May 12 demo. Component + ingestion pipelines stay intact. */}
            {SHOW_INDUSTRY_CONTEXT_BOX && industryResearch.length > 0 && (() => {
              // D24: derive a per-citation "why am I seeing this" string from trigger_conditions.
              // Honest about the gate that fired so the agent can defend the citation to a client.
              const tooltipFor = (item) => {
                const tc = item.trigger_conditions || {};
                const parts = [];
                if (tc.zip_in_market === 'portland_metro') {
                  parts.push('Property is in the Portland-Vancouver-Hillsboro metro area.');
                }
                if (Array.isArray(tc.loan_type_in)) {
                  const loans = tc.loan_type_in.join('/');
                  const cats = (tc.finding_categories_any_of || tc.findings_include_any || []).join('/');
                  parts.push(cats
                    ? `Buyer is using ${loans} financing and an inspection finding affects ${cats}.`
                    : `Buyer is using ${loans} financing.`);
                }
                if (tc.finding_text_age_signal_present === true) {
                  parts.push('An inspection finding describes a component as aged or near end of useful life.');
                } else if (Array.isArray(tc.finding_text_contains_any)) {
                  parts.push(`An inspection finding mentions: ${tc.finding_text_contains_any.slice(0, 4).join(', ')}.`);
                }
                return parts.join(' ') || 'Surfaced based on this deal\'s context.';
              };
              return (
                <div className="rounded-xl p-4 no-print" style={{
                  background: 'rgba(30,41,59,0.4)',
                  border: '1px solid rgba(255,255,255,0.06)'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                    <span style={{ fontSize: '11px', letterSpacing: '0.15em', color: '#94a3b8', textTransform: 'uppercase', fontWeight: 500 }}>📚 Industry Context</span>
                  </div>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {industryResearch.map(item => (
                      <li key={item.id} style={{ marginBottom: '12px', paddingBottom: '12px', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                        <div style={{ fontSize: '13px', lineHeight: 1.5, color: '#e2e8f0' }}>{item.statistic_text}</div>
                        <div style={{ fontSize: '11px', color: '#94a3b8', marginTop: '4px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                          <span>
                            Source: {item.source_url
                              ? <a href={item.source_url} target="_blank" rel="noopener noreferrer" style={{ color: '#bfc7ff', textDecoration: 'none' }}>{item.citation_short || item.source_name}</a>
                              : (item.citation_short || `${item.source_name}${item.source_date ? ', ' + item.source_date : ''}`)}
                          </span>
                          <span style={{ color: '#64748b', cursor: 'help' }} title={tooltipFor(item)}>· why am I seeing this? ⓘ</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })()}
            {/* D23: Tabs header relocated to top of strategy-report (right after TEST DATA banner). */}
            {/* D23: Scenario bar — moved below Industry Context. Visual weight softened
                per directive 4.3 (reduced vertical padding, slightly muted chip backgrounds). */}
            {baselineRow && (
              <div className="no-print rounded-lg" style={{
                background: 'rgba(30,41,59,0.35)',
                border: '1px solid rgba(255,255,255,0.05)',
                padding: '6px 10px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                flexWrap: 'wrap'
              }}>
                <button
                  onClick={() => switchToScenario('baseline')}
                  className="px-3 py-1 text-xs rounded-lg transition-all"
                  style={{
                    background: activeScenarioId === 'baseline' ? 'rgba(123,139,255,0.18)' : 'rgba(255,255,255,0.03)',
                    color: activeScenarioId === 'baseline' ? '#bfc7ff' : '#94a3b8',
                    border: activeScenarioId === 'baseline' ? '1px solid rgba(123,139,255,0.3)' : '1px solid rgba(255,255,255,0.06)',
                    fontWeight: activeScenarioId === 'baseline' ? 500 : 400
                  }}>📍 Baseline ({baselineRow.score})</button>
                {savedScenarios.map(scn => (
                  <button key={scn.id} onClick={() => switchToScenario(scn.id)}
                    className="px-3 py-1 text-xs rounded-lg transition-all"
                    style={{
                      background: activeScenarioId === scn.id ? 'rgba(123,139,255,0.18)' : 'rgba(255,255,255,0.03)',
                      color: activeScenarioId === scn.id ? '#bfc7ff' : '#94a3b8',
                      border: activeScenarioId === scn.id ? '1px solid rgba(123,139,255,0.3)' : '1px solid rgba(255,255,255,0.06)'
                    }}>{scn.scenario_label} ({scn.score})</button>
                ))}
                <button onClick={() => setSaveScenarioOpen(true)} disabled={!gamePlanScoreState || savedScenarios.length >= 8}
                  className="px-3 py-1 text-xs rounded-lg transition-all"
                  style={{
                    background: 'rgba(123,139,255,0.08)',
                    color: '#94a3b8',
                    border: '1px dashed rgba(123,139,255,0.25)',
                    opacity: savedScenarios.length >= 8 ? 0.4 : 1,
                    cursor: savedScenarios.length >= 8 ? 'not-allowed' : 'pointer'
                  }}>+ Save this version</button>
                {savedScenarios.length > 0 && (
                  <button onClick={() => setCompareScenariosOpen(true)}
                    className="px-3 py-1 text-xs rounded-lg transition-all ml-auto"
                    style={{ background: 'transparent', color: '#64748b', border: '1px solid rgba(255,255,255,0.06)' }}>
                    Compare scenarios →
                  </button>
                )}
              </div>
            )}

            {/* Step 4 "Add Info" Navigation Nudges */}
            {(() => {
              // Calculate total credit ask for nudge thresholds
              const totalCreditAsk = findings
                .filter(f => f.selected && (f.requestType || 'credit') === 'credit')
                .reduce((sum, f) => sum + (f.cost || 0), 0);

              // Check if closing cost fields are empty
              const closingCostEmpty = !propertyInfo.estimatedClosingCosts ||
                parseInt(String(propertyInfo.estimatedClosingCosts).replace(/[^0-9]/g, '')) === 0;

              // Check if down payment fields are empty
              const downPaymentEmpty = !propertyInfo.minimumDownPayment || !propertyInfo.plannedDownPayment ||
                parseInt(String(propertyInfo.minimumDownPayment).replace(/[^0-9]/g, '')) === 0 ||
                parseInt(String(propertyInfo.plannedDownPayment).replace(/[^0-9]/g, '')) === 0;

              // Nudge conditions
              const showClosingCostNudge = closingCostEmpty && totalCreditAsk > 5000 && !dismissedNudges.closingCost;
              const showDownPaymentNudge = downPaymentEmpty && totalCreditAsk > 10000 && !dismissedNudges.downPayment;

              if (!showClosingCostNudge && !showDownPaymentNudge) return null;

              const handleGoToStep1 = () => {
                setCurrentStep(1);
              };

              return (
                <div className="space-y-3 mb-4">
                  {showClosingCostNudge && (
                    <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex items-start gap-3">
                          <span className="text-lg">💡</span>
                          <div>
                            <p className="text-blue-300 font-medium">Want to check if this fits your buyer's capacity?</p>
                            <button
                              onClick={handleGoToStep1}
                              className="text-blue-400 hover:text-blue-300 text-sm mt-1 flex items-center gap-1"
                            >
                              Add closing cost info →
                            </button>
                          </div>
                        </div>
                        <button
                          onClick={() => setDismissedNudges(prev => ({ ...prev, closingCost: true }))}
                          className="text-stone-500 hover:text-stone-300 text-lg leading-none"
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  )}

                  {showDownPaymentNudge && (
                    <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4">
                      <div className="flex items-start justify-between gap-3">
                        <div className="flex items-start gap-3">
                          <span className="text-lg">💡</span>
                          <div>
                            <p className="text-blue-300 font-medium">Your buyer may have a price reduction option.</p>
                            <button
                              onClick={handleGoToStep1}
                              className="text-blue-400 hover:text-blue-300 text-sm mt-1 flex items-center gap-1"
                            >
                              Add down payment info →
                            </button>
                          </div>
                        </div>
                        <button
                          onClick={() => setDismissedNudges(prev => ({ ...prev, downPayment: true }))}
                          className="text-stone-500 hover:text-stone-300 text-lg leading-none"
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })()}

            {/* ================================================================ */}
            {/* v4.1: STRATEGY TAB */}
            {/* ================================================================ */}
            {/* Anchor for auto-scroll on tab switch — added to make tab changes visibly land
                below the shared above-the-fold content (GPS hero, Strategy Insight, citations). */}
            <div id="step4-tab-content" style={{ scrollMarginTop: '90px' }} />
            {activeTab === 'strategy' && (
              <>
                {/* Credit Capacity Warning Banner - Prominent top-of-page alert */}
                {(() => {
                  const overageData = calculateClosingCostOverage();
                  if (!overageData || !overageData.hasOverage) return null;

                  return (
                    <div style={{
                      background: 'rgba(239, 68, 68, 0.12)',
                      border: '1px solid rgba(239, 68, 68, 0.4)',
                      borderRadius: '12px',
                      padding: '16px 20px',
                      marginBottom: '20px',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '12px',
                    }} data-pdf-section="credit-capacity-alert">
                      <span style={{ fontSize: '20px', flexShrink: 0 }}>⚠️</span>
                      <div>
                        <p style={{
                          color: '#fca5a5',
                          fontSize: '15px',
                          fontWeight: '600',
                          margin: '0 0 6px 0'
                        }}>
                          Credit request may exceed available capacity
                        </p>
                        <p style={{
                          color: '#a8a29e',
                          fontSize: '13px',
                          margin: 0,
                          lineHeight: '1.5'
                        }}>
                          Your total ask is {formatCurrency(overageData.totalCreditAsk)}, but closing cost credits in this price range
                          are typically limited to {formatCurrency(overageData.availableCapacity)}. Consider requesting
                          seller repairs instead of credits for larger items, or prioritize your must-have items.
                        </p>
                      </div>
                    </div>
                  );
                })()}

                {/* v4.0: THE OUTLOOK VERDICT - The Prestige (Screenshot-Ready) */}
                {/* D14: Call OutlookVerdict as a function instead of as a JSX component to avoid */}
                {/* React treating it as a new component type on each parent render (it's defined inside */}
                {/* the parent, so the function reference changes each render, causing unmount/remount */}
                {/* and restarting the verdict-fade-in animation — the "car trying to start" flutter). */}
                {verdictPhase !== 'hidden' && OutlookVerdict({
                  outlookData: calculateOutlookScore(leverageScore, findings),
                  phase: verdictPhase,
                  needleAngle: needleRotation,
                  showSummary: showSummary,
                  showAssessments: showAssessments,
                  propertyInfo: propertyInfo
                })}

                {/* v4.0: THE FUNNEL + DETAILS - Only show after verdict reveal */}
                {showFunnel && (
                <>
                {/* D36 (2026-05-06): Concession Probability Curve — bespoke insight tile.
                    Mockup-as-feature for the May 12 demo. Renders above the funnel, takes
                    score / ask / property value as inputs, displays a logistic close-prob
                    curve with the current ask plotted on it. PREVIEW ribbon makes its
                    future-state nature unmistakable. Pure visualization — no engine touch. */}
                {(() => {
                  const _d36PurchasePrice = parseInt(String(propertyInfo.listPrice || '').replace(/[^0-9]/g, '')) || 0;
                  const _d36TotalAsk = requestTotals.creditTotal + requestTotals.sellerRepairTotal;
                  const _d36Score = gamePlanScoreState?.score;
                  if (typeof _d36Score !== 'number') return null;
                  return (
                    <ConcessionProbabilityCurve
                      propertyValue={_d36PurchasePrice}
                      askAmount={_d36TotalAsk}
                      score={_d36Score}
                    />
                  );
                })()}

                {/* v4.0: Calculate Funnel Values */}
                {(() => {
                  // Total Ask = credit + seller repairs
                  const totalAsk = requestTotals.creditTotal + requestTotals.sellerRepairTotal;

                  // Floor = deal-critical items total
                  const floor = strat.dealCriticalTotal || totals.mustHaves;

                  // Expected Landing Range (total value, not just credit). Ensure low >= floor.
                  // Bug fix: when floor pushes expectedLow up past raw expectedHigh, the band
                  // would invert (e.g. "$5,500–$3,500"). Now we anchor expectedHigh to the ask
                  // amount whenever floor wins — realistic outcome is between floor and ask.
                  const baseExpectedLow = Math.round(totalAsk * (0.40 + (leverageScore > 5 ? 0.05 : leverageScore < -5 ? -0.05 : 0)));
                  const baseExpectedHigh = Math.round(totalAsk * (0.55 + (leverageScore > 5 ? 0.05 : leverageScore < -5 ? -0.05 : 0)));
                  const rawExpectedLowR500 = Math.round(baseExpectedLow / 500) * 500;
                  const rawExpectedHighR500 = Math.round(baseExpectedHigh / 500) * 500;
                  const expectedLow = Math.max(floor, rawExpectedLowR500);
                  const expectedHigh = expectedLow > rawExpectedHighR500
                    ? Math.max(expectedLow, Math.round(totalAsk / 500) * 500)
                    : rawExpectedHighR500;
                  // D49: all-deal-critical degeneracy. When floor (sum of deal-critical
                  // items) consumes ≥95% of the total ask, the funnel collapses to
                  // "$X → $X-$X → $X" — informationally empty and visually confusing.
                  // In that case render explanatory copy in the EXPECT TO LAND tier
                  // and consolidate the floor tier to match. Threshold 0.95 (not 1.0)
                  // catches near-degenerate cases where one tiny non-critical item
                  // would otherwise wedge a single $500 rounding step between tiers.
                  const _d49AllCritical = floor > 0 && totalAsk > 0 && floor / totalAsk >= 0.95;

                  // v5.1: Use OUTLOOK score (combined leverage + ask) for consistency with top verdict
                  const funnelOutlook = calculateOutlookScore(leverageScore, findings);
                  const funnelOutlookScore = funnelOutlook.outlookScore;
                  // Outlook-based labels matching the top verdict
                  const getOutlookLabel = (score) => {
                    if (score >= 7) return 'STRONG';
                    if (score >= 3) return 'FAVORABLE';
                    if (score >= -2) return 'BALANCED';
                    if (score >= -6) return 'CHALLENGING';
                    return 'DIFFICULT';
                  };
                  const getOutlookClass = (score) => {
                    if (score >= 3) return 'favorable';
                    if (score >= -2) return 'balanced';
                    return 'limited';
                  };
                  const outlookLabel = getOutlookLabel(funnelOutlookScore);
                  const outlookClass = getOutlookClass(funnelOutlookScore);

                  // v5.10c: Use actual report text, not fabricated explanations
                  const getCriticalExplanation = (item) => {
                    // Option A: Use the actual inspection report description
                    const reportText = item.description || item.reportText || '';
                    if (reportText.length > 0) {
                      const cleaned = reportText.replace(/\s+/g, ' ').trim();
                      // D30 fix: was truncating to 57 chars + "..." which cut mid-word
                      // ("burnished b..."). Now: word-boundary truncation at 220 chars.
                      // Generous limit so most descriptions render in full, but caps
                      // pathologically long inputs (entire inspection paragraphs) without
                      // mid-word ugliness.
                      if (cleaned.length <= 220) return cleaned;
                      const slice = cleaned.substring(0, 220);
                      const lastSpace = slice.lastIndexOf(' ');
                      return (lastSpace > 100 ? slice.substring(0, lastSpace) : slice) + '…';
                    }

                    // Option B fallback: Safe generic labels that can't be wrong
                    const text = `${item.item || ''}`.toLowerCase();
                    if (text.includes('electrical') || text.includes('panel') || text.includes('fpe') || text.includes('federal pacific')) {
                      return 'May affect insurance binding';
                    }
                    if (text.includes('hvac') || text.includes('furnace') || text.includes('heating') || text.includes('cooling')) {
                      return 'Essential system — requires evaluation';
                    }
                    if (text.includes('sewer') || text.includes('septic') || text.includes('drain')) {
                      return 'Requires professional evaluation';
                    }
                    if (text.includes('roof')) {
                      return 'Requires professional evaluation';
                    }
                    if (text.includes('mold') || text.includes('asbestos') || text.includes('lead')) {
                      return 'Requires environmental assessment';
                    }
                    if (text.includes('foundation') || text.includes('structural')) {
                      return 'Requires structural evaluation';
                    }
                    if (text.includes('plumbing') || text.includes('water heater')) {
                      return 'Essential system — requires evaluation';
                    }
                    return 'Flagged for professional evaluation';
                  };

                  return (
                    <>
                      {/* D18a Bug 1.1: Removed duplicate property card (Context Bar). The OutlookVerdict
                          component above already renders the property + address. The "BALANCED OUTLOOK"
                          leverage badge that previously lived here is also gone per D18a Part 2 — no
                          more Balanced Outlook labeling on Step 4. */}

                      {/* D18a Bug 1.2: Empty-state guard — hide funnel entirely when no costs entered */}
                      {totalAsk === 0 ? (
                        <div className="rounded-xl p-6 text-center" style={{
                          background: 'rgba(30,41,59,0.4)',
                          border: '1px dashed rgba(255,255,255,0.12)',
                          color: '#94a3b8',
                          fontSize: '14px',
                          lineHeight: 1.6
                        }} data-pdf-section="funnel">
                          <strong style={{ color: '#cbd5e1' }}>Pricing pending</strong> — add cost data on Step 2 to see your strategy range.
                        </div>
                      ) : (
                      /* The Funnel */
                      <div className="funnel-container" data-pdf-section="funnel">
                        {/* ASK FOR - Top Tier */}
                        <div
                          className="funnel-tier funnel-tier-ask"
                          onClick={() => scrollToSection('section-ask-breakdown')}
                        >
                          <div className="funnel-label">ASK FOR</div>
                          <div className="funnel-amount">{formatCurrency(totalAsk)}</div>
                          <div className="funnel-breakdown">
                            💵 {formatCurrency(requestTotals.creditTotal)} credit
                            {requestTotals.sellerRepairTotal > 0 && (
                              <span>  +  🔧 {formatCurrency(requestTotals.sellerRepairTotal)} repairs</span>
                            )}
                          </div>
                        </div>

                        <div className="funnel-arrow">▼</div>

                        {/* EXPECT TO LAND - Middle Tier */}
                        <div
                          className="funnel-tier funnel-tier-expect"
                          onClick={() => scrollToSection('section-market-context')}
                        >
                          <div className="funnel-label">EXPECT TO LAND</div>
                          {_d49AllCritical ? (
                            <>
                              {/* D49: every selected item is deal-critical, so floor ≈ ask.
                                  Rendering "$X – $X" reads as broken. Replace with copy
                                  that names the actual posture: this is a hold-the-line
                                  ask, not a negotiation range. */}
                              <div
                                className="funnel-amount funnel-amount-medium"
                                style={{ fontSize: '20px', lineHeight: 1.25 }}
                              >
                                Full ask or walk
                              </div>
                              <div className="funnel-subtext">All items are deal-critical — no concession room</div>
                            </>
                          ) : (
                            <>
                              <div className="funnel-amount funnel-amount-medium">
                                {/* D30: collapse range to single value when min === max
                                    (common when D29's expected-band converges or all-in repairs) */}
                                {expectedLow === expectedHigh
                                  ? formatCurrency(expectedLow)
                                  : `${formatCurrency(expectedLow)} – ${formatCurrency(expectedHigh)}`}
                              </div>
                              <div className="funnel-subtext">(total value)</div>
                            </>
                          )}
                        </div>

                        <div className="funnel-arrow">▼</div>

                        {/* DON'T GO BELOW - Bottom Tier */}
                        <div
                          className="funnel-tier funnel-tier-floor"
                          onClick={() => scrollToSection('section-critical-items')}
                        >
                          <div className="funnel-label">DON'T GO BELOW</div>
                          <div className="funnel-amount funnel-amount-small funnel-floor-amount">
                            {formatCurrency(floor)}
                          </div>
                          <div className="funnel-subtext">
                            {_d49AllCritical ? 'This IS the ask — walk away below it' : 'Walk away below this'}
                          </div>
                        </div>
                      </div>
                      )}
                      {/* end D18a empty-state ternary */}

                      {/* Seller Motivation Insight */}
                      {(() => {
                        const motivation = calculateSellerMotivation();
                        if (!motivation) return null;

                        // Color coding based on motivation level
                        const motivationColors = {
                          VERY_DESPERATE: { bg: 'bg-green-500/10', border: 'border-green-500/30', text: 'text-green-400', badge: 'bg-green-500' },
                          DESPERATE: { bg: 'bg-green-500/10', border: 'border-green-500/30', text: 'text-green-400', badge: 'bg-green-500' },
                          MOTIVATED: { bg: 'bg-emerald-500/10', border: 'border-emerald-500/30', text: 'text-emerald-400', badge: 'bg-emerald-500' },
                          TESTING: { bg: 'bg-yellow-500/10', border: 'border-yellow-500/30', text: 'text-yellow-400', badge: 'bg-yellow-500' },
                          STUCK: { bg: 'bg-red-500/10', border: 'border-red-500/30', text: 'text-red-400', badge: 'bg-red-500' },
                          FRESH: { bg: 'bg-stone-500/10', border: 'border-stone-500/30', text: 'text-stone-400', badge: 'bg-stone-500' },
                          NEUTRAL: { bg: 'bg-stone-500/10', border: 'border-stone-500/30', text: 'text-stone-400', badge: 'bg-stone-500' }
                        };

                        const colors = motivationColors[motivation.motivation] || motivationColors.NEUTRAL;
                        const motivationLabels = {
                          VERY_DESPERATE: 'Very Desperate',
                          DESPERATE: 'Desperate',
                          MOTIVATED: 'Motivated',
                          TESTING: 'Testing',
                          STUCK: 'Stuck',
                          FRESH: 'Fresh Listing',
                          NEUTRAL: 'Neutral'
                        };

                        return (
                          <div className={`${colors.bg} border ${colors.border} rounded-xl p-4`} data-pdf-section="seller-motivation">
                            <div className="flex items-start gap-3">
                              <span className="text-xl">📊</span>
                              <div className="flex-1">
                                <div className="flex items-center gap-2 mb-1">
                                  <span className={`text-xs font-semibold px-2 py-0.5 rounded ${colors.badge} text-white`}>
                                    {motivationLabels[motivation.motivation]}
                                  </span>
                                  <span className={`${colors.text} font-medium`}>Seller Motivation</span>
                                </div>
                                {motivation.description && (
                                  <p className="text-stone-400 text-sm mb-2">{motivation.description}</p>
                                )}
                                {motivation.totalConcession > 0 && motivation.motivation !== 'NEUTRAL' && (
                                  <p className="text-stone-500 text-xs mb-2">
                                    Total concessions: {formatCurrency(motivation.totalConcession)} ({motivation.concessionPercent.toFixed(1)}%)
                                    {motivation.priceReduction > 0 && motivation.creditsNegotiated > 0 && (
                                      <> — {formatCurrency(motivation.priceReduction)} price drop + {formatCurrency(motivation.creditsNegotiated)} credits</>
                                    )}
                                  </p>
                                )}
                                <p className={`${colors.text} text-sm`}>
                                  <strong>Strategy:</strong> {motivation.strategyTip}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })()}

                      {/* Closing Cost Ceiling Warning */}
                      {(() => {
                        const overageData = calculateClosingCostOverage();
                        if (!overageData || !overageData.hasOverage) return null;

                        return (
                          <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4" data-pdf-section="closing-cost-warning">
                            <div className="flex items-start gap-3">
                              <span className="text-xl">⚠️</span>
                              <div className="flex-1">
                                <p className="text-amber-400 font-medium">
                                  Credit request exceeds closing cost capacity by {formatCurrency(overageData.overage)}
                                </p>
                                <p className="text-stone-400 text-sm mt-1">
                                  Requesting {formatCurrency(overageData.totalCreditAsk)} in credits, but only {formatCurrency(overageData.availableCapacity)} available
                                  {overageData.creditsNegotiated > 0 && ` (${formatCurrency(overageData.estimatedCosts)} closing costs − ${formatCurrency(overageData.creditsNegotiated)} already negotiated)`}
                                </p>

                                <button
                                  onClick={() => setClosingCostTipExpanded(!closingCostTipExpanded)}
                                  className="mt-3 text-amber-400 hover:text-amber-300 text-sm font-medium flex items-center gap-1"
                                >
                                  Strategy Tip {closingCostTipExpanded ? '▲' : '▼'}
                                </button>

                                {closingCostTipExpanded && (
                                  <div className="mt-3 bg-stone-800/50 rounded-lg p-4 border border-stone-700/50">
                                    <p className="text-stone-300 text-sm flex items-start gap-2">
                                      <span>💡</span>
                                      <span>Consider converting some items to seller repairs instead of credits:</span>
                                    </p>
                                    <ul className="mt-2 ml-6 text-stone-400 text-sm space-y-1">
                                      <li>• Many contractors accept payment at closing</li>
                                      <li>• Seller handles the work — you stay under capacity</li>
                                      <li>• Especially useful for: sewer, roofing, electrical</li>
                                    </ul>

                                    {/* Price Reduction Tip - shows when buyer has down payment cushion */}
                                    {overageData.canUsePriceReduction && (
                                      <div className="mt-4 pt-4 border-t border-stone-700/50">
                                        <p className="text-stone-300 text-sm flex items-start gap-2">
                                          <span>💰</span>
                                          {overageData.cushionCoversOverage ? (
                                            <span>
                                              <strong>Consider a price reduction of {formatCurrency(overageData.overage)} instead of credits</strong>
                                              <br />
                                              <span className="text-stone-400">
                                                Buyer has enough cushion ({formatCurrency(overageData.downPaymentCushion)}) to cover this.
                                                Loan amount stays the same, buyer keeps cash for repairs.
                                              </span>
                                            </span>
                                          ) : (
                                            <span>
                                              <strong>Consider negotiating a price reduction instead of credits</strong>
                                              <br />
                                              <span className="text-stone-400">
                                                Your buyer has {formatCurrency(overageData.downPaymentCushion)} cushion above their minimum down payment.
                                                A price reduction keeps cash in their pocket for repairs.
                                              </span>
                                            </span>
                                          )}
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })()}

                      {/* What's In Your Ask - Collapsible */}
                      <div id="section-ask-breakdown" className="glass rounded-2xl overflow-hidden" data-pdf-section="ask-breakdown">
                        <button
                          onClick={() => toggleSection('section-ask-breakdown')}
                          className="w-full p-4 flex justify-between items-center hover:bg-stone-800/30 transition-all"
                        >
                          <div className="flex items-center gap-3">
                            <span>📋</span>
                            <span className="font-semibold text-white">WHAT'S IN YOUR ASK</span>
                            <span className="text-stone-400">— {formatCurrency(totalAsk)}</span>
                          </div>
                          <svg className={`w-5 h-5 text-stone-400 transition-transform ${expandedSections['section-ask-breakdown'] ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                        {expandedSections['section-ask-breakdown'] && (
                          <div className="px-4 pb-4">
                            {requestTotals.creditTotal > 0 && (
                              <div className="mb-4">
                                <div className="flex items-center gap-2 mb-2 text-brand-400 font-semibold text-sm">
                                  💵 CREDIT REQUEST — {formatCurrency(requestTotals.creditTotal)}
                                </div>
                                <div className="space-y-2 pl-4 border-l-2 border-brand-500/30">
                                  {requestTotals.creditItems.map(item => {
                                    // D39: cost provenance line. Override metadata is intentionally
                                    // NEVER referenced — agent overrides display the underlying source.
                                    const provenance = formatCostProvenance(item);
                                    return (
                                      <div key={item.id} className="py-1">
                                        <div className="flex justify-between items-center">
                                          <span className="text-white">{item.item}</span>
                                          <span className="text-stone-400">{formatCurrency(item.cost)}</span>
                                        </div>
                                        {provenance && (
                                          <p className="text-xs italic text-stone-500 mt-0.5">{provenance}</p>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                            {requestTotals.sellerRepairTotal > 0 && (
                              <div>
                                <div className="flex items-center gap-2 mb-2 text-blue-400 font-semibold text-sm">
                                  🔧 SELLER REPAIRS — {formatCurrency(requestTotals.sellerRepairTotal)}
                                </div>
                                <div className="space-y-2 pl-4 border-l-2 border-blue-500/30">
                                  {requestTotals.sellerRepairItems.map(item => {
                                    const provenance = formatCostProvenance(item);
                                    return (
                                      <div key={item.id} className="py-1">
                                        <div className="flex justify-between items-center">
                                          <span className="text-white">{item.item}</span>
                                          <span className="text-stone-400">{formatCurrency(item.cost)}</span>
                                        </div>
                                        {provenance && (
                                          <p className="text-xs italic text-stone-500 mt-0.5">{provenance}</p>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      {/* Market Context - Collapsible */}
                      <div id="section-market-context" className="glass rounded-2xl overflow-hidden" data-pdf-section="market-context">
                        <button
                          onClick={() => toggleSection('section-market-context')}
                          className="w-full p-4 flex justify-between items-center hover:bg-stone-800/30 transition-all"
                        >
                          <div className="flex items-center gap-3">
                            <span>📊</span>
                            <span className="font-semibold text-white">{/* D30: collapse range when min === max. D49: degenerate-funnel label swap. */}WHY {_d49AllCritical ? 'this ask' : (expectedLow === expectedHigh ? formatCurrency(expectedLow) : `${formatCurrency(expectedLow)} – ${formatCurrency(expectedHigh)}`)}?</span>
                          </div>
                          <svg className={`w-5 h-5 text-stone-400 transition-transform ${expandedSections['section-market-context'] ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                        {expandedSections['section-market-context'] && (() => {
                          // D35-A1 (Andrew session 2026-05-06): dropped "documented repairs"
                          // and the 28-48% capture-rate framing — the percentages were anchored
                          // to the wrong denominator and the framing exposed Game Plan's repair
                          // estimates to the buyer in a quotable way. Replaced with ask
                          // calibration drawn from the GPS engine.
                          const _purchasePriceForCtx = parseInt(String(propertyInfo.listPrice || '').replace(/[^0-9]/g, '')) || 0;
                          const _askPctForCtx = _purchasePriceForCtx > 0 ? (totalAsk / _purchasePriceForCtx * 100) : null;
                          return (
                            <div className="px-4 pb-4 space-y-2 text-stone-300">
                              <p>• <span className="text-stone-400">Median days on market:</span> <span className="text-white">{PORTLAND_MARKET_DATA.medianDOM}</span></p>
                              {totalAsk > 0 && (
                                <p>• <span className="text-stone-400">Your ask:</span> <span className="text-white">{formatCurrency(totalAsk)}{_askPctForCtx !== null ? ` (${_askPctForCtx.toFixed(1)}% of property value)` : ''}</span></p>
                              )}
                              {gamePlanScoreState && (
                                <p>• <span className="text-stone-400">Game Plan Score:</span> <span className="text-white">{gamePlanScoreState.score}/10 — {_gpsTierLabels[gamePlanScoreState.score] || _gpsTierBadgeLabel(gamePlanScoreState.score)}</span></p>
                              )}
                              {/* D35-A3: leverage position bullet gated on SHOW_LEVERAGE_POSITION_BOX.
                                  The verdict logic produced a contradictory read on the 1980 16th
                                  St dev case; suppressed until the rework lands. */}
                              {SHOW_LEVERAGE_POSITION_BOX && (
                                <p>• <span className="text-stone-400">Your leverage position:</span> <span className="text-white">{
                                  gamePlanScoreState?.components?.leverage != null
                                    ? _gpsComponentLabel('leverage', gamePlanScoreState.components.leverage)
                                    : `${position.position} (${leverageScore >= 0 ? '+' : ''}${Math.round(leverageScore / 2)})`
                                }</span></p>
                              )}
                            </div>
                          );
                        })()}
                      </div>

                      {/* Critical Items - Collapsible */}
                      <div id="section-critical-items" className="glass rounded-2xl overflow-hidden" data-pdf-section="critical-items">
                        <button
                          onClick={() => toggleSection('section-critical-items')}
                          className="w-full p-4 flex justify-between items-center hover:bg-stone-800/30 transition-all"
                        >
                          <div className="flex items-center gap-3">
                            <span>🚨</span>
                            <span className="font-semibold text-white">WHY {formatCurrency(floor)} IS YOUR FLOOR</span>
                          </div>
                          <svg className={`w-5 h-5 text-stone-400 transition-transform ${expandedSections['section-critical-items'] ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                        {expandedSections['section-critical-items'] && (
                          <div className="px-4 pb-4">
                            <p className="text-stone-400 mb-4">These items must be addressed for the deal to work:</p>
                            <div className="space-y-3">
                              {strat.dealCriticalItems.map(item => (
                                <div key={item.id} className="flex justify-between items-start">
                                  <div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-red-400">🔴</span>
                                      <span className="text-white font-medium">{item.item}</span>
                                    </div>
                                    <div className="text-stone-500 text-sm ml-6">└── {getCriticalExplanation(item)}</div>
                                  </div>
                                  <span className="text-red-400 font-medium">{formatCurrency(item.cost)}</span>
                                </div>
                              ))}
                              {strat.dealCriticalItems.length === 0 && buckets.mustHaves.slice(0, 4).map(item => (
                                <div key={item.id} className="flex justify-between items-start">
                                  <div>
                                    <div className="flex items-center gap-2">
                                      <span className="text-red-400">🔴</span>
                                      <span className="text-white font-medium">{item.item}</span>
                                    </div>
                                    <div className="text-stone-500 text-sm ml-6">└── {getCriticalExplanation(item)}</div>
                                  </div>
                                  <span className="text-red-400 font-medium">{formatCurrency(item.cost)}</span>
                                </div>
                              ))}
                            </div>
                            <div className="mt-4 pt-4 border-t border-stone-700 flex justify-between">
                              <span className="text-stone-400 font-semibold">TOTAL CRITICAL:</span>
                              <span className="text-red-400 font-bold">{formatCurrency(floor)}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  );
                })()}

                </>
                )}
                {/* End of showFunnel conditional */}

              </>
            )}

            {/* ================================================================ */}
            {/* v5.12b: CLIENT EXPLANATION TAB - Complete Overhaul */}
            {/* ================================================================ */}
            {activeTab === 'client' && (
              <>
                {/* v5.12b: CLIENT EXPLANATION TAB - What to present to the buyer */}
                {(() => {
                  // Calculate totals for client view
                  const totalAsk = requestTotals.creditTotal + requestTotals.sellerRepairTotal;
                  const floor = strat.dealCriticalTotal || totals.mustHaves;
                  const baseExpectedLow = Math.round(totalAsk * (0.40 + (leverageScore > 5 ? 0.05 : leverageScore < -5 ? -0.05 : 0)));
                  const baseExpectedHigh = Math.round(totalAsk * (0.55 + (leverageScore > 5 ? 0.05 : leverageScore < -5 ? -0.05 : 0)));
                  // Same inversion fix as Strategy/Negotiation tabs (rounded to $1k for client view).
                  const rawExpectedLowCli = Math.round(baseExpectedLow / 1000) * 1000;
                  const rawExpectedHighCli = Math.round(baseExpectedHigh / 1000) * 1000;
                  const expectedLow = Math.max(floor, rawExpectedLowCli);
                  const expectedHigh = expectedLow > rawExpectedHighCli
                    ? Math.max(expectedLow, Math.round(totalAsk / 1000) * 1000)
                    : rawExpectedHighCli;

                  // v5.12b: Generate unique, client-friendly descriptions based on item characteristics
                  const getClientItemDescription = (item) => {
                    const text = `${item.item} ${item.description || ''}`.toLowerCase();
                    const cost = item.cost || 0;

                    // Safety/Insurance items
                    if (/electrical.*panel|federal.*pacific|fpe|zinsco/.test(text)) return 'insurance requirement — many carriers won\'t cover this';
                    if (/gfci|ground.?fault/.test(text)) return 'safety code requirement for bathrooms & kitchens';
                    if (/smoke|carbon.*monoxide|co.*detector/.test(text)) return 'safety requirement — protects your family';
                    if (/handrail|railing|guard/.test(text)) return 'safety code item — prevents falls';
                    if (/radon/.test(text)) return 'health concern — should be addressed before move-in';
                    if (/asbestos/.test(text)) return 'requires professional handling — better done before you move in';
                    if (/mold/.test(text)) return 'health concern — needs professional remediation';

                    // Major systems
                    if (/roof/.test(text) && cost > 5000) return 'major expense — addressing now protects your investment';
                    if (/roof/.test(text)) return 'protects the entire home from water damage';
                    if (/hvac|furnace|heat.*pump|air.*condition/.test(text)) return 'essential system — expensive to replace after closing';
                    if (/water.*heater/.test(text)) return 'daily necessity — older units can fail without warning';
                    if (/plumbing|sewer|drain/.test(text)) return 'hidden system — problems are expensive to diagnose later';
                    if (/foundation|structural/.test(text)) return 'critical — affects everything built on top of it';

                    // Exterior
                    if (/siding/.test(text)) return 'protects the home from weather and pests';
                    if (/window/.test(text)) return 'affects energy bills and comfort';
                    if (/deck|porch/.test(text)) return 'safety and usability concern';
                    if (/gutter|downspout/.test(text)) return 'prevents water damage to foundation';
                    if (/driveway|concrete/.test(text)) return 'curb appeal and safety';

                    // Interior
                    if (/flooring|floor/.test(text)) return 'affects daily living comfort';
                    if (/appliance/.test(text)) return 'convenience item — nice to have working on day one';
                    if (/paint|cosmetic/.test(text)) return 'appearance item — lower priority';

                    // Cost-based fallbacks
                    if (cost > 10000) return 'significant investment — worth negotiating now';
                    if (cost > 5000) return 'notable expense — better to address upfront';
                    if (cost > 2000) return 'worthwhile to include in negotiations';
                    return 'minor item — included for completeness';
                  };

                  // v5.12b: Get priority color
                  const getPriorityColor = (item) => {
                    if (item.priority === 'high') return 'text-red-400';
                    if (item.priority === 'medium') return 'text-amber-400';
                    return 'text-emerald-400';
                  };

                  const getPriorityDot = (item) => {
                    if (item.priority === 'high') return '🔴';
                    if (item.priority === 'medium') return '🟡';
                    return '🟢';
                  };

                  return (
                    <>
                      {/* v5.12b: Agent Branding Header — hidden on screen post-D23 (the compressed
                          branding bar at the top of Step 4 covers this). Kept in the DOM with
                          print:block so native browser-print still includes it on the standalone
                          Client Explanation PDF; D30 will rebuild the PDF pipeline cleanly. */}
                      <div className="glass rounded-2xl p-6 hidden print:block" data-pdf-section="client-header">
                        <div className="flex items-start justify-between gap-4">
                          <div className="flex items-center gap-4">
                            {ENABLE_PROFILE_BRANDING && profile?.headshot_url && (
                              <img
                                src={`https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${profile.headshot_url}`}
                                alt="Your Agent"
                                className="w-16 h-16 rounded-full object-cover border-2 border-white/20"
                              />
                            )}
                            <div>
                              <h2 className="text-xl font-bold text-white">
                                {ENABLE_PROFILE_BRANDING && profile ? `${profile.first_name || ''} ${profile.last_name || ''}`.trim() || 'Your Agent' : 'Your Agent'}
                              </h2>
                              {ENABLE_PROFILE_BRANDING && profile?.brokerage && (
                                <p className="text-stone-400 text-sm">{profile.brokerage}</p>
                              )}
                              {ENABLE_PROFILE_BRANDING && profile?.phone_number && (
                                <p className="text-brand-400 text-sm font-medium">{profile.phone_number}</p>
                              )}
                            </div>
                          </div>
                          {ENABLE_PROFILE_BRANDING && profile?.brokerage_logo_url && (
                            <img
                              src={`https://qiegfdufpoizyguyznbp.supabase.co/storage/v1/object/public/profile-images/${profile.brokerage_logo_url}`}
                              alt="Brokerage"
                              className="h-12 object-contain"
                            />
                          )}
                        </div>
                        <div className="mt-4 pt-4 border-t border-white/10">
                          <h3 className="text-lg font-semibold text-white mb-1">Your Inspection Summary</h3>
                          <div className="text-stone-400 text-sm space-y-1">
                            <p className="text-white">{propertyInfo.address || 'Property Address'}</p>
                            <p>Prepared for: <span className="text-brand-300 font-medium">{propertyInfo.clientName || 'You'}</span></p>
                            <p>{new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
                          </div>
                        </div>
                      </div>

                      {/* Hero Number V2 (2026-05-06): score-driven client-facing card.
                          Replaces the prior generic "BOTTOM LINE" content with per-integer
                          buyer-facing copy + universal disclaimer footer. Copy is locked
                          editorial — see SCORE_BUYER_COPY constant. */}
                      <div className="glass rounded-2xl p-6" data-pdf-section="client-bottom-line">
                        {gamePlanScoreState && (() => {
                          const score = gamePlanScoreState.score;
                          const buyerCopy = SCORE_BUYER_COPY[score];
                          // Cap edge case (score 1 with D31 cap applied): swap copy
                          // for an "ask-out-of-band" framing rather than the regular
                          // tier copy, which would read awkwardly at score 1.
                          const isCapPinned = gamePlanScoreState.capWasApplied && score === 1;
                          return (
                            <>
                              <div className="flex items-center gap-4 mb-5">
                                <div
                                  className="rounded-2xl flex items-center justify-center flex-shrink-0"
                                  style={{
                                    width: '88px',
                                    height: '88px',
                                    background: _gpsTierGradient(score),
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.25)'
                                  }}
                                >
                                  <span className="text-white font-bold leading-none" style={{ fontSize: '52px' }}>{score}</span>
                                </div>
                                <div className="flex-1">
                                  <div className="text-xs uppercase tracking-widest text-stone-400">Game Plan Score</div>
                                  <div className="text-xl font-semibold text-white mt-1">
                                    {isCapPinned ? 'Recheck the inputs' : (SCORE_AGENT_TAGLINE[score]?.line1 || _gpsTierLabels[score] || '—')}
                                  </div>
                                </div>
                              </div>
                              <p className="text-stone-300 leading-relaxed text-base">
                                {isCapPinned
                                  ? "The numbers behind this score suggest the ask may not match what's typical for this market. Before sharing this report further, talk with your agent about whether the inputs accurately reflect the deal."
                                  : (buyerCopy || "Your offer is currently being analyzed. Talk with your agent for the full read.")}
                              </p>
                              <p className="text-stone-500 text-xs mt-5 leading-relaxed italic">
                                {DISCLAIMER_FOOTER}
                              </p>
                            </>
                          );
                        })()}
                        {!gamePlanScoreState && (
                          <p className="text-stone-400 italic">Computing your Game Plan Score...</p>
                        )}
                      </div>

                      {/* v5.12b: Credits vs Repairs Explained */}
                      <div className="glass rounded-2xl p-6" data-pdf-section="client-explainer">
                        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                          <span className="text-2xl">💡</span> UNDERSTANDING YOUR OPTIONS
                        </h3>
                        <div className="grid md:grid-cols-2 gap-4">
                          <div className="p-4 bg-brand-900/20 border border-brand-500/30 rounded-lg">
                            <h4 className="text-brand-400 font-semibold mb-2">💵 Credits (Money Back)</h4>
                            <p className="text-stone-300 text-sm">
                              The seller reduces your closing costs, giving you cash to hire your own contractors after closing.
                              <span className="text-stone-400"> Best for: items where you want to choose the contractor or timing.</span>
                            </p>
                          </div>
                          <div className="p-4 bg-blue-900/20 border border-blue-500/30 rounded-lg">
                            <h4 className="text-blue-400 font-semibold mb-2">🔧 Seller Repairs</h4>
                            <p className="text-stone-300 text-sm">
                              Seller completes the repairs before closing, using their own contractors. Best for complex jobs or items where you want to ensure correctness.
                              <span className="text-stone-400"> Also keeps liability on the seller if a "can of worms" is discovered during the repair — the buyer doesn't absorb cost overruns.</span>
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* v5.12b: What We're Asking For - With Unique Descriptions */}
                      <div className="glass rounded-2xl p-6" data-pdf-section="client-asking-for">
                        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                          <span className="text-2xl">📝</span> WHAT WE'RE ASKING FOR
                        </h3>

                        {requestTotals.creditTotal > 0 && (
                          <div className="mb-6">
                            <div className="flex items-center gap-2 mb-3 p-3 bg-brand-900/30 rounded-lg">
                              <span className="text-2xl">💵</span>
                              <span className="text-brand-400 font-semibold">CREDIT REQUEST:</span>
                              <span className="text-white font-bold text-lg">{formatCurrency(requestTotals.creditTotal)}</span>
                            </div>
                            <p className="text-stone-400 text-sm mb-3">Money back at closing that you can use for repairs on your timeline:</p>
                            <ul className="space-y-2">
                              {requestTotals.creditItems.slice(0, 6).map(item => (
                                <li key={item.id} className="flex items-start gap-2 text-stone-300">
                                  <span className={getPriorityColor(item)}>{getPriorityDot(item)}</span>
                                  <div>
                                    <span className="text-white font-medium">{item.item}</span>
                                    <span className="text-stone-400"> — {getClientItemDescription(item)}</span>
                                    <span className="text-stone-500 text-sm ml-2">({formatCurrency(item.cost)})</span>
                                  </div>
                                </li>
                              ))}
                              {requestTotals.creditItems.length > 6 && (
                                <li className="text-stone-400 italic ml-6">[+ {requestTotals.creditItems.length - 6} additional items totaling {formatCurrency(requestTotals.creditItems.slice(6).reduce((sum, i) => sum + (i.cost || 0), 0))}]</li>
                              )}
                            </ul>
                          </div>
                        )}

                        {requestTotals.sellerRepairTotal > 0 && (
                          <div className="mb-6">
                            <div className="flex items-center gap-2 mb-3 p-3 bg-blue-900/30 rounded-lg">
                              <span className="text-2xl">🔧</span>
                              <span className="text-blue-400 font-semibold">SELLER TO REPAIR:</span>
                              <span className="text-white font-bold text-lg">{formatCurrency(requestTotals.sellerRepairTotal)}</span>
                            </div>
                            <p className="text-stone-400 text-sm mb-3">Items we're asking the seller to fix before you move in:</p>
                            <ul className="space-y-2">
                              {requestTotals.sellerRepairItems.map(item => (
                                <li key={item.id} className="flex items-start gap-2 text-stone-300">
                                  <span className={getPriorityColor(item)}>{getPriorityDot(item)}</span>
                                  <div>
                                    <span className="text-white font-medium">{item.item}</span>
                                    <span className="text-stone-400"> — {getClientItemDescription(item)}</span>
                                    <span className="text-stone-500 text-sm ml-2">({formatCurrency(item.cost)})</span>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        {requestTotals.excludedTotal > 0 && (
                          <div className="p-4 bg-stone-800/30 rounded-lg border border-stone-700">
                            <div className="flex items-center gap-2 mb-2">
                              <span className="text-xl">✓</span>
                              <span className="text-emerald-400 font-semibold">WE'RE NOT ASKING FOR:</span>
                              <span className="text-stone-300">{formatCurrency(requestTotals.excludedTotal)}</span>
                            </div>
                            <p className="text-stone-400 text-sm">We've strategically left out minor items (caulking, weatherstripping, cosmetic touches) to keep our request focused and reasonable. This actually helps our negotiating position.</p>
                          </div>
                        )}

                        {/* Priority Legend */}
                        <div className="mt-4 pt-4 border-t border-white/10 flex gap-4 text-xs text-stone-400">
                          <span>🔴 Critical/Safety</span>
                          <span>🟡 Important</span>
                          <span>🟢 Recommended</span>
                        </div>
                      </div>

                      {/* v5.12b: What Happens Next - Timeline */}
                      <div className="glass rounded-2xl p-6" data-pdf-section="client-timeline">
                        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                          <span className="text-2xl">📅</span> WHAT HAPPENS NEXT
                        </h3>
                        <div className="space-y-4">
                          <div className="flex gap-4">
                            <div className="flex flex-col items-center">
                              <div className="w-8 h-8 bg-brand-500 rounded-full flex items-center justify-center text-white font-bold text-sm">1</div>
                              <div className="w-0.5 h-full bg-brand-500/30 mt-2"></div>
                            </div>
                            <div className="pb-4">
                              <h4 className="text-white font-medium">We Submit Our Request</h4>
                              <p className="text-stone-400 text-sm">I'll send this repair request to the seller's agent with documentation supporting each item.</p>
                            </div>
                          </div>
                          <div className="flex gap-4">
                            <div className="flex flex-col items-center">
                              <div className="w-8 h-8 bg-brand-500 rounded-full flex items-center justify-center text-white font-bold text-sm">2</div>
                              <div className="w-0.5 h-full bg-brand-500/30 mt-2"></div>
                            </div>
                            <div className="pb-4">
                              <h4 className="text-white font-medium">Seller Responds (Usually 2-3 Days)</h4>
                              <p className="text-stone-400 text-sm">They'll likely counter with a lower amount — that's expected and normal. Don't panic!</p>
                            </div>
                          </div>
                          <div className="flex gap-4">
                            <div className="flex flex-col items-center">
                              <div className="w-8 h-8 bg-brand-500 rounded-full flex items-center justify-center text-white font-bold text-sm">3</div>
                              <div className="w-0.5 h-full bg-brand-500/30 mt-2"></div>
                            </div>
                            <div className="pb-4">
                              <h4 className="text-white font-medium">We Negotiate</h4>
                              <p className="text-stone-400 text-sm">We'll go back and forth, usually once or twice, until we reach an agreement that makes you feel comfortable moving forward. Remember, you're in the driver's seat — your agent guides the conversation, but the call is yours.</p>
                            </div>
                          </div>
                          <div className="flex gap-4">
                            <div className="flex flex-col items-center">
                              <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center text-white font-bold text-sm">✓</div>
                            </div>
                            <div>
                              <h4 className="text-white font-medium">Agreement & Moving Forward</h4>
                              <p className="text-stone-400 text-sm">Once we agree, it becomes part of your contract. Credits appear at closing; repairs get done before you get the keys.</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* v5.12b: Common Questions - With Agent Contact */}
                      <div className="glass rounded-2xl p-6" data-pdf-section="client-questions">
                        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                          <span className="text-2xl">❓</span> QUESTIONS YOU MIGHT HAVE
                        </h3>
                        <div className="space-y-4">
                          <div className="p-3 bg-stone-800/30 rounded-lg">
                            <p className="text-white font-medium">"What if they say no to everything?"</p>
                            <p className="text-stone-400 text-sm mt-1">Very rare. Sellers expect to negotiate, and walking away costs them money and time. We have leverage here.</p>
                          </div>
                          <div className="p-3 bg-stone-800/30 rounded-lg">
                            <p className="text-white font-medium">"What if they only offer {formatCurrency(Math.round(expectedLow / 2))}?"</p>
                            <p className="text-stone-400 text-sm mt-1">That's an opening position, not their final answer. We'll counter, and they'll likely move significantly. That's the game.</p>
                          </div>
                          <div className="p-3 bg-stone-800/30 rounded-lg">
                            <p className="text-white font-medium">"What if we don't reach an agreement?"</p>
                            <p className="text-stone-400 text-sm mt-1">You have options. We can accept what's offered, continue negotiating, or in rare cases, walk away. Your agent will walk you through each path until you're comfortable moving forward — the decision is yours, and your agent's job is to help you make it with the best information available.</p>
                          </div>
                        </div>

                        {/* Agent Contact CTA */}
                        <div className="mt-6 p-4 bg-brand-900/30 border border-brand-500/30 rounded-lg">
                          <p className="text-brand-300 font-medium mb-2">📞 Let's Talk Before I Send This</p>
                          <p className="text-stone-300 text-sm">
                            I want to make sure you're comfortable with our strategy before I submit this to the seller.
                            {ENABLE_PROFILE_BRANDING && profile?.phone_number && (
                              <span className="text-white font-medium"> Call or text me at {profile.phone_number}</span>
                            )}
                            {ENABLE_PROFILE_BRANDING && profile?.phone_number && profile?.email && ' or '}
                            {ENABLE_PROFILE_BRANDING && profile?.email && (
                              <span className="text-white font-medium">email {profile.email}</span>
                            )}
                            {(!ENABLE_PROFILE_BRANDING || (!profile?.phone_number && !profile?.email)) && (
                              <span className="text-white font-medium"> — reach out anytime.</span>
                            )}
                          </p>
                        </div>
                      </div>

                      {/* v5.12b: Disclaimer */}
                      <div className="glass rounded-2xl p-4" data-pdf-section="client-disclaimer">
                        <p className="text-stone-500 text-xs leading-relaxed">
                          <span className="font-medium">Disclaimer:</span> This summary is provided for informational purposes to help you understand the inspection findings and our proposed negotiation strategy.
                          Cost estimates are approximations based on regional data and may vary. The negotiation outcome depends on many factors including seller motivation, market conditions, and the specific circumstances of this transaction.
                          Your agent will guide you through the process and help you make informed decisions. This document does not constitute legal, financial, or professional inspection advice.
                        </p>
                      </div>
                    </>
                  );
                })()}
              </>
            )}

            {/* ================================================================ */}
            {/* v4.0: SELLER NEGOTIATION TAB */}
            {/* ================================================================ */}
            {activeTab === 'negotiation' && (
              <>
                {/* v4.0: SELLER NEGOTIATION TAB - Scripts, tactics, justifications */}
                {(() => {
                  // Calculate totals for negotiation view
                  const totalAsk = requestTotals.creditTotal + requestTotals.sellerRepairTotal;
                  const floor = strat.dealCriticalTotal || totals.mustHaves;
                  const baseExpectedLow = Math.round(totalAsk * (0.40 + (leverageScore > 5 ? 0.05 : leverageScore < -5 ? -0.05 : 0)));
                  const baseExpectedHigh = Math.round(totalAsk * (0.55 + (leverageScore > 5 ? 0.05 : leverageScore < -5 ? -0.05 : 0)));
                  // Same inversion fix as Strategy tab — floor pushes low up but high needs to follow.
                  const rawExpectedLowNeg = Math.round(baseExpectedLow / 500) * 500;
                  const rawExpectedHighNeg = Math.round(baseExpectedHigh / 500) * 500;
                  const expectedLow = Math.max(floor, rawExpectedLowNeg);
                  const expectedHigh = expectedLow > rawExpectedHighNeg
                    ? Math.max(expectedLow, Math.round(totalAsk / 500) * 500)
                    : rawExpectedHighNeg;
                  const leverageLabel = leverageScore >= 5 ? 'FAVORABLE' : leverageScore >= -2 ? 'BALANCED' : 'LIMITED';

                  // D47 Task 4: dynamic opening script by item count. No dollar
                  // figures (cost context lives elsewhere). The bracketed severity
                  // clause in the 1-item template only surfaces when the single
                  // item is high-severity (red). 2-3 and 4+ templates are fixed.
                  const askItems = [...buckets.mustHaves, ...buckets.strongAsks];
                  const askItemCount = askItems.length;
                  const _severityImpactWord = (f) => {
                    const blob = `${f?.item || ''} ${f?.category || ''} ${f?.description || ''}`.toLowerCase();
                    if (/federal pacific|aluminum wiring|knob.?and.?tube|panel/.test(blob)) return 'insurability';
                    if (/asbestos|lead\b|radon|gas leak|carbon monoxide|fire/.test(blob)) return 'safety';
                    return 'habitability';
                  };
                  let openingScriptText;
                  if (askItemCount === 0) {
                    openingScriptText = "We've reviewed the inspection findings carefully and we're not raising any items at this time.";
                  } else if (askItemCount === 1) {
                    const item = askItems[0];
                    const isHigh = _normalizeSeverity(item) === 'red';
                    const impactClause = isHigh ? ` which directly affects ${_severityImpactWord(item)}` : '';
                    openingScriptText = `We've been deliberate about keeping this ask narrow and reasonable so we can close cleanly. We're requesting just one credit — ${item.item}${impactClause}. Addressing this one item moves us forward.`;
                  } else if (askItemCount <= 3) {
                    openingScriptText = `We've narrowed this list to the items that genuinely need addressing. We're requesting credit on ${askItemCount} items — focused on what most affects insurability and habitability, not a wishlist.`;
                  } else {
                    openingScriptText = `This list reflects what we believe is genuinely necessary based on the inspection findings. We've been selective — there are items we're not asking about — and these ${askItemCount} are the ones we'd need addressed to feel confident moving forward.`;
                  }

                  return (
                    <>
                      {/* Opening Script */}
                      <div className="glass rounded-2xl p-6">
                        <h3 className="text-lg font-semibold text-white mb-3 flex items-center gap-2">
                          📣 OPENING SCRIPT
                        </h3>
                        <div className="p-4 bg-stone-800/50 rounded-lg border-l-4 border-brand-500">
                          <p className="text-stone-300 italic">
                            "{openingScriptText}"
                          </p>
                        </div>
                        <button
                          onClick={() => copyToClipboard(openingScriptText)}
                          className="mt-3 text-sm text-brand-400 hover:text-brand-300 flex items-center gap-2"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                          </svg>
                          Copy to Clipboard
                        </button>
                      </div>

                      {/* Your Position at a Glance */}
                      <div className="glass rounded-2xl p-6" data-pdf-section="position-summary">
                        <h3 className="text-lg font-semibold text-white mb-4">YOUR POSITION</h3>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
                          <div className="p-3 bg-stone-800/50 rounded-lg">
                            <div className={`text-sm font-bold ${leverageScore >= 5 ? 'text-emerald-400' : leverageScore >= -2 ? 'text-yellow-400' : 'text-red-400'}`}>
                              {leverageLabel} ({leverageScore >= 0 ? '+' : ''}{leverageScore})
                            </div>
                            <div className="text-xs text-stone-400 mt-1">Leverage</div>
                          </div>
                          <div className="p-3 bg-stone-800/50 rounded-lg">
                            <div className="text-sm font-bold text-white">{formatCurrency(totalAsk)}</div>
                            <div className="text-xs text-stone-400 mt-1">Ask</div>
                          </div>
                          <div className="p-3 bg-stone-800/50 rounded-lg">
                            <div className="text-sm font-bold text-white">{formatCurrency(expectedLow)} – {formatCurrency(expectedHigh)}</div>
                            <div className="text-xs text-stone-400 mt-1">Expect</div>
                          </div>
                          <div className="p-3 bg-stone-800/50 rounded-lg">
                            <div className="text-sm font-bold text-red-400">{formatCurrency(floor)}</div>
                            <div className="text-xs text-stone-400 mt-1">Floor</div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })()}

                {/* Itemized Request Tables */}
                {requestTotals.creditItems.length > 0 && (
                  <div className="glass rounded-2xl p-6" data-pdf-section="credit-table">
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-lg font-semibold text-white">CREDIT REQUEST</h3>
                      <div className="flex items-center gap-3">
                        <span className="text-brand-400 font-bold">{formatCurrency(requestTotals.creditTotal)}</span>
                        <button onClick={() => copyToClipboard(requestTotals.creditItems.map(f => `${f.item}: ${formatCurrency(f.cost)}`).join('\n'))} className="text-xs text-stone-400 hover:text-white">Copy</button>
                      </div>
                    </div>
                    <table className="w-full text-sm">
                      <thead className="text-stone-400 border-b border-stone-700">
                        <tr><th className="text-left py-2">Item</th><th className="text-left py-2">Category</th><th className="text-right py-2">Amount</th><th className="text-right py-2">Priority</th></tr>
                      </thead>
                      <tbody>
                        {requestTotals.creditItems.map(item => (
                          <tr key={item.id} className="border-b border-stone-800">
                            <td className="py-2 text-white">{item.priority === 'high' ? '🔴' : item.priority === 'medium' ? '🟠' : '⚪'} {item.item}</td>
                            <td className="py-2 text-stone-400">{item.category || 'General'}</td>
                            <td className="py-2 text-right text-brand-400 font-medium">{formatCurrency(item.cost)}</td>
                            <td className="py-2 text-right text-stone-400 capitalize">{item.priority}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {requestTotals.sellerRepairItems.length > 0 && (
                  <div className="glass rounded-2xl p-6" data-pdf-section="repair-table">
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-lg font-semibold text-white">SELLER REPAIRS REQUESTED</h3>
                      <div className="flex items-center gap-3">
                        <span className="text-blue-400 font-bold">Est. {formatCurrency(requestTotals.sellerRepairTotal)}</span>
                        <button onClick={() => copyToClipboard(requestTotals.sellerRepairItems.map(f => `${f.item}: ${formatCurrency(f.cost)}`).join('\n'))} className="text-xs text-stone-400 hover:text-white">Copy</button>
                      </div>
                    </div>
                    <table className="w-full text-sm">
                      <thead className="text-stone-400 border-b border-stone-700">
                        <tr><th className="text-left py-2">Item</th><th className="text-left py-2">Category</th><th className="text-right py-2">Est Value</th></tr>
                      </thead>
                      <tbody>
                        {requestTotals.sellerRepairItems.map(item => (
                          <tr key={item.id} className="border-b border-stone-800">
                            <td className="py-2 text-white">{item.priority === 'high' ? '🔴' : '🟠'} {item.item}</td>
                            <td className="py-2 text-stone-400">{item.category || 'General'}</td>
                            <td className="py-2 text-right text-blue-400 font-medium">{formatCurrency(item.cost)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {requestTotals.excludedItems.length > 0 && (
                  <div className="glass rounded-2xl p-6 opacity-75" data-pdf-section="excluded-items">
                    <div className="flex justify-between items-center mb-4">
                      <h3 className="text-lg font-semibold text-white">NOT REQUESTED (Good Faith)</h3>
                      <span className="text-stone-400">{formatCurrency(requestTotals.excludedTotal)}</span>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {requestTotals.excludedItems.map(item => (
                        <span key={item.id} className="text-xs px-2 py-1 bg-stone-800 rounded text-stone-400">⚪ {item.item} — {formatCurrency(item.cost)}</span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Justification Cards */}
                {relevantCards.length > 0 && (
                  <div className="space-y-4" data-pdf-section="justification-cards">
                    <h3 className="text-lg font-semibold text-white">JUSTIFICATION CARDS</h3>
                    {relevantCards.map(card => (
                      <div key={card.id} className="glass rounded-2xl p-6">
                        <div className="flex justify-between items-start mb-3">
                          <h4 className="text-white font-medium flex items-center gap-2"><span>{card.icon}</span> {card.title}</h4>
                          <button onClick={() => copyToClipboard(`${card.issue}\n\nWhy it matters:\n${card.whyItMatters.join('\n')}\n\nIf they push back: "${card.pushbackResponse}"`)} className="text-xs text-stone-400 hover:text-white">Copy</button>
                        </div>
                        <p className="text-stone-400 text-sm mb-3"><strong className="text-stone-300">THE ISSUE:</strong> {card.issue}</p>
                        <div className="mb-3">
                          <strong className="text-stone-300 text-sm">WHY IT MATTERS:</strong>
                          <ul className="text-stone-400 text-sm mt-1">
                            {card.whyItMatters.map((point, i) => <li key={i}>• {point}</li>)}
                          </ul>
                        </div>
                        <div className="p-3 bg-brand-500/10 border border-brand-500/30 rounded-lg">
                          <strong className="text-brand-400 text-sm">IF THEY PUSH BACK:</strong>
                          <p className="text-stone-300 text-sm italic mt-1">"{card.pushbackResponse}"</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Concession Strategy */}
                {requestTotals.excludedItems.length > 0 && (
                  <div className="glass rounded-2xl p-6" data-pdf-section="concessions">
                    <h3 className="text-lg font-semibold text-white mb-4">🤝 STRATEGIC CONCESSIONS</h3>
                    <p className="text-stone-400 mb-3">Items intentionally NOT requested (good faith gesture):</p>
                    <ul className="text-stone-300 mb-4">
                      {requestTotals.excludedItems.slice(0, 4).map(item => (
                        <li key={item.id}>• {item.item} — {formatCurrency(item.cost)}</li>
                      ))}
                    </ul>
                    <p className="text-stone-400 mb-3">Total value waived: <span className="text-white font-medium">{formatCurrency(requestTotals.excludedTotal)}</span></p>
                    <div className="p-3 bg-emerald-500/10 border border-emerald-500/30 rounded-lg">
                      <strong className="text-emerald-400 text-sm">💬 USE THIS LINE:</strong>
                      <p className="text-stone-300 text-sm italic mt-1">"We've intentionally excluded several items from our request. We're focused on safety and value, not nickel-and-diming."</p>
                      <button onClick={() => copyToClipboard("We've intentionally excluded several items from our request. We're focused on safety and value, not nickel-and-diming.")} className="text-xs text-stone-400 hover:text-white mt-2">Copy Script</button>
                    </div>
                  </div>
                )}

                {/* Seller Repair Dynamics Note */}
                {requestTotals.sellerRepairTotal > 5000 && (
                  <div className="glass rounded-2xl p-6 border border-yellow-500/30" data-pdf-section="negotiation-dynamics">
                    <h3 className="text-lg font-semibold text-yellow-400 mb-3">⚠️ NEGOTIATION DYNAMICS</h3>
                    <p className="text-stone-300 mb-3">You're requesting <span className="text-white font-medium">{formatCurrency(requestTotals.sellerRepairTotal)}</span> in seller repairs. Keep in mind:</p>
                    <ul className="text-stone-400 space-y-2 text-sm">
                      <li>• Large seller repair requests typically reduce flexibility on credit negotiation</li>
                      <li>• Sellers may prefer giving credit over managing contractors</li>
                      <li>• If seller pushes back, consider: "Would you prefer to give us a credit of ${Math.round(requestTotals.sellerRepairTotal * 0.9)} and we'll handle the repairs ourselves?"</li>
                    </ul>
                    <p className="text-stone-400 text-sm mt-3 italic">Be prepared to pivot between credit and seller repair based on seller's preference. The total value matters more than structure.</p>
                  </div>
                )}

                {/* Negotiation Playbook */}
                {(() => {
                  // D47 Task 5: Playbook copy + math rewrite. Prepared Concession
                  // is now clamped at walk_away (sum of critical items in ask) so
                  // it can never fall below the floor — that was the original
                  // logic bug. All five points now adapt to actual deal
                  // structure (critical count, non-critical count, request mix)
                  // instead of relying on a binary "single-finding vs not" flag.
                  const selectedInAsk = findings.filter(f => f.selected);
                  const criticalInAsk = selectedInAsk.filter(f => _normalizeSeverity(f) === 'red');
                  const nonCriticalInAsk = selectedInAsk.filter(f => _normalizeSeverity(f) !== 'red');
                  const walkAway = criticalInAsk.reduce((s, f) => s + (f.cost || 0), 0);
                  const nonCriticalTotal = nonCriticalInAsk.reduce((s, f) => s + (f.cost || 0), 0);
                  const totalAsk = walkAway + nonCriticalTotal;
                  // Prepared Concession: low clamps at walk_away; high adds half
                  // of the non-critical pool. When everything is critical, both
                  // ends collapse to walk_away ("Hold firm" copy fires).
                  const concessionLow = walkAway;
                  const concessionHigh = walkAway + Math.round(0.5 * nonCriticalTotal);
                  const allCritical = nonCriticalInAsk.length === 0 && criticalInAsk.length > 0;
                  const noneCritical = criticalInAsk.length === 0 && nonCriticalInAsk.length > 0;
                  const noFlexThreshold = Math.round(totalAsk * 0.5 / 500) * 500;
                  // Severity impact word for Point 2 / Point 5 dynamic clauses.
                  // Default to 'habitability' for any high-severity item lacking
                  // a specific category match (per directive 2% concern).
                  const _impactWord = (f) => {
                    const blob = `${f?.item || ''} ${f?.category || ''} ${f?.description || ''}`.toLowerCase();
                    if (/federal pacific|aluminum wiring|knob.?and.?tube|panel/.test(blob)) return 'insurability';
                    if (/asbestos|lead\b|radon|gas leak|carbon monoxide|fire/.test(blob)) return 'safety';
                    return 'habitability';
                  };
                  // Point 1 subtitle reflects request-type mix.
                  const point1Subtitle = (requestTotals.creditTotal > 0 && requestTotals.sellerRepairTotal > 0)
                    ? 'Full ask: credit + seller repairs'
                    : (requestTotals.sellerRepairTotal > 0 ? 'Full ask: seller repair request' : 'Full ask: credit request');
                  // Point 2 quote by critical count.
                  let point2Quote;
                  if (criticalInAsk.length === 0) {
                    point2Quote = '"All items here are negotiable, but we\'d like to land close to the original ask."';
                  } else if (criticalInAsk.length === 1) {
                    const item = criticalInAsk[0];
                    point2Quote = `"We can be flexible on the other items, but the ${item.item} isn't negotiable — it affects ${_impactWord(item)}."`;
                  } else {
                    const word = _impactWord(criticalInAsk[0]);
                    point2Quote = `"We can be flexible on the smaller items, but the ${criticalInAsk.length} critical items aren't negotiable — they affect ${word}."`;
                  }
                  // Point 3 dynamic concession line.
                  const point3Line = allCritical
                    ? 'Hold firm — no concessions available'
                    : `Drop non-critical items selectively → land at ${formatCurrency(concessionLow)}–${formatCurrency(concessionHigh)}`;
                  // Point 4 good-faith signal by non-critical count.
                  let point4Line;
                  if (nonCriticalInAsk.length === 0) {
                    point4Line = 'No flexibility to signal — the ask is already at the floor';
                  } else if (nonCriticalInAsk.length === 1) {
                    point4Line = `Show willingness to drop the ${nonCriticalInAsk[0].item} entirely if needed`;
                  } else {
                    point4Line = 'Show flexibility on the non-critical items — drop one entirely if it helps';
                  }
                  // Point 5 walk-away quote by critical count.
                  let point5Quote;
                  if (criticalInAsk.length === 1) {
                    point5Quote = `"Below ${formatCurrency(walkAway)}, my clients will need to reconsider — the ${criticalInAsk[0].item} is a non-negotiable."`;
                  } else if (criticalInAsk.length >= 2) {
                    point5Quote = `"Below ${formatCurrency(walkAway)}, my clients will need to reconsider — the critical safety/insurability items aren't optional."`;
                  } else {
                    point5Quote = `"We're hoping to land at ${formatCurrency(noFlexThreshold)}; below that gets uncomfortable for my clients."`;
                  }
                  return (
                    <div className="glass rounded-2xl p-6">
                      <h3 className="text-lg font-semibold text-white mb-4">PLAYBOOK</h3>
                      <div className="space-y-4">
                        <div className="flex gap-4">
                          <div className="w-8 h-8 bg-brand-500/20 rounded-full flex items-center justify-center text-brand-400 font-bold shrink-0">1️⃣</div>
                          <div>
                            <h4 className="text-white font-medium">OPEN AT {formatCurrency(totalAsk)}</h4>
                            <p className="text-stone-400 text-sm">{point1Subtitle}</p>
                          </div>
                        </div>

                        <div className="flex gap-4">
                          <div className="w-8 h-8 bg-brand-500/20 rounded-full flex items-center justify-center text-brand-400 font-bold shrink-0">2️⃣</div>
                          <div>
                            <h4 className="text-white font-medium">IF THEY COUNTER LOW</h4>
                            <p className="text-stone-400 text-sm">{point2Quote}</p>
                          </div>
                        </div>

                        <div className="flex gap-4">
                          <div className="w-8 h-8 bg-brand-500/20 rounded-full flex items-center justify-center text-brand-400 font-bold shrink-0">3️⃣</div>
                          <div>
                            <h4 className="text-white font-medium">PREPARED CONCESSION</h4>
                            <p className="text-stone-400 text-sm">{point3Line}</p>
                          </div>
                        </div>

                        <div className="flex gap-4">
                          <div className="w-8 h-8 bg-brand-500/20 rounded-full flex items-center justify-center text-brand-400 font-bold shrink-0">4️⃣</div>
                          <div>
                            <h4 className="text-white font-medium">GOOD FAITH SIGNAL</h4>
                            <p className="text-stone-400 text-sm">{point4Line}</p>
                          </div>
                        </div>

                        <div className="flex gap-4">
                          <div className="w-8 h-8 bg-red-500/20 rounded-full flex items-center justify-center text-red-400 font-bold shrink-0">5️⃣</div>
                          <div>
                            <h4 className="text-white font-medium">WALK-AWAY LINE</h4>
                            <p className="text-stone-400 text-sm">{point5Quote}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* D47 Task 3: removed the "Refine This Strategy" box (pre-PPG
                    artifact). Game Plan is a probability engine, not a
                    strategy generator. The handleRefinement function and its
                    refinementFeedback / refinedStrategy state remain declared
                    but unreferenced — leaving the schema alone per directive. */}

                {/* Beta Feedback Widget */}
                <div className="glass rounded-2xl overflow-hidden mt-6" style={{ borderColor: 'rgba(99, 102, 241, 0.2)' }}>
                  {!feedbackOpen && !feedbackSent && (
                    <button
                      onClick={() => setFeedbackOpen(true)}
                      className="w-full p-4 flex items-center justify-center gap-2 text-stone-400 hover:text-white transition-colors text-sm"
                    >
                      <span>Found a bug or have feedback? <strong className="text-indigo-400">Let us know →</strong></span>
                    </button>
                  )}
                  {feedbackSent && (
                    <div className="p-4 text-center text-emerald-400 text-sm">
                      Thanks! We got your feedback. 🙏
                    </div>
                  )}
                  {feedbackOpen && !feedbackSent && (
                    <div className="p-5">
                      <div className="flex items-center gap-2 mb-3">
                        <span className="font-semibold text-white text-sm">BETA FEEDBACK</span>
                      </div>
                      <textarea
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                        placeholder="What happened? What could be better? Any bugs to report?"
                        className="w-full bg-stone-800/50 border border-stone-700 rounded-lg p-3 text-white placeholder-stone-500 text-sm resize-none focus:outline-none focus:border-indigo-500"
                        rows={4}
                      />
                      <div className="flex items-center justify-between mt-3">
                        <p className="text-stone-500 text-xs">Your feedback goes directly to the engineering team.</p>
                        <div className="flex gap-2">
                          <button
                            onClick={() => { setFeedbackOpen(false); setFeedbackText(''); }}
                            className="px-3 py-1.5 text-stone-400 hover:text-white text-sm transition-colors"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={async () => {
                              if (!feedbackText.trim()) return;
                              setFeedbackSending(true);
                              try {
                                // D47 Task 2: was `reportId` (short human-readable
                                // RPT-XXXX-YYYY code), which Postgres rejected with
                                // "invalid input syntax for type uuid". pendingReportId
                                // is the actual UUID for the current/loaded report.
                                const { error } = await supabaseClient.from('feedback').insert({
                                  user_id: user?.id || null,
                                  email: user?.email || 'anonymous',
                                  message: feedbackText.trim(),
                                  page: 'strategy',
                                  report_id: pendingReportId || null,
                                  created_at: new Date().toISOString()
                                });
                                if (error) throw error;
                                setFeedbackSent(true);
                                setFeedbackText('');
                              } catch (err) {
                                console.error('Feedback error:', err);
                                alert('Failed to send feedback. Please try again.');
                              } finally {
                                setFeedbackSending(false);
                              }
                            }}
                            disabled={feedbackSending || !feedbackText.trim()}
                            className="px-4 py-1.5 bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 text-white text-sm rounded-lg font-medium transition-colors"
                          >
                            {feedbackSending ? 'Sending...' : 'Submit Feedback'}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
            {/* Actions */}
            {/* D18c Part 2: Edit Factors is available on saved reports — agents can navigate
                back to Step 3 to model alternate slider configurations. */}
            <div className="flex justify-between no-print">
              <button
                onClick={() => goToStep(3)}
                className="px-6 py-3 bg-stone-800 text-white rounded-xl hover:bg-stone-700 transition-all"
              >
                Edit Factors
              </button>
              <div className="flex gap-3">
                <button
                  onClick={() => window.print()}
                  className="px-8 py-3 bg-gradient-to-r from-brand-500 to-brand-600 text-white font-semibold rounded-xl hover:from-brand-600 hover:to-brand-700 transition-all"
                >
                  Print Report
                </button>
              </div>
            </div>

            {/* Outcome Tracking Modal */}
            {showOutcomeModal && (
              <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 no-print">
                <div className="bg-stone-900 rounded-2xl p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-stone-700">
                  <div className="flex justify-between items-center mb-6">
                    <div>
                      <h3 className="text-xl font-bold text-white flex items-center gap-2">
                        <span>📊</span> Track Your Outcome
                      </h3>
                      <p className="text-stone-400 text-sm">Help improve recommendations for all agents</p>
                    </div>
                    <button
                      onClick={() => setShowOutcomeModal(false)}
                      className="text-stone-400 hover:text-white text-2xl"
                    >×</button>
                  </div>

                  <div className="space-y-6">
                    {/* Negotiation Result */}
                    <div>
                      <label className="block text-sm text-stone-300 mb-2">How did the negotiation end?</label>
                      <div className="space-y-2">
                        {[
                          { value: 'closed', label: 'Deal closed successfully' },
                          { value: 'fell_through_inspection', label: 'Deal fell through (inspection-related)' },
                          { value: 'fell_through_other', label: 'Deal fell through (other reasons)' },
                          { value: 'still_negotiating', label: 'Still in negotiation' }
                        ].map(option => (
                          <label key={option.value} className="flex items-center gap-3 p-3 bg-stone-800/50 rounded-lg cursor-pointer hover:bg-stone-800">
                            <input
                              type="radio"
                              name="negotiationResult"
                              value={option.value}
                              checked={outcomeData.negotiationResult === option.value}
                              onChange={(e) => setOutcomeData({...outcomeData, negotiationResult: e.target.value})}
                              className="text-brand-500"
                            />
                            <span className="text-white">{option.label}</span>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Show additional fields only if deal closed */}
                    {outcomeData.negotiationResult === 'closed' && (
                      <>
                        {/* Final Credit Received */}
                        <div>
                          <label className="block text-sm text-stone-300 mb-2">Final credit received</label>
                          <div className="relative">
                            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400">$</span>
                            <input
                              type="text"
                              value={outcomeData.finalCreditReceived}
                              onChange={(e) => setOutcomeData({...outcomeData, finalCreditReceived: e.target.value})}
                              placeholder="0"
                              className="w-full bg-stone-800/50 border border-stone-700 rounded-lg pl-8 pr-4 py-3 text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none"
                            />
                          </div>
                        </div>

                        {/* Seller Repair Value */}
                        <div>
                          <label className="block text-sm text-stone-300 mb-2">Estimated value of seller-completed repairs (if any)</label>
                          <div className="relative">
                            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400">$</span>
                            <input
                              type="text"
                              value={outcomeData.sellerRepairValue}
                              onChange={(e) => setOutcomeData({...outcomeData, sellerRepairValue: e.target.value})}
                              placeholder="0"
                              className="w-full bg-stone-800/50 border border-stone-700 rounded-lg pl-8 pr-4 py-3 text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none"
                            />
                          </div>
                        </div>

                        {/* Recommendation Accuracy */}
                        <div>
                          <label className="block text-sm text-stone-300 mb-2">How did our recommendation compare to reality?</label>
                          <div className="space-y-2">
                            {[
                              { value: 'spot_on', label: 'Spot on — landed right where you predicted' },
                              { value: 'close', label: 'Close — within 20% of target' },
                              { value: 'optimistic', label: 'Optimistic — market was tougher than expected' },
                              { value: 'conservative', label: 'Conservative — got more than expected' }
                            ].map(option => (
                              <label key={option.value} className="flex items-center gap-3 p-3 bg-stone-800/50 rounded-lg cursor-pointer hover:bg-stone-800">
                                <input
                                  type="radio"
                                  name="recommendationAccuracy"
                                  value={option.value}
                                  checked={outcomeData.recommendationAccuracy === option.value}
                                  onChange={(e) => setOutcomeData({...outcomeData, recommendationAccuracy: e.target.value})}
                                  className="text-brand-500"
                                />
                                <span className="text-white">{option.label}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      </>
                    )}

                    {/* Agent Notes */}
                    <div>
                      <label className="block text-sm text-stone-300 mb-2">What worked? What would you do differently? (optional)</label>
                      <textarea
                        value={outcomeData.agentNotes}
                        onChange={(e) => setOutcomeData({...outcomeData, agentNotes: e.target.value})}
                        placeholder="Share any insights that could help other agents..."
                        className="w-full h-24 bg-stone-800/50 border border-stone-700 rounded-lg px-4 py-3 text-white placeholder-stone-500 focus:border-brand-500 focus:outline-none resize-none"
                      />
                    </div>

                    {/* Privacy Note */}
                    <div className="flex items-start gap-2 text-stone-400 text-xs">
                      <span>🔒</span>
                      <p>Your data is anonymized and used only to improve recommendations for all GambitLab users.</p>
                    </div>

                    {/* Submit Button */}
                    <div className="flex justify-end gap-3">
                      <button
                        onClick={() => setShowOutcomeModal(false)}
                        className="px-6 py-3 bg-stone-800 text-white rounded-xl hover:bg-stone-700 transition-all"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleOutcomeSubmit}
                        disabled={!outcomeData.negotiationResult}
                        className={`px-6 py-3 bg-emerald-600 text-white rounded-xl transition-all ${
                          !outcomeData.negotiationResult ? 'opacity-50 cursor-not-allowed' : 'hover:bg-emerald-700'
                        }`}
                      >
                        Submit Outcome
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Disclaimer */}
            <div className="text-center text-stone-600 text-xs mt-8">
              <div className="flex items-center justify-center gap-2 mb-2">
                <img src={window.KNIGHT_LOGO_SRC} alt="" className="w-4 h-4 object-contain opacity-40" />
                <p>Powered by Gambit Lab v5.0 | Report generated {new Date().toLocaleString()}</p>
              </div>
              <p className="max-w-2xl mx-auto">
                This report is for informational purposes only and does not constitute professional advice.
                All repair cost estimates are AI-generated suggestions. Consult with licensed contractors for actual quotes.
              </p>
            </div>
          </div>
        );
      };

      // ================================================================
      // V3: REFINEMENT HANDLER
      // ================================================================
      const handleRefinement = async () => {
        if (!refinementFeedback.trim()) return;
        
        setIsGenerating(true);
        
        try {
          const strategy = generateStrategy();
          const { buckets, totals, position } = strategy;
          
          const prompt = `You are a real estate negotiation strategist.

CURRENT SITUATION:
- Property: ${propertyInfo.address}
- Total documented repairs: ${formatCurrency(totals.allItems)}
- Current leverage position: ${position.position}
- Current recommended opening ask: ${formatCurrency(totals.mustHaves + totals.strongAsks)}

CURRENT ITEM CLASSIFICATION:
Must-Haves (${buckets.mustHaves.length} items, ${formatCurrency(totals.mustHaves)}):
${buckets.mustHaves.map(f => `- ${f.item}: ${formatCurrency(f.cost)}`).join('\n')}

Strong Asks (${buckets.strongAsks.length} items, ${formatCurrency(totals.strongAsks)}):
${buckets.strongAsks.map(f => `- ${f.item}: ${formatCurrency(f.cost)}`).join('\n')}

Tradeables (${buckets.tradeables.length} items, ${formatCurrency(totals.tradeables)}):
${buckets.tradeables.map(f => `- ${f.item}: ${formatCurrency(f.cost)}`).join('\n')}

Concessions (${buckets.concessions.length} items, ${formatCurrency(totals.concessions)}):
${buckets.concessions.map(f => `- ${f.item}: ${formatCurrency(f.cost)}`).join('\n')}

AGENT'S NEW INPUT:
"${refinementFeedback}"

TASK:
Based on this new information, provide a revised negotiation approach. Consider:
1. Has the buyer's leverage changed? (New BATNA, time pressure, emotional factors)
2. Should any items move between buckets?
3. What's the new recommended approach?

If the agent's request seems unreasonable (e.g., asking for 2x documented repairs), push back constructively.

Respond with a brief strategic recommendation (2-3 paragraphs) that the agent can use.`;

          // v4.4: Use Cloudflare Worker proxy (API key stored server-side)
          // D47: this is the legacy "Refine This Strategy" handler. UI removed
          // but handler retained per directive; D53 label keeps cost telemetry
          // labelled clearly if this ever fires (it shouldn't from current UI).
          const response = await fetch(API_CONFIG.claudeApi.proxyUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              _ppgMeta: { callSite: 'proxy_strategy_refinement_legacy', reportId: pendingReportId || null },
              model: API_CONFIG.claudeApi.model,
              max_tokens: 1024,
              messages: [{ role: 'user', content: prompt }]
            })
          });

          const data = await response.json();

          if (data.content && data.content[0]) {
            setRefinedStrategy({
              approach: data.content[0].text
            });
          }
        } catch (error) {
          console.error('Refinement error:', error);
          setRefinedStrategy({
            approach: 'Unable to generate refined strategy. Please try again.'
          });
        }
        
        setIsGenerating(false);
        setRefinementFeedback('');
      };
      // ================================================================
      // v5.0: MAIN RENDER - Unified App Flow
      // ================================================================

      // Effect to load reports when user becomes available
      React.useEffect(() => {
        if (user && profile) {
          loadUserReports();
        }
      }, [user, profile]);

      // Render based on auth state and view
      if (authLoading) {
        return (
          <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, #1c1917 0%, #292524 100%)'}}>
            <div className="text-center">
              <div className="w-12 h-12 border-4 border-brand-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-stone-400">Loading...</p>
            </div>
          </div>
        );
      }

      // Not logged in - show landing page
      if (!user) {
        return <LandingPage onSignIn={signInWithGoogle} />;
      }

      // D38: universal post-auth signup consent gate. Fires BEFORE the whitelist
      // check so every signup path (Google OAuth, email/password, pre-whitelisted
      // bulk pilot) is captured in a single funnel. 'unknown' = query in flight,
      // fall through to avoid flashing the gate. 'missing' = render the gate.
      // 'present' = fall through to the rest of the app.
      if (signupAttestationStatus === 'missing') {
        return (
          <SignupConsentGate
            user={user}
            onConfirm={recordSignupConsent}
            onSignOut={handleSignOut}
          />
        );
      }

      // D12 (S3): Beta cohort whitelist gate.
      // Only enforce when profile has loaded AND is_beta_cohort is explicitly not true.
      // If profile is still loading (null/undefined), fall through so we don't flash the gate.
      if (profile && profile.is_beta_cohort !== true) {
        return <RequestAccessScreen user={user} onSignOut={handleSignOut} />;
      }

      // PPG DEV: Paywall disabled for testing - START
      // Logged in but no subscription/beta access - show payment required
      // if (!profile?.is_beta_cohort && profile?.subscription_status !== 'active') {
      //   return <PaymentRequired onSignOut={handleSignOut} onSwitchAccount={switchAccount} userId={user?.id} />;
      // }
      // PPG DEV: Paywall disabled for testing - END

      // User has access - show appropriate view

      // Profile page
      if (currentView === 'profile') {
        return (
          <ProfilePage
            user={user}
            profile={profile}
            profileForm={profileForm}
            setProfileForm={setProfileForm}
            onSave={saveProfile}
            onBack={goToDashboard}
            saving={profileSaving}
            pendingHeadshot={pendingHeadshot}
            setPendingHeadshot={setPendingHeadshot}
            pendingBrokerageLogo={pendingBrokerageLogo}
            setPendingBrokerageLogo={setPendingBrokerageLogo}
            onSwitchAccount={switchAccount}
          />
        );
      }

      // v5.2: Outcome tracking form
      if (currentView === 'outcome') {
        return (
          <OutcomeForm
            reportId={outcomeReportId}
            onBack={() => {
              // Clear preselected status when going back
              setOutcomePreselectedStatus(null);
              setOutcomeSource('in_app');
              goToDashboard();
            }}
            user={user}
            supabaseClient={supabaseClient}
            preselectedStatus={outcomePreselectedStatus}
            source={outcomeSource}
          />
        );
      }

      // ================================================================
      // SESSION 5 PREP: CONFIDENCE COACHING CONTENT FOR DAY 7 EMAIL
      // ================================================================
      // Include above the outcome buttons, personalized per report
      //
      // CONFIDENCE COACHING BLOCK:
      // Template:
      // "When you ran this analysis, you had a leverage score of {leverageScore} —
      //  {leverageDescription}. The data supported {askAmount} in concessions.
      //  However it turned out, you went in prepared."
      //
      // leverageDescription mapping:
      //   score >= 7:  "a strong negotiating position"
      //   score >= 3:  "solid ground to negotiate from"
      //   score >= 0:  "a balanced position with room to push"
      //   score < 0:   "a challenging position, but you had a clear strategy"
      //
      // Example output:
      // "When you ran this analysis, you had a leverage score of +9 — a strong
      //  negotiating position. The data supported $36,178 in concessions.
      //  However it turned out, you went in prepared."
      //
      // ----------------------------------------------------------------
      // OUTCOME RESPONSE COPY — for email landing page / in-app form
      // ----------------------------------------------------------------
      //
      // Won: "Congrats on the win! 🎉 Your leverage score was {score} and you
      //       went in asking for {askAmount}. Your outcome helps Game Plan get
      //       smarter for every agent in {market}."
      //
      // Lost: "Thanks for sharing. Every outcome — wins and losses — makes our
      //        recommendations more accurate. Your data is already improving
      //        Game Plan for agents in {market}."
      //
      // Ongoing/Stalled: "Good luck finishing this one up. We'll check back in a week."
      //
      // Walked: "Sometimes walking away is the right call. Your data still helps
      //          us understand deal dynamics in {market}."
      //
      // ================================================================
      // Helper function for Session 5 to use:
      const getLeverageDescription = (score) => {
        if (score >= 7) return "a strong negotiating position";
        if (score >= 3) return "solid ground to negotiate from";
        if (score >= 0) return "a balanced position with room to push";
        return "a challenging position, but you had a clear strategy";
      };
      // ================================================================

      if (currentView === 'product') {
        return (
          <div className="min-h-screen">
            {/* Header */}
            <header className="glass border-b border-brand-500/20 sticky top-0 z-50 no-print">
              <div className="max-w-5xl mx-auto px-6 py-4">
                <div className="flex items-center justify-between">
                  {/* v5.0: Dashboard back button */}
                  <div className="flex items-center gap-3">
                    <button
                      onClick={goToDashboard}
                      className="flex items-center gap-2 text-stone-400 hover:text-white transition-colors mr-4"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                      </svg>
                      Dashboard
                    </button>
                    <div className="w-10 h-10 bg-gradient-to-br from-brand-500 to-brand-600 rounded-xl flex items-center justify-center overflow-hidden">
                      <img src={window.KNIGHT_LOGO_SRC} alt="Game Plan PPG" className="w-full h-full object-contain" />
                    </div>
                    <div>
                      <h1 className="text-xl font-bold text-white">Game Plan PPG<sup className="text-xs">™</sup></h1>
                    </div>
                  </div>

                  {/* Desktop: Step indicators and menu */}
                  {/* D13: Step indicators are now shown in BOTH live and read-only mode so users can navigate saved reports */}
                  <div className="hidden md:flex items-center gap-4">
                    <div className="flex items-center gap-2">
                      {[1, 2, 3, 4].map((step) => (
                        <div
                          key={step}
                          className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all
                            ${currentStep === step
                              ? 'bg-brand-500 text-white'
                              : canAccessStep(step)
                                ? 'bg-brand-500/20 text-brand-400 cursor-pointer hover:bg-brand-500/30'
                                : 'bg-stone-800 text-stone-600 cursor-not-allowed'}`}
                          onClick={() => canAccessStep(step) && goToStep(step)}
                        >
                          {completedSteps.includes(step) && currentStep !== step ? (
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                          ) : step}
                        </div>
                      ))}
                    </div>
                    {/* User Menu - Desktop */}
                    <div className="flex items-center gap-3 ml-4 pl-4 border-l border-stone-700">
                      {ENABLE_PROFILE_BRANDING && (
                        <button onClick={() => setCurrentView('profile')} className="text-sm text-stone-400 hover:text-white transition-colors">Profile</button>
                      )}
                      <button onClick={handleSignOut} className="text-sm text-stone-400 hover:text-white transition-colors">Sign Out</button>
                    </div>
                  </div>

                  {/* Mobile: Hamburger menu */}
                  <div className="md:hidden">
                    <button onClick={() => setAppMobileMenuOpen(!appMobileMenuOpen)} className="text-stone-400 hover:text-white p-2">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Mobile Menu Dropdown */}
              {appMobileMenuOpen && (
                <div className="md:hidden border-t border-stone-700 bg-stone-900/95">
                  <div className="px-6 py-4 space-y-3">
                    {/* Step indicator for mobile - D13: Now shown in both live and read-only mode */}
                    <div className="flex items-center justify-center gap-2 pb-3 border-b border-stone-700">
                      {[1, 2, 3, 4].map((step) => (
                        <div
                          key={step}
                          className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all
                            ${currentStep === step
                              ? 'bg-brand-500 text-white'
                              : canAccessStep(step)
                                ? 'bg-brand-500/20 text-brand-400'
                                : 'bg-stone-800 text-stone-600'}`}
                          onClick={() => { canAccessStep(step) && goToStep(step); setAppMobileMenuOpen(false); }}
                        >
                          {completedSteps.includes(step) && currentStep !== step ? (
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                          ) : step}
                        </div>
                      ))}
                    </div>
                    {ENABLE_PROFILE_BRANDING && (
                      <button
                        onClick={() => { setCurrentView('profile'); setAppMobileMenuOpen(false); }}
                        className="block w-full text-left text-stone-300 hover:text-white py-2"
                      >
                        Profile
                      </button>
                    )}
                    <button
                      onClick={() => { handleSignOut(); setAppMobileMenuOpen(false); }}
                      className="block w-full text-left text-stone-300 hover:text-white py-2"
                    >
                      Sign Out
                    </button>
                  </div>
                </div>
              )}
            </header>

            {/* Main Content */}
            <main className="max-w-5xl mx-auto px-6 py-8">
              {isGenerating ? (
                /* D43 Task 2 (2026-05-11): branded computation screen.
                   Full-viewport overlay (fixed inset, z-9999) so it covers the
                   header chrome too — Jared wants the moment to feel separate
                   from the rest of the app. Spinner replaced with a gentle
                   scale-pulse on the knight icon. Three-dot animation on the
                   headline reinforces "actively working." Dismiss is governed
                   by the watch effect (engine done + ≥1.2s min hold). */
                <div style={{
                  position: 'fixed', inset: 0, zIndex: 9999,
                  background: 'linear-gradient(135deg, #0a0e1a 0%, #1c1917 60%, #292524 100%)',
                  display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center',
                  padding: '24px', textAlign: 'center'
                }}>
                  <style>{`
                    @keyframes d43-knight-pulse {
                      0%, 100% { transform: scale(1.0); opacity: 0.92; }
                      50%      { transform: scale(1.05); opacity: 1.0; }
                    }
                    @keyframes d43-dot-bounce {
                      0%, 80%, 100% { opacity: 0.2; }
                      40%           { opacity: 1.0; }
                    }
                    .d43-knight { animation: d43-knight-pulse 1.5s ease-in-out infinite; }
                    .d43-dot-1  { animation: d43-dot-bounce 1.4s ease-in-out 0s    infinite; }
                    .d43-dot-2  { animation: d43-dot-bounce 1.4s ease-in-out 0.18s infinite; }
                    .d43-dot-3  { animation: d43-dot-bounce 1.4s ease-in-out 0.36s infinite; }
                  `}</style>
                  <img
                    src={window.KNIGHT_LOGO_SRC}
                    alt=""
                    className="d43-knight"
                    style={{
                      width: 64, height: 64, marginBottom: 32,
                      filter: 'drop-shadow(0 0 28px rgba(123, 139, 255, 0.32))'
                    }}
                  />
                  <h2 style={{
                    fontSize: 22, fontWeight: 500, color: 'white',
                    margin: 0, marginBottom: 10, letterSpacing: '-0.005em',
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
                  }}>
                    Calculating your Game Plan Score<span className="d43-dot-1">.</span><span className="d43-dot-2">.</span><span className="d43-dot-3">.</span>
                  </h2>
                  <p style={{
                    fontSize: 14.5, color: '#94a3b8', margin: 0,
                    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
                  }}>
                    Running the math on your deal.
                  </p>
                </div>
              ) : (
                <>
                  {currentStep === 1 && Step1PropertyInfo()}
                  {currentStep === 2 && Step2Findings()}
                  {currentStep === 3 && Step3Leverage()}
                  {currentStep === 4 && (
                    <>
                      {Step4Report()}

                      {/* v5.0: Save & Return to Dashboard button (only in edit mode) */}
                      {!readOnlyMode && (
                        <div className="mt-8 flex justify-center">
                          <button
                            onClick={saveAndReturnToDashboard}
                            className="px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-xl hover:opacity-90 transition-opacity flex items-center gap-2"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            Save & Return to Dashboard
                          </button>
                        </div>
                      )}

                      {/* D18a: Aged-report cue — show only when report ≥7 days old AND no outcome submitted */}
                      {readOnlyMode && selectedReport && (() => {
                        const hasOutcome = selectedReport.outcome_status && ['won', 'lost', 'walked', 'stalled'].includes(selectedReport.outcome_status);
                        if (hasOutcome) return null;
                        const createdAt = selectedReport.created_at ? new Date(selectedReport.created_at) : null;
                        if (!createdAt) return null;
                        const ageDays = (Date.now() - createdAt.getTime()) / (1000 * 60 * 60 * 24);
                        if (ageDays < 7) return null;
                        return (
                          <div className="mt-10 text-center no-print">
                            <button
                              onClick={() => {
                                setOutcomeReportId(selectedReport.id);
                                setOutcomePreselectedStatus(null);
                                setOutcomeSource('in_app');
                                setCurrentView('outcome');
                                window.history.replaceState({}, '', window.location.pathname + '#outcome/' + selectedReport.id);
                              }}
                              className="text-sm text-stone-400 hover:text-stone-200 transition-colors italic"
                            >
                              Did this deal close? Tell us how it landed →
                            </button>
                          </div>
                        );
                      })()}

                      {/* v5.0: Read-only mode buttons (viewing saved report) */}
                      {/* D13 Fix 3a: Removed the Re-analyze button — saved reports should be a permanent record */}
                      {readOnlyMode && selectedReport && (
                        <div className="mt-8 flex justify-center gap-4">
                          <button
                            onClick={goToDashboard}
                            className="px-6 py-3 bg-stone-700 text-white font-medium rounded-xl hover:bg-stone-600 transition-colors flex items-center gap-2"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                            Back to Dashboard
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}

              {/* v5.0: Footer */}
              {currentStep === 4 && (
                <footer className="mt-12 pt-6 border-t border-stone-800 text-center text-sm text-stone-500">
                  {ENABLE_PROFILE_BRANDING && profile?.first_name && profile?.last_name ? (
                    <p>&copy; {profile.first_name} {profile.last_name}, {new Date().getFullYear()} &bull; Powered by Game Plan PPG™</p>
                  ) : (
                    <p>Powered by Game Plan PPG™</p>
                  )}
                </footer>
              )}
            </main>
          </div>
        );
      }

      // Default: Dashboard (fallthrough for 'dashboard', 'landing', or any other state)
      return (
        <Dashboard
          user={user}
          profile={profile}
          reports={reports}
          onNewReport={() => {
            resetForm();
            setCurrentView('product');
          }}
          onViewReport={(report) => {
            loadFrozenReport(report);
          }}
          onResumeDraft={(report) => {
            resumeDraft(report);
          }}
          onHideReport={hideReport}
          onTrackOutcome={(reportId) => {
            setOutcomeReportId(reportId);
            setOutcomePreselectedStatus(null); // Reset when opening from dashboard
            setOutcomeSource('in_app');
            setCurrentView('outcome');
            window.history.replaceState({}, '', window.location.pathname + '#outcome/' + reportId);
          }}
          onSignOut={handleSignOut}
          onProfile={() => setCurrentView('profile')}
          dismissedProfileNudge={dismissedProfileNudge}
          onDismissProfileNudge={() => setDismissedProfileNudge(true)}
          dismissedPhoneNudge={dismissedPhoneNudge}
          onDismissPhoneNudge={() => setDismissedPhoneNudge(true)}
        />
      );
    };

    // Render the app
    // D27: replaced legacy ReactDOM.createRoot global ref with imported createRoot.
    createRoot(document.getElementById('root')).render(<GambitLabV2 />);
